import { ProposalDecision } from '../../agents/types.js';
import { BlameLogType } from '../../blamelog/index.js';
import { CaseState, CaseStatus, CaseType, SystemEndReason, } from '../../cases/index.js';
import { CaseTag } from '../../cases/index.js';
import { CollectorType, PaymentOptionType } from '../../collectors/index.js';
import { ConnectConnectionStatus } from '../../connect/connections/index.js';
import { ConnectCaseMappingStatus, RetractionReason, } from '../../connect/mappings/index.js';
import { ProductService } from '../../connect/products/index.js';
import { InterestType, LienType, ValuationSource, } from '../../cosmoV2/assets.js';
import { ProviderName } from '../../cosmoV2/providers/index.js';
import { SubmitToCourtError } from '../../court/auto-submit.js';
import { UdbetalingsRekvisitioner } from '../../court/index.js';
import { CreditorState } from '../../creditor/index.js';
import { AlternativeContactType, CompanyStarCycle, DissolvedStatus, FoundationCode, PrivateStarCycle, RelationType, } from '../../customers/index.js';
import { DebtRegistrationState, RegistryType, } from '../../debt-register/index.js';
import { DebtRegistrationError } from '../../debt-register/rki.js';
import { DocumentTypes } from '../../documents/index.js';
import { AutoBillingTiming, Timing, } from '../../economy/billing-appendix-setups/index.js';
import { DepositShareType } from '../../economy/billing/organize.js';
import { CaseVoucherEventType } from '../../economy/case-voucher-events/event-type.js';
import { State as CaseVoucherState } from '../../economy/case-vouchers/index.js';
import { CaseVoucherSource, PaymentType, State, } from '../../economy/case-vouchers/index.js';
import { CaseVoucherTags } from '../../economy/index.js';
import { PaymentPlanEntryStatus } from '../../economy/payment-plans/index.js';
import { PayoutState, PayoutType } from '../../economy/payouts/index.js';
import { CompoundingPeriod, ImposeInterestFrequency, VoucherCategory, VoucherTypeIds, VoucherTypeSetting, } from '../../economy/vouchers/index.js';
import { EmbedPlacement } from '../../embeds/index.js';
import { EndReasonCategory } from '../../end-reasons/index.js';
import { ImportState } from '../../imports/types.js';
import { Entity, Gender, PermissionLevels, TimespanUnit } from '../../index.js';
import { AggregationType } from '../../insights/aggregations.js';
import { BulkActionType } from '../../insights/bulk-actions.js';
import { FilterType } from '../../insights/index.js';
import { DiscountType, IntentType } from '../../intents/index.js';
import { InteractionEventType } from '../../interactions/events/index.js';
import { InteractionType, PhoneIncomingTag, PhoneOutgoingTag, ReturnReason, } from '../../interactions/index.js';
import { PerformedByType } from '../../performed-by/index.js';
import { SystemProcedure, SystemProcedureId } from '../../procedures/index.js';
import { TemplateMention, TemplateTag, TemplateType, } from '../../templates/index.js';
import { SKU } from '../../tenants/billing.js';
import { TenantStatus } from '../../tenants/index.js';
import { TribunalCaseStatus, TribunalCaseType, } from '../../tribunal/cases/types.js';
import { CourtMeetingState, DistraintType, TribunalJobType, } from '../../tribunal/jobs/types.js';
import { UpdateType } from '../../updates/index.js';
import { InterestFrom, VoucherApplicationTarget, VoucherApplicationType, } from '../../voucher-applications/index.js';
import { PathWarning, RequirementType, TimingType, TodoType, } from '../../workflows/index.js';
const map = {
    propertyRefDescriptions: {
        [Entity.Customer]: 'Egenskapen fylls i på kunden och delas mellan kundens ärenden',
    },
    ultimateCreditors: {
        notes: 'Anteckningar',
    },
    agentProposals: {
        proposedInput: 'Förslag',
        appliedInput: 'Använd indata',
        finalVersion: 'Slutlig version',
        agentVersion: 'Agentens förslag',
    },
    categoryInsights: {
        tabTitle: 'Kategorier',
        category: 'Kategori',
        allCategories: 'Alla kategorier',
        interactions: 'Interaktioner',
        uncategorized: 'Inte kategoriserad',
        addedByCaseworkers: 'Tillagd av handläggare',
        removedByCaseworkers: 'Borttagen av handläggare',
        noInteractions: 'Inga kategoriserade interaktioner under perioden.',
        removed: 'Borttagen av en handläggare',
        addedByAi: 'Tillagd av AI',
    },
    agentPerformance: {
        tabTitle: 'Agentförslag',
        action: 'Åtgärd',
        allActions: 'Alla åtgärder',
        taskPrompt: 'Uppgiftsprompt',
        task: 'Uppgift',
        allTaskPrompts: 'Alla uppgiftsprompter',
        startedManually: 'Startad manuellt',
        unknownUpdateType: 'Okänd uppgiftstyp',
        accepted: 'Godkänt',
        proposals: 'Förslag',
        decisionTime: 'Beslutstid',
        escalated: 'Eskalerat till handläggare',
        oldestPending: 'Äldsta: {age}',
        comparedToPrevious: 'Jämfört med föregående period',
        percentagePoints: '{points} %-enheter',
        duration: {
            minutes: '{minutes} min',
            hours: '{hours} tim',
            days: '{days} dagar',
        },
        decisions: {
            [ProposalDecision.Pending]: 'Väntar',
            [ProposalDecision.ApprovedAsIs]: 'Godkänt oförändrat',
            [ProposalDecision.Edited]: 'Redigerat',
            [ProposalDecision.Rejected]: 'Avvisat',
            [ProposalDecision.Failed]: 'Misslyckat',
            [ProposalDecision.Closed]: 'Stängt',
        },
        allDecisions: 'Alla',
        noProposals: 'Inga förslag under perioden.',
    },
    is: {
        currently: 'sv',
    },
    langs: {
        en: 'Engelska',
        da: 'Danska',
        sv: 'Svenska',
        no: 'Norska',
        fi: 'Finska',
        nl: 'Nederländska',
        de: 'Tyska',
        fr: 'Franska',
        es: 'Spanska',
        cs: 'Tjeckiska',
        el: 'Grekiska',
    },
    tribunalCaseTypes: {
        [TribunalCaseType.DKBetalingspaakrav]: '🇩🇰 Betalningsföreläggande (Betalingspåkrav)',
        [TribunalCaseType.DKFogedrekvisition]: '🇩🇰 Begäran till Kronofogden (fogedrekvisition)',
        [TribunalCaseType.DKAndreFogedsager]: '🇩🇰 Övriga Kronofogdeärenden',
        [TribunalCaseType.GLStaevning]: '🇬🇱 Stämning',
        [TribunalCaseType.GLFogedBegaering]: '🇬🇱 Fogedbegæring',
        [TribunalCaseType.GLBetalingspaakrav]: '🇬🇱 Betalningsföreläggande (Betalingspåkrav)',
    },
    tribunalCaseStatuses: {
        [TribunalCaseStatus.Created]: 'Skapat',
        [TribunalCaseStatus.Awaiting1Paategning]: 'Väntar på "1.-påtegning"',
        [TribunalCaseStatus.ClosedBecauseOfObjection]: 'Avslutat - invändning',
        [TribunalCaseStatus.Closed]: 'Avslutat',
        [TribunalCaseStatus.Awaiting2Paategning]: 'Väntar på "2.-påtegning"',
        [TribunalCaseStatus.AwaitingBailiffMeeting]: 'Väntar på möte',
        [TribunalCaseStatus.AwaitingNoticeForBailiffMeeting]: 'Väntar på mötesunderrättelse',
        [TribunalCaseStatus.AwaitingVerdict]: 'Väntar på dom',
        [TribunalCaseStatus.AwaitingNoticeForFogedmoede]: 'Väntar på kallelse',
        [TribunalCaseStatus.AwaitingFogedmoede]: 'Väntar på möte',
    },
    tribunalJobTypes: {
        [TribunalJobType.GLCreateBetalingspaakrav]: 'Skapa Kronofogdeärende',
        [TribunalJobType.GLResendBetalingspaakrav]: 'Skickar om Kronofogdeärende',
        [TribunalJobType.CreateBetalingspaakrav]: 'Skapa Kronofogdeärende',
        [TribunalJobType.ResendBetalingspaakrav]: 'Skickar om Kronofogdeärende',
        [TribunalJobType.Register1Paategning]: 'Registrerar "1.-påtegning"',
        [TribunalJobType.ClosedObjection]: 'Avslutat efter 1.-påtegning på grund av invändning',
        [TribunalJobType.Register2Paategning]: 'Registrerar "2.-påtegning"',
        [TribunalJobType.CreateFogedrekvisition]: 'Skapa "fogedrekvisition"',
        [TribunalJobType.RegisterInsolvency]: 'Registrera insolvens',
        [TribunalJobType.RegisterPolicePresentation]: 'Registrera polisframställning',
        [TribunalJobType.CreateStaevning]: 'Skapa stämning',
        [TribunalJobType.RegisterVerdict]: 'Dom registrerad',
        [TribunalJobType.ResendStaevning]: 'Skickar om stämning',
        [TribunalJobType.CreateFogedbegaering]: 'Skapa fogedbegæring',
        [TribunalJobType.ResendFogedbegaering]: 'Skickar om fogedbegæring',
        [TribunalJobType.RegisterInsolvens]: 'Registrera insolvens',
        [TribunalJobType.CourtMeeting]: 'Domstolsmöte',
        [TribunalJobType.Distraint]: 'Utmätning',
        [TribunalJobType.CreateOtherFogedsager]: 'Skapa övrigt Kronofogdeärende',
        [TribunalJobType.Note]: 'Lägg till anteckning',
        [TribunalJobType.CloseCase]: 'Markera ärende som avslutat',
    },
    distraintType: {
        [DistraintType.Property]: 'Fastighet',
        [DistraintType.Vehicle]: 'Fordon',
        [DistraintType.RentalDeposit]: 'Deposition i hyresbostad',
        [DistraintType.CooperativeHousing]: 'Bostadsrätt',
        [DistraintType.Other]: 'Övrigt',
        [DistraintType.MortgageDeed]: 'Pantbrev',
        [DistraintType.ExcessTax]: 'Överskjutande skatt',
    },
    tenantStatus: {
        [TenantStatus.Active]: 'Aktiv',
        [TenantStatus.Demo]: 'Demo',
        [TenantStatus.Disabled]: 'Inaktiverad',
        [TenantStatus.GettingStarted]: 'Väntar på driftsättning',
        [TenantStatus.Sandbox]: 'Sandbox',
    },
    tenantStatusPlural: {
        [TenantStatus.Active]: 'Aktiva',
        [TenantStatus.Demo]: 'Demos',
        [TenantStatus.Disabled]: 'Inaktiverade',
        [TenantStatus.GettingStarted]: 'Väntar på driftsättning',
        [TenantStatus.Sandbox]: 'Sandboxar',
    },
    tenantBillingUnits: {
        "Concatenated SMS'": 'Sammanslagna SMS',
        'Min.': 'Min.',
        'Pcs.': 'St.',
        Months: 'Månader',
    },
    tenantBilling: {
        invoices: 'Fakturor',
        invoice: 'Faktura',
        creditNote: 'Kreditnota',
        noInvoicesYet: 'Inga fakturor att visa',
        backToTenantBilling: 'Tillbaka till fakturering',
    },
    tenantSKU: {
        [SKU.DomesticSMS]: 'SMS inrikes',
        [SKU.InternationalSMS]: 'SMS utrikes',
        [SKU.DomesticAutoCall]: 'Automatiskt samtal inrikes',
        [SKU.InternationalAutoCall]: 'Automatiskt samtal utrikes',
        [SKU.DomesticLetter]: 'Brev inrikes',
        [SKU.InternationalLetter]: 'Brev utrikes',
        [SKU.ReturnLetter]: 'Returbrev',
        [SKU.DigitalSignature]: 'Digital signatur',
        [SKU.PhoneLookup]: 'Uppslag av telefonnummer',
        [SKU.EmailLookup]: 'Uppslag av e-post',
        [SKU.CaseCreation]: 'Ärendeskapande',
        [SKU.MigratedCaseCreation]: 'Skapande av migrerat ärende',
        [SKU.MonthlyBaseFee]: 'Månatlig licensavgift',
        [SKU.SupportAgreement]: 'Supportavtal',
        [SKU.EBoks0_60KB]: 'e-Boks-meddelande (0-60kb)',
        [SKU.EBoks61_120KB]: 'e-Boks-meddelande (61-120kb)',
        [SKU.EBoks121_300KB]: 'e-Boks-meddelande (121-300kb)',
        [SKU.EBoks301_480KB]: 'e-Boks-meddelande (301-480kb)',
        [SKU.EBoks481_960KB]: 'e-Boks-meddelande (481-960kb)',
        [SKU.EBoks961_1440KB]: 'e-Boks-meddelande (961-1440kb)',
        [SKU.EBoks1441_1920KB]: 'e-Boks-meddelande (1441-1920kb)',
        [SKU.EBoks1921_10080KB]: 'e-Boks-meddelande (1921-10080kb)',
        [SKU.Onboarding]: 'Onboarding',
        [SKU.LetterExtraSheet]: 'Extra sidor, fysiskt brev',
        [SKU.NemId]: 'NemId-validering',
        [SKU.MitID]: 'MitID-validering',
        [SKU.FreezingSystemSignOn]: 'Registrering i spärrsystem',
        [SKU.FreezingSystemSignOff]: 'Avregistrering från spärrsystem',
        [SKU.Consultancy]: 'Konsulttjänster',
        [SKU.CosmoPersonLookup]: 'Uppslag av person',
        [SKU.CosmoCompanyLookup]: 'Uppslag av företag',
    },
    caseVoucherTableLabels: {
        overview: 'Ärendeekonomi',
        detailed: 'Ärendeekonomi detaljerad',
        principalWithReferenceCaseVouchers: 'Kapitalbelopp med referensverifikat',
    },
    documentSettings: {
        newDocumentSigningLink: 'Ny länk för dokumentsignering',
        name: 'Namn på sammanfogningsfält',
        description: 'Beskrivning',
        signedProcedure: 'Utlös om dokumentet signeras',
        declinedSigningProcedure: 'Utlös om signering av dokumentet avvisas',
    },
    caseVoucherTables: {
        createNewTable: 'Lägg till tabell',
        name: 'Namn på sammanfogningsfält',
        description: 'Beskrivning',
        includeHeader: 'Visa rubrik i tabell',
        includeSumRow: 'Visa summeringsrad i tabell',
        showDepositDistribution: 'Visa fördelning av depositioner baserat på ränte- och depositionsordning',
        showInterestCalculationDetails: 'Visa detaljer om ränteberäkning',
        includeDeleted: 'Visa raderade ärendeverifikat',
        includeFIKPaymentDetails: 'Inkludera FIK-betalnings-ID baserat på ärendeverifikatets referens-id',
        includeDate: 'Visa datum',
        includeDueDate: 'Visa förfallodatum',
        excludeNotDueCaseVouchers: 'Dölj ej förfallna fakturor',
        onlyShowSelectedVoucherCategories: 'Visa endast valda ärendeverifikatkategorier',
        includeReferenceCaseVouchers: 'Dölj referensverifikat',
        filterOnCaseVoucherProperties: 'Filtrera på ärendeverifikatets attribut',
        groupBy: 'Gruppera ärendeverifikat',
        groupByText: 'Text',
        groupIncludesPayments: 'Inkludera alla betalningstyper',
        excludePaymentsFromSubTotal: 'Exkludera alla betalningstyper',
        matchPropertiesShouldBeTrue: 'Ska vara sant',
        matchPropertiesShouldBeFalse: 'Ska vara falskt',
        type: 'Tabelltyp',
        typeStandard: 'Standard',
        typeLedger: 'Skuldsammanställning med löpande saldo',
        typeLedgerDescription: 'Alla ärendeverifikat och varje månads ränta i kronologisk ordning, med vad varje inbetalning täckte samt kvarvarande kapital, ränta och kostnader.',
    },
    economyCategories: {
        [VoucherCategory.DISBURSEMENT]: 'Utlägg',
        [VoucherCategory.FEE]: 'Avgift',
        [VoucherCategory.COLLECTIONCOMMISSION]: 'Inkassoprovision',
        [VoucherCategory.OVERPAYMENT]: 'Överbetalning',
        [VoucherCategory.PAYOUT]: 'Utbetalning',
        [VoucherCategory.VAT]: 'Moms',
        [VoucherCategory.TRANSACTION]: 'Transaktion',
        [VoucherCategory.COST]: 'Kostnad',
        [VoucherCategory.COURTCOST]: 'Domstolskostnad',
        [VoucherCategory.INTEREST]: 'Ränta',
        [VoucherCategory.PRINCIPAL]: 'Kapitalbelopp',
    },
    pluralEconomyVoucherTypeLabels: {
        [VoucherTypeIds.PRINCIPAL]: 'Kapitalbelopp',
        [VoucherTypeIds.INVOICE]: 'Fakturor',
        [VoucherTypeIds.ONACCOUNTINVOICE]: 'Fakturor på konto',
        [VoucherTypeIds.FINALINVOICE]: 'Slutgörelser',
        [VoucherTypeIds.CONTROLFEE]: 'Kontrollavgifter',
        [VoucherTypeIds.ADMINISTRATIONCOST]: 'Administrationskostnader',
        [VoucherTypeIds.UDTRAEKSGEBYR]: 'Utträdesavgifter',
        [VoucherTypeIds.CREDITNOTE]: 'Kreditnota',
        [VoucherTypeIds.YEARLYINTEREST]: 'Årliga räntor',
        [VoucherTypeIds.MONTHLYINTEREST]: 'Månatliga räntor',
        [VoucherTypeIds.STARTEDMONTHINTEREST]: 'Räntor per påbörjad månad',
        [VoucherTypeIds.PROCESSINTEREST]: 'Räntor',
        [VoucherTypeIds.GLPROCESSINTEREST]: 'Räntor (GL)',
        [VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Ränta på ränta (daglig räntetillskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Ränta på ränta (månatlig räntetillskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Ränta på ränta (kvartalsvis räntetillskrivning)',
        [VoucherTypeIds.REMINDERFEE]: 'Påminnelseavgifter',
        [VoucherTypeIds.COLLECTIONCOST]: 'Inkassokostnader',
        [VoucherTypeIds.COLLECTIONFEE]: 'Inkassoavgifter',
        [VoucherTypeIds.BAILIFFSFEE]: 'Kronofogdens avgifter',
        [VoucherTypeIds.WRITFEE]: 'Utredningsavgifter',
        [VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Domstolskostnader utan civil domstol',
        [VoucherTypeIds.COURTCLAIMSALARY]: 'Domstolslöner',
        [VoucherTypeIds.BAILIFSSALARY]: 'Kronofogdens löner',
        [VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Kronofogdens rekvisitionsavgifter',
        [VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Polisens presentationsavgifter',
        [VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Domstolskostnader med kronofogdens domstol',
        [VoucherTypeIds.WRITSALARY]: 'Utredningslöner',
        [VoucherTypeIds.COMPENSATIONCOST]: 'Kompensationskostnader',
        [VoucherTypeIds.Folkeregisteropslag]: 'Uppslag i folkbokföringen',
        [VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Immaterialrättsliga ärenden',
        [VoucherTypeIds.CIVILCOURTCOST]: 'Civila domstolskostnader',
        [VoucherTypeIds.DEPOSIT]: 'Depositioner',
        [VoucherTypeIds.WITHDRAWAL]: 'Uttag',
        [VoucherTypeIds.OVERPAYMENT]: 'Överbetalningar',
        [VoucherTypeIds.COLLECTIONCOMMISSION]: 'Inkassoprovisioner',
        [VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Inkassoprovisioner (övervakning)',
        [VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Inkassoprovisioner (kreditorgaranti)',
        [VoucherTypeIds.JURIDISKBISTAND]: 'Juridiskt stöd',
        [VoucherTypeIds.ENDCASEFEE]: 'Avgifter för slutet av fallet',
        [VoucherTypeIds.STARTCASEFEE]: 'Avgifter för starten av fallet',
        [VoucherTypeIds.BPKFEE]: 'BPK-avgifter',
        [VoucherTypeIds.FOGEDFEE]: 'Kronofogdens rekvisitionsavgifter',
        [VoucherTypeIds.DEBTREGISTERREGISTRATIONFEE]: 'Skuldregister-registreringsavgifter',
        [VoucherTypeIds.BPKDISBURSEMENT]: 'Utredningsutgifter',
        [VoucherTypeIds.POLICEDISBURSEMENT]: 'Polisens presentationsutgifter',
        [VoucherTypeIds.FOGEDDISBURSEMENT]: 'Kronofogdens rekvisitionsutgifter',
        [VoucherTypeIds.VAT]: 'Moms',
        [VoucherTypeIds.GAELDSBREV]: 'Lån',
        [VoucherTypeIds.SETTLEMENT]: 'Förlikning',
        [VoucherTypeIds.FIXEDINTEREST]: 'Fast ränta',
        [VoucherTypeIds.DEPOSITPAYOUT]: 'Uttag av deposition',
        [VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkbokföringsuppslag',
        [VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmälan av fordran',
        [VoucherTypeIds.MeetingFee]: 'Mötesavgifter',
        [VoucherTypeIds.STAEVNINGSGEBYR]: 'Utredningsavgift',
        [VoucherTypeIds.BERAMMELSESAFGIFT]: 'Avgift för bokning',
        [VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Avbokning av utlägg',
        [VoucherTypeIds.LOCKSMITHFEE]: 'Låssmedsavgift',
        [VoucherTypeIds.DRIVINGFEE]: 'Körkostnader',
        [VoucherTypeIds.OTHERFEE]: 'Övriga kostnader',
        [VoucherTypeIds.REFUND]: 'Återbetalning',
        [VoucherTypeIds.JOINTDEPOSIT]: 'Solidariska betalningar',
        [VoucherTypeIds.SEPROCESSINTEREST]: 'Dröjsmålsräntor',
        [VoucherTypeIds.SEKRONOFOGDENAPPLICATIONFEE]: 'Ansökningsavgifter (Kronofogden)',
        [VoucherTypeIds.SEKRONOFOGDENREPRESENTATIONFEE]: 'Ombudsarvoden (betalningsföreläggande)',
        [VoucherTypeIds.NOLATEINTEREST]: 'Dröjsmålsräntor (Norge)',
        [VoucherTypeIds.NOFORLIKSRADFEE]: 'Rättsavgifter (förlikningsrådet)',
        [VoucherTypeIds.NOLEGALCOLLECTIONFEE]: 'Tunga inkassoarvoden (rättslig)',
    },
    economyVoucherTypeLabels: {
        [VoucherTypeIds.PRINCIPAL]: 'Kapitalbelopp',
        [VoucherTypeIds.INVOICE]: 'Faktura',
        [VoucherTypeIds.ONACCOUNTINVOICE]: 'Faktura på konto',
        [VoucherTypeIds.FINALINVOICE]: 'Slutgiltig faktura',
        [VoucherTypeIds.CONTROLFEE]: 'Kontrollavgift',
        [VoucherTypeIds.ADMINISTRATIONCOST]: 'Administrationskostnad',
        [VoucherTypeIds.UDTRAEKSGEBYR]: 'Avgift för uttag',
        [VoucherTypeIds.CREDITNOTE]: 'Kreditnota',
        [VoucherTypeIds.YEARLYINTEREST]: 'Årlig ränta',
        [VoucherTypeIds.MONTHLYINTEREST]: 'Månatlig ränta',
        [VoucherTypeIds.STARTEDMONTHINTEREST]: 'Ränta per påbörjad månad',
        [VoucherTypeIds.PROCESSINTEREST]: 'Ränta',
        [VoucherTypeIds.GLPROCESSINTEREST]: 'Ränta (GL)',
        [VoucherTypeIds.COMPOUNDINTEREST_DAILY_CAP]: 'Ränta på ränta (daglig räntetillskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_MONTHLY_CAP]: 'Ränta på ränta (månatlig räntetillskrivning)',
        [VoucherTypeIds.COMPOUNDINTEREST_QUARTERLY_CAP]: 'Ränta på ränta (kvartalsvis räntetillskrivning)',
        [VoucherTypeIds.REMINDERFEE]: 'Påminnelseavgift',
        [VoucherTypeIds.COLLECTIONCOST]: 'Inkassokostnad',
        [VoucherTypeIds.COLLECTIONFEE]: 'Inkassoavgift',
        [VoucherTypeIds.COMPENSATIONCOST]: 'Kompensationskostnad',
        [VoucherTypeIds.Folkeregisteropslag]: 'Uppslag i folkbokföringen',
        [VoucherTypeIds.IMMATERIALRETLIGESAGER]: 'Immaterialrättsliga ärenden',
        [VoucherTypeIds.DEPOSIT]: 'Deposition',
        [VoucherTypeIds.WITHDRAWAL]: 'Uttag',
        [VoucherTypeIds.OVERPAYMENT]: 'Överbetalning',
        [VoucherTypeIds.COLLECTIONCOMMISSION]: 'Inkassokommission',
        [VoucherTypeIds.COLLECTIONCOMMISSIONSURVEILLANCE]: 'Inkassokommission (övervakning)',
        [VoucherTypeIds.COLLECTIONCOMMISSIONCLIENTDEPOSIT]: 'Inkassokommission (klientdeposition)',
        [VoucherTypeIds.JURIDISKBISTAND]: 'Juridiskt bistånd',
        [VoucherTypeIds.ENDCASEFEE]: 'Avgift för avslut av ärende',
        [VoucherTypeIds.STARTCASEFEE]: 'Avgift för start av ärende',
        [VoucherTypeIds.BPKFEE]: 'BPK-avgift',
        [VoucherTypeIds.FOGEDFEE]: 'Fogedrekvisitionsavgift',
        [VoucherTypeIds.DEBTREGISTERREGISTRATIONFEE]: 'Skuldregister-registreringsavgift',
        [VoucherTypeIds.BPKDISBURSEMENT]: 'Utgifter för skriftlig befallning',
        [VoucherTypeIds.POLICEDISBURSEMENT]: 'Utgifter för polisframställning',
        [VoucherTypeIds.FOGEDDISBURSEMENT]: 'Utgifter för fogedrekvisition',
        [VoucherTypeIds.COURTCLAIMCOSTWITHOUTCIVILCOURT]: 'Rättegångskostnader utan civilrätt',
        [VoucherTypeIds.COURTCLAIMSALARY]: 'Rättegångslön',
        [VoucherTypeIds.VAT]: 'Moms',
        [VoucherTypeIds.BAILIFFSFEE]: 'Fogdeavgift',
        [VoucherTypeIds.BAILIFSSALARY]: 'Fogdelön',
        [VoucherTypeIds.POLICEPRESENTATIONFEE]: 'Polisframställningsavgift',
        [VoucherTypeIds.COURTCLAIMCOSTWITHBAILIFFSCOURT]: 'Rättegångskostnader med fogderätt',
        [VoucherTypeIds.CIVILCOURTCOST]: 'Kostnad för civilrätt',
        [VoucherTypeIds.FOGEDREKVISITIONSFEE]: 'Fogedrekvisitionsavgift',
        [VoucherTypeIds.WRITFEE]: 'Skriftlig avgift',
        [VoucherTypeIds.WRITSALARY]: 'Skriftlig lön',
        [VoucherTypeIds.GAELDSBREV]: 'Lån',
        [VoucherTypeIds.SETTLEMENT]: 'Förlikning',
        [VoucherTypeIds.FIXEDINTEREST]: 'Fast ränta',
        [VoucherTypeIds.DEPOSITPAYOUT]: 'Uttag av deposition',
        [VoucherTypeIds.FOLKEREGISTEROPSLAG]: 'Folkbokföringsuppslag',
        [VoucherTypeIds.ANMELDELSEAFKRAV]: 'Anmälan av krav',
        [VoucherTypeIds.MeetingFee]: 'Mötesavgift',
        [VoucherTypeIds.STAEVNINGSGEBYR]: 'Skriftlig avgift',
        [VoucherTypeIds.BERAMMELSESAFGIFT]: 'Bokningsavgift',
        [VoucherTypeIds.AFLYSNINGAFUDLAEG]: 'Aflysning av utlägg',
        [VoucherTypeIds.LOCKSMITHFEE]: 'Låssmedsavgift',
        [VoucherTypeIds.DRIVINGFEE]: 'Körkostnader',
        [VoucherTypeIds.OTHERFEE]: 'Övriga avgifter',
        [VoucherTypeIds.REFUND]: 'Återbetalning',
        [VoucherTypeIds.JOINTDEPOSIT]: 'Solidarisk betalning',
        [VoucherTypeIds.SEPROCESSINTEREST]: 'Dröjsmålsränta',
        [VoucherTypeIds.SEKRONOFOGDENAPPLICATIONFEE]: 'Ansökningsavgift (Kronofogden)',
        [VoucherTypeIds.SEKRONOFOGDENREPRESENTATIONFEE]: 'Ombudsarvode (betalningsföreläggande)',
        [VoucherTypeIds.NOLATEINTEREST]: 'Dröjsmålsränta (Norge)',
        [VoucherTypeIds.NOFORLIKSRADFEE]: 'Rättsavgift (förlikningsrådet)',
        [VoucherTypeIds.NOLEGALCOLLECTIONFEE]: 'Tungt inkassoarvode (rättslig)',
    },
    transactionAccounts: {
        transactionAccount: 'bankkonto',
        name: 'Kontonamn',
        referenceId: 'Referensnr.',
        edit: 'Redigera konto',
        bankAccountsPlaceholder: 'Bankkontots namn',
        add: 'Lägg till bankkonto',
    },
    connectionReasons: {
        someoneAddedTheFollowingVouchers: 'lade till följande verifikat',
        addedTheFollowingVouchers: 'Följande verifikat lades till',
        someoneDeletedTheFollowingVouchers: 'raderade följande verifikat',
        deletedTheFollowingVouchers: 'Följande verifikat raderades',
        thatResultedIn: 'Det resulterade i denna avräkning',
    },
    economyDownloadPostings: {
        postingReference: 'Bilags-id',
        creditorReference: 'Borgenärsreferens',
        transactionId: 'Transaktions-ID',
        type: 'Typ',
        ofVoucher: 'Av verifikat',
        date: 'Datum',
        currency: 'Valuta',
        amount: 'Belopp',
        accountType: 'Kontotyp',
        account: 'Konto',
    },
    systemTankHandles: {
        DEPOSITS: 'Inbetalningar',
    },
    billingModels: {
        name: 'Namn',
        preventNegativeCreditorBalance: 'Förhindra negativt borgenärssaldo',
        moreSettings: 'Fler inställningar',
        forceCollectionCommissionBilling: 'Tvinga automatisk avräkning av inkassoprovision – även före inbetalningar.',
        forceCollectionCommissionBillingVoucherTypeId: 'Välj verifikattyp för avräkning',
        selectSeparateFeeVoucherType: 'Avräkna inkassoprovision separat',
        selectVouchersGroup: 'Välj verifikat',
        systemConnector: 'Systemavräkningsmodell',
        tenantConnector: 'Skapad avräkningsmodell',
        voucherCategory: 'Verifikatkategori',
        voucherType: 'Verifikattyp',
        allVouchers: 'Alla verifikat',
        categoriesOrTypesFilter: 'Välj verifikat som ska avräknas',
        caseTagFilter: 'Filtrera ärenden',
        caseTagSurveillanceFilter: 'Endast bevakning',
        caseTagCompanyFilter: 'Endast företagsärenden',
        caseTagPrivateFilter: 'Endast privatärenden',
        voucherTagFilter: 'Avräkna efter vem som påfört',
        imposedByCollector: 'Påfört av inkassobolag',
        imposedByCreditor: 'Påfört av borgenär',
        feeFraction: 'Avräkna en del av verifikatet',
        feeFractionPlaceholder: 'Del av verifikatet',
        addShare: 'Lägg till ytterligare avräkningsfilter',
        byVoucherCategory: 'Efter verifikatkategori',
        byVoucherType: 'Efter verifikattyp',
        createBillingModel: 'Skapa avräkningsmodell',
        simulateBilling: 'Simulera avräkning',
        simulateCompany: 'Simulera ett företag',
        simulateSurveillance: 'Simulera bevakning',
        simulateAmount: 'Inbetalningsbelopp',
        previewBillingModel: 'Förhandsgranska avräkningsmodell',
        selectBillingModel: 'Välj avräkningsmodell',
        searchBillingModels: 'Sök avräkningsmodeller',
    },
    billingAppendixSetups: {
        tenantBillingAppendixSetup: 'Skapad uppsättning',
        systemBillingAppendixSetup: 'Systemuppsättning',
        name: 'Namn',
        billingAppendixSetups: 'Uppsättningar för avräkningsbilagor',
        noBillingAppendixSetupsToShow: 'Inga uppsättningar att visa',
        newBillingAppendixSetup: 'Ny uppsättning för avräkningsbilaga',
        addBillingAppendixSetup: 'Skapa uppsättning för avräkningsbilaga',
        billing: 'Avräkna',
        createNew: 'Skapa uppsättning',
        addNewSetup: 'Lägg till uppsättning',
        appendixHandle: 'Bilagenamn',
        hideFromCreditor: 'Dölj avräkningar av denna bilagstyp på borgenärswebben',
        includeVatInDepositShare: 'Inkludera moms i inkassoprovisionen i inbetalningstabeller',
        selectBillingAppendixSetup: 'Välj uppsättning för avräkningsbilaga',
        searchBillingAppendixSetups: 'Sök uppsättningar för avräkningsbilaga',
        previewBillingAppendixSetup: 'Förhandsgranska uppsättning för avräkningsbilaga',
        autoBilling: 'Automatisk avräkning',
        autoBillingDescription: 'Generera avräkningen automatiskt enligt ett fast schema. När avstängd skapas avräkningen manuellt.',
        autoBillingOff: 'Avstängd',
        selectAllVoucherTypes: 'Välj alla verifikattyper',
    },
    billingAppendixSetupTimings: {
        [Timing.Manual]: 'Manuell avräkning',
        [Timing.ASAP]: 'Dagligen',
        [Timing.OnCaseEnd]: 'Efter ärendeavslut',
        [Timing.Weekly]: 'Veckovis',
        [Timing.Monthly]: 'Månadsvis',
        [Timing.Quarterly]: 'Kvartalsvis',
    },
    autoBillingTimings: {
        [AutoBillingTiming.Weekdays0700]: 'Vardagar kl. 07:00',
    },
    caseVoucherStates: {
        [State.Unmapped]: 'Ej mappad',
        [State.Unknown]: 'Okänd',
        [State.Archived]: 'Arkiverad',
        [State.Overpayment]: 'Överbetalning',
        [State.FullPayment]: 'Full betalning',
        [State.PartialPayment]: 'Delbetalning',
        [State.PaymentPlanEntryPayment]: 'Avbetalning',
        [State.UnkownPaymentPlanPayment]: 'Okänd betalningsplan',
        [State.AccordPayment]: 'Ackordsbetalning',
        [State.PrincipalPayment]: 'Kapitalbetalning',
        [State.Pending]: 'Väntande',
    },
    caseVoucherSources: {
        [CaseVoucherSource.Collector]: 'Inkassobolag',
        [CaseVoucherSource.Creditor]: 'Borgenär',
    },
    depositShareType: {
        [DepositShareType.AdjustmentCredit]: 'Justering - kredit',
        [DepositShareType.AdjustmentDebit]: 'Justering - debet',
        [DepositShareType.Deposit]: 'Inbetalning',
        [DepositShareType.Fee]: 'Inkassoprovision',
    },
    voucherTypeSettings: {
        voucherType: 'Verifikattyp',
        category: 'Kategori',
        vat: 'Moms',
        setting: 'Inställning',
        createNewVoucherType: 'Skapa ny verifikattyp',
        create: 'Skapa',
        interruptsLimitationPeriod: 'Avbryter preskriptionen',
        interruptsLimitationPeriodDesc: 'Betalningar av denna typ startar om skuldens preskriptionstid.',
        customCaseVoucherType: 'Skapade ärendeverifikattyper',
        standardCaseVoucherType: 'Standardärendeverifikattyper',
        customBillingVoucherType: 'Skapade avräkningsverifikattyper',
        standardBillingVoucherType: 'Standardavräkningsverifikattyper',
        caseVoucherType: 'Ärendeverifikattyp',
        caseVoucherTypeDesc: 'Namn på ärendeverifikattyp, kategori och inställning.',
        label: 'Namn',
        noSetting: 'Ingen',
        interstDays: 'Räntedagar',
        interstDaysDesc: 'Dagar per år',
        interestRounding: 'Avrundning',
        interestRoundingDesc: 'När räntan ska avrundas.',
        interestRoundingContent: 'Avrundas till närmaste öre dagligen.',
        interestCompoundingPeriod: 'Räntekapitalisering',
        interestCompoundingPeriodDesc: 'Hur ofta räntan ska läggas till kapitalbeloppet. Kallas även kapitaliseringsperiod.',
        interestCompoundVouchers: 'Kapitaliserade ränteverifikat',
        interestCompoundVouchersDesc: 'Verifikattyper som ska klassificeras som kapitaliserad ränta om de refererar till samma kapitalverifikat.',
        interestFrequency: 'Beräkningsfrekvens',
        interestFrequencyDesc: 'Hur ofta räntan beräknas.',
        interestTable: 'Räntesatstabell',
        interestTableDesc: 'Räntesatstabell',
        interestTableFromDate: 'Från datum',
        interestTableRate: 'Räntesats',
        interestTableAddRate: 'Lägg till räntesats',
        interestTableEditRate: 'Redigera räntesats',
        interestTableSaveRate: 'Spara',
        interestTableCancelEdit: 'Avbryt',
        interestTableDeleteRate: 'Radera räntesats',
        interestTableNoRates: 'Inga räntesatser ännu. Lägg till en för att komma igång.',
        interestTableWarning: 'Ändringar kan påverka befintliga ärenden',
        interestTableWarningDesc: 'Att redigera historiska räntesatser eller lägga till räntesatser med datum före idag kan ändra räntan på befintliga ärenden, avbetalningar i betalningsplaner och redan avslutade ärenden. Fortsätt med försiktighet.',
        editor: 'Verifikatredigerare',
        editorDesc: 'Konfigurera vilka fält som är tillgängliga när verifikat av denna typ skapas, och hur de beter sig.',
        editorGroupInputs: 'Tillgängliga fält',
        editorGroupInputsDesc: 'Välj vilka fält användaren kan fylla i när ett verifikat skapas.',
        editorGroupBehavior: 'Beteende',
        editorGroupBehaviorDesc: 'Hur verifikat av denna typ beter sig när de har skapats.',
        editorGroupVisibility: 'Synlighet',
        editorGroupVisibilityDesc: 'Styr var denna verifikattyp och dess verifikat visas.',
        editorRequired: 'Obligatorisk',
        editorDueDate: 'Förfallodatum',
        editorDueDateDesc: 'Visa ett fält för förfallodatum.',
        editorDefaultAmount: 'Standardbelopp',
        editorDefaultAmountDesc: 'Fyll i beloppsfältet på förhand med detta värde. Lämna tomt för att inaktivera.',
        editorText: 'Fritext',
        editorTextDesc: 'Visa ett textfält för ytterligare anteckningar.',
        editorReferenceId: 'Referens-ID',
        editorReferenceIdDesc: 'Visa ett fält för en extern referensidentifierare.',
        editorReferenceVoucher: 'Referensverifikat',
        editorReferenceVoucherDesc: 'Tillåt att verifikatet kopplas till ett annat verifikat på samma ärende.',
        editorAppendix: 'Bilaga',
        editorAppendixDesc: 'Tillåt att en bilagefil bifogas.',
        editorSource: 'Källväljare',
        editorSourceDesc: 'Låt handläggaren välja om verifikatet påförs av borgenären eller inkassobolaget.',
        editorSourceDefaultCreditor: 'Standard till borgenär',
        editorAmountNegative: 'Tillåt negativt belopp',
        editorAmountNegativeDesc: 'Används för kreditnotor och depositioner där beloppet minskar ärendets saldo.',
        editorAddInterest: 'Lägg automatiskt till dröjsmålsränta',
        editorAddInterestDesc: 'Lägger till ett verifikat för dröjsmålsränta som refererar till detta verifikat.',
        editorShowOnCreditorWeb: 'Visa i borgenärsportalen',
        editorShowOnCreditorWebDesc: 'Synligt för borgenärer i självbetjäningsportalen.',
        editorHideProperties: 'Dölj egenskaper',
        editorHidePropertiesDesc: 'Dölj panelen med verifikategenskaper i redigeraren.',
        editorHideFromAllUsers: 'Dölj för alla användare',
        editorHideFromAllUsersDesc: 'Verifikattypen kommer inte att gå att välja när ett nytt verifikat skapas.',
        billingVoucherType: 'Avräkningsverifikattyp',
        billingVoucherTypeDesc: 'Namn på avräkningsverifikattyp och kategori.',
        editorPayoutToContact: 'Betala ut till kontakt',
        editorPayoutToContactDesc: 'Handläggaren väljer en kontakt med kontouppgifter och en utbetalning till kontakten skapas när verifikatet skapas. Används för leverantörer anlitade för borgenärens räkning, t.ex. en låssmed.',
        editorCreditorDisbursement: 'Fakturera utlägget till borgenären',
        editorCreditorDisbursementDesc: 'Handläggaren kan lägga till beloppet i borgenärsavräkningen med den valda avräkningsverifikattypen. Om det krävs sker det varje gång.',
    },
    voucherTypeSetting: {
        [VoucherTypeSetting.AmountFromTable]: 'Belopp från tabell',
        [VoucherTypeSetting.InterestFromTable]: 'Ränta från tabell',
        [VoucherTypeSetting.CompoundInterest]: 'Ränta på ränta',
        [VoucherTypeSetting.FixedInterest]: 'Fast ränta',
        [VoucherTypeSetting.InterestPercentage]: 'Årsränta',
        [VoucherTypeSetting.TextAsLabel]: 'Text som namn',
        [VoucherTypeSetting.Payment]: 'Betalning',
    },
    compoundingPeriod: {
        [CompoundingPeriod.Daily]: 'Dagligen',
        [CompoundingPeriod.Monthly]: 'Månadsvis',
        [CompoundingPeriod.Quarterly]: 'Kvartalsvis',
    },
    imposeInterestFrequency: {
        [ImposeInterestFrequency.Daily]: 'Dagligen',
        [ImposeInterestFrequency.Monthly]: 'Per påbörjad månad',
    },
    economy: {
        groupPostings: 'Gruppera verifikat i export',
        generalBillingSettings: 'Avräkningsinställningar',
        sendingBillingByEmail: 'Skicka avräkningsbilagor via e-post',
        doNotAttachBillingAppendicesInEmails: 'Bifoga inte avräkningsbilagor i e-post',
        billingModels: 'Avräkningsmodeller',
        tenantBillingModels: 'Dina avräkningsmodeller',
        defaultBillingModels: 'Standardavräkningsmodeller',
        noBillingModelsToShow: 'Inga avräkningsmodeller att visa',
        newBillingModel: 'Avräkningsmodell',
        addBillingModel: 'Lägg till avräkningsmodell',
        billingAppendixSetup: 'Uppsättning av avräkningsbilaga',
        standardPrice: 'standardpris:',
        regNumber: 'Clearingnr.',
        accountNumber: 'Kontonummer',
        pipeFilterSelectVoucherTypes: 'Välj verifikattyper',
        depositFile: 'Depositionsfil',
        caseEconomy: 'Ärendeekonomi',
        costCeilingReached: 'Kostnadstak nått',
        costCeilingReachedDescription: 'Räntor och avgifter på detta ärende är begränsade till kapitalbeloppet.',
        costCeilingExceeded: 'Kostnadstak överskridet',
        costCeilingExceededDescription: 'Avgifter och kostnader på detta ärende överstiger redan i sig själva kostnadstaket.',
        voucherAlreadyExists: 'finns redan på ärendet',
        histItemHeader: 'Ekonomi',
        sum: 'Summa',
        voucherType: 'Verifikattyp',
        account: 'Konto',
        referenceId: 'Referens-ID',
        text: 'Beskrivning',
        amount: 'Belopp',
        originalAmount: 'Ursprungligt belopp',
        amountAfterWriteOffs: 'Belopp efter avskrivningar',
        date: 'Datum',
        addAppendix: 'Lägg till bilaga',
        referenceVoucher: 'Referensverifikat att beräkna ränta på',
        selectReferenceVoucher: 'Välj referensverifikat',
        interestRate: 'Räntesats',
        interestAmount: 'Räntebelopp',
        interest: 'Ränta',
        dueDate: 'Förfallodatum',
        expirationDate: 'Preskriptionsdatum',
        expirationFromDate: 'Särskilt startdatum för preskription',
        expirationManualSet: 'Preskriptionsdatum manuellt satt',
        expiredAmount: 'Preskriberat belopp',
        irrecoverableAmount: 'Oindrivbart belopp',
        cannotMoveWrittenOffVoucher: 'Verifikatet är helt eller delvis preskriberat eller oindrivbart och kan inte flyttas till detta ärende',
        interestStartDate: 'Startdatum för ränta',
        interestStartDays: 'Dagar innan ränta börjar löpa',
        interestEndDate: 'Slutdatum för ränta',
        imposedByCreditor: 'Påförd av borgenär',
        debtIrrecoverable: 'Ej indrivningsbar',
        debtExpied: 'Preskriberad',
        markExpired: 'Preskribera och avsluta ärende',
        markSomeExpired: 'Preskribera',
        markSomeExpiredPostings: 'verifikat',
        sureYouWantToMarkExpired: 'Är du säker på att du vill markera verifikat som preskriberade?',
        voucherCreationCreate: 'Skapa',
        voucherCreationIncludeInterest: 'Lägg till ränta',
        voucherCreationCreditorDeposit: 'Deposition till borgenär',
        addDisbursementToBilling: 'Fakturera utlägget till borgenären',
        disbursementAddedToBilling: 'Utlägget faktureras borgenären',
        caseVoucherInfoType: 'Typ',
        caseVoucherInfoTypeSeeDetails: 'Se detaljer om ärendets verifikattyp',
        caseVoucherInfoCreatedAt: 'Skapad',
        voucherInfoId: 'Verifikat-id',
        voucherInfoCreatedBy: 'Skapad av',
        caseVoucherInfoCategory: 'Kategori',
        caseVoucherInfoState: 'Status',
        caseVoucherInfoHeaderTheVoucher: 'Ärendets verifikat',
        caseVoucherInfoHeaderMeta: 'Information',
        caseVoucherInfoHeaderInterest: 'Ränta',
        voucherInfoText: 'Text',
        voucherInfoAmount: 'Belopp',
        voucherInfoCasePreview: 'Ärende',
        voucherInfoMoveToCase: 'Ärendets verifikat flyttat till ärende',
        voucherInfoCreditorName: 'Borgenär',
        voucherInfoAppendix: 'Bilaga',
        voucherInfoRefVoucher: 'Referensverifikat',
        voucherInfoInterestHis: 'Räntehistorik',
        voucherInfoIfrom: 'Från',
        voucherInfoITo: 'Till',
        voucherInfoIInterval: 'Intervall',
        voucherInfoIRVA: 'Referensverifikatets belopp',
        voucherInfoICompoundedAmount: 'Kapitaliserat belopp',
        voucherInfoIDays: 'dagar',
        voucherInfoIReapplied: 'Återpåförd',
        voucherInfoInterestPeriods: 'Ränteperioder',
        voucherInfoInterestPeriodFrozen: 'Räntefri',
        voucherInfoInterestPeriodVoided: 'Återpåförd',
        voucherInfoInterestPeriodOpenEnded: 'Öppen',
        voucherInfoDistributedOnto: 'Fördelad på',
        voucherInfoDistributionsReceived: 'Täckt av',
        voucherInfoDistributionVoucher: 'Verifikat',
        voucherInfoDistributionAmount: 'Belopp',
        voucherInfoDistributionType: 'Typ',
        voucherInfoDistributionFixed: 'Fast',
        voucherInfoDistributionAutomatic: 'Automatisk',
        voucherInfoDistributionBilling: 'Fast (avräkning)',
        voucherInfoDistributionRemaining: 'Återstående',
        voucherInfoDeleteFixedDistribution: 'Ta bort fast fördelning',
        voucherInfoEditFixedDistribution: 'Redigera fast fördelning',
        voucherInfoConfirmDeleteFixedDistribution: 'Är du säker på att du vill ta bort denna fasta fördelning?',
        voucherInfoFixedDistributionSave: 'Spara',
        voucherInfoFixedDistributionJointInfo: 'Denna ändring påverkar även tillhörande betalningar på andra ärenden',
        voucherInfoAllocatePayment: 'Fördela betalning',
        voucherInfoAllocatePaymentTarget: 'Fördela till verifikat',
        voucherInfoDistributionDynamic: 'Beräknad',
        voucherInfoDistributionUnallocated: 'Ofördelad',
        voucherInfoEditDistributions: 'Redigera fördelningar',
        voucherInfoDistributionDateFromOriginal: 'Datum från original',
        voucherInfoDistributionDateFromApplied: 'Datum från tillämpad',
        voucherInfoCreateCounterEntry: 'Skapa motpost',
        voucherInfoConfirmCounterEntry: 'Är du säker på att du vill skapa en motpost för detta verifikat?',
        voucherInfoCounterEntryAmount: 'Motpostens belopp',
        voucherInfoDeleteVoucher: 'Radera verifikat',
        voucherDeleteHasFixedDistributions: 'Detta verifikat har fasta fördelningar. Vill du ta bort dem och radera verifikatet?',
        voucherDeleteHasFixedDistributionsWithJoint: 'Detta verifikat har fasta fördelningar. Radering tar även bort tillhörande betalningar på andra ärenden. Fortsätta?',
        voucherInfoMarkVoucherExpired: 'Markera preskriberad',
        voucherInfoUnmarkVoucherExpired: 'Avmarkera preskriberad',
        voucherInfoMarkVoucherIrrecoverable: 'Ej indrivningsbar',
        voucherInfoRestoreVoucher: 'Återställ verifikat',
        currency: 'Valuta',
        billingModel: 'Avräkningsmodell',
        aggregation: 'Sammanräkning',
        postings: 'Bokföringsposter',
        bookkeepingMapping: 'Mappa bokföringskonton',
        bookkeepingMappingBase: 'Allmänt',
        bookkeepingMappingFees: 'Avgifter',
        bookkeepingMappingDisbursements: 'Utlägg',
        bookkeepingMappingAccount: 'Konto',
        bookkeepingMappingAccountType: 'Kontotyp',
        bookkeepingMappingReverse: 'Vänd belopp',
        bookkeepingMappingExclude: 'Uteslut',
        bookkeepingMappingIncludeVat: 'Inkludera moms',
        bookkeepingMappingContraAccountOn: 'Motverifikat',
        bookkeepingMappingContraAccount: 'Motkonto',
        bookkeepingMappingContraAccountType: 'Motkontotyp',
        bookkeepingMappingCreditorReferenceId: 'Borgenärens referens-id',
        bookkeepingMappingBankOrPSP: 'Bank eller inlösare',
    },
    economyAppendixHeaders: {
        type: 'Typ',
        date: 'Datum',
        voucherId: 'Verifikat-id',
        voucherType: 'Verifikattyp',
        text: 'Text',
        amount: 'Belopp',
        currency: 'Valuta',
    },
    caseVoucherTags: {
        [CaseVoucherTags.IMPOSEDBYCOLLECTOR]: 'Påförd av inkassobolag',
        [CaseVoucherTags.IMPOSEDBYCREDITOR]: 'Påförd av borgenär',
        [CaseVoucherTags.CREDITORTRANSACTION]: 'Borgenärstransaktion',
        [CaseVoucherTags.ECONOMIC_IMPORT]: 'E-conomic-import',
        [CaseVoucherTags.EXPIRED]: 'Preskriberad',
        [CaseVoucherTags.IRRECOVERABLE]: 'Ej indrivningsbar',
    },
    caseTags: {
        [CaseTag.SURVEILLANCE]: 'Bevakning',
    },
    transactionImports: {
        transactionImportsHeader: 'Transaktionsimporter',
        selectType: 'Välj betalningstyp',
    },
    caseVouchers: {
        source: 'Källa',
        irrecoverableDate: 'Datum för ej indrivningsbar',
        expirationDate: 'Preskriptionsdatum',
        expired: 'Preskriberad',
        case: 'Ärende',
        map: 'Mappa',
        mapHeader: 'Mappa ärendets verifikat till ärende',
        deleteWarning: 'Är du säker på att du vill radera detta verifikat? Denna åtgärd kan inte ångras.',
        exportFileName: 'arendets-verifikat',
        voucherId: 'Verifikat-id',
        voucherReferenceId: 'Verifikatreferens',
        caseId: 'Ärendenummer',
        creditor: 'Borgenär',
        creditorReference: 'Borgenärens referens',
        customerReference: 'Kundreferens',
        account: 'Konto',
        accountId: 'Konto-id',
        bookingDate: 'Bokföringsdatum',
        bookingDateDescription: 'Datumet då inbetalningen bokförs i redovisningen. Betalningsdatumet avgör hur räntan beräknas; bokföringsdatumet avgör vilken redovisningsperiod inbetalningen hör till.',
        bookingDateFollowsDate: 'Följer betalningsdatumet',
        setBookingDate: 'Ange bokföringsdatum',
        setBookingDateDescription: 'Ange datumet då de valda inbetalningarna bokförs i redovisningen. Använd det när en avräkning från en inlösare når banken senare än själva betalningarna.',
        clearBookingDate: 'Rensa, följ betalningsdatumet',
    },
    payouts: {
        caseSeqId: 'Ärende-id',
        caseReferenceId: 'Ärendereferens',
        billingId: 'Avräknings-id',
        court: 'Domstol',
        type: 'Typ',
        account: 'Konto',
        creditorReference: 'Borgenärens referens',
        text: 'Text',
        state: 'Status',
        amount: 'Belopp',
        currency: 'Valuta',
        createdAt: 'Skapad',
        updatedAt: 'Uppdaterad',
        complete: 'Slutförd',
        completeOnExport: 'Markera slutförd vid export',
        exportFileName: 'utbetalningar',
    },
    payoutState: {
        [PayoutState.Completed]: 'Slutförd',
        [PayoutState.Created]: 'Skapad',
        [PayoutState.DataUpdated]: 'Data uppdaterad',
        [PayoutState.Failed]: 'Misslyckad',
        [PayoutState.Initiated]: 'Initierad',
    },
    payoutType: {
        [PayoutType.CourtFee]: 'Domstolsavgift',
        [PayoutType.CreditorReceivables]: 'Borgenärens tillgodohavanden',
        [PayoutType.Other]: 'Annan',
        [PayoutType.Overpayment]: 'Överbetalning',
    },
    clientBilling: {
        clientBilling: 'Borgenärsavräkning',
        isAdjustment: 'Justering',
        billings: 'Avräkningar',
        seeDetails: 'Se detaljer om borgenärsavräkning',
        seeDetailsCreditor: 'Se avräkningsdetaljer',
        fetchingUpdatedEconomy: 'Hämtar uppdaterad information',
        deposits: 'Depositioner',
        fees: 'Avgifter',
        disbursements: 'Utlägg',
        showPerDeposit: 'Visa per deposition',
        voucherType: 'Verifikattyp',
        original: 'Ursprunglig',
        paid: 'Betald',
        residue: 'Restbelopp',
        collector: 'Inkassobolag',
        creditor: 'Borgenär',
        overpayment: 'Överbetalning',
        text: 'Text',
        addVoucher: 'Lägg till verifikat',
        otherPayments: 'av andra depositioner.',
        noVouchers: 'Inga verifikat',
        hoursOf: 'timmar à',
        hourOf: 'timme à',
        hourlyRateOn: 'Debitera timtaxa',
        hourlyRate: 'Timtaxa',
        hourlyRateHours: 'Timmar',
        hourlyRateMinutes: 'Minuter',
    },
    search: {
        migratedId: 'Migrerat ärendenr.',
        noResults: 'Inga resultat',
        voucherReferenceId: 'Verifikat-id',
        cvr: 'CVR',
        cpr: 'CPR',
        phone: 'Telefon',
    },
    deposits: {
        customizeExport: 'Anpassa export',
        selectedExportHint: 'Endast de markerade bokföringsposterna',
        filteredExportHint: 'Alla resultat från tabellens filter · max 10 000',
        exportEditorDescription: 'Välj fält till vänster och anpassa filens kolumner till höger.',
        exportFormat: 'Filformat',
        standardExportColumns: 'Standardfält',
        availableExportColumns: 'Tillgängliga fält',
        searchExportColumns: 'Sök efter fält eller attribut…',
        exportColumnHint: 'Dra för att ändra ordning. Klicka på ett namn för att byta namn.',
        exportColumnName: 'Kolumnnamn',
        chooseExportColumns: 'Välj fält till vänster för att skapa din export.',
        resetExportColumns: 'Återställ standard',
        saveExportSettings: 'Spara inställningar',
        exportStoredLocally: 'Personliga inställningar · sparas på den här enheten',
        exportSettings: 'Exportera betalningar',
        exportFiltered: 'Filtrerade bokföringsposter',
        exportSelected: 'Valda bokföringsposter',
        exportLimit: 'Exportera upp till 10 000 betalningar med tabellens filter. Begränsa filtren om det finns fler resultat.',
        markAsExported: 'Markera bokföringsposter som exporterade',
        exportColumns: 'Exportkolumner',
        addExportColumn: 'Lägg till kolumn',
        moveColumnUp: 'Flytta kolumn uppåt',
        moveColumnDown: 'Flytta kolumn nedåt',
        removeExportColumn: 'Ta bort kolumn',
        pickPaymentType: 'Välj betalningstyp',
        unknownDeposit: 'Okända depositioner',
        unknownDepositSubHeader: 'Kunde inte identifiera deposition',
        archive: 'Arkiv',
        exportDesc: 'Export av depositioner från bank eller PSP (kredit-/betalkort osv.)',
        unknownDesc: 'Här är en lista över okända depositioner.',
        transactionLookUpDesc: 'Här kan du slå upp depositioner via transaktions-id.',
        transactionLookUpPlaceholder: 'Ange transaktions-id (till exempel: 12341234)',
        transactionLookUpNotFound: 'Transaktionen hittades inte.',
        transactionLookUpNotDeposit: 'Transaktionen är inte en deposition.',
        transactionLookUpButton: 'Slå upp',
        transactionLookUpDeposit: 'Deposition',
        downloadSample: 'Ladda ner exempel',
        downloadSampleQuantity: 'Antal depositioner i exempel',
        linkBank: 'Koppla bankkonto',
        selectBankAccount: 'Välj bankkonto',
        dropHere: 'Släpp här',
        upload: 'Registrera depositioner',
        deposits: 'Depositioner',
        map: 'Registrera depositioner',
        handleTransaction: 'Hantera deposition',
        addSingleDepositHeader: 'Lägg till enskild deposition',
        addSingleDepositPaymentType: 'Betalningstyp',
        addSingleDepositDate: 'Datum',
        addSingleDepositText: 'Text',
        addSingleDepositAmount: 'Belopp',
        addSingleDepositAddAndClose: 'Lägg till och stäng',
        addSingleDepositAddAndClear: 'Lägg till och rensa',
    },
    depositsPaymentTypes: {
        [PaymentType.Mastercard]: 'MasterCard',
        [PaymentType.Swish]: 'Swish',
        [PaymentType.Vipps]: 'Vipps',
        [PaymentType.Visa]: 'Visa',
        [PaymentType.Dankort]: 'Dankort',
        [PaymentType.MobilePay]: 'MobilePay',
        [PaymentType.Betalingsservice]: 'Betalingsservice',
        [PaymentType.Leverandørservice]: 'Leverandørservice',
        [PaymentType.BankTransfer]: 'Banköverföring',
        [PaymentType.FIK]: 'FIK',
        [PaymentType.IBAN]: 'IBAN',
        [PaymentType.Creditor]: 'Borgenär',
        [PaymentType.PayPal]: 'PayPal',
        [PaymentType.ApplePay]: 'Apple Pay',
        [PaymentType.GooglePay]: 'Google Pay',
    },
    caseVoucherEvents: {
        header: 'Ändringar på inbetalningar',
        desc: 'Allt som har hänt med de inbetalningar vi har tagit emot på våra konton. Exportera ändringarna för att bokföra dem — de markeras som exporterade, så samma ändring bokförs aldrig två gånger.',
        eventId: 'Ändrings-id',
        eventType: 'Ändring',
        eventDate: 'Tidpunkt för ändring',
        performedByType: 'Utförd av typ',
        performedById: 'Utförd av id',
        fromCase: 'Från ärende',
        toCase: 'Till ärende',
        fromCreditor: 'Från borgenär',
        fromCreditorReference: 'Från borgenärsreferens',
        exported: 'Exporterad',
    },
    caseVoucherEventTypes: {
        [CaseVoucherEventType.Created]: 'Skapad',
        [CaseVoucherEventType.Booked]: 'Bokförd på ärende',
        [CaseVoucherEventType.Moved]: 'Flyttad till annat ärende',
        [CaseVoucherEventType.Unbooked]: 'Avbokförd från ärende',
        [CaseVoucherEventType.Deleted]: 'Raderad',
        [CaseVoucherEventType.Restored]: 'Återställd',
    },
    billingReasons: {
        caseVoucherInlineDeleted: 'Verifikat (raderat senare)',
        caseVoucherPatchedCaseId: 'kopplades till ärendet',
        caseVoucherPatched: 'redigerades',
        caseVoucherCreated: 'tillagt på ärendet',
        caseVoucherDeleted: 'raderat från ärendet',
        billingModelChanged: 'Avräkningsmodell ändrad',
        billingStartDateChanged: 'Startdatum för avräkning ändrat',
    },
    billing: {
        ongoingWork: 'Pågående arbete',
        bills: 'Fakturor',
        billingSequentialId: 'Id',
        case: 'Ärende',
        date: 'Datum',
        type: 'Typ',
        text: 'Text',
        customerReferenceId: 'Kundref.',
        revenue: 'Avgifter',
        vat: 'Moms',
        payout: 'Utbetalning',
        disbursements: 'Utlägg',
        overpayments: 'Överbetalningar',
        balance: 'Saldo',
        amount: 'Belopp',
        deposits: 'Depositioner',
        deposit: 'Deposition',
        depositShareTooLongForPDF: 'Specifikationen av depositioner ingår inte i PDF:en eftersom denna avräkning har mer än 100 depositioner. Summan av depositionerna ingår dock fortfarande.',
        bill: 'Faktura',
        delete: 'Ta bort',
        deleteApproval: 'Är du säker på att du vill ta bort verifikaten från avräkningen? Åtgärden kan inte ångras.',
        adjustments: 'Justeringar',
        billingPrevented: 'Uppskjutna avräkningar',
        billingStartDate: 'Starta avräkning från',
        appendix: 'Bilaga',
        readyForBilling: 'Klar för avräkning',
        awaitingCaseEnd: 'Väntar på ärendeavslut',
        appendixMissing: 'Bilaga saknas',
        billSelected: 'Fakturera valda',
        addBillingVoucher: 'Lägg till verifikat',
        recipient: 'Mottagare',
        billingSent: 'Skickad',
        sendBilling: 'Skicka',
        information: 'Information',
        addedToPayouts: 'Tillagd i utbetalningar',
        addToPayouts: 'Lägg till i utbetalningar',
        invoiceNo: 'Fakturanr.',
        specifiedByBankTransfer: 'bör anges vid banköverföring',
        paymentTerms: 'Betalningsvillkor: Netto',
        daysAndBillingDate: 'dagar - Betalningsdatum',
        billingAlreadySentAlert: 'Bilagan har redan skickats. Är du säker på att du vill skicka den igen?',
        amountWillBeWithdrawnToAccount: 'dras till konto',
        amountShouldBePaidToAccount: 'betalas till konto',
        preview: 'Förhandsvisning',
        PDFPreview: 'PDF',
        ExcelPreview: 'Excel',
        forPayout: 'För utbetalning',
        collectionCommission: 'Inkassoprovision',
        fees: 'Avgifter',
        otherVat: 'Övrig moms',
        subtotal: 'Delsumma',
        total: 'Totalt',
        billingCollectionBillingSequentialId: 'Id',
        billingCollectionBillingDate: 'Datum',
        billingCollectionBillingAddedToPayouts: 'Tillagd i utbetalningar',
        billingCollectionBillingSent: 'Skickad',
        billingCollectionBillingBalance: 'Saldo',
        billingsAppendix: 'Bilaga',
        billingsType: 'Typ',
        billingsCreditor: 'Borgenär',
        billingsCases: 'Ärenden',
        billingsCurrency: 'Valuta',
        generateAppendix: 'Generera bilaga',
        awaitingGeneration: 'Bilagor klara att genereras',
        warnThisWillAffectBilling: 'Denna åtgärd påverkar redan avräknade depositioner. Är du säker på att du vill fortsätta?',
        deletionWarning: 'Är du säker på att du vill radera denna avräkning? Åtgärden kan inte ångras. Observera att radering inte tar hänsyn till justeringar – dessa måste hanteras manuellt. Vidare tas det inte hänsyn till om avräkningen redan har skickats eller bokförts.',
    },
    creditorBilling: {
        newBillingFrom: 'Ny avräkning från',
        dear: 'Bäste',
        herebyForwarded: 'Härmed översänds:',
        seeAttached: 'Se bifogad fil.',
    },
    bookkeeping: {
        settleAll: 'Avräkna alla borgenärer',
        preview: 'Förhandsvisning',
        type: 'Typ',
        date: 'Datum',
        text: 'Text',
        amount: 'Belopp',
        account: 'Konto',
        contraAccount: 'Motkonto',
        debtorVoucher: 'Gäldenärspostering',
        showMoreVouchers: 'Visa fler verifikat',
        showing: 'Visar',
        of: 'av',
        vouchers: 'verifikat',
        exportNdownload: 'Exportera och ladda ner',
        history: 'Historik',
        noHistorical: 'Inga historiska poster ännu',
        erpIntegrationHeader: 'Integration med bokföringssystem',
        accounts: 'Konton',
        revenuePlaceholder: 'Omsättning',
        outlayPlaceholder: 'Utlägg',
        erpVendor: 'ERP-leverantör:',
        makeSureThat: 'Se till att:',
        creditorReferenceIdsMatch: 'Borgenärernas referens-id matchar kundernas i e-conomic',
        bankAccountReferenceIdsMatch: 'Bank- och PSP-kontonas referens-id matchar kontona i e-conomic',
        activeAccountingYear: 'Det finns ett aktivt räkenskapsår',
        connectEconomic: 'Anslut e-conomic',
    },
    sites: {
        caseworkerWeb: 'Handläggarwebb',
        clientWeb: 'Borgenärswebb',
        detiorWeb: 'Gäldenärswebb',
    },
    blameLogs: {
        overview: 'Översikt',
        userVisits: 'Användarbesök',
        debtorUpdates: 'Gäldenärsändringar',
        economy: 'Ekonomi',
        interactions: 'Interaktioner',
        noEntries: 'Inga poster',
        blameLog: 'Handlingslogg',
        logged: 'Åtgärd',
        ago: 'sedan',
        type: 'Typ',
        content: 'Innehåll',
        subject: 'Ämne',
        stepTitle: 'Stegtitel',
        chainTitle: 'Arbetsflödestitel',
        viewLetter: 'Visa brev',
        phoneNumber: 'Telefonnummer',
        label: 'Etikett',
        workflow: 'Arbetsflöde',
        fromWorkflow: 'Bytte från arbetsflöde',
        toWorkflow: 'Till arbetsflöde',
        noLogs: 'Inga loggar ännu',
        settings: 'Inställningar',
        toggled: 'Växlade till',
        trueActivated: 'aktiverad',
        falseActivated: 'inaktiverad',
        key: 'Nyckel',
        code: 'Kod',
        username: 'Användarnamn',
        password: 'Lösenord',
        trueChanged: 'Ändrad',
        falseChanged: 'Oförändrad',
        experianClientId: 'Experian klient-ID',
        to: 'till',
        when: 'När',
        procedure: 'Genväg',
        removed: 'Borttagen',
        other: 'Övriga åtgärder',
        description: 'Beskrivning',
        note: 'Anteckning',
        createdAt: 'Skapad',
        trueYes: 'Ja',
        falseNo: 'Nej',
        dunning: 'Dunning',
        connectorBillingModel: 'Faktureringsmodell',
        cleared: 'Borttagen',
        newValue: 'Nytt värde',
        caseSeqId: 'Ärendenummer',
        previousStatus: 'Föregående status',
        reason: 'Orsak',
        direction: 'Riktning',
        mergedTo: 'Sammanslagen till',
        mergedFrom: 'Sammanslagen från',
        fromCase: 'Från ärende',
        toCase: 'Till ärende',
        fromVoucher: 'Från verifikat',
        toVoucher: 'Till verifikat',
        fromStatus: 'Från status',
        toStatus: 'Till status',
        entriesCount: 'Antal poster',
        activationTrigger: 'Aktivering utlöst',
        tribunalType: 'Ärendetyp',
        jobType: 'Åtgärd',
        documentType: 'Dokumenttyp',
        fileName: 'Filnamn',
        signedAt: 'Signerad',
        signedBy: 'Signerad av',
        source: 'Källa',
        successCount: 'Lyckades',
        updatedCount: 'Uppdaterade',
        failedCount: 'Misslyckades',
        dateUpdated: 'Datum',
        fileUploaded: 'Fil uppladdad',
        costsRegistered: 'Kostnader',
        meetingStateChanged: 'Status',
        noteUpdated: 'Anteckning uppdaterad',
        caseLifecycle: 'Ärendets livscykel',
        paymentPlans: 'Betalningsplaner',
        tribunal: 'Domstol',
    },
    blameLogSimplfiedType: {
        [BlameLogType.CaseVisit]: 'Ärendebesök',
        [BlameLogType.CaseVoucherCreate]: 'Verifikat skapat',
        [BlameLogType.CaseVoucherDelete]: 'Verifikat raderat',
        [BlameLogType.CaseVoucherRestore]: 'Verifikat återställt',
        [BlameLogType.UnknownCaseVoucherMapped]: 'Okänd deposition kopplad till ärende',
        [BlameLogType.CaseVoucherPatch]: 'Verifikat uppdaterat',
        [BlameLogType.UserOnCustomerVisit]: 'Kundbesök',
        [BlameLogType.CreditorVisit]: 'Borgenärsbesök',
        [BlameLogType.VisitedBy]: 'Besök',
        [BlameLogType.CaseVoucherIrrecoverable]: 'Verifikat oindrivbart',
        [BlameLogType.CaseVoucherExpired]: 'Verifikat utgånget',
        [BlameLogType.InteractionCreate]: 'Interaktion skapad',
        [BlameLogType.InteractionDelete]: 'Interaktion raderad',
        [BlameLogType.WorkflowRollback]: 'Återställning av arbetsflöde',
        [BlameLogType.InteractionHideFromClient]: 'Interaktion dold för borgenär',
        [BlameLogType.InteractionMappedToCase]: 'Interaktion kopplad till ärende',
        [BlameLogType.InteractionUnmappedFromCase]: 'Interaktion frånkopplad från ärende',
        [BlameLogType.InteractionRollback]: 'Återställning av interaktion',
        [BlameLogType.DebtorWebLoginEId]: 'Gäldenärswebb-inloggning med e-ID',
        [BlameLogType.DebtorUpdateName]: 'Namn ändrat',
        [BlameLogType.DebtorUpdatePhone]: 'Telefon ändrad',
        [BlameLogType.DebtorUpdateAddress]: 'Adress ändrad',
        [BlameLogType.DebtorUpdateEmail]: 'E-post ändrad',
        [BlameLogType.DebtorUpdateCourt]: 'Jurisdiktion ändrad',
        [BlameLogType.DebtorUpdateBirthdate]: 'Födelsedatum ändrat',
        [BlameLogType.DebtorUpdateCVR]: 'CVR ändrat',
        [BlameLogType.DebtorUpdateCPR]: 'CPR ändrat',
        [BlameLogType.AKSConfiguration]: 'AKS-konfiguration',
        [BlameLogType.AutoDebtRegister]: 'Automatisk RKI',
        [BlameLogType.AutoIgnoreUnresolvedOppositions]: 'Ignorera RKI-invändningar',
        [BlameLogType.AutoDeleteDebtRegistrationOnCaseEnd]: 'Radera RKI-registrering automatiskt vid ärendeavslut',
        [BlameLogType.AutoRegisterInOpenRegistry]: 'Öppna RKI',
        [BlameLogType.AKSClientID]: 'Experian klient-id',
        [BlameLogType.RKIOveride]: 'Åsidosätt automatisk RKI',
        [BlameLogType.AKSActivated]: 'AKS aktiverad',
        [BlameLogType.PriceList]: 'Prislista',
        [BlameLogType.UserPasswordUpdate]: 'Användarlösenord ändrat',
        [BlameLogType.TriggerShortcut]: 'Utlösarändring',
        [BlameLogType.WorkflowChange]: 'Arbetsflödesändring',
        [BlameLogType.WorkflowChangeOnCase]: 'Arbetsflöde ändrat på ärende',
        [BlameLogType.CaseCreate]: 'Ärende skapat',
        [BlameLogType.CaseDelete]: 'Ärende raderat',
        [BlameLogType.CaseMerge]: 'Ärende sammanslaget',
        [BlameLogType.CaseStatusChange]: 'Ärendestatus ändrad',
        [BlameLogType.CaseJournalNumberChange]: 'Journalnummer ändrat',
        [BlameLogType.CaseCostCeilingAmountChange]: 'Kostnadstaksbelopp ändrat',
        [BlameLogType.CaseCostCeilingEnabledChange]: 'Kostnadstak aktiverat/inaktiverat',
        [BlameLogType.PaymentPlanCreate]: 'Betalningsplan skapad',
        [BlameLogType.PaymentPlanPatched]: 'Betalningsplan uppdaterad',
        [BlameLogType.PaymentPlanDelete]: 'Betalningsplan raderad',
        [BlameLogType.CaseVoucherMoved]: 'Verifikat flyttat',
        [BlameLogType.TribunalCaseCreate]: 'Domstolsärende skapat',
        [BlameLogType.TribunalJobCreate]: 'Domstolsuppgift skapad',
        [BlameLogType.TribunalJobPatch]: 'Domstolsuppgift uppdaterad',
        [BlameLogType.TribunalJobDelete]: 'Domstolsuppgift raderad',
        [BlameLogType.DocumentUpload]: 'Dokument uppladdat',
        [BlameLogType.DocumentDelete]: 'Dokument raderat',
        [BlameLogType.DocumentSigned]: 'Dokument signerat',
        [BlameLogType.ImportCreated]: 'Import skapad',
        [BlameLogType.ImportRun]: 'Import körd',
        [BlameLogType.DeleteUpdate]: 'Uppgift raderad',
        [BlameLogType.ConnectorBillingUpdate]: 'Faktureringsmodell ändrad',
        [BlameLogType.CreditorSettingsUpdate]: 'Borgenärsinställningar ändrade',
        [BlameLogType.BulkAction]: 'Massåtgärd',
        [BlameLogType.FixedDistributionCreate]: 'Fördelning skapad',
        [BlameLogType.FixedDistributionUpdate]: 'Fördelning uppdaterad',
        [BlameLogType.FixedDistributionDelete]: 'Fördelning raderad',
    },
    caseTypes: {
        [CaseType.CLIENT]: 'Borgenärsärende',
        [CaseType.TENANT]: 'Organisationsärende',
    },
    cases: {
        case: 'Ärende',
        customerReferenceId: 'Referensnr.',
        creditor: 'Borgenär',
        debt: 'Ursprungligt',
        deposits: 'Depositioner',
        balance: 'Skuld',
        status: 'Ärendestatus',
        caseVoucher: 'Ärendeverifikat',
        amount: 'Belopp',
        workflow: 'Arbetsflöde',
        responsible: 'Ansvarig',
        showAll: 'Visa alla',
        caseInfo: 'Ärendeinfo',
        cases: 'Ärenden',
        createNewCase: 'Skapa nytt ärende',
        caseOverview: 'Alla ärenden',
        casesLeft: 'Ärenden kvar',
        casePaused: 'Ärende pausat',
        dueDateIsIn: 'Förfallodatum är om',
        days: 'dagar',
        pressCommandOrCtrlToContinue: 'Tryck på command eller control för att även fortsätta ärendet.',
        source: 'Källa',
        sourceClient: 'Ärendet härstammar från detta ärende',
        referenceId: 'Borgenärens referens-id',
        createdAt: 'Skapandedatum',
        caseState: {
            [CaseState.ALL]: 'Alla ärenden',
            [CaseState.ACTIVE]: 'Aktiva ärenden',
            [CaseState.CLOSED]: 'Avslutade ärenden',
        },
        caseStatus: {
            [CaseStatus.VERIFIED]: 'Verifierad',
            [CaseStatus.PENDING]: 'Väntande',
            [CaseStatus.ENDED]: 'Avslutad',
        },
        settings: 'Ärendeinställningar',
        caseSettings: {
            disableDebtorPaymentPlan: 'Inaktivera gäldenärens betalningsplan',
        },
        VERIFIED: 'Verifierad',
        PENDING: 'Väntande',
        ENDED: 'Avslutad',
        dunning: 'Dunning',
        debtCollection: 'Inkasso',
        verify: 'Verifiera',
        end: 'Avsluta',
        reVerify: 'Verifiera igen',
        endCase: 'Avsluta ärende',
        choosEndReason: 'Välj avslutningsorsak',
        caseGroup: 'Ärendegrupp',
        pause: 'Pausa',
        pauseCase: 'Pausa ärende',
        pauseReason: 'Orsak till paus',
        pauseComment: 'Kommentar',
        blameLog: 'Handlingslogg',
        logged: 'Åtgärd',
        ago: 'sedan',
        newCase: 'Skapa nytt ärende',
        caseReferenceId: 'Borgenärens referens-id',
        invoiceId: 'Faktura-ID',
        file: 'Faktura-pdf',
        debtorName: 'Namn',
        address: 'Adress',
        phone: 'Telefonnummer',
        email: 'E-post',
        cpr: 'CPR',
        cvr: 'CVR',
        debtorHaveObjections: 'Gäldenären har invänt',
        isCompany: 'Gäldenären är ett företag',
        theDetails: 'Info',
        theDebt: 'Skulden',
        theDebtor: 'Gäldenär',
        manual: 'Manuellt',
        fromFile: 'Från fil',
        dropFile: 'Släpp fakturan här',
        clickHereToUpload: 'Eller ladda upp',
        addDebt: 'Ny faktura',
        issueDate: 'Fakturans utställningsdatum',
        dueDate: 'Fakturans förfallodatum',
        sendNoteToCollector: 'Skicka meddelande till inkassobolag',
        sendNoteToCollectorButton: 'Skicka',
        note: 'Anteckning',
        caseHasBeenDeleted: 'Ärendet har raderats',
        missingCreateAccess: 'Avtalet har upphört och därför kan inga nya ärenden skapas. Kontakta oss för mer information',
        newCaseCreate: 'Ärendeinfo',
        newCaseEconomy: 'Ekonomi',
        newCaseDone: 'Klar',
        noDebts: 'Inga skulder',
        noDebtsExplainer: "Lägg till skuld med knappen '+'",
        newCaseCreateExplainer: 'Du håller på att skapa ett nytt ärende. Du kan ange kundnumret från ditt system här. Om ärendet är i en annan valuta än danska kan du också välja detta här.',
        newCaseEconomyExplainer: 'Ditt ärende är nu skapat, och nedanför bör ärendets ekonomi läggas till. Om du har skapat ärendet men behöver ångra det rekommenderar vi att du kontaktar oss för radering av ärendet.',
        newCaseCreationWarning: 'När du klickar vidare skapas ärendet i systemet. Om du inte har all information för att skapa ärendet rekommenderas det att du inte fortsätter förrän du har all information om skulden och gäldenären',
        deleteCase: 'Radera ärende',
        sureYouWantToDeleteCase: 'Är du säker på att du vill radera detta ärende?',
    },
    mergeCases: {
        header: 'Slå samman detta ärende med ett annat',
        explanation: 'Slå samman detta ärende med ett annat ärende valt nedan. Verifikat överförs automatiskt till målärendet och detta ärende avslutas med avslutningsorsaken "Ärendet är sammanslaget"',
        searchPlaceholder: 'Sök efter målärende på samma borgenär',
        mergeBtn: 'Slå samman ärenden',
        undoCaseMerge: 'Ångra sammanslagning av ärende',
    },
    customers: {
        party: 'part',
        addParty: 'Lägg till part',
        contact: 'Kontaktperson',
        selectType: 'Välj typ',
        errorEmailValidation: 'Ogiltig e-post',
        errorCPRValidation: 'Ogiltigt CPR',
        errorCVRValidation: 'Ogiltigt CVR',
        noContactSelected: 'Ingen kontaktperson vald',
        noContact: 'Ingen kontakt',
        noRelatedCases: 'Inga relaterade ärenden',
        customer: 'Kund',
        createdAt: 'Skapad',
        casesOnCreditor: 'Ärenden på kund',
        thatIsRelatedTo: 'som är relaterad till kundreferens',
        casesRelatedToCustomerDescription: 'Ärenden matchade på e-post, CPR, CVR eller via externa källor.',
        information: 'Information',
        casesOnCustomer: 'Ärenden på kund',
        relatedCases: 'Relaterade ärenden',
        caseStatus: 'Status',
        relationType: 'Relation',
        creditor: 'Borgenär',
        case: 'Ärende',
        customerHasBeenDeleted: 'Kunden har raderats',
        parties: 'Parter',
        customerReferenceId: 'Kundreferens-id',
        private: 'Privatperson',
        company: 'Företag',
        existingCustomer: 'Befintlig kund',
        backToCase: 'Tillbaka till ärende',
        referenceId: 'Referens-id',
        alternativeContactReferenceId: 'Alternativt kontaktreferens-id',
        secondaryEntityDisabled: 'Inaktiv',
        addSecondaryEmails: 'Lägg till en eller flera sekundära e-postadresser',
        note: 'Valfri anteckning',
        addSecondaryEmail: 'Lägg till sekundär e-post',
        addSecondaryPhones: 'Lägg till ett eller flera sekundära telefonnummer',
        addSecondaryPhone: 'Lägg till sekundärt telefonnummer',
        enabled: 'Aktiv',
        save: 'Spara',
        createNewCaseOnCustomer: 'Lägg till ärende på kund',
        copyCaseIds: 'Kopiera ärendenummer',
        notes: {
            title: 'Anteckningar',
            addNote: 'Lägg till en anteckning',
            noNotes: 'Inga anteckningar',
            edit: 'Redigera',
            save: 'Spara',
            cancel: 'Avbryt',
            delete: 'Radera',
            deleteConfirm: 'Radera denna anteckning?',
            editPlaceholder: 'Anteckningstext',
            noDebtor: 'Ingen gäldenär på denna kund',
        },
    },
    assets: {
        note: 'Anteckning',
        assets: 'Tillgångar',
        realEstate: 'Fastighet',
        vehicles: 'Fordon',
        other: 'Övriga tillgångar',
        noAssets: 'Inga tillgångar registrerade',
        addAsset: 'Lägg till tillgång',
        editAsset: 'Redigera tillgång',
        deleteAsset: 'Radera tillgång',
        confirmDelete: 'Är du säker på att du vill radera denna tillgång?',
        description: 'Beskrivning',
        estimatedValue: 'Uppskattat värde',
        bfeNumber: 'BFE-nummer',
        address: 'Adress',
        zipcode: 'Postnummer',
        city: 'Ort',
        registrationNumber: 'Registreringsnummer',
        brand: 'Märke',
        model: 'Modell',
        variant: 'Variant',
        year: 'År',
        lienType: 'Panttyp',
        source: 'Källa',
        notSubscribed: 'Kunden prenumererar inte på Cosmo',
        type: 'Typ',
        realEstateType: 'Fastighet',
        vehicleType: 'Fordon',
        taxType: 'Skatt',
        otherType: 'Övrigt',
        owners: 'Ägare',
        liens: 'Panträtter',
        transactions: 'Transaktioner',
        currency: 'Valuta',
        save: 'Spara',
        cancel: 'Avbryt',
        administrator: 'Administratör',
        creditor: 'Borgenär',
        date: 'Datum',
        amount: 'Belopp',
        totalLiens: 'Totala panträtter',
        noLiens: 'Inga panträtter registrerade',
        noTransactions: 'Inga transaktioner registrerade',
        lienCountSuffix: 'panträtter',
        assetCountSuffix: 'tillgångar',
        thisCreditor: 'Denna borgenär',
        linkedCase: 'Ärende',
        otherDistraints: 'Övriga utmätningar',
        transferDate: 'Överlåtelsedatum',
        transferMethod: 'Överlåtelsemetod',
        purchaseSum: 'Köpeskilling',
        conditional: 'Villkorlig',
        summary: 'Sammanfattning',
        netWorth: 'Uppskattad nettoförmögenhet',
        totalEstimatedValue: 'Totalt uppskattat värde',
        loanToValue: 'Belåningsgrad',
        liensToThisCreditor: 'Panträtter till denna borgenär',
        addLien: 'Lägg till panträtt',
        editLien: 'Redigera panträtt',
        registrationDate: 'Registreringsdatum',
        priority: 'Prioritet',
        missingCreditorRegisterId: 'Denna borgenär har inget centralt register-ID — ange ett innan du lägger till panträtter.',
        interestRate: 'Räntesats (%)',
        interestType: 'Räntetyp',
        contributionRate: 'Bidragssats (%)',
        totalTermYears: 'Total löptid (år)',
        interestOnlyYears: 'Amorteringsfri period (år)',
        termShort: 'Löptid',
        interestOnlyShort: 'Amorteringsfri',
        yearsShort: 'år',
        outstandingBalances: 'Utestående saldon',
        outstandingBalance: 'Utestående saldo',
        outstandingBalanceDate: 'Saldo kontrollerat datum',
        expectedOutstanding: 'Förväntat utestående',
        assumedTooltip: 'Uppskattat värde',
        addOutstandingBalance: 'Lägg till utestående saldo',
        noOutstandingBalances: 'Inga utestående saldon registrerade',
        remove: 'Ta bort',
        assetRegistrationNumber: 'Reg.nr.',
        assetModelYear: 'Modellår',
        ownershipShare: 'Ägarandel',
        ownershipNotConfirmed: 'Ägande ej bekräftat',
        bfeAmbiguousOwner: 'Fastighetsdata otillgänglig',
        bfeAmbiguousOwnerDescription: 'Flera personer med detta namn hittades i fastighetsregistret. Lägg till ett födelsedatum på gäldenären för att lösa detta.',
        notSubscribedDescription: 'Kunden övervakas inte längre, så dessa tillgångar är en ögonblicksbild från när övervakningen upphörde och kan inte redigeras.',
        proportionalValue: 'Gäldenärens andelsvärde',
        debtors: 'Gäldenärer',
        totalLabel: 'totalt',
        showHiddenLiens: 'Visa dolda panträtter',
        hideHiddenLiens: 'Dölj dolda panträtter',
        lienTypes: {
            [LienType.Attachment]: 'Utmätning',
            [LienType.Mortgage]: 'Inteckning',
            [LienType.OwnerNote]: 'Ägarhypotek',
            [LienType.PrivateNote]: 'Privat pantbrev',
            [LienType.PrivateIndexLinkedMortgage]: 'Privat indexreglerat pantbrev',
            [LienType.Other]: 'Övrigt',
            [LienType.Unknown]: 'Okänt',
        },
        interestTypes: {
            [InterestType.Variable]: 'Rörlig',
            [InterestType.Fixed]: 'Bunden',
        },
        transferMethods: {
            FREE_SALE: 'Fri försäljning',
            FORCED_AUCTION: 'Exekutiv auktion',
            INHERITANCE: 'Arv',
            GIFT: 'Gåva',
            FAMILY_TRANSFER: 'Familjeöverlåtelse',
            EXCHANGE: 'Byte',
            OTHER: 'Övrigt',
        },
        valuations: 'Värderingar',
        assetOverview: 'Tillgångsöversikt',
        equity: 'Eget kapital',
        viewAllAssets: 'Visa alla tillgångar',
        valuationSources: {
            [ValuationSource.PublicAssessment]: 'Offentlig värdering',
            [ValuationSource.LastSale]: 'Senaste försäljning',
            [ValuationSource.Manual]: 'Manuell',
        },
    },
    customerCaseRelationType: {
        [RelationType.CPR]: 'CPR',
        [RelationType.CVR]: 'CVR',
        [RelationType.Cosmo]: 'Extern',
        [RelationType.CustomerReferenceId]: 'Kundref.',
        [RelationType.Email]: 'E-post',
        [RelationType.NameAddress]: 'Namn/adr.',
    },
    debtors: {
        private: 'Privat',
        company: 'Företag',
        addAlternativeContact: 'Lägg till alternativ kontakt',
        debtor: 'Gäldenär',
        alternativeContact: 'Alternativ kontaktperson',
        ownsCompany: 'Äger företag',
        movedAbroad: 'Flyttat utomlands',
        ownsCompanies: 'Äger företag',
        rkiRegistrations: 'RKI-registreringar',
        confirmDeleteUserFromCustomer: 'Är du säker på att du vill ta bort denna användare från kunden?',
        companyStatus: 'Företagsstatus',
        otherCasesOnDebtorTooltip: 'Gäldenären är kopplad till flera ärenden',
        otherCasesOnDebtor: 'Annat ärende',
        otherCasesOnDebtorPlural: 'andra ärenden',
        movedTo: 'Flyttat till',
        debtors: 'Gäldenärer',
        aksFailed: 'AKS misslyckades',
        cprStatus: 'CPR-status',
        status: {
            [PrivateStarCycle.Active]: 'Aktiv',
            [PrivateStarCycle.Dead]: 'Avliden',
            [PrivateStarCycle.Disappeared]: 'Försvunnen',
            [PrivateStarCycle.Homeless]: 'Hemlös',
            [PrivateStarCycle.GoneAway]: 'Flyttat utomlands',
            [PrivateStarCycle.ForTaxReason]: 'Skattepersonnummer',
            [PrivateStarCycle.NotVerified]: 'Overifierad',
            // [CompanyStarCycle.Active]: 'Active',
            [CompanyStarCycle.Inactive]: 'Inaktiv',
            [CompanyStarCycle.OperationsCeased]: 'Verksamheten upphörd',
            [CompanyStarCycle.ShelfCompany]: 'Lagerbolag',
        },
        dissolvedStatus: {
            [DissolvedStatus.UnderLiquidation]: 'Under likvidation',
            [DissolvedStatus.DissolvedAfterLiquidation]: 'Upplöst efter likvidation',
            [DissolvedStatus.InvoluntaryDissolution]: 'Tvångsupplösning',
            [DissolvedStatus.Dissolved]: 'Upplöst',
            [DissolvedStatus.Unknown]: 'Okänd upplösningsstatus',
            [DissolvedStatus.Voluntary]: 'Under frivillig likvidation',
            [DissolvedStatus.VoluntaryDeclaration]: 'Under frivillig likvidation (deklaration)',
            [DissolvedStatus.Forced]: 'Under tvångsupplösning',
            [DissolvedStatus.DissolvedAfterDeclaration]: 'Upplöst efter deklaration',
            [DissolvedStatus.DissolvedAfterMerger]: 'Upplöst efter fusion',
            [DissolvedStatus.DissolvedAfterDemerger]: 'Upplöst efter delning',
            [DissolvedStatus.DissolvedAfterBankruptcy]: 'Upplöst efter konkurs',
            [DissolvedStatus.Ceased]: 'Upphörd',
        },
        dissolutionStatus: 'Upplösningsstatus',
        addressProtection: 'Adress- och namnskydd',
        addressProtectionShort: 'Skyddad',
        addDebtor: 'Lägg till gäldenär',
        guardian: 'God man',
        relatedCases: 'relaterade ärenden',
        relatedCasesDescription: 'Antal relaterade ärenden som är verifierade / totalt antal relaterade ärenden',
        otherCases: 'andra ärenden',
        otherCasesDescription: 'Antal verifierade ärenden för kunden / totalt antal ärenden',
    },
    emailValidations: {
        risk: 'Risk',
        emailRisk: 'E-postrisk',
        didYouMean: 'Menade du',
        isDisposableAddress: 'Är engångs-e-post',
        isRoleAddress: 'Är rollbaserad e-post',
        high: 'Hög',
        medium: 'Medel',
        low: 'låg',
        unknown: 'Okänd',
        no_mx: 'Inga MX-poster',
        unknown_provider: 'Okänd e-postleverantör',
        high_risk_domain: 'Högriskdomän',
        subdomain_mailer: 'Subdomän-e-postadress',
        immature_domain: 'Nyskapad domän',
        tld_risk: 'Domänen är registrerad som högrisk',
        mailbox_does_not_exist: 'E-postadressen finns inte',
        mailbox_is_disposable_address: 'E-postadressen är en engångs-e-post',
        mailbox_is_role_address: 'Brevlådan är rollbaserad e-post',
        catch_all: 'Catch all',
        long_term_disposable: 'Långvarig engångs-e-post',
    },
    phoneValidation: {
        mobile: 'Mobil',
        landline: 'Fast telefon',
        landline_premium: 'Fast telefon',
        landline_tollfree: 'Fast telefon',
        virtual: 'Virtuell',
        unknown: 'Okänd',
        pager: 'Personsökare',
        roaming: 'Roaming',
    },
    debtorInfo: {
        debtorInfo: 'Gäldenärsinfo',
        debtorCreatedAt: 'Gäldenär skapad',
        company: 'Företag',
        male: 'Man',
        female: 'Kvinna',
        private: 'Privat',
        activated: 'aktiverad',
        subscribed: 'prenumererad',
        failed: 'misslyckad',
        movedTo: 'Flyttat till',
        description: 'Beskrivning',
        addDescription: 'Lägg till beskrivning',
        name: 'Namn',
        email: 'E-post',
        noEmailAddr: 'Ingen e-postadress',
        phone: 'Telefon',
        noAddr: 'Ingen adress',
        address: 'Adress',
        letterReturned: 'Brev returnerat',
        cpr: 'CPR',
        cvr: 'CVR',
        registryIdentifier: 'Centralt register-ID',
        addressProtection: 'Adress- och namnskydd',
        addressProtectionShort: 'Skyddad',
        jurisdiction: 'Jurisdiktion',
        noJurisdiction: 'Ingen jurisdiktion',
        chooseJurisdiction: 'Välj jurisdiktion',
        status: {
            [PrivateStarCycle.Active]: 'Aktiv',
            [PrivateStarCycle.Dead]: 'Avliden',
            [PrivateStarCycle.Disappeared]: 'Försvunnen',
            [PrivateStarCycle.Homeless]: 'Hemlös',
            [PrivateStarCycle.GoneAway]: 'Flyttat utomlands',
            [PrivateStarCycle.ForTaxReason]: 'Skattepersonnummer',
            [PrivateStarCycle.NotVerified]: 'Overifierad',
            // [CompanyStarCycle.Active]: 'Active',
            [CompanyStarCycle.Inactive]: 'Inaktiv',
            [CompanyStarCycle.OperationsCeased]: 'Verksamheten upphörd',
            [CompanyStarCycle.ShelfCompany]: 'Lagerbolag',
        },
        dissolvedStatus: {
            [DissolvedStatus.UnderLiquidation]: 'Under likvidation',
            [DissolvedStatus.DissolvedAfterLiquidation]: 'Upplöst efter likvidation',
            [DissolvedStatus.InvoluntaryDissolution]: 'Tvångsupplösning',
            [DissolvedStatus.Dissolved]: 'Upplöst',
            [DissolvedStatus.Unknown]: 'Okänd upplösningsstatus',
            [DissolvedStatus.Voluntary]: 'Under frivillig likvidation',
            [DissolvedStatus.VoluntaryDeclaration]: 'Under frivillig likvidation (deklaration)',
            [DissolvedStatus.Forced]: 'Under tvångsupplösning',
            [DissolvedStatus.DissolvedAfterDeclaration]: 'Upplöst efter deklaration',
            [DissolvedStatus.DissolvedAfterMerger]: 'Upplöst efter fusion',
            [DissolvedStatus.DissolvedAfterDemerger]: 'Upplöst efter delning',
            [DissolvedStatus.DissolvedAfterBankruptcy]: 'Upplöst efter konkurs',
            [DissolvedStatus.Ceased]: 'Upphörd',
        },
        dissolutionStatus: 'Upplösningsstatus',
        save: 'Spara',
        remove: 'Ta bort',
        birthdate: 'Födelsedatum',
        noBirthdate: 'Inget födelsedatum',
        yearsOld: 'år gammal',
        companyForm: 'Bolagsform',
        industry: 'Bransch',
        employees: 'Anställda',
        companyStatus: 'Företagsstatus',
        website: 'Webbplats',
        dateOfFoundation: 'Grundningsdatum',
        quantifyOfPUnits: 'Antal P-enheter',
        powerToBind: 'Firmateckningsregel',
        adProtected: 'Reklamskyddad',
        cars: 'Bilar',
        from: 'Från',
        liabilities: 'Skulder',
        priority: 'Prioritet',
        interest: 'Ränta',
        properties: 'Fastigheter',
        toilet: 'Toalett',
        roof: 'Tak',
        bath: 'Bad',
        built: 'Byggd',
        rkiRegis: 'RKI-registreringar',
        administrator: 'Administratör',
        disclosureDate: 'Utlämningsdatum',
        deleted: 'raderad',
        toBedeleted: 'raderas',
        companyRelations: 'Företagsrelationer',
        roles: 'Roller',
        accountableParticipant: 'Fullt ansvarig deltagare',
        director: 'Direktör',
        executiveBoard: 'Ledning',
        beneficialOwner: 'Verklig huvudman',
        founder: 'Grundare',
        owner: 'ägare',
        stakeholder: 'Intressent',
        chairperson: 'Styrelseordförande',
        managingDirector: 'Verkställande direktör',
        boardMember: 'Styrelseledamot',
        equityTier: 'Kapitalklass',
        viceChairperson: 'Vice ordförande',
        rightToVote: 'Rösträtt',
        audit: 'Revision',
        specialOwnership: 'Särskilda ägarförhållanden',
        previous: 'Tidigare',
        noPreviousToShow: 'Inga tidigare att visa',
        backTo: 'Tillbaka till',
        casesOnThisDebtor: 'Ärenden gällande denna gäldenär',
        guardianName: 'God mans namn',
        guardianAddress: 'God mans adress',
        guardianStartDate: 'God mans startdatum',
    },
    debtorWebHome: {
        dear: 'Kära',
        representative: 'Vi har registrerat att du har loggat in som representant för gäldenären.',
        you: 'Du',
        debtor: 'Gäldenär',
        owe: 'är skyldig',
        to: 'till',
        youCanDoThisHere: 'Du kan betala på denna sida, anmäla dig till en betalningsplan eller uppdatera dina kontaktuppgifter. Du är också välkommen att skicka ett meddelande till oss om du har några frågor.',
        yourInfo: 'Dina uppgifter',
        name: 'Namn',
        informName: 'Ange namn',
        email: 'E-post',
        informEmail: 'Ange e-post',
        phone: 'Telefon',
        informPhone: 'Ange telefon',
        address: 'Adress',
        cpr: 'CPR',
        cvr: 'CVR',
        informAddress: 'Ange adress',
        confirmation: 'Jag bekräftar att mina uppgifter är korrekta.',
        updateButton: 'Uppdatera uppgifter',
        confirm: 'Bekräfta',
        faq: 'Vanliga frågor',
        contactUs: 'Kontakta oss',
        contactUsText: 'Skicka gärna ett e-postmeddelande till oss, ring oss eller skicka ett meddelande via textfältet nedan.',
        yourMessage: 'Ditt meddelande',
        enterEmail: 'Ange e-post för att skicka ett meddelande',
        send: 'Skicka',
        logout: 'Logga ut',
        privacyPolicy: 'Integritetspolicy',
        businessTerms: 'Affärsvillkor',
        paymentMethods: 'Betalningsmetoder',
        payWithFI: 'Betala med FI-nummer',
        paySafeWithFI: 'Betala säkert med följande FI-nummer:',
        payWithIBAN: 'Betala med IBAN',
        paySafeWithIBAN: 'Betala säkert med IBAN från din bank:',
        payWithSWIFT: 'Betala med SWIFT',
        paySafeWithSWIFT: 'Betala säkert med SWIFT från din bank:',
        payWithBankTransfer: 'Betala med banköverföring',
        registrationNumber: 'Clearingnummer',
        accountNumber: 'Kontonr.',
        payWithBankTransferText: 'Gör en insättning till vårt konto:',
        payWithBankTransferInfo: 'Kom ihåg att ange ärendenr.',
        or: 'Eller',
        iApprove: 'Jag accepterar',
        theBusinessTerms: 'affärsvillkoren',
        pleaseAcceptBusinessTerms: 'Du måste acceptera affärsvillkoren innan du kan fortsätta till betalningssidan.',
        payWithCardButton: 'Betala med kort',
        createAPaymentPlan: 'Skapa en betalningsplan',
        fullPayment: 'Full betalning',
        partialPayment: 'Delbetalning',
    },
    debtorWebPaymentPlans: {
        backToCase: 'Tillbaka till ärende',
        paymentPlanOn: 'Betalningsplan på ärende',
        selectPlan: 'Välj betalningsplan',
        chooseDifferentPlan: 'Välj en annan betalningsplan',
        sign: 'Underteckna avtal',
        gatherInfo: 'Ange information',
        paymentMethod: 'Välj betalningsmetod',
        approval: 'Bekräftelse',
        info: 'Info',
        paymentPlan: 'Betalningsplan',
        firstPayment: 'Första betalning',
        entry: 'post',
        lastPayment: 'Sista betalning',
        signedDoc: 'Undertecknat dokument',
        needHelp: 'Behöver hjälp?',
        orPay: 'Eller betala hela skulden',
        pay: 'Betala hela skulden',
        months: 'Månader',
        month: 'månad',
        total: 'Total betalning',
        select: 'Välj',
        noOptions: 'Tyvärr går det inte att skapa en betalningsplan.',
        signTextOne: 'För att skriva upp dig på en betalningsplan med',
        signTextTwoAlternativeContact: 'måste gäldenären underteckna följande avtal.',
        signTextTwoDebtor: 'måste du underteckna följande avtal.',
        signTextThree: 'För att kunna underteckna avtalet måste du fylla i dina uppgifter.',
        agreement: 'Underteckna avtal',
        agreementTitle: 'Avtal',
        approvalText: 'Grattis. Du har ingått en betalningsplan.',
        paymentMethodText: 'Vi tar hand om dina kortuppgifter och gör det enkelt för dig att anmäla dig till automatisk betalning.',
        connectCard: 'Anslut betalningsmetod',
        automaticPaymentMethod: 'Automatisk betalningsmetod',
        manualBankTransferTitle: 'Föredrar du manuell banköverföring?',
        manualBankTransferHint: 'Du kan istället göra en manuell banköverföring. Bankuppgifter finns på ärendeöversikten.',
        securePaymentHint: 'Säker betalning',
        deleteCardToChange: 'Du kan ändra/radera det valda kortet genom att klicka på knappen för att radera kortet.',
        deleteCard: 'Radera kort',
        paymentPlanEntries: 'Betalningsplanposter',
        progressTitle: 'Din betalningsplan',
        progressPaid: 'Betald',
        progressRemaining: 'Återstående',
        progressNext: 'Nästa termin',
        progressComplete: 'Betalningsplan slutförd',
        progressOf: 'av',
        amount: 'Belopp',
        date: 'Datum',
        status: 'Status',
        statusCode: {
            [PaymentPlanEntryStatus.SETTLED]: 'Betald',
            [PaymentPlanEntryStatus.CANCELED]: 'Misslyckad',
            [PaymentPlanEntryStatus.PENDING]: 'Kommande',
            [PaymentPlanEntryStatus.REMINDED]: 'Påmind',
            [PaymentPlanEntryStatus.AWAITING]: 'Väntar',
            [PaymentPlanEntryStatus.OVERDUE]: 'Försenad',
            [PaymentPlanEntryStatus.ERRORSETTLED]: 'Misslyckad kortdragning',
        },
    },
    paymentPlanEntryStatuses: {
        [PaymentPlanEntryStatus.SETTLED]: 'Betald',
        [PaymentPlanEntryStatus.CANCELED]: 'Missad',
        [PaymentPlanEntryStatus.PENDING]: 'Framtida',
        [PaymentPlanEntryStatus.REMINDED]: 'Påmind',
        [PaymentPlanEntryStatus.AWAITING]: 'Väntar',
        [PaymentPlanEntryStatus.OVERDUE]: 'Förfallen',
        [PaymentPlanEntryStatus.ERRORSETTLED]: 'Fel vid reglering',
    },
    chains: {
        nextStep: 'Nästa steg',
    },
    chainGroups: {
        dunningChain: 'Påminnelseflöde',
        chain: 'Arbetsflöde',
        add: 'Lägg till',
        delete: 'Radera',
        configure: 'Konfigurera arbetsflöden för ärendegrupper',
        caseGroup: 'Ärendegrupp',
    },
    migration: {
        migrateData: 'Migrera data',
        modalHeader: 'Migrera data',
        uploadErrorMessage: 'Ett fel uppstod, kontrollera att filen är korrekt och försök igen',
    },
    creditorStateDescriptions: {
        [CreditorState.Lead]: 'Borgenärer som håller på att sättas upp, men som ännu inte har fått tillgång till borgenärswebben.',
        [CreditorState.SignedOn]: 'Borgenärer som ännu inte är aktiva kunder, men som vill ha en demo av borgenärswebben.',
        [CreditorState.Active]: 'Aktiva borgenärer som laddar upp nya ärenden och har full tillgång till borgenärswebben.',
        [CreditorState.Ceased]: 'Borgenärer som är uppsagda, men som fortfarande har aktiva ärenden att följa.',
        [CreditorState.Cancelled]: 'Borgenärer som är uppsagda och inte längre ska ha tillgång till borgenärswebben.',
    },
    creditors: {
        creditor: 'Borgenär',
        creditors: 'Borgenärer',
        creditorInfo: 'Borgenärsinformation',
        allCreditors: 'Alla borgenärer',
        searchCreditors: 'Sök borgenärer',
        newCreditorInfo: 'Borgenärsinfo',
        newCreditorEconomy: 'Ekonomi',
        newCreditorChains: 'Arbetsflöden',
        newCreditorUsers: 'Användare',
        newCreditorDone: 'Klart',
        states: {
            [CreditorState.Active]: 'Aktiv',
            [CreditorState.Lead]: 'Lead',
            [CreditorState.SignedOn]: 'Registrerad',
            [CreditorState.Cancelled]: 'Uppsagd',
            [CreditorState.Ceased]: 'Upphörd',
        },
        downloadOverview: 'Ladda ner översikt',
        newCreditor: 'Ny borgenär',
        defaultBillingModelDescription: 'Välj den faktureringsmodell som nya ärenden ska initieras med. Alla ärenden kan ha sin egen faktureringsmodell. När ett nytt ärende skapas skapas det med borgenärens standardfaktureringsmodell.',
        tenantInheritedBillingModelDescription: 'Om du inte väljer en standardfaktureringsmodell skapas ärenden med organisationens standardfaktureringsmodell',
        tenantInheritedDunningConnectorDescription: 'Om du inte väljer en standardfaktureringsmodell skapas ärenden med organisationens standardmodell för påminnelser',
        chainsHeader: 'Välj standardarbetsflöden',
        chainsDescription: 'Välj vilket arbetsflöde nya ärenden ska skapas med. Alla ärenden kan ha sitt eget arbetsflöde. När ett nytt ärende skapas skapas det med borgenärens standardarbetsflöde.',
        usersNewHeader: 'Skapa inloggning för borgenärer',
        usersCreditorHeader: 'Välj ansvariga användare',
        next: 'Nästa',
        previous: 'Föregående',
        setCreditorState: 'Ange borgenärsstatus',
        cvr: 'CVR',
        company: 'Företag',
        person: 'Person',
        vatRegistered: 'Momsregistrerad',
        notVatRegistered: 'Ej momsregistrerad',
        acquisitionResponsible: 'Ansvarig för anskaffning',
        selectAcquiRespon: 'Välj ansvarig för anskaffning',
        contact: 'Kontakt',
        selectContact: 'Välj kontakt',
        caseworkerContact: 'Handläggarkontakt',
        selectCaseworkerContact: 'Välj handläggarkontakt',
        none: 'Ingen',
        createCreditor: 'Skapa borgenär',
        reference: 'Referens',
        name: 'Namn',
        selectDefaultCollector: 'Välj standardindrivare',
        status: 'Status',
        active: 'Aktiv',
        lead: 'Lead',
        selectClientContact: 'Välj borgenärskontakt',
        isCompany: 'Är företag',
        create: 'Skapa',
        createdAt: 'Skapelsedatum',
        quantityCases: 'Antal ärenden',
        referenceId: 'Nr.',
        wincentAvgPrediction: 'Wincent genomsn. poäng',
        selectDefaultChain: 'Välj standardarbetsflöde',
        defaultChain: 'Arbetsflöde',
        selectDefaultClientChain: 'Välj standardarbetsflöde',
        defaultClientChain: 'Påminnelseflöde',
        mandates: 'Fullmakter',
        mandatesPlaceholder: 'Tomt',
        experianClientId: 'Experian client id',
        updateExperianClientId: 'Uppdatera client id',
        requestClientIdExperian: 'Begär ett client id från Experian',
        requestClientIdExperianSuccess: 'Experian har begärts och kommer automatiskt att fylla i client id.',
        erpLink: 'Länk till borgenärens ERP-system',
        updateErpLink: 'Uppdatera länk',
        aksEnabled: 'AKS aktiverat',
        advokatindestaaelse: 'Advokatindeståelse för öppen RKI',
        debitorRegistretCreateCreditor: 'Skapa borgenär i Debitor Registret',
        debitorRegistretCreateCreditorDescription: 'Skapar borgenären i Debitor Registret och sparar borgenärsnumret.',
        debitorRegistretCreateCreditorSuccess: 'Borgenären skapades i Debitor Registret.',
        debitorRegistretCreateCreditorSkipped: 'Borgenären är redan skapad i Debitor Registret.',
        bankAccountDetails: 'Bankkontouppgifter',
        updateBankAccountDetails: 'Uppdatera konto',
        autoRKI: 'Auto-RKI',
        automaticDebtRegister: 'Åsidosätt automatisk registrering i RKI',
        useAutomaticDebtRegister: 'Ange automatisk registrering i RKI på borgenär',
        useAutoRKIOpen: 'Ange öppen RKI på borgenär',
        useAutoRKIIgnoreUnresolvedOppositions: 'Ange ignorera olösta interaktioner (invändningar) på borgenär',
        selfCollection: 'Egen inkasso',
        useSelfCollectionOption: 'Ange egen inkasso på borgenär',
        outboundCall: 'Utgående samtal',
        useOutboundCallOption: 'Ange utgående samtal på borgenär',
        autoVerify: 'Verifiera ärenden automatiskt',
        useAutoVerifyOption: 'Ange automatisk verifiering på borgenär',
        paymentTerms: 'Betalningsvillkor',
        paymentDays: 'Betalningsdagar',
        billingRecipients: 'Faktureringsmottagare',
        billingRecipientsDescription: 'Ange flera e-postadresser så här',
        automaticExpireVouchers: 'Åsidosätt automatiskt utgående av verifikat',
        useAutomaticExpireVouchers: 'Ange automatiskt utgående av verifikat på borgenär',
        configurationOptions: 'Konfigurationer',
        experianConfig: 'Experian-konfigurationer',
        courtSubmitConfig: 'Konfiguration för automatisk inlämning till domstol',
        foundationExpiration: 'Utgående med grund',
        normalExpiration: 'Utgående utan grund',
        interestExpiration: 'Ränteutgående',
        debtorFAQ: 'Vanliga frågor (visas i gäldenärswebben)',
        faqHeader: 'Behöver du hjälp att skapa en ny borgenär?',
        faqText: 'Vi har skrivit en artikel om hur du gör. Klicka på knappen nedan för att läsa mer.',
        newUserDisabled: 'Nya användare kan inte skapas med nuvarande borgenärsstatus',
        cancelledError: 'Tillgången har sagts upp',
        cancelledErrorMessage: 'Din tillgång är uppsagd. Kontakta oss för mer information.',
        eInvoice: {
            eInvoice: 'E-faktura',
            companyId: 'Företags-id',
            identification: 'Identifikationsnummer',
            addChildCompany: 'Lägg till som dotterbolag',
        },
        creditorCreationDisabled: 'Skapande av borgenärer är avstängt',
        creditorCreationDisabledDescription: 'Borgenärer kan inte skapas via användargränssnittet',
        moveCasesToNewCreditor: 'Flytta ärenden till ny borgenär',
        moveCases: 'Flytta ärenden',
        noCreditors: 'Inga borgenärer',
    },
    collectorTypes: {
        [CollectorType.CREDITOR]: 'Borgenär',
        [CollectorType.TENANT]: 'Indrivare',
    },
    collectors: {
        collector: 'Indrivare',
        updateEntity: 'Spara',
        masterData: 'Information',
        layout: 'Layout',
        websites: 'Webbplatser',
        legal: 'Juridik',
        paymentOptions: 'Betalningsalternativ',
        communicationChannels: 'Kommunikationskanaler',
        namePlaceholder: 'Namn',
        centralRegisterIdPlaceholder: 'Lokalt organisationsnummer',
        nicknamePlaceholder: 'Smeknamn',
        addressPlaceholder: 'Adress',
        logoFileIdPlaceholder: 'Logotyp',
        letterFrontLogoFileIdPlaceholder: 'Logotyp som används på brevens första sida',
        websitePlaceholder: 'Webbplats',
        clientWebBasePlaceholder: 'Bas för borgenärswebb',
        debtorWebBasePlaceholder: 'Bas för gäldenärswebb',
        titlePlaceholder: 'Företagstitel',
        privacyPolicyPlaceholder: 'Integritetspolicy',
        businessTermsPlaceholder: 'Affärsvillkor',
        emailPlaceholder: 'E-post',
        replyToPlaceholder: 'Svara till-e-post',
        phonePlaceholder: 'Telefon',
        paymentOptionsPlaceholder: 'Betalningsalternativ',
        themePlaceholder: 'Tema',
        hideEmail: 'Dölj e-post',
        secondaryCollector: 'Sekundär inkasserare',
        addSecondaryCollector: 'Lägg till sekundär inkasserare',
    },
    paymentPlans: {
        cannotOfferPaymentPlan: 'Tyvärr kan vi inte erbjuda dig några betalningsplaner online. Kontakta inkassobolaget.',
        paymentPlansDisabled: 'Betalningsplaner inaktiverade',
        paymentPlanDisabledForDebtor: 'Gäldenären kan inte skapa betalningsplaner. Se ärendeinställningar',
        paymentPlan: 'Betalningsplan',
        customFoundation: 'Grund för betalningsplaner',
        customFoundationDescription: 'Välj vilken mall som ska användas som grund för skulden i gäldenärswebben. Om ingen mall väljs används en standardgrund.',
        skipTo: 'Hoppa till',
        editPaymentPlan: 'Redigera betalningsplan',
        editPaymentPlanDescription: 'Justera postbeloppet, varaktigheten eller intervallet. Redan betalda poster behålls.',
        editPaymentPlanHint: 'De {count} poster som redan har betalats behålls. Endast framtida poster ersätts med den nya planen.',
        collapsedEntries: 'hopfällda poster',
        deletePaymentPlan: 'Radera betalningsplan',
        progress: 'Förlopp',
        selectPaymentPlan: 'Välj betalningsplan',
        signPaymentPlan: 'Signera betalningsplan',
        selectPaymentMethod: 'Välj betalningsmetod',
        confirmation: 'Bekräftelse',
        createNewPaymentPlan: 'Skapa ny betalningsplan',
        months: 'månader',
        month: 'månad',
        totalPayment: 'Total återbetalning',
        createCustomPlan: 'Skapa anpassad betalningsplan',
        createStandardPlan: 'Skapa standardbetalningsplan',
        byAmount: 'Efter belopp',
        byDuration: 'Efter varaktighet',
        monthly: 'Månadsvis',
        everyOtherMonth: 'Varannan månad',
        quarterly: 'Kvartalsvis',
        yearly: 'Årsvis',
        everyOtherWeek: 'Varannan vecka',
        weekly: 'Veckovis',
        lastBankDayOfMonth: 'Sista bankdagen i månaden',
        rest: 'Rest',
        generate: 'Generera',
        entries: 'Poster',
        entry: 'Post',
        date: 'Datum',
        reminder: 'Påminnelse',
        lastChanceOfPayment: 'Sista chansen',
        addedInterests: 'Tillagd ränta',
        cancelled: 'Missad',
        amount: 'Belopp',
        confirmationCheckbox: 'Skicka bekräftelse när betalningsplanen aktiveras',
        activate: 'Aktivera',
        cancel: 'Avbryt',
        agreement: 'Avtal',
        inputAmount: 'Ange beloppet.',
        details: 'Detaljer',
        createPaymentPlan: 'Skapa betalningsplan',
        activatePaymentPlanWithoutFoundation: 'Aktivera betalningsplan utan grund.',
        errorCaseEnded: 'Kan inte skapa betalningsplan: ärendet har avslutats',
        paymentEntryText: 'Betalning av',
        yearlyAPR: 'årlig effektiv ränta',
        before: 'före',
        CREATED: 'Skapad',
        ACTIVE: 'Aktiv',
        FINISHED: 'Slutförd',
        CANCELED: 'Avbruten',
        DELETED: 'Raderad',
        errorInInput: 'Fel i inmatning',
        save: 'Spara',
        calculationFoundation: 'Belopp eller varaktighet',
        calculationFoundationDescription: 'Välj betalningsplanens beräkningsgrund. Antingen ett belopp eller antalet poster.',
        calculateByAmount: 'Beräkna utifrån ett belopp',
        calculateByDuration: 'Beräkna utifrån en varaktighet',
        addScheduledAmountChange: '+ Justera senare avbetalningar',
        scheduledAmountChangeFromDate: 'Från datum',
        createdAt: 'Skapad',
        startDate: 'Startdatum',
        startDateDescription: 'Betalningsdatum för den första posten.',
        upfrontPayment: 'Förskottsbetalning',
        upfrontPaymentDescription: 'Om en förskottsbetalning som visar betalningsvilja behövs kan den aktiveras här.',
        upfrontPaymentDate: 'Datum för förskottsbetalning',
        interval: 'Intervall',
        intervalDescription: 'Välj tidsspannet mellan betalningsplanens poster.',
        interestFree: 'Räntefri period',
        interestFreeDescription: 'Om en räntefri period behövs kan den väljas här.',
        interestFreeFrom: 'Från',
        interestFreeTo: 'Till',
        interestFreeOnDefault: 'Om planen missas',
        interestFreeOnDefaultKeepFrozen: 'Behåll perioden räntefri, ränta återupptas från datumet för missad betalning',
        interestFreeOnDefaultReapply: 'Tillämpa den efterskänkta räntan från perioden på nytt',
        settlement: 'Ackord',
        settlementDescription: 'Gäldenären betalar ett avtalat nedsatt belopp; resten efterskänks när planen är slutförd.',
        settlementEnable: 'Ingå ackord (betala mindre än hela skulden)',
        settlementAgreedTotal: 'Avtalat belopp',
        settlementPercentOfBalance: 'Procent av saldot',
        settlementAmountForgiven: 'Efterskänkt belopp',
        settlementCurrentBalance: 'Aktuellt saldo',
        settlementSettledSoFar: 'Betalat hittills',
        settlementRemainingToPay: 'Återstående av avtalat belopp',
        settlementForgivenOnCompletion: 'Efterskänks vid slutförande',
        settlementSummary: 'Gäldenären betalar {total} av {balance} ({percent} %)',
        settlementExceedsBalance: 'Det avtalade beloppet måste vara mindre än det aktuella saldot',
        fees: 'Avgifter',
        feesDescription: 'Lägg till valfria avgifter till betalningsplanen.',
        initialFee: 'Startavgift',
        initialFeeDescription: 'Lägg till en engångsavgift när betalningsplanen startar.',
        perEntryFee: 'Avgift per post',
        perEntryFeeDescription: 'Lägg till en avgift för varje post i betalningsplanen.',
        voucherType: 'Verifikattyp',
        selectVoucherType: 'Välj verifikattyp',
        selectVoucherTypeRequired: 'Välj en verifikattyp för att tillämpa denna avgift',
        defaultFees: 'Standardavgifter',
        defaultFeesDescription: 'Konfigurera standardavgifter som tillämpas på nya betalningsplaner.',
        feesWillBeApplied: 'Avgifter kommer att tillämpas',
        overrideFees: 'Åsidosätt avgifter på borgenär',
        moreSettings: 'Fler inställningar',
        detailsWarning: 'Denna plan visar ärendets utveckling om planen följs. Avvikelser kan uppstå om till exempel betalningsdatum skiljer sig från avbetalningsplanen.',
        debtAmount: 'Skuldbelopp',
        accumulatedInterest: 'Ackumulerad ränta',
        planedAccumulatedPayments: 'Planerade ackumulerade betalningar',
        disclaimerLastEntryVaries: 'Om posterna inte betalas på angivet datum kan beloppet för den sista posten skilja sig.',
        disclaimerVariableInterest: 'Räntesatsen på ärendet kan förändras över tid, vilket också kan påverka beloppet för den sista posten.',
        savedPaymentMethod: 'Sparad betalningsmetod',
        removePaymentMethod: 'Ta bort gäldenärens betalningsmetod',
        areYouSureRemovePaymentMethod: 'Är du säker på att du vill ta bort gäldenärens betalningsmetod?',
        paymentMethodSection: 'Betalningsmetod',
        noPaymentMethodConnected: 'Ingen betalningsmetod ansluten',
        noPaymentMethodHint: 'Anslut en betalningsmetod så att avbetalningar kan dras automatiskt på förfallodagen.',
        connectPaymentMethod: 'Anslut betalningsmetod',
        connectCardOrBetalingsservice: 'Anslut kort eller Betalingsservice',
        noActiveCardOption: 'Borgenären har ingen aktiv kortbetalningsmetod tillgänglig.',
        createBSMandate: 'Skapa Betalingsservice-medgivande',
        bsMandateDescription: 'Registrera ett Betalingsservice-medgivande för gäldenären med deras CPR-nummer och kontouppgifter.',
        bsMandateName: 'Namn',
        bsMandateCpr: 'CPR-nummer',
        bsMandateRegNo: 'Clearingnummer',
        bsMandateAccountNo: 'Kontonummer',
        bsMandateSubmit: 'Skapa medgivande',
        bsMandateCreated: 'Betalingsservice-medgivande skapat. Inväntar bekräftelse från banken.',
        recommendedBadge: 'Rekommenderas',
        lastBankDayOfMonthDescription: 'Dra på lönedagen – bäst chans till lyckad betalning.',
        recalculate: 'Beräkna om',
        recalculateDescription: 'Omberäkning raderar alla väntande poster och genererar planen på nytt.',
        daily: 'Dagligen',
    },
    debtRegistration: {
        registration: 'Skuldregistrering',
        tabGeneral: 'Allmänt',
        tabRki: 'RKI',
        tabDebitorRegistret: 'Debitor Registret',
        createNewRegistration: 'Skapa ny registrering',
        newRegistration: 'Ny skuldregistrering',
        chooseDebtor: 'Välj gäldenär',
        amount: 'Belopp',
        withFoundation: 'Med grund',
        chooseFoundationType: 'Välj grundtyp',
        dateFoundation: 'Datum för grund',
        noFoundationsOnCase: 'Ingen grund hittades på ärendet. Lägg till en grund på ärendet för att fortsätta.',
        foundationCode: {
            [FoundationCode.betalingspåkrav1påtegning]: 'Betalingspåkrav 1. påtegning',
            [FoundationCode.betalingspåkrav2påtegning]: 'Betalingspåkrav 2. påtegning',
            [FoundationCode.stævning]: 'Stævning',
            [FoundationCode.fogedsag]: 'Fogedsag',
            [FoundationCode.dom]: 'Dom',
            [FoundationCode.insolvens]: 'Insolvenserklæring i anden sag',
            [FoundationCode.konkurs]: 'Konkurs',
            [FoundationCode.tvangsakkord]: 'Tvangsakkord, indledt',
            [FoundationCode.fogedretsrekv]: 'Fogedretsrekv',
            [FoundationCode.tvangsauktionudlæg]: 'Tvangsauktion - udlæg',
            [FoundationCode.skylderklæring]: 'Skylderklæring',
            [FoundationCode.forlig]: 'Frivilligt forlig',
        },
        state: {
            [DebtRegistrationState.ACTIVE]: 'ACTIVE',
            [DebtRegistrationState.ERROR]: 'ERROR',
            [DebtRegistrationState.DELETED]: 'DELETED',
            [DebtRegistrationState.CONCLUDED]: 'CONCLUDED',
        },
        registry: {
            [RegistryType.OPEN]: 'OPEN',
            [RegistryType.CLOSED]: 'CLOSED',
        },
        status: 'Status',
        remark: 'Anmärkning',
        deleteReason: 'Orsak till radering',
        migrated: 'Migrerad',
        latestWarningDate: 'Datum för senaste varning',
        errors: {
            [DebtRegistrationError.AlreadyRegistered]: 'Gäldenären är redan registrerad',
            [DebtRegistrationError.MissingWarning]: 'Saknar varning',
            [DebtRegistrationError.WrongCurrency]: 'Valutan är inte DKK',
            [DebtRegistrationError.WarningLetterWasReturned]: 'Varningsbrevet returnerades',
            [DebtRegistrationError.EmailWarningWasNeverDelivered]: 'Varningen via e-post levererades aldrig',
            [DebtRegistrationError.WarningIsOlderThanOneYear]: 'Varningen är äldre än ett år',
            [DebtRegistrationError.FoundationCouldNotBeMapped]: 'Grundkoden kunde inte identifieras',
            [DebtRegistrationError.FoundationDateCouldNotFound]: 'Datum för grund kunde inte hittas',
            [DebtRegistrationError.UnresolvedOpposition]: 'Olöst interaktion',
            [DebtRegistrationError.OppositionFound]: 'Aktiv invändning',
            [DebtRegistrationError.NoRegistryFound]: 'Uppfyller inte kraven för något register',
            [DebtRegistrationError.FoundationAmountCouldNotBeFound]: 'Belopp på grund saknas',
            [DebtRegistrationError.FoundationAmountTooSmall]: 'Beloppet på grunden är för litet för det öppna registret',
            [DebtRegistrationError.NameTooLong]: 'Skuldregistrering tillåter maximalt 60 tecken i namnet. För enskilda firmor kan "v/" tas bort tillsammans med allt efter "/v".',
            [DebtRegistrationError.OldestRegistrationIsTooOld]: 'Den äldsta registreringen är för gammal',
            [DebtRegistrationError.FoundationFileMissing]: 'Grunddokumentet har ingen fil (krävs för öppen registrering utan advokatgaranti)',
            [DebtRegistrationError.FoundationMissing]: 'Det finns ingen grund på ärendet, vilket krävs för öppen registrering',
            [DebtRegistrationError.BalanceTooSmallForOpen]: 'Saldot på ärendet är för lågt för öppen registrering',
        },
        infobox: {
            herebyRegister: 'registrerar härmed',
            open: 'Öppna',
            closed: 'Stängda',
            inThe: 'i det',
            debtorNotPaid: 'skuldregistret, eftersom gäldenären inte har betalat det förfallna beloppet på DKK',
            criteria: 'Ärendet uppfyller följande kriterier:',
            min18years: 'Gäldenären är minst 18 år',
            min3messages: 'Gäldenären har fått minst 3 meddelanden från borgenär och/eller indrivare gällande skulden',
            totalDebt: 'Total skuld inklusive avbetalningar och avgifter är på minst DKK 1.000',
            hasFoundation: 'Har grund',
            debtorWarning: 'Gäldenären har varnats för minst 15 dagar sedan och högst 6 månader sedan',
            totalPrincipal: 'Totalt kapitalbelopp är minst DKK 200',
            noDemurral: 'Gäldenären har inte invänt',
            institutionsInfo: 'Försäkringsbolag, finansinstitut och hypoteksinstitut får inte registrera gäldenärer i skuldregister utan att ärendet har prövats av civil domstol eller Kronofogden',
            incoming: 'Interaktioner markerade som invändningar och olösta interaktioner',
            specialCreditors: 'Försäkringsbolag, finansinstitut och hypoteksinstitut får inte registrera gäldenärer i skuldregister utan att ärendet har prövats av civil domstol eller Kronofogden',
            closedRegister: 'Stängt register',
            openRegister: 'Öppet register',
            foundationType: 'Registrering med korrekt grundtyp',
            registerButton: 'Registrera i skuldregister',
            finePrint: {
                NB: 'OBS: Det kan ta upp till 10 minuter att behandla registreringar och ändringar. Om registreringen eller ändringen väljs för manuell behandling kan det ta flera arbetsdagar.',
                letter: 'Gäldenären får ett brev efter att registreringen har publicerats.',
                expiration: 'Registreringar i det stängda registret upphör efter 2 år. Det kan förlängas upp till 5 om det överförs till det öppna registret. Registreringar i det öppna registret upphör efter 5 år från datumet för grund.',
                faultyData: 'Om det uppstår problem med data, kontakta supporten.',
                newClient: 'För att skapa en ny klient, kontakta supporten.',
            },
        },
    },
    RKI: {
        registration: 'RKI-registrering',
    },
    debitorRegistret: {
        registration: 'Debitor Registret-registrering',
    },
    financials: {
        debtExpiresWithinThreeMonths: 'Skuld som preskriberas inom 3 månader',
        debtExpired: 'Skuld preskriberad',
        principal: 'Kapitalbelopp',
        interests: 'Räntor',
        costs: 'Kostnader',
        debt: 'Skuld',
        deposit: 'Deposition',
        balance: 'Saldo',
        revenue: 'Intäkt',
        revenueBasedDepositOrder: 'Intäktsbaserad avräkningsordning',
        interestBasedDepositOrder: 'Räntebaserad avräkningsordning',
        details: 'Detaljer',
        invoiceId: 'Faktura-ID',
        reminderFee: 'Påminnelseavgift',
        overpayment: 'Överbetalning',
        repayment: 'Återbetalning',
        responsibleForRepayment: 'Ansvarig för återbetalning',
        sourceBankAccount: 'Källbankkonto',
        registrationNumber: 'Clearingnummer',
        accountNumber: 'Kontonummer',
        repaymentAmount: 'Återbetalningsbelopp',
        sendRepaymentRequest: 'Skicka återbetalningsbegäran',
        currency: 'Valuta',
        moneyScaleSuffixes: {
            thousands: 't',
        },
        imposedByCollector: 'Skuld påförd av inkassobolag',
        imposedByCreditor: 'Skuld påförd av borgenär',
    },
    sftp: {
        servers: 'SFTP-servrar',
        explanation: 'Skapa SFTP-servrar för att utbyta filer med borgenärer och samarbetspartner. Varje server har sina egna användare, som loggar in med en SSH-nyckel.',
        name: 'Namn',
        creditor: 'Borgenär',
        noCreditor: 'Ingen borgenär',
        created: 'Skapad',
        newServer: 'Ny SFTP-server',
        createServer: 'Skapa SFTP-server',
        deleteServer: 'Ta bort SFTP-server',
        deleteServerWarning: 'Om SFTP-servern tas bort försvinner alla dess användare och deras åtkomst. Detta kan inte ångras.',
        typeNameToConfirm: 'Skriv SFTP-serverns namn för att bekräfta',
        noServers: 'Inga SFTP-servrar har skapats ännu',
        connection: 'Anslutning',
        host: 'Värd',
        port: 'Port',
        users: 'Användare',
        connectionExplanation: 'Användare ansluter med en SFTP-klient till värden nedan och loggar in med sin SSH-nyckel. Inget lösenord används.',
        keyType: 'Nyckel',
        login: 'Inloggning',
        deleteServerExplanation: 'Tar bort SFTP-servern och alla dess användare. Redan uppladdade filer finns kvar i mappen.',
        newUser: 'Ny användare',
        createUser: 'Skapa användare',
        username: 'Användarnamn',
        usernameHint: '3-100 tecken: bokstäver, siffror, understreck, bindestreck, punkt och @',
        publicKey: 'Publik SSH-nyckel',
        publicKeyHint: 'Klistra in den publika nyckeln, t.ex. "ssh-ed25519 AAAA... kommentar"',
        deleteUser: 'Ta bort användare',
        confirmDeleteUser: 'Är du säker på att du vill ta bort den här användaren? Användaren förlorar åtkomst omedelbart.',
        noUsers: 'Inga användare har skapats ännu',
        backToServers: 'Alla SFTP-servrar',
    },
    navigation: {
        overview: 'Översikt',
        home: 'Hem',
        cases: 'Ärenden',
        views: 'Vyer',
        transactions: 'Transaktioner',
        economy: 'Ekonomi',
        economyCaseVouchers: 'Ärendeverifikat',
        economyBookkeeping: 'Bokföring',
        economyImposedDebt: 'Påförd skuld',
        economyDeposits: 'Depositioner',
        economySetup: 'Inställningar',
        economyBilling: 'Fakturering',
        economyPayment: 'Betalning',
        economyPayouts: 'Utbetalningar',
        economyChartOfAccounts: 'Kontoplan',
        economyUnknown: 'Oidentifierade transaktioner',
        bankAccounts: 'Konton',
        export: 'Export',
        transactionLookup: 'Transaktionssökning',
        depositChanges: 'Ändringar',
        economyIrrecoverableDebt: 'Osäker fordran',
        economyExpiredDebt: 'Preskriberad skuld',
        reports: 'Insikter',
        communication: 'Kanaler',
        content: 'Innehåll',
        creditors: 'Borgenärer',
        creditorEconomy: 'Ekonomi',
        creditorInvoicing: 'Fakturering',
        creditorCustomers: 'Kunder',
        creditorCases: 'Ärenden',
        creditorCollector: 'Inkassobolag',
        creditorIrrecoverableDebt: 'Osäker fordran',
        creditorExpiredDebt: 'Preskriberad skuld',
        creditorEconomySetup: 'Konfiguration',
        creditorTribunal: 'Domstol',
        creditorSetup: 'Inställningar',
        creditorAISettings: 'AI',
        creditorWorkflows: 'Arbetsflöden',
        creditorUsers: 'Användare',
        creditorIntegrations: 'Integrationer',
        journalizer: 'Journalisering',
        interactionHistory: 'Interaktionshistorik',
        returnLetters: 'Returbrev',
        outbox: 'Utkorg',
        outboundCalls: 'Utgående samtal',
        import: 'Import',
        support: 'Support',
        search: 'Sök ärenden...',
        settings: 'Inställningar',
        settingsDesc: 'Inställningar för organisation',
        user: 'Mitt konto',
        userDesc: 'Dina inställningar',
        homeOverview: 'Översikt',
        settingsGeneral: 'Allmänt',
        settingsTemplates: 'Mallar',
        settingsDevelopers: 'Utvecklare',
        settingsDevelopersDesc: 'Åtkomst till API och mer',
        settingsSwitchAccount: 'Byt konto',
        settingsSwitchAccountDesc: 'Växla mellan konton',
        settingsTenantBilling: 'Fakturering',
        settingsTenantBillingDesc: 'Se alla fakturor',
        settingsProperties: 'Egenskaper',
        settingsCaseVoucherTables: 'Verifikatstabeller för ärenden',
        settingsDocuments: 'Dokument',
        settingsCaseGroups: 'Ärendegrupper',
        settingsCaseConfig: 'Ärendekonfiguration',
        settingsWebhooks: 'Webhooks',
        settingsSftp: 'SFTP',
        settingsEmbed: 'Inbäddning',
        settingsAPI: 'API',
        settingsCollectors: 'Inkassobolag',
        settingsDebtRegister: 'Skuldregistrering',
        settingsIntegrateCalendar: 'Synkronisera uppgifter till kalender',
        settingsEconomy: 'Ekonomi',
        settingsPriceList: 'Prislista',
        settingsBookkeeping: 'Bokföringsbilaga',
        settingsBilling: 'Faktureringskonfiguration',
        settingsBankAccounts: 'Bankkonton',
        settingsCaseVoucherTypes: 'Verifikatstyper för ärenden',
        settingsBillingVoucherTypes: 'Verifikatstyper för fakturering',
        settingsUsers: 'Användare',
        settingsEndReasons: 'Avslutsorsaker',
        settingsTribunal: 'Domstol',
        settingsTeams: 'Team',
        settingsTenant: 'Organisation',
        settingsUpdateTypes: 'Uppgifter',
        settingsProcedures: 'Genvägar',
        settingsApplications: 'Regelbaserade verifikat',
        settingsCaseMergeRules: 'Regler för sammanslagning av ärenden',
        settingsPaymentPlansConfig: 'Betalningsplaner',
        settingsJournalizerConfig: 'Journalisering',
        settingsAI: 'AI',
        reportsExorts: 'Filexporter',
        reportsPaymentPlans: 'Betalningsplaner',
        reportsCourtMeetings: 'Domstolsmöten',
        reportsDistraints: 'Utmätningar',
        reportsGeneralManagement: 'Ledningsrapportering',
        reportsAI: 'AI',
        reportsPrevious: 'Tidigare rapporter',
        reportsSankey: 'Debbie flödesdiagram',
        settingsWorkflows: 'Arbetsflöden',
        reportsPaymentDays: 'Diagram över betalningsdagar',
        myAccount: 'Mitt konto',
        integrations: 'Integrationer',
    },
    timespanUnits: {
        [TimespanUnit.Years]: 'År',
        [TimespanUnit.Quarters]: 'Kvartal',
        [TimespanUnit.Months]: 'Månader',
        [TimespanUnit.Weeks]: 'Veckor',
        [TimespanUnit.Days]: 'Dagar',
        [TimespanUnit.Hours]: 'Timmar',
        [TimespanUnit.Minutes]: 'Minuter',
        [TimespanUnit.Seconds]: 'Sekunder',
        [TimespanUnit.MS]: 'Millisekunder',
    },
    paymentPlansConfig: {
        description: 'Ställ in vilka alternativ gäldenären ska erbjudas när denne själv upprättar en betalningsplan.',
        minEntryAmountPlaceholder: 'Minsta belopp per avbetalning',
        daysBetweenEntriesPlaceholder: 'Dagar emellan',
        durationPlaceholder: 'Månader',
        addOption: 'Lägg till',
        save: 'Spara',
        override: 'Åsidosätt konfiguration på borgenär',
        disablePaymentPlans: 'Stäng av betalningsplaner så att varken gäldenärer eller handläggare kan upprätta betalningsplaner.',
        requireCentralRegisterId: 'Kräv personnummer/organisationsnummer före signatur',
        activationDeadlineDays: 'Avbryt oaktiverade betalningsplaner efter antal dagar',
    },
    referenceIdFinders: {
        referenceIdFinding: 'Sökning av referens-ID',
        description: 'Journalisera e-post och matcha depositioner baserat på referensnummer såsom kundnummer eller ärendeverifikatsreferenser (t.ex. fakturanummer).',
        length: 'Antal siffror i referensnumret',
        min: 'Minsta möjliga referensnummer',
        max: 'Största möjliga referensnummer',
        createNew: 'Skapa ny referensnummersökning',
        add: 'Lägg till',
        caseVoucherReference: 'Ärendeverifikatsreferens',
        caseVoucherReferenceDescription: 'Ärendeverifikatsreferens (t.ex. fakturanummer)',
        customerReference: 'Kundreferens',
        customerReferenceDescription: 'Kundreferens (t.ex. patient-, klient- eller medlemsnummer)',
    },
    caseMergeRules: {
        description: 'Bestäm om nya verifikat gällande en kund ska läggas till befintliga ärenden eller om ett nytt ärende ska skapas.',
        preventMerge: 'Förhindra sammanslagning med ärenden',
        caseStatusVerified: 'Slå samman med verifierade ärenden',
        adjustVariableCaseVouchers: 'Justera inkassokostnader och avgifter',
        caseStatusPending: 'Slå samman med väntande ärenden',
        hasFoundation: 'Slå samman med ärenden med fordringsunderlag',
        caseVoucherConstraints: 'Ärendeverifikatstyper med dubblettkontroll',
        caseVoucherConstraintsDescription: 'Välj vilka ärendeverifikatstyper som inte ska förekomma på båda ärendena om de skapas inom det angivna antalet dagar. De nyaste ärendeverifikaten tas bort.',
        caseVoucherConstraintsAllDays: 'Ta bort alla',
        caseVoucherConstraintsDays: 'Dagar',
        addCaseVoucherConstraint: 'Lägg till dubblettkontroll',
        addCaseVoucherConstraintSelectVoucherType: 'Välj ärendeverifikatstyp',
        addCaseVoucherConstraintUniqueInDays: 'Unik inom antal dagar (lämna tomt om alla ska tas bort)',
        addCaseVoucherConstraintAddButton: 'Lägg till',
        doesNotHaveUpdateTypeIds: 'Slå inte samman med ärenden med dessa uppgifter',
        doesHaveUpdateTypeIds: 'Slå endast samman med ärenden med dessa uppgifter',
        hasActivePaymentPlan: 'Slå samman ärenden med en aktiv betalningsplan',
    },
    workflows: {
        workflows: 'Arbetsflöden',
        customWorkflows: 'Skapade arbetsflöden',
        standardWorkflow: 'Standardarbetsflöden',
        creditorStandardWorkflowDescription: 'Ställ in vilket arbetsflöde nya ärenden ska skapas i. Om du ändrar arbetsflödet här ändras inte redan skapade ärenden.',
        creditorInteraction: 'till borgenär',
        removeVouchers: 'Ta bort',
        rollbackTask: 'Återställ uppgift',
        rolledback: 'Återställd',
        runTask: 'Flytta ärende till denna uppgift',
        sureYouWantToDeleteTask: 'Är du säker på att du vill radera uppgiften?',
        addRequirement: 'Lägg till krav',
        searchUpdates: 'Sök',
        noUpdatesToShow: 'Inga uppgifter att visa',
        manualSelection: 'Manuellt val',
        changeWorkflowOnCase: 'Byt arbetsflöde',
        nextTaskASAP: 'Nästa uppgift kommer att utföras inom kort',
        workflowWillStartWhenCaseIsVerified: 'Arbetsflödet startar när ärendet är verifierat',
        caseIsPaused: 'Ärendet är pausat',
        pausedBecauseOfPaymentPlan: 'Nästa uppgift utförs om betalningsplanen fallerar',
        priority: 'Prioritet',
        priorityDescription: 'Om en väg inte kan hittas automatiskt används prioriteten. 1 är högsta prioritet.',
        timing: 'Tidpunkt',
        requirements: 'Krav',
        amount: 'Belopp',
        imposedByCreditor: 'Påförd av borgenär',
        text: 'Text',
        addTodo: 'Lägg till att-göra',
        selectTemplate: 'Välj mall',
        includeVoucherAttachments: 'Bifoga verifikatsbilagor (till exempel faktura).',
        attachFoundations: 'Bifoga fordringsunderlag',
        selectEmailPDFAttachment: 'Välj mall som ska bifogas e-postmeddelandet.',
        sendImmediatelyDeviateFromSettings: 'Ska omedelbar utskick avvika från de allmänna inställningarna på ditt konto?',
        sendImmediately: 'Skicka omedelbart',
        doNotSendImmediately: 'Skicka inte omedelbart',
        endCaseIfThereIsNoPrincipalLeft: 'Avsluta ärendet om det inte finns något kapitalbelopp kvar',
        endCaseReason: 'Om ärendet ska avslutas, vilken avslutningsorsak ska användas?',
        selectCollector: 'Välj inkassobolag',
        useCreditorCollector: 'Använd borgenärens identitet',
        creditorCollector: 'Borgenärens identitet',
        setAsPrincipalReferenceCaseVoucher: 'Ange som referensärendeverifikat för kapitalbelopp',
        setMaxTotalAmount: 'Ange max. belopp',
        maxTotalAmount: 'Max. belopp',
        selectCaseGroup: 'Välj ärendegrupp',
        addNewTemplate: 'Lägg till mall',
        addNewTemplateSubheading: 'Lägg till en ny mall',
        timespan: 'Tidsspann',
        timespanUnit: 'Tidsenhet',
        timespanUnitQuantity: 'Tidsspann',
        timeOfDay: 'Tid på dagen',
        moreThan: 'Mer än',
        updateIsActive: 'Uppgifter ska vara aktiva',
        onlySpecificDocumentTypes: 'Endast specifika dokumenttyper',
        propertySingleLineTextOneOfFollowingStrings: 'Är en av följande strängar (kommaseparerade)',
        propertyDropdownOneOfFollowingValues: 'Är en av följande',
        thresholdAmount: 'Belopp',
        caseGroup: 'Ärendegrupp',
        percentageSplitFrom: 'Procentuell fördelning från',
        percentageSplitTo: 'Procentuell fördelning till',
        selectedCreditor: 'Borgenär',
        onlySelectedVoucherCategories: 'Endast valda verifikatskategorier',
        noRequirements: 'Inga krav',
        infoModalHeading: 'Inställningar för arbetsflöde',
        title: 'Titel',
        description: 'Beskrivning',
        endCaseIfThereIsNoDebt: 'Avsluta ärendet om det inte finns någon skuld kvar',
        endCaseIfThereIsNoDebtDesc: 'Om ingen avslutningsorsak väljs fortsätter ärendet bara.',
        selectEndReason: 'Avslutningsorsak',
        newWorkflow: 'Nytt arbetsflöde',
        createNewWorkflow: 'Skapa arbetsflöde',
        duplicateWorkflow: 'Duplicera arbetsflöde',
        deleteWorkflow: 'Radera arbetsflöde',
        deleteWorkflowConfirm: 'Är du säker på att du vill radera detta arbetsflöde?',
        endedCasesPercentage: 'avslutade ärenden',
        casesInTask: 'ärenden i status',
        task: 'Uppgift',
        remind: 'Påminn',
        remindCase: 'Ska uppdateringen läggas till ärendet som en påminnelse?',
        pause: 'Pausa',
        pauseCase: 'Ska ärendet pausas?',
        pauseUnlimited: 'Kräv manuell fortsättning',
        remindNow: 'Påminn nu',
        stats: 'Statistik',
        endedCases: 'Avslutade ärenden',
        sum: 'Summa',
        totalCases: 'Totalt antal ärenden som har varit i denna status',
        currentCases: 'Ärenden som för närvarande är i denna status',
        incomingInteractionsStats: 'Inkommande interaktioner',
        paymentPlansCreatedStats: 'Skapade betalningsplaner',
        satisfactionStats: 'Anseende',
        alternativePaths: 'Alternativa vägar',
        alternativePath: 'Alternativ väg',
        addAlternativePath: 'Lägg till alternativ väg',
        source: 'Från uppgifts-ID',
        mergeCaseTodoDescription: 'Ärendet kommer att försöka slås samman med andra ärenden på kunden baserat på reglerna för sammanslagning. Det är också möjligt att slå samman ärendet med relaterade ärenden baserat på relationstyperna som väljs nedan.',
        mergeWithRelatedCasesOfType: 'Möjlighet att slå samman med relaterade ärenden med relationstyper',
        applyCustomMergeRules: 'Anpassade regler för sammanslagning av ärenden',
        settings: {
            workflowSettings: 'Arbetsflödesinställningar',
            tenantDefaultsDescription: 'Nya ärenden startar i detta arbetsflöde. Det kan åsidosättas för vissa ärendegrupper och enskilda borgenärer.',
            creditorDefaultsDescription: 'Nya ärenden för denna borgenär startar i detta arbetsflöde. Tomma val ärver organisationens inställningar.',
            caseGroupDefaults: 'Undantag per ärendegrupp',
            caseGroupDefaultsDescription: 'Använd ett annat arbetsflöde för vissa ärendegrupper. Det har företräde framför standardarbetsflödet.',
            addCaseGroupDefault: 'Lägg till undantag',
            noAvailableCaseGroups: 'Inga lediga ärendegrupper. Du kan välja ett arbetsflöde per ärendegrupp. Skapa fler ärendegrupper för att lägga till fler undantag.',
            newCaseGroupDefault: 'Nytt undantag',
            newCasesOnly: 'Ändringar gäller endast nya ärenden.',
            executionSettings: 'Körning av arbetsflöden',
            defaultWorkflow: 'Standardarbetsflöde',
            disableWorkflows: 'Inaktivera arbetsflöden',
            disableWorkflowsWarning: 'Är du säker på att du vill inaktivera ALLA arbetsflöden?',
            workflowsDisabled: 'Arbetsflöden är inaktiverade',
            limitExecutionInterval: 'Begränsa tidsintervallet då arbetsflöden kan köras',
        },
    },
    timingTypes: {
        [TimingType.Timespan]: 'Tidsspann',
        [TimingType.TimespanFromDueDate]: 'Tidsspann från senaste förfallodatum',
    },
    updatesEditor: {
        update: 'Uppgift',
        information: 'Information',
        informationDescription: 'Arbetsflöden som uppgiften läggs till i.',
        standardSettings: 'Allmänt',
        standardSettingsDescription: 'Allmänna inställningar för denna uppgift.',
        label: 'Etikett',
        save: 'Spara',
        important: 'Viktig',
        importantPlaceholder: 'Denna uppgift är viktig och bör framhävas på ärendet.',
        pausing: 'Pausande',
        pausingPlaceholder: 'Denna uppgift ska pausa ärendet',
        selectable: 'Valbar',
        selectablePlaceholder: 'Denna uppgift kan väljas på ett ärende',
        procedure: 'Procedur',
        procedureDescription: 'Proceduren som denna uppgift ska utföra. Om aktiverad utförs den definierade proceduren om den är i ett arbetsflöde.',
        procedureOn: 'Aktivera procedur för denna uppgift',
        procedurePlaceholder: 'Aktivera procedur',
        onCaseExit: 'Vid ärendeavslut',
        onCaseExitDescription: 'Om ett ärende avslutas med denna uppgift, sätt på en självvald uppgift.',
        onCaseExitContinueUpdates: 'Ska uppgifter av denna typ fortsätta när ett ärende avslutas?',
        continueOnCaseExit: 'Fortsätt vid ärendeavslut',
        onCaseExitPauseWith: 'Vid ärendeavslut, pausa ärendet med denna uppgift',
        selectUpdateType: 'Uppdateringstyp',
        roles: 'Roller',
        rolesDescription: 'Välj ansvarig roll',
        responsibleRole: 'Ansvarig roll',
        hiddenForCreditors: 'Dold för borgenärer',
        hiddenForCreditorsPlaceholder: 'Ska denna uppgift döljas för borgenärer?',
        introduction: 'Introduktion',
        introductionDescription: 'Introduktion till uppdateringen med text och eventuellt en bild. Det är en fördel, om borgenären är ansvarig, att göra en bra introduktion.',
        introductionHeaderImage: 'Hjältebild',
        introductionHeaderImageDropText: 'Dra och släpp en hjältebild här',
        deleteButton: 'Radera uppgift',
        deleteWarning: 'Du raderar både uppdateringstypen men också alla uppdateringar av typen. Vill du fortsätta?',
    },
    workflowTodoTypes: {
        [TodoType.AddVoucher]: 'Lägg till verifikat',
        [TodoType.AddBillingVoucher]: 'Lägg till faktureringsverifikat',
        [TodoType.RemoveVoucher]: 'Ta bort verifikat',
        [TodoType.CreateInteraction]: 'Skapa interaktion',
        [TodoType.CreateCreditorInteraction]: 'Skapa interaktion till borgenär',
        [TodoType.CreateOtherInteraction]: 'Skapa interaktion till annan',
        [TodoType.SetCollector]: 'Ange inkassobolag',
        [TodoType.SetCaseGroup]: 'Ange ärendegrupp',
        [TodoType.MoveToTenant]: 'Flytta ärende till organisation',
        [TodoType.ChangeCaseStatus]: 'Ändra ärendestatus',
        [TodoType.OutboundCall]: 'Utgående samtal',
        [TodoType.SetCaseTag]: 'Lägg till ärendetagg',
        [TodoType.RemoveCaseTag]: 'Ta bort ärendetagg',
        [TodoType.DebtRegister]: 'Registrera i skuldregister',
        [TodoType.DebtRegisterSkip]: 'Redo att registrera i skuldregister?',
        [TodoType.SubmitToCourt]: 'Lämna in till domstol',
        [TodoType.ReadyToSubmitToCourt]: 'Redo att lämna in till domstol?',
        [TodoType.ConnectToDebtCollector]: 'Skicka till en connect-partner',
        [TodoType.ReturnToConnectSource]: 'Återlämna ärende till connect-partner',
        [TodoType.SwitchWorkflow]: 'Byt arbetsflöde',
        [TodoType.SwitchBackToPreviousWorkflow]: 'Byt tillbaka till föregående arbetsflöde',
        [TodoType.Bespoke]: 'Anpassad',
        [TodoType.MergeCase]: 'Slå samman ärende om möjligt',
        [TodoType.CreateProperties]: 'Skapa egenskaper',
        [TodoType.SetResponsible]: 'Ange ansvarig på ärendet',
        [TodoType.MarkExpired]: 'Markera ärendeverifikat som preskriberade',
        [TodoType.SetCaseSetting]: 'Ange ärendeinställning',
    },
    workflowPathWarnings: {
        [PathWarning.ReadyForEboksRequirementRecommended]: 'Kravet "Redo för e-Boks" rekommenderas',
        [PathWarning.ValidEmailRequirementRecommended]: 'Kravet "E-post giltig" rekommenderas',
        [PathWarning.ValidAddressRequirementRecommended]: 'Kravet "Adress giltig" rekommenderas',
    },
    workflowRequirementTypes: {
        [RequirementType.MissingUpdate]: 'Har inte en av valda uppdateringar',
        [RequirementType.HasUpdate]: 'Har en av valda uppdateringar',
        [RequirementType.HasNoValidAddress]: 'Adress ogiltig',
        [RequirementType.HasValidCentralRegisterId]: 'Har organisationsnummer / personnummer',
        [RequirementType.HasNoValidCentralRegisterId]: 'Har inte organisationsnummer / personnummer',
        [RequirementType.HasValidAddress]: 'Adress giltig',
        [RequirementType.HasValidEmail]: 'E-post giltig',
        [RequirementType.HasNoValidEmail]: 'E-post ogiltig',
        [RequirementType.IsCompany]: 'Är företag',
        [RequirementType.ReadyForEInvoice]: 'Redo för e-faktura',
        [RequirementType.ReadyForEboks]: 'Redo för e-Boks',
        [RequirementType.DebtRemarks]: 'Betalningsanmärkningar',
        [RequirementType.HasValidPhone]: 'Telefon giltig',
        [RequirementType.HasNoValidPhone]: 'Telefon ogiltig',
        [RequirementType.IsPrivate]: 'Är privatperson',
        [RequirementType.AmountThreshold]: 'Beloppströskel',
        [RequirementType.CaseGroup]: 'Är en av ärendegrupperna',
        [RequirementType.PercentageSplit]: 'Procentuella ärenden',
        [RequirementType.HasFoundation]: 'Har fordringsunderlag',
        [RequirementType.DoesNotHaveFoundation]: 'Har inte fordringsunderlag',
        [RequirementType.SpecificCreditor]: 'Specifik borgenär',
        [RequirementType.CustomerHasTag]: 'Kund har tagg',
        [RequirementType.CaseHasTag]: 'Ärende har tagg',
        [RequirementType.HasIncomingInteractions]: 'Har inkommande interaktion',
        [RequirementType.CaseStatusIn]: 'Ärendestatus är en av',
        [RequirementType.Property]: 'Regel baserad på egenskap',
    },
    embeds: {
        embeds: 'Embed',
        embedTitle: 'Titel på embed-område',
        embedURL: 'URL som ska anropas',
        embedHeight: 'Områdets höjd i px',
        addEmbedArea: 'Lägg till embed-område',
        embedPlacement: 'Placering',
        embedToken: 'Valideringstoken',
        embedCreatedAt: 'Skapad',
        noAreasYet: 'Inga embed-områden ännu',
        couldNotLoad: 'Kunde inte ladda',
        caseworkerNavMenuItemCategory: 'Externt',
        creditorNavMenuItemCategory: 'Externt',
        calledWithDescription: 'URL:en anropas med en GET-förfrågan med följande query-parametrar och headers',
        header: 'Header',
    },
    embedPlacements: {
        [EmbedPlacement.CaseworkerWebCreditorPage]: 'Debbie Caseworker Web: Borgenärssida uppe till höger',
        [EmbedPlacement.CaseworkerWebCasePage]: 'Debbie Caseworker Web: Ärendesida under ekonomipanelen',
        [EmbedPlacement.CaseworkerWebMenuItem]: 'Debbie Caseworker Web: Helsida med länk i menyn till höger',
        [EmbedPlacement.CreditorWebCasePage]: 'Debbie Creditor Web: Ärendesida under ekonomipanelen',
        [EmbedPlacement.CreditorWebFrontPage]: 'Debbie Creditor Web: Startsida till höger',
        [EmbedPlacement.CreditorWebMenuItem]: 'Debbie Creditor Web: Helsida med länk i menyn till höger',
    },
    webhookSettings: {
        noWebhooksYet: 'Inga webhooks ännu',
        hookNotFound: 'Den tillhörande webhook-konfigurationen kunde inte hittas. Kontrollera att du är på rätt organisation.',
        failedToLoad: 'Det gick inte att ladda webhook-detaljerna. Försök igen senare.',
        webhook: 'Webhook',
        webhooks: 'Webhooks',
        columnEvent: 'Händelse',
        columnWebhook: 'Webhook',
        columnUrl: 'URL',
        columnDate: 'Datum',
        columnState: 'Status',
        stateAwaiting: 'Väntar',
        statePermanentlyFailed: 'Permanent misslyckad',
        stateSucceeded: 'Genomförd',
        namePlaceholder: 'Namn på webhook',
        urlPlaceholder: 'Webhook-URL',
        emailPlaceholder: 'E-post för felaviseringar',
        requestHeaders: 'Request headers',
        otherSettings: 'Övriga inställningar',
        deepFlatten: 'Platta ut request body för att undvika nästlade JSON-objekt',
        pullWebhooks: 'Pull webhooks',
        advancedSettings: 'AVANCERADE INSTÄLLNINGAR',
        addWebhook: 'Lägg till webhook',
        pullWebhook: 'Pull webhook',
        verificationToken: 'Verifieringstoken',
        headerKeyPlaceholder: 'Header-nyckel',
        headerValuePlaceholder: 'Header-värde',
        addHeader: 'Lägg till header',
        eventDate: 'Händelsedatum',
        headers: 'Headers',
        body: 'Body',
        bodyMapping: 'Body-mappning',
        resendWebhook: 'Skicka om webhook',
        attempts: 'Försök',
        nextAttemptAt: 'Nästa försök:',
        attemptSuccess: 'Genomförd',
        attemptFailed: 'Misslyckad',
        copy: 'KOPIERA',
        columnCreditor: 'Borgenär',
        allCreditors: 'Alla borgenärer',
    },
    userOverrideSettings: {
        label: 'Gäldenärsöverskrivningar',
        description: 'Du kan använda gäldenärsöverskrivningar för att automatiskt ändra information för kunder som uppfyller vissa kriterier. När en kund som uppfyller dessa kriterier uppdateras ersätts de valda fälten automatiskt med de inställningar du har gjort.',
        whenMatching: 'När en gäldenär matchar',
        overrideFields: 'Överskriv fält',
        deleteEmail: 'Ta bort e-post',
    },
    apiSettings: {
        documentation: 'API-dokumentation',
        keys: 'API-nycklar',
        noKeysYet: 'Det finns inga nycklar ännu',
        newKeyButton: 'Skapa ny API-nyckel',
        newKey: 'Ny API-nyckel',
        newKeyCreatedInfo: 'Det var allt! Kom ihåg att förvara din nyckel på en säker plats. Detta är första och sista gången du kan hämta den från Debbie.',
        closeModal: 'Uppfattat',
        keyName: 'Namnge din API-nyckel',
        createNewKey: 'Skapa ny API-nyckel',
    },
    updateTypeSettings: {
        label: 'Etikett',
        responsibleRole: 'Ansvarig roll',
        isImportant: 'Viktig',
        tenantSpecific: 'Organisationsspecifik',
        isTenantSpecific: 'Är organisationsspecifik',
        referenceType: 'Referenstyp',
        onCaseExit: 'Vid ärendets avslut pausa med',
        isPausing: 'Pausar',
        hiddenForRoles: 'Dold för roll',
        knowledgeBaseLink: 'Kunskapsbas',
        deadlineTitle: 'Tidsfrist',
        deadlineDescription: 'Antal dagar en uppgift av denna typ får ligga i uppgiftslistan innan tidsfristen anses överskriden. Lämna fältet tomt om ingen tidsfrist ska gälla.',
        deadlinePlaceholder: 'T.ex. 7',
        deadlineSave: 'Spara',
    },
    overview: {
        todoList: 'Att göra-lista',
        noDescription: 'Ingen beskrivning',
        noPauseStatus: 'Ingen pausstatus',
        settlementTime: 'Tid till förlikning i månader',
        instalmentAgreement: 'Avbetalningsavtal',
        statistics: 'Statistik',
        averageIntro: 'Det tar i genomsnitt',
        averageOutro: 'dagar för ett ärende att förlikas.',
        quantityCases: 'Antal ärenden',
        quantifyCustomers: 'Antal kunder',
        statusDistribution: 'Statusfördelning',
        chartStatuses: {
            Godkendt: 'Godkänd',
            'Afventer Godkendelse': 'Väntar på godkännande',
            Afsluttet: 'Slutförd',
            Annuleret: 'Annullerad',
            Afslutningsårsag: 'Avslutsorsak',
        },
    },
    endReason: {
        [SystemEndReason.ErrorCreditor]: 'Fel från borgenär',
        [SystemEndReason.ErrorUs]: 'Felaktig skapelse',
        [SystemEndReason.Expiration]: 'Ärendet har förfallit',
        [SystemEndReason.Departed]: 'Gäldenären har avvikit (flyttat/lämnat)',
        [SystemEndReason.Unidentified]: 'Gäldenären kan inte valideras',
        [SystemEndReason.AddressUnknown]: 'Gäldenärens adress är okänd',
        [SystemEndReason.Paid]: 'Gäldenären har betalat hela skulden',
        [SystemEndReason.Transferred]: 'Ärendet har överförts',
        [SystemEndReason.Dead]: 'Gäldenären har avlidit',
        [SystemEndReason.Objection]: 'Avslutat på grund av bestridande',
        [SystemEndReason.Withdrawn]: 'Borgenären har återkallat ärendet',
        [SystemEndReason.OfferFromUs]: 'Betalat enligt ackordsförslag från oss',
        [SystemEndReason.OfferFromDebtor]: 'Betalat enligt ackordsförslag från gäldenären',
        [SystemEndReason.DebtRelief]: 'Gäldenären har beviljats skuldsanering',
        [SystemEndReason.Bankruptcy]: 'Gäldenären är i konkurs',
        [SystemEndReason.ForcedDissolved]: 'Gäldenären har tvångslikviderats',
        [SystemEndReason.ConflictOfInterest]: 'Intressekonflikt mellan gäldenären och oss',
        [SystemEndReason.NegativePayoff]: 'Negativ utbetalning för borgenären',
        [SystemEndReason.Overpayment]: 'Gäldenären har betalat för mycket',
        [SystemEndReason.Minor]: 'Gäldenären är minderårig',
        [SystemEndReason.Irrecoverable]: 'Ärendet är oindrivbart',
        [SystemEndReason.PartiallyPaid]: 'Delvis betalat',
        [SystemEndReason.CreditorUnresponsive]: 'Borgenären svarar inte',
        [SystemEndReason.Merged]: 'Ärendet har sammanslagits',
        [SystemEndReason.FireAndForget]: 'Fire & forget',
        [SystemEndReason.SmallCaseNotWanted]: 'Litet ärende ej önskat',
        [SystemEndReason.NoDebt]: 'Ingen skuld',
        [SystemEndReason.Deleted]: 'Raderad',
        [SystemEndReason.NoCourt]: 'Ärendet går genom den utomrättsliga processen',
        [SystemEndReason.Other]: 'Annan orsak',
    },
    courtSubmitErrors: {
        [SubmitToCourtError.IsNotWarned]: 'Ärendet ej varnat',
        [SubmitToCourtError.CurrencyNotDKK]: 'Valutan är inte DKK',
        [SubmitToCourtError.WarningWasReturned]: 'Varning ej levererad',
        [SubmitToCourtError.AlreadyHasFoundation]: 'En grund har redan registrerats på detta ärende',
        [SubmitToCourtError.MoreThanOneDebtor]: 'Det finns fler än en gäldenär på detta ärende',
        [SubmitToCourtError.HasAlternativeContact]: 'Ärendet har alternativ kontakt',
        [SubmitToCourtError.EconomyContactMissing]: 'En betalningsansvarig till domstolen saknas',
        [SubmitToCourtError.CreditorNameMissing]: 'Borgenärens namn saknas',
        [SubmitToCourtError.CreditorAddressMissing]: 'Borgenärens adress saknas',
        [SubmitToCourtError.CompanyFullResponsibleParticipantMissing]: '"Fuldt ansvarlig deltager" saknas',
        [SubmitToCourtError.CompanyDirectorNameMissing]: 'Namn på direktör saknas',
        [SubmitToCourtError.CompanyDirectorAddressMissing]: 'Adress till direktör saknas',
        [SubmitToCourtError.JurisdictionMissing]: 'Kunde inte hitta domstol',
        [SubmitToCourtError.EconomicalSubmitThreshold]: 'Ärendets saldo är lägre än tröskelvärdet',
        [SubmitToCourtError.SagsfremstillingMissing]: 'Ärendeframställning saknas',
        [SubmitToCourtError.CaseHasExceededMaxDebtRegistrationsThreshold]: 'Ärendet har överskridit borgenärens maximala tröskel för skuldregistreringar',
        [SubmitToCourtError.AlreadyInCourt]: 'Redan registrerat i domstol',
        [SubmitToCourtError.AddressNotInDK]: 'Adressen är inte dansk',
        [SubmitToCourtError.DebtorMovedAbroad]: 'Gäldenären har flyttat utomlands',
        [SubmitToCourtError.CaseHasDeposits]: 'Ärendet har depositioner',
        [SubmitToCourtError.DebtorBankrupt]: 'Gäldenären är i konkurs',
        [SubmitToCourtError.DebtorCompanyCeased]: 'Gäldenärens företag har upphört',
        [SubmitToCourtError.DebtorDead]: 'Gäldenären är avliden',
        [SubmitToCourtError.DebtorHomeless]: 'Gäldenären är hemlös',
        [SubmitToCourtError.ExcessiveReminderFeeImposed]: 'För många påminnelseavgifter påförda',
        [SubmitToCourtError.ExcessiveCollectionFeeImposed]: 'För många inkassoavgifter påförda',
        [SubmitToCourtError.ExcessiveCollectionCostImposed]: 'Inkassokostnaderna stämmer inte med det beräknade beloppet',
        [SubmitToCourtError.ExcessivePrincipal]: 'Kapitalbeloppet överstiger det högsta tillåtna',
        [SubmitToCourtError.IsNotDebtor]: 'Den valda kontaktpersonen är en företrädare',
    },
    templateTags: {
        [TemplateTag.BPKWarning]: 'Varning från Kronofogden',
        [TemplateTag.DebtRegistrationWarning]: 'RKI-varning',
    },
    templates: {
        allTemplates: 'Alla mallar',
        searchTemplates: 'Sök mallar',
        customTemplates: 'Skapade mallar',
        standardTemplates: 'Standardmallar',
        confirmDelete: 'Är du säker på att du vill radera denna mall?',
        delete: 'Radera',
        updateTypesUsingThisTemplate: 'Uppgifter som använder denna mall',
        newTemplate: 'Ny mall',
        selectType: 'Välj typ',
        letter: 'Brev',
        name: 'Namn',
        create: 'Skapa',
        quantityTemplates: 'Antal mallar',
        singleOwner: 'Välj en enskild ägare',
        standard: 'Standard',
        alternativeContact: 'Alternativ kontakt',
        saveDraft: 'Spara utkast',
        saveAndPublish: 'Spara och publicera',
        preview: 'Förhandsvisa',
        versions: 'Versioner',
        publish: 'Publicera',
        copyOtherTemplate: 'Importera från mall',
        copy: 'Kopiera mall',
        settings: 'Inställningar',
        lastChangedOn: 'Senast ändrad',
        by: 'av',
        WIP: 'Pågående arbete',
        versionPublished: 'Denna version är publicerad',
        selectTestCase: 'Välj ett testärende',
        collector: 'Inkassobolag',
        ifCollectorSelected: 'Om vald visas denna mall endast på ärenden med inkassobolaget.',
        selectCollector: 'Välj inkassobolag',
        creditor: 'Borgenär',
        ifCreditorSelected: 'Om vald visas denna mall endast på ärenden med borgenären.',
        selectCreditor: 'Välj borgenär',
        letterTheme: 'Brevtema',
        ifThemeSelected: 'Detta väljer mallens design.',
        selectTheme: 'Välj malltema',
        fileName: 'Filnamn',
        docxTemplate: 'Word-mall (.docx)',
        docxTemplateDescription: 'Ladda upp ett Word-dokument som brevet ska renderas från. Infoga {~~body} där innehållet från rich text-redigeraren ska visas (HTML renderas via docxtemplater HTML-modulen). Övriga platshållare (t.ex. {customer.name}) fylls i från ärendedata.',
        uploadDocxTemplate: 'Ladda upp .docx',
        removeDocxTemplate: 'Ta bort .docx-mall',
        docxTemplateUploaded: 'Word-mall uppladdad',
        docxTemplateUploadFailed: 'Det gick inte att ladda upp Word-mallen',
        docxAvailableTags: 'Tillgängliga malltaggar',
        docxAvailableTagsDescription: 'Klicka på en tagg för att kopiera den. Klistra in den i Word-mallen där du vill att värdet ska visas.',
        docxTag: 'Tagg',
        docxBodyTagDescription: 'Infoga innehållet från rich text-redigeraren här (renderas som HTML).',
        docxConditionalBadge: 'Villkorlig',
        docxConditionalIfTrue: 'Om sant',
        docxConditionalIfFalse: 'Om falskt',
        docxConditionalDescription: 'Använd det första blocket för att visa innehåll när fältet är sant och det andra blocket när det är falskt. Kopiera endast det block du behöver — båda kan användas tillsammans om du vill ha olika innehåll för båda fallen.',
        docxHtmlDescription: 'Värdet innehåller HTML och renderas som formaterad text (radbrytningar, fetstil osv. bevaras).',
        state: 'Tillstånd',
        type: 'Typ',
        savedAt: 'Sparad',
        firstName: 'Förnamn',
        lastName: 'Efternamn',
        view: 'Visa',
        confirmDeleteItem: 'Är du säker på att du vill radera detta objekt?',
        confirmPublish: 'Ändringar sparas INTE. Du kommer att publicera den senast sparade versionen av mallen. Är du säker?',
        validations: {
            missing: 'Saknas',
            invalidOrder: 'Ogiltig ordning',
            inSubject: 'i ämnesraden',
            inBody: 'i brödtexten',
        },
        addTag: 'Lägg till tagg',
        selectTag: 'Välj tagg',
    },
    templateTypes: {
        [TemplateType.AUTOCALL]: 'Autouppringning',
        [TemplateType.EBOKS]: 'e-Boks',
        [TemplateType.KIVRA]: 'Kivra',
        [TemplateType.DIGIPOST]: 'Digipost',
        [TemplateType.EMAIL]: 'E-post',
        [TemplateType.LETTER]: 'Brev',
        [TemplateType.SMS]: 'SMS',
    },
    integrations: {
        chooseCreditor: 'Välj borgenär för integrationen',
        active: 'Aktiv',
        activeIntegrations: 'Aktiva integrationer',
        available: 'Integrationer tillgängliga för borgenär',
        unavailable: 'Integrationer ej tillgängliga för borgenär',
        isAvailable: 'Ge borgenären åtkomst att konfigurera eller inaktivera integration',
        connect: 'Anslut',
        deactivate: 'Pausa integration',
        reactivate: 'Återaktivera',
        integrationOptions: 'integrationsalternativ',
        importAllText: 'Importera fakturor före förfallodatum',
        updateCustomers: 'Uppdatera kunddata när de ändras i e-conomic',
        cutoffDateText: 'Brytdatum (Importera endast fakturor efter detta datum, importerar alla om ej angivet)',
        runsOut: '',
        turnsDue: '',
        invoiceDate: 'Antal dagar efter fakturadatumet som bokföringsposterna ska överföras',
        dueDate: 'Antal dagar efter fakturans förfallodatum som bokföringsposterna ska överföras',
        notChangable: 'Alternativen kan inte ändras igen senare.',
        all: 'Alla',
        recommended: 'Rekommenderad',
        essential: 'Nödvändig',
        additionalCustomers: 'ytterligare kunder',
    },
    eConomicTypeName: {
        creditNote: 'Kreditnota',
        invoice: 'Faktura',
        payment: 'Betalning',
        reminder: 'Påminnelse',
    },
    integrationMapper: {
        voucherNumber: 'Verifikatsnummer',
        invoiceNumber: 'Fakturanummer',
        amountLeftToMap: 'Belopp kvar att mappa',
        totalAmount: 'Verifikatsbelopp',
        noMoreEntries: 'Det finns inga fler poster att mappa',
        selectEntries: 'Välj en post för att börja mappa',
        customerId: 'Kund-id',
        map: 'Mappa',
        notAvailable: 'E-conomic-mappning är inte tillgänglig ännu, kontakta Debbies support för hjälp med mappning',
        selectedEntryLabel: 'Vald post utan mappning',
        potentialMatches: 'Potentiella matchningar',
    },
    createdBy: {
        createdBy: 'Skapad av',
        goToImport: 'Gå till import',
    },
    createdByType: {
        [PerformedByType.Connect]: 'connect',
        [PerformedByType.Import]: 'import',
        [PerformedByType.Integration]: 'integration',
        [PerformedByType.Key]: 'API-nyckel',
        [PerformedByType.User]: 'användare',
        [PerformedByType.Workflow]: 'arbetsflöde',
        [PerformedByType.Trigger]: 'utlösare',
        [PerformedByType.VoucherApplication]: 'regelbaserat verifikat',
        [PerformedByType.BulkAction]: 'massåtgärd',
        [PerformedByType.UpdateTypeOnCaseEnd]: 'uppdateringstyp vid ärendets avslut',
        [PerformedByType.InteractionCategory]: 'interaktionskategori',
        [PerformedByType.AI]: 'AI',
        [PerformedByType.PaymentPlan]: 'betalningsplan',
        [PerformedByType.System]: 'system',
    },
    createdByTypeLabel: {
        [PerformedByType.PaymentPlan]: 'bp',
    },
    journalizer: {
        update: 'Uppdatera',
        deleteInteraction: 'Radera interaktion',
        unknownEntityInteraction: 'Begär journalnummer',
        recentlyJournalized: 'NYLIGEN JOURNALFÖRDA',
        unmap: 'AVMAPPA',
        suggested: 'FÖRESLAGNA',
        noInteractions: 'Det finns för närvarande inga interaktioner',
        searchCreditors: 'Sök borgenärer...',
        journalizeOnCase: 'Journalför på ärende',
        journalizeOnCreditor: 'Journalför på borgenär',
    },
    returnLetter: {
        unknownAtAddress: 'Okänd mottagare',
        addressNotAdequate: 'Adressen är otillräcklig',
        nameNotVisible: 'Mottagarens namn syns inte på brevlådan',
        recipientMoved: 'Mottagaren har flyttat och den nya adressen är okänd eller det finns problem gällande flytten',
        recipientNoExist: 'Mottagaren existerar inte',
        letterCantBeDelivered: 'Brevet kan inte levereras',
        cantFindStreet: 'Gatunamn/husnummer kan inte hittas',
        mailboxIssue: 'Problem med brevlådan',
        emptyPlace: 'Bostaden är obebodd/tomt hus/lägenhet',
        noHouseOrConstruction: 'Det finns ingen bostad eller så är den under uppförande',
        otherIssues: 'Problem såsom bristande snöröjning eller andra problem som hindrar åtkomst',
        deliveryRejected: 'Leverans avvisad',
        recipientRejectsLetter: 'Mottagaren avvisar leveransen och accepterar inte att ta emot brevet',
    },
    returnLetterReasons: {
        [ReturnReason.DENIED]: 'Avvisad',
        [ReturnReason.NOTDELIVERABLE]: 'Ej levererbar ',
        [ReturnReason.UNKNOWNRECIPIENT]: 'Okänd mottagare',
    },
    outbox: {
        verifyInteraction: 'Verifiera interaktion',
        editTemplate: 'Redigera mall',
        deleteInteraction: 'Radera interaktion',
        rollbackChain: 'Återställ arbetsflöde',
        goToCase: 'Gå till ärende',
        envelope: 'Kuvert',
        nextLetterSending: 'Nästa brevutskick schemalagt till',
        filters: 'Filter',
        includeInteractionsPaused: 'Inkludera interaktioner på pausade ärenden',
        aiFilterHeader: 'AI',
        aiFilterAll: 'Alla',
        aiFilterAi: 'AI',
        aiFilterNoAi: 'Ingen AI',
        filterOnInteractionType: 'Filtrera på typer av interaktioner',
        filterOnCreditor: 'Filtrera på borgenär',
        filterOnTemplate: 'Filtrera på mall',
        autoSendModalHeader: 'Konfigurera automatiskt utskick',
        autoSendDescription: 'Ange hur många manuella utskick som måste göras från utkorgen för varje mallversion innan meddelanden skickas automatiskt. Om du sätter värdet till 0 skickas alla meddelanden automatiskt utan att kräva godkännande. Detta ger flexibilitet mellan full automatisering och manuell kontroll — beroende på dina behov.',
        configureAutoSend: 'Konfigurera automatiskt utskick',
        autoSendOn: 'När {{autoSendQuantity}} meddelanden med denna mallversion har skickats kommer alla framtida meddelanden att skickas automatiskt.',
    },
    inputs: {
        creditorSelect: 'Välj borgenär',
        from: 'Från',
        to: 'Till',
        max: 'Max.',
        min: 'Min.',
        phoneNumber: 'Telefonnummer',
        phoneLocale: 'Landskod',
        searchForCompany: 'Sök företag',
        search: 'Sök',
        noResults: 'Inga resultat',
        recentlyUsed: 'Senast använda',
        clear: 'Rensa',
        searchAddress: 'Sök adress',
        manual: 'Manuell',
        address: 'Adress',
        noAddress: 'Ingen adress',
        co: 'C/O',
        zipcode: 'Postnummer',
        city: 'Ort',
        country: 'Land',
        done: 'Klar',
        removeAddress: 'Ta bort adress',
        remove: 'Ta bort',
        save: 'Spara',
        saved: 'Sparad',
        dropToUpload: 'Släpp för att ladda upp',
        uploadFailed: 'Uppladdning misslyckades',
        overrideDefault: 'Åsidosätt standardvärde',
        overrideTenantSetting: 'Åsidosätt organisationsinställning',
    },
    paymentOptions: {
        addNew: 'Lägg till nytt betalningsalternativ',
        currencies: 'Valutor',
        bankName: 'Banknamn',
        registrationNumber: 'Clearingnummer',
        accountNumber: 'Kontonummer',
        fi: 'FI-borgenärsnummer',
        fikSyntax: 'Använd kapitalbeloppspostens referensnummer som id istället för ärendenummer',
        useAlternativeCreditorNumberInCaseVoucherTables: 'Använd alternativt borgenärsnummer i ärendets verifikatstabeller',
        iban: 'IBAN-borgenärsnummer',
        swift: 'SWIFT-borgenärsnummer',
        reepayPrivateKey: 'Frisbii privat API-nyckel',
        farpayPrivateKey: 'Farpay privat API-nyckel',
        dankort: 'Dankort',
        visa: 'Visa',
        mastercard: 'Mastercard',
        currencySpecific: 'Endast valda valutor',
        mobilepay: 'MobilePay',
        swish: 'Swish',
        vipps: 'Vipps',
        betalingsservice: 'Betalingsservice',
        leverandorservice: 'Leverandørservice',
        isActive: 'Aktiv betalningsgateway',
        confirmChangeOfPaymentGateway: 'Är du säker på att du vill ändra din betalningsgateway?',
        mobilePeopleHmac: 'MobilePeople HMAC',
        mobilePeopleClientRef: 'MobilePeople Client Reference',
        url: 'Länk till betalningsgateway',
        titleToDebtor: 'Titel i gäldenärswebben',
        descriptionToDebtor: 'Beskrivning i gäldenärswebben',
        hideOnDebtorweb: 'Dölj i gäldenärswebben',
    },
    paymentOptionTypes: {
        [PaymentOptionType.BANKTRANSFER]: 'Banköverföring',
        [PaymentOptionType.FI]: 'FIK-rad',
        [PaymentOptionType.SWIFT]: 'SWIFT',
        [PaymentOptionType.REEPAY]: 'Frisbii Payment Gateway',
        [PaymentOptionType.FARPAY]: 'Farpay Payment Gateway',
        [PaymentOptionType.MOBILE_PEOPLE]: 'MobilePeople Payment Gateway',
        [PaymentOptionType.LINK_TO_OWN_PAYMENT]: 'Länk till egen betalningsgateway',
    },
    todoPanel: {
        searchTodos: 'Sök',
        overdueTooltip: (count) => `${count} ${count === 1 ? 'uppgift har' : 'uppgifter har'} passerat tidsfristen`,
    },
    support: {
        imgsrc: 'https://storage.googleapis.com/debbie-public-files/help-ad-en.svg',
        readMore: 'Läs mer',
    },
    home: {
        welcome: 'Välkommen',
        todos: 'Att göra',
        caseworkerTodo: 'Att göra för handläggare',
        todoPlaceholder: 'Inget att visa',
        clientTodo: 'Att göra för borgenär',
        clientTodoPlaceholder: 'Inget att visa',
        noResponsibleTodo: 'Att göra utan någon ansvarig',
        noResponsibleTodoPlaceholder: 'Inget att visa',
        pendingCases: 'Väntande ärenden',
        pendingCasesPlaceholder: 'Inga väntande ärenden att visa',
        pendingDunningCases: 'Nya kravärenden',
        pendingDunningCasesPlaceholder: 'Inga nya kravärenden att visa',
        topCases: 'Topp 150 ärenden efter skuldbelopp',
        topCasesPlaceholder: 'Inget ärende att visa',
        unassigned: 'Ej tilldelad',
        today: 'Idag',
        yesterday: 'Igår',
        thisMonth: 'Denna månad',
        lastMonth: 'Förra månaden',
        deposits: 'Depositioner',
        depositsSmall: 'depositioner',
        depositsToClient: 'Depositioner till borgenär',
        depositsToCollector: 'Depositioner till inkassobolag',
        depositCount: 'Antal depositioner',
        paymentPlans: 'Betalningsplaner',
        totalPlans: 'Totalt antal planer',
        totalActivePlans: 'Aktiva planer',
        totalSettledAmount: 'Totalt reglerat belopp',
        settledAmountLastMonth: 'Reglerat belopp förra månaden',
        settledAmountThisMonth: 'Reglerat belopp denna månad',
        plannedAmountNextMonth: 'Planerat belopp nästa månad',
        cases: 'Ärenden',
        interactions: 'Interaktioner',
        foundations: 'Underlag',
        totalFoundations: 'Totalt antal underlag',
    },
    autoCall: {
        called: 'Till',
        from: 'Från',
        with: 'med',
        withVoice: 's röst',
        call: 'Ring',
        addAction: 'Lägg till åtgärd',
        selectAction: 'Välj åtgärd',
    },
    autoCallEvents: {
        started: 'Startad',
        ringing: 'Ringer',
        answered: 'Besvarad',
        completed: 'Slutförd',
        inbound: 'Inkommande',
        busy: 'Upptaget',
        timeout: 'Ej besvarad',
        rejected: 'Avvisad',
        machine: 'Röstbrevlåda',
    },
    interactionTypes: {
        [InteractionType.AutoCall]: 'Autosamtal',
        [InteractionType.ClientNote]: 'Meddelande till borgenär',
        [InteractionType.DebtorNote]: 'Meddelande till gäldenär',
        [InteractionType.Eboks]: 'e-Boks',
        [InteractionType.Kivra]: 'Kivra',
        [InteractionType.Digipost]: 'Digipost',
        [InteractionType.Email]: 'E-post',
        [InteractionType.Letter]: 'Brev',
        [InteractionType.Note]: 'Anteckning',
        [InteractionType.Other]: 'Övrigt',
        [InteractionType.Personal]: 'Personligt',
        [InteractionType.Phone]: 'Samtal',
        [InteractionType.SMS]: 'SMS',
        [InteractionType.EInvoice]: 'E-faktura',
    },
    interactions: {
        interaction: 'interaktion',
        metadata: 'Metadata',
        removingPhoneNumberOnSubmit: 'När telefonsamtalet registreras kommer telefonnumret att raderas från gäldenären.',
        events: 'Händelser',
        sendLetter: 'Skicka brev',
        addTemplate: 'Lägg till från mall',
        sendEBoks: 'Skicka',
        from: 'Från',
        to: 'Till',
        subject: 'Ämne',
        sent: 'Skickad',
        debtorInteraction: 'Meddelande',
        newInteractions: 'Nya interaktioner',
        courtEmailSubject: 'Ärende hos {{collector.name}}: {{tribunal.latestReferenceId}} [ärendenr: {{journalNumber}}]',
        emailSubjectMessageFrom: 'Meddelande från',
        areYouSureProcedure: 'Är du säker på att du vill köra denna genväg?',
        procedures: 'Genvägar',
        reminder: 'Påminnelse',
        unlikelyToReceive: 'Tidigare interaktioner via denna kanal misslyckades',
        removeMarking: 'Ta bort markering',
        attachment: 'bilaga',
        other: 'Övrigt',
        OUTGOING: 'Utgående',
        INCOMING: 'Inkommande',
        UNMAPPED: 'Ej kopplad',
        MAPPED: 'Kopplad',
        HANDLED: 'Hanterad',
        DELETED: 'Raderad',
        PENDING: 'Väntande',
        CANCELLED: 'Avbruten',
        SENT: 'Skickad',
        QUEUED: 'I kö',
        delete: 'Radera',
        verify: 'Verifiera',
        transacted: 'Skickad',
        journalizedAt: 'Journalförd den',
        at: 'kl.',
        journaled: 'Interaktionen journalfördes',
        unjournaled: 'Interaktionens journalföring togs bort',
        journaledBy: 'Journalförd av',
        unjournaledBy: 'Journalföring borttagen av',
        onCase: 'På ärende',
        copiedBy: 'Kopierad av',
        toCase: 'Till ärende',
        fromCase: 'Från ärende',
        rollback: 'Återställ',
        unmap: 'Koppla bort',
        editTemplate: 'Redigera mall',
        envelope: 'Kuvert',
        readMore: 'Läs mer',
        readLess: 'Läs mindre',
        downloadFailed: 'Nedladdning misslyckades',
        downloadSuccessful: 'Förhandsgranskning av PDF har laddats ner',
        selectTemplate: 'Välj mall',
        contact: 'Kontakt',
        preview: 'Förhandsgranska',
        mention: 'Sammanfogningsfält',
        explanation: 'Förklaring',
        example: 'Exempel',
        addDebtorDocuments: 'Lägg till gäldenärsdokument',
        addIntent: 'Lägg till avsikt',
        sendEmail: 'Skicka e-post',
        reply: 'Svara',
        replyingTo: 'Svarar på',
        thread: 'Visa tråd',
        emailThread: 'E-posttråd',
        note: 'Anteckning',
        addNote: 'Lägg till anteckning',
        sendNoteToDebtor: 'Skicka anteckning till gäldenär',
        sendNoteToClient: 'Skicka anteckning till borgenär',
        addFiles: 'Lägg till filer',
        remindingDescription: 'Påminnelsebeskrivning',
        remindingDate: 'Påminnelsedatum',
        setReminder: 'Ställ in påminnelse',
        download: 'Ladda ner',
        downloadDocx: 'Ladda ner Word',
        phoneNumber: 'Telefonnummer',
        phoneNotes: 'Telefonanteckningar',
        registerPhoneCall: 'Registrera telefonsamtal',
        sendSMS: 'Skicka SMS',
        smsMultipleDeliveriesWarning: 'Flera leveranshändelser indikerar ett långt SMS som delades upp i delar.',
        opposition: 'Invändning',
        notOpposition: 'Ingen invändning',
        optionalNote: 'Valfri anteckning',
        visibilityCheckText: 'Synlig för borgenär',
        hideFromClient: 'Dölj för borgenär',
        hiddenFromClient: 'Dold för borgenär',
        showToClient: 'Visa för borgenär',
        printPDF: 'Ladda ner PDF',
        seeDocument: 'Se dokument',
        clone: 'Klona till annat ärende',
        cloned: 'Interaktion klonad',
        generateReply: 'Generera AI-svar',
        generatingReply: 'Genererar svar...',
        aiGenerated: 'AI-genererad',
        replyGenerated: 'Svar genererat och tillagt i utkorgen',
        replyBlocked: 'Svar blockerat för manuell granskning',
        deliveredAt: 'Leveranstidpunkt',
        failedAt: 'Tidpunkt för fel',
        eBoksMessageId: 'e-Boks meddelande-ID',
        reason: 'Orsak',
        recipientDomain: 'Mottagardomän',
        recipient: 'Mottagare',
        recipientIpAddress: 'Mottagarens IP-adress',
        deliveryMethod: 'Leveransmetod',
        routingDomain: 'Routningsdomän',
        openedAt: 'Öppnad den',
        emailOpenedWarning: 'Obs: Statistik för öppnad e-post kan vara felaktig. Falska positiva resultat kan uppstå om e-postklienten automatiskt laddar bilder. Falska negativa resultat kan uppstå om mottagaren har inaktiverat bilder i sin e-postklient.',
        emailDelayed: 'E-postmeddelandet kunde inte levereras - försöker igen senare',
        delayedAt: 'Tidpunkt för fördröjning',
        delayReason: 'Orsak till fördröjning',
        bounceCode: 'Studskod',
        errorCode: 'Felkod',
        complainedAt: 'Tidpunkt för klagomål',
        complaintType: 'Typ av klagomål',
        letterReturned: 'Brev returnerat',
        operator: 'Operatör',
        clickedLink: 'Klickad länk',
        referer: 'Hänvisare',
        userAgent: 'Användaragent',
        duration: 'Varaktighet',
        network: 'Nätverk',
        subState: 'Understatus',
        digits: 'Angivna siffror',
        timedOut: 'Tidsgräns överskreds',
        timedOutDescription: 'Användaren avslutade inte med fyrkant.',
        actions: 'Åtgärder',
        template: 'Mall',
        eInvoiceEvents: {
            created: 'Skapad',
            transmissionStarted: 'Överföring startad',
            transmissionCompleted: 'Överföring slutförd',
            sent: 'Skickad',
            received: 'Mottagen',
            endpointNotFound: 'Fel',
            error: 'Fel',
            documentId: 'Dokument-ID',
            statusCode: 'Statuskod',
            statusMessage: 'Statusmeddelande',
            deliveryType: 'Leveranstyp',
            receiver: 'Mottagare',
            receiverCvr: 'Mottagarens CVR',
        },
    },
    interactionEventTypes: {
        [InteractionEventType.Journaled]: 'Journalförd',
        [InteractionEventType.Copied]: 'Kopierad',
        [InteractionEventType.Clicked]: 'Länk klickad',
        [InteractionEventType.Complained]: 'Klagade',
        [InteractionEventType.Delivered]: 'Levererad',
        [InteractionEventType.Failed]: 'Misslyckad',
        [InteractionEventType.Opened]: 'Öppnad',
        [InteractionEventType.Delayed]: 'I kö',
        [InteractionEventType.Answered]: 'Besvarad',
        [InteractionEventType.Cancelled]: 'Avbruten',
        [InteractionEventType.Started]: 'Startad',
        [InteractionEventType.Ringing]: 'Ringer',
        [InteractionEventType.Completed]: 'Slutförd',
        [InteractionEventType.Voicemail]: 'Röstbrevlåda',
        [InteractionEventType.HumanAnswered]: 'Människa identifierad',
        [InteractionEventType.DigitsEntered]: 'Angivna siffror',
        [InteractionEventType.Inbound]: 'Inkommande samtal',
        [InteractionEventType.Sent]: 'Skickad',
        [InteractionEventType.TransmissionStarted]: 'Överföring startad',
        [InteractionEventType.Created]: 'Skapad',
        [InteractionEventType.Received]: 'Mottagen',
        [InteractionEventType.SendingApproved]: 'Sändning godkänd',
        [InteractionEventType.TransferredToPrintAndDistribution]: 'Skickad till tryck och distribution',
    },
    outboundPhone: {
        noCasesLeft: 'Inga ärenden att visa',
        priority: 'Prioritet',
        nextCase: 'Nästa ärende',
    },
    outgoingPhoneCallTags: {
        [PhoneOutgoingTag.FullPayment]: 'Full betalning',
        [PhoneOutgoingTag.IncorrectNumber]: 'Numret finns inte',
        [PhoneOutgoingTag.NoAnswer]: 'Inget svar',
        [PhoneOutgoingTag.WrongNumber]: 'Fel nummer',
        [PhoneOutgoingTag.Opposition]: 'Invändning',
        [PhoneOutgoingTag.Other]: 'Annan orsak',
        [PhoneOutgoingTag.OtherAgreement]: 'Annan överenskommelse',
        [PhoneOutgoingTag.PaymentPlan]: 'Betalningsplan',
    },
    incomingPhoneCallTags: {
        [PhoneIncomingTag.FullPayment]: 'Full betalning',
        [PhoneIncomingTag.Opposition]: 'Invändning',
        [PhoneIncomingTag.Other]: 'Annan orsak',
        [PhoneIncomingTag.OtherAgreement]: 'Annan överenskommelse',
        [PhoneIncomingTag.PaymentPlan]: 'Betalningsplan',
        [PhoneIncomingTag.Billing]: 'Avräkning',
        [PhoneIncomingTag.Terms]: 'Avtalsförhållande',
        [PhoneIncomingTag.Caseworking]: 'Ärendehantering',
    },
    procedures: {
        procedure: 'Genväg',
        customProcedures: 'Skapade genvägar',
        standardProcedures: 'Standardgenvägar',
        deleteProcedure: 'Radera genväg',
        confirmDeleteProcedure: 'Är du säker på att du vill radera denna genväg?',
        general: 'Allmänt',
        generalDescription: 'Allmänna inställningar för denna genväg',
        showOnCase: 'Visa på ärende',
        save: 'Spara',
        selectedProcedure: 'Genvägar',
        createProcedure: 'Skapa genväg',
        title: 'Titel',
        description: 'Beskrivning',
        triggers: 'Utlösare',
        defaultToSystemStandard: 'Om ingen utlösare valts:',
        emptyTrigger: 'Ingen utlösare vald',
        deleteConfirmation: 'Du är på väg att ta bort denna procedur från en utlösare. Är du säker på att du vill fortsätta?',
        associatedWithCollector: 'Kopplad till inkassobolag',
        selectCollector: 'Välj inkassobolag',
        selectSetting: 'Välj inställning',
        associatedWithCreditor: 'Kopplad till borgenär',
        selectCreditor: 'Välj borgenär',
        tasks: 'Uppgifter',
        tasksDescription: 'Uppgifter som ska köras.',
        automaticTask: 'Automatiska uppgifter',
        selectUpdate: 'Välj uppgifter',
        add: 'Lägg till',
        taskOrderExplainer: 'Uppgifterna gås igenom uppifrån och ned – den första uppgiften vars krav är uppfyllda är den som utförs. Dra i uppgifterna för att ändra ordningen.',
        noTasksYet: 'Inga uppgifter ännu – lägg till den första nedan.',
        otherwise: 'annars',
        untilManualContinuation: 'tills den fortsätts manuellt',
        addTask: 'Lägg till uppgift',
        removeTask: 'Ta bort uppgift',
        economyProcedureTriggers: 'Ekonomi',
        paymentPlansProcedureTriggers: 'Betalningsplaner',
        debtExpiredProcedureTriggers: 'Preskription av skuld',
        CosmoProcedureTriggers: 'Gäldenärshändelser',
        otherProcedureTriggers: 'Övriga',
        timeBeforeExpiration: 'Tid före preskription',
        atExpiration: 'Vid preskription',
        beforeExpiration: 'före preskription',
        proceduresToRun: 'Procedurer som körs',
        foundationFilter: 'Krav på underlag',
        foundationFilterAny: 'Med eller utan underlag',
        foundationFilterWithFoundation: 'Endast med underlag',
        foundationFilterWithoutFoundation: 'Endast utan underlag',
        addTriggerConfiguration: 'Lägg till konfiguration',
        duplicateProcedure: 'Du kan inte lägga till samma procedur två gånger',
        deleteTriggerConfigurationConfirmation: 'Är du säker på att du vill ta bort den här konfigurationen?',
    },
    triggers: {
        [SystemProcedure.CreditorEndedCase]: 'När borgenär avslutar ett ärende',
        [SystemProcedure.EndCase]: 'Vid avslut av ärende',
        [SystemProcedure.Overpayment]: 'Vid överbetalning',
        [SystemProcedure.RemainderReminder]: 'Vid restpåminnelse',
        [SystemProcedure.PrincipalPayment]: 'Vid restpåminnelse som motsvarar kapitalbeloppet',
        [SystemProcedure.PaymentOnCourtCase]: 'Vid betalning på ärende i domstol',
        [SystemProcedure.EndCaseAccord]: 'Vid avslut av ackordsärende',
        [SystemProcedure.Update]: 'Vid uppdatering av ärende',
        [SystemProcedure.InteractionSentToDebtor]: 'Vid manuell interaktion skickad till gäldenär',
        [SystemProcedure.CaseStatusChange]: 'Vid ändring av ärendestatus',
        [SystemProcedure.ObjectionOnRelatedCase]: 'När ett nytt ärende skapas och kunden har invänt mot en fordran på ett annat ärende',
        [SystemProcedure.PaymentPlanInitial]: 'Vid aktivering av betalningsplan',
        [SystemProcedure.PaymentPlanDocumentSigned]: 'Vid signering av dokument vid aktivering av en betalningsplan',
        [SystemProcedure.PaymentPlanReminder]: 'Vid påminnelse om post i betalningsplan',
        [SystemProcedure.PaymentPlanPayment]: 'Vid betalning av post i betalningsplan',
        [SystemProcedure.PaymentPlanAutoPaymentFailure]: 'Vid misslyckad betalning av post i betalningsplan',
        [SystemProcedure.PaymentPlanBSLSSubmitFailed]: 'Vid misslyckad inlämning av betalningsservice-betalning',
        [SystemProcedure.PaymentPlanBSLSRejected]: 'Vid avvisad betalningsservice-betalning',
        [SystemProcedure.PaymentPlanBSLSAgreementCancelled]: 'Vid avbrutet betalningsservice-avtal',
        [SystemProcedure.PaymentPlanDeadline]: 'Vid tidsfrist för post i betalningsplan',
        [SystemProcedure.PaymentPlanCanceled]: 'Vid annullering av post i betalningsplan',
        [SystemProcedure.PaymentPlanTwoHourActivationReminder]: 'Två timmar efter att en betalningsplan har valts men inte aktiverats',
        [SystemProcedure.PaymentPlanOneDayActivationReminder]: 'En dag efter att en betalningsplan har valts men inte aktiverats',
        [SystemProcedure.PaymentPlanThreeDayActivationReminder]: 'Tre dagar efter att en betalningsplan har valts men inte aktiverats',
        [SystemProcedure.CancelUnactivatedPaymentPlansAfterActivationDeadline]: 'Annullera icke-aktiverade betalningsplaner efter aktiveringsfristen',
        [SystemProcedure.PaymentPlanCreationByCaseworker]: 'När en handläggare skapar en betalningsplan',
        [SystemProcedure.BankAccountDetailsApprovalRefund]: 'Godkännande efter inmatning av bankkontouppgifter för utbetalning av överbetalning',
        [SystemProcedure.DebtExpires]: 'När ett verifikat preskriberas',
        [SystemProcedure.DebtorCanBeRegisteredInDebtRegister]: 'När gäldenären kan registreras i ett skuldregister men ännu inte är registrerad',
        [SystemProcedure.DebtorIsUnderage]: 'Vid minderårig gäldenär',
        [SystemProcedure.Address]: 'Vid adressändring',
        [SystemProcedure.Active]: 'När en gäldenär blir aktiv',
        [SystemProcedure.Dead]: 'Vid dödsfall',
        [SystemProcedure.Disappeared]: 'Vid försvinnande',
        [SystemProcedure.MovedAbroad]: 'När en gäldenär flyttar utomlands',
        [SystemProcedure.Homeless]: 'När en gäldenär blir bostadslös',
        [SystemProcedure.CompanyActive]: 'När ett företag blir aktivt',
        [SystemProcedure.Inactive]: 'När ett företag blir inaktivt',
        [SystemProcedure.OperationsCeased]: 'När verksamheten upphör',
        [SystemProcedure.AddressProtection]: 'När adress- eller namnskydd registreras',
        [SystemProcedure.NewRKIRegristration]: 'När ny extern RKI-registrering registreras',
        [SystemProcedure.DeletedRKIRegistration]: 'När extern RKI-registrering raderas',
        [SystemProcedure.DeletedRKIRegistrationWillingnessToPay]: 'När extern RKI-registrering raderas med indikation på betalningsvilja',
        [SystemProcedure.GuardianStatus]: 'Vid ändring av förvaltarstatus',
        [SystemProcedure.DissolutionStatus]: 'Vid ändring av upplösningsstatus',
        [SystemProcedure.AKSFailed]: 'När AKS misslyckas med att prenumerera',
        [SystemProcedure.BOBEHANDLING]: 'Vid konkurs eller dödsfall',
        [SystemProcedure.NewAsset]: 'När en ny tillgång registreras',
        [SystemProcedure.NewLien]: 'När en ny panträtt registreras',
        [SystemProcedure.AssetChanged]: 'När en tillgång uppdateras',
        [SystemProcedure.LienChanged]: 'När en panträtt uppdateras',
        [SystemProcedure.AssetRemoved]: 'När en tillgång tas bort',
        [SystemProcedure.LienRemoved]: 'När en panträtt tas bort',
    },
    procedureTitles: {
        [SystemProcedureId.CreditorEndedCase]: 'När borgenären avslutar ett ärende via API:et',
        [SystemProcedureId.EndCase]: 'Fullt betalt ärende',
        [SystemProcedureId.Overpayment]: 'Överbetalning',
        [SystemProcedureId.RemainderReminder]: 'Delvis betalt ärende',
        [SystemProcedureId.PrincipalPayment]: 'Delvis betalt ärende',
        [SystemProcedureId.PaymentOnCourtCase]: 'Betalning på ärende i domstol',
        [SystemProcedureId.EndCaseAccord]: 'Ackordsbetalning',
        [SystemProcedureId.Update]: 'Ärendeuppdatering',
        [SystemProcedureId.PaymentPlanInitial]: 'Betalningsplan initial',
        [SystemProcedureId.PaymentPlanReminder]: 'Betalningsplan påminnelse',
        [SystemProcedureId.PaymentPlanPayment]: 'Betalningsplan reglering lyckades',
        [SystemProcedureId.PaymentPlanAutoPaymentFailure]: 'Betalningsplan reglering misslyckades',
        [SystemProcedureId.PaymentPlanBSLSSubmitFailed]: 'Betalningsplan inlämning misslyckades BS & LS',
        [SystemProcedureId.PaymentPlanBSLSRejected]: 'Betalningsplan avvisad betalning BS & LS',
        [SystemProcedureId.PaymentPlanBSLSAgreementCancelled]: 'Betalningsplan avtal avbrutet BS & LS',
        [SystemProcedureId.PaymentPlanDeadline]: 'Betalningsplan tidsfrist',
        [SystemProcedureId.PaymentPlanCanceled]: 'Betalningsplan avbruten',
        [SystemProcedureId.PaymentPlanTwoHourActivationReminder]: 'Betalningsplan aktiveringspåminnelse efter två timmar',
        [SystemProcedureId.PaymentPlanOneDayActivationReminder]: 'Betalningsplan aktiveringspåminnelse efter en dag',
        [SystemProcedureId.PaymentPlanThreeDayActivationReminder]: 'Betalningsplan aktiveringspåminnelse efter tre dagar',
        [SystemProcedureId.PaymentPlanCreationByCaseworker]: 'Manuellt skapad betalningsplan skicka erbjudande',
        [SystemProcedureId.DebtExpired]: 'Skuld preskriberad',
        [SystemProcedureId.DebtExpiresWithinThreeMonths]: 'Skuld preskriberas inom 3 månader',
        [SystemProcedureId.DebtExpiresWithinThreeMonthsWithFoundation]: 'Skuld preskriberas inom 3 månader med fundament',
        [SystemProcedureId.DebtorCanBeRegisteredInDebtRegister]: 'När gäldenären kan registreras i skuldregistret men ännu inte är registrerad',
        [SystemProcedureId.DebtorIsUnderage]: 'Gäldenären är minderårig',
        [SystemProcedureId.Address]: 'Adress',
        [SystemProcedureId.Active]: 'Aktiv',
        [SystemProcedureId.Dead]: 'Avliden',
        [SystemProcedureId.Disappeared]: 'Försvunnen',
        [SystemProcedureId.MovedAbroad]: 'Flyttat utomlands',
        [SystemProcedureId.Homeless]: 'Hemlös',
        [SystemProcedureId.CompanyActive]: 'Företag aktivt',
        [SystemProcedureId.Inactive]: 'Inaktiv',
        [SystemProcedureId.OperationsCeased]: 'Verksamhet upphörd',
        [SystemProcedureId.AddressProtection]: 'Namn-/adressskydd',
        [SystemProcedureId.NewRKIRegristration]: 'Ny RKI-registrering',
        [SystemProcedureId.DeletedRKIRegistration]: 'Raderad RKI-registrering',
        [SystemProcedureId.DeletedRKIRegistrationWillingnessToPay]: 'Raderad RKI-registrering med indikation på betalningsvilja',
        [SystemProcedureId.GuardianStatus]: 'Förmyndarstatus',
        [SystemProcedureId.DissolutionStatus]: 'Upplösningsstatus',
        [SystemProcedureId.AKSFailed]: 'AKS misslyckades',
        [SystemProcedureId.BOBEHANDLING]: 'Dödsbohantering',
    },
    procedureDescriptions: {
        [SystemProcedureId.CreditorEndedCase]: 'När borgenären avslutar ett ärende via API:et',
        [SystemProcedureId.EndCase]: 'Avsluta ärendet och informera kontaktpersonen.',
        [SystemProcedureId.Overpayment]: 'Mer har betalats än vad som har debiterats.',
        [SystemProcedureId.RemainderReminder]: 'Ärendet delvis betalt. Informera kontaktpersonen',
        [SystemProcedureId.PrincipalPayment]: 'Ärendet delvis betalt. Informera kontaktpersonen',
        [SystemProcedureId.PaymentOnCourtCase]: 'Betalning på ärende i domstol. Informera domstolen',
        [SystemProcedureId.EndCaseAccord]: 'Avsluta ärendet med ackordsbetalning',
        [SystemProcedureId.Update]: 'Ärendet har uppdaterats.',
        [SystemProcedureId.PaymentPlanInitial]: 'Bekräftelse som skickas ut när nya planer skapas',
        [SystemProcedureId.PaymentPlanReminder]: 'Påminnelse som skickas ut före betalningsdatumet',
        [SystemProcedureId.PaymentPlanPayment]: 'När en betalningsplan regleras framgångsrikt',
        [SystemProcedureId.PaymentPlanAutoPaymentFailure]: 'När regleringen av en betalningsplan misslyckas',
        [SystemProcedureId.PaymentPlanBSLSSubmitFailed]: 'När en betalningsplan med BS eller LS inte kunde schemalägga betalning',
        [SystemProcedureId.PaymentPlanBSLSRejected]: 'När en betalningsplan med BS eller LS har en avvisad betalning efter den första i månaden',
        [SystemProcedureId.PaymentPlanBSLSAgreementCancelled]: 'När avtalet för en betalningsplan med BS eller LS avbryts',
        [SystemProcedureId.PaymentPlanDeadline]: 'När en betalningsplan inte betalas före tidsfristen',
        [SystemProcedureId.PaymentPlanCanceled]: 'När en betalningsplan inte betalas efter att en andra chans getts',
        [SystemProcedureId.PaymentPlanTwoHourActivationReminder]: 'När en betalningsplan skapas men inte aktiveras efter två timmar',
        [SystemProcedureId.PaymentPlanOneDayActivationReminder]: 'När en betalningsplan skapas men inte aktiveras efter en dag',
        [SystemProcedureId.PaymentPlanThreeDayActivationReminder]: 'När en betalningsplan skapas men inte aktiveras efter tre dagar',
        [SystemProcedureId.PaymentPlanCreationByCaseworker]: 'Skicka erbjudande för manuell betalningsplan skapad av en handläggare',
        [SystemProcedureId.DebtExpired]: 'Skulden är preskriberad',
        [SystemProcedureId.DebtExpiresWithinThreeMonths]: 'Skulden preskriberas inom 3 månader',
        [SystemProcedureId.DebtExpiresWithinThreeMonthsWithFoundation]: 'Skuld med fundament preskriberas inom 3 månader',
        [SystemProcedureId.DebtorCanBeRegisteredInDebtRegister]: 'När gäldenären kan registreras i skuldregistret men ännu inte är registrerad',
        [SystemProcedureId.DebtorIsUnderage]: 'Vid minderårig gäldenär',
        [SystemProcedureId.Address]: 'Vid adressändring',
        [SystemProcedureId.Active]: 'När en gäldenär blir aktiv',
        [SystemProcedureId.Dead]: 'Vid dödsfall',
        [SystemProcedureId.Disappeared]: 'Vid försvinnande',
        [SystemProcedureId.MovedAbroad]: 'När en gäldenär flyttar utomlands',
        [SystemProcedureId.Homeless]: 'När en gäldenär blir hemlös',
        [SystemProcedureId.CompanyActive]: 'När ett företag blir aktivt',
        [SystemProcedureId.Inactive]: 'När ett företag blir inaktivt',
        [SystemProcedureId.OperationsCeased]: 'När verksamheten upphör',
        [SystemProcedureId.AddressProtection]: 'När adress- eller namnskydd registreras',
        [SystemProcedureId.NewRKIRegristration]: 'När en ny extern RKI-registrering registreras',
        [SystemProcedureId.DeletedRKIRegistration]: 'När en extern RKI-registrering raderas',
        [SystemProcedureId.DeletedRKIRegistrationWillingnessToPay]: 'När en extern RKI-registrering raderas med indikation på betalningsvilja',
        [SystemProcedureId.GuardianStatus]: 'Vid ändring av förmyndarstatus',
        [SystemProcedureId.DissolutionStatus]: 'Vid ändring av upplösningsstatus',
        [SystemProcedureId.AKSFailed]: 'När AKS misslyckas med att prenumerera',
        [SystemProcedureId.BOBEHANDLING]: 'Vid konkurs eller dödsfall',
    },
    panels: {
        filters: 'Filter',
        selectAll: 'Välj alla',
        totalDebt: 'Total skuld',
        clickToQueueText: 'Klicka för att köa valda ärenden',
        queue: 'Köa',
    },
    misc: {
        selectAll: 'Välj alla',
        notChosen: 'Ej valt',
        copiedToClipboard: 'Kopierat till urklipp!',
        cosmoActivated: 'Aktiverad',
        searchForAccount: 'Sök efter konto',
        approve: 'Godkänn',
        cancel: 'Avbryt',
        okay: 'Okej',
        create: 'Skapa',
        createdAt: 'Skapad',
        createdBy: 'Skapad av',
        updatedAt: 'Uppdaterad',
        updatedBy: 'Uppdaterad av',
        submit: 'Skicka',
        save: 'Spara',
        saved: 'Sparad',
        edit: 'Redigera',
        update: 'Uppdatera',
        errorCreating: 'Fel vid skapande',
        errorUpdating: 'Fel vid uppdatering',
        errorDeleting: 'Fel vid borttagning',
        errorPerforming: 'Fel vid åtgärd relaterad till',
        successCreating: 'skapad',
        successUpdating: 'uppdaterad',
        successDeleting: 'borttagen',
        language: 'Språk',
        chooseFile: 'Välj fil',
        yes: 'Ja',
        no: 'Nej',
        all: 'Alla',
        add: 'Lägg till',
        enabled: 'Aktiverad',
        search: 'Sök',
        contactSupport: 'Kontakta vår support',
        error: 'Fel',
        errorOccured: 'Ett fel uppstod',
        days: 'Dagar',
        date: 'Datum',
        loadingError: 'Kunde inte ladda data',
        export: 'Exportera',
        exported: 'Exporterad',
        goToCase: 'Gå till ärende',
        after: 'efter',
        skip: 'Hoppa över',
        value: 'Värde',
        delete: 'Radera',
        apply: 'Tillämpa',
        unnamed: 'Namnlös',
        name: 'Namn',
        description: 'Beskrivning',
        learnMore: 'Läs mer',
        ascending: 'Stigande',
        descending: 'Fallande',
        and: 'och',
        or: 'eller',
        id: 'id',
        type: 'Typ',
        text: 'Text',
        state: 'Tillstånd',
        limitReached: 'Gräns uppnådd',
        accept: 'Acceptera',
        loading: 'Laddar...',
        logo: 'Logotyp',
    },
    table: {
        selectedOptions: 'Valda',
        next: 'Nästa',
        previous: 'Föregående',
        first: 'Första',
        last: 'Sista',
        showing: 'Visar',
        outOf: 'av',
        loadMore: 'Ladda mer',
        from: 'Från',
        to: 'Till',
        search: 'Sök',
        noData: 'Inga data',
        clearFilters: 'Rensa alla filter',
    },
    history: {
        paymentPlanCreated: 'Avbetalningsplan skapad',
        tribunalCaseCreated: 'Domstolsärende skapat',
        documentAdded: 'Dokument tillagt',
        history: 'Historik',
        searchHistory: 'Sök historik',
        filterHistory: 'Filtrera historik',
        filterEconomy: 'Ekonomi',
        filterBilling: 'Fakturering',
        filterUpdates: 'Uppgifter',
        filterInteractions: 'Interaktioner',
        filterDebts: 'Skulder',
        filterDebtorTransactions: 'Gäldenärstransaktioner',
        filterNotifications: 'Aviseringar',
        filterCaseStatus: 'Ärendestatus',
        filterType: 'Typ',
        filterTags: 'Taggar',
        resetFilter: 'Återställ',
        hideAll: 'Dölj alla',
        caseCreated: 'Ärende skapat',
        creditorDisbursement: 'Utbetalning till borgenär',
        creditorVat: 'Borgenärsmoms',
        creditorFee: 'Borgenärsavgift',
        deposit: 'Fakturering av deposition',
    },
    connect: {
        fromConnectPartner: 'Från en connect-partner',
        connection: 'Anslutning',
        product: 'Produkt',
        updates: 'Uppdateringar',
        mappedCases: 'Anslutna ärenden',
        updatedBy: 'Uppdaterad av ',
        partner: 'connect-partner',
        us: 'denna organisation',
        thirdParty: 'en tredje part',
        sendsToConn: 'Anslutningen skickar ärenden till',
        sendsFromConn: 'Anslutningen tar emot ärenden från',
        histItemHeader: 'Connect -',
        histItemExported: 'Skickat till partner',
        histItemRetracted: 'Återkallat',
        histItemCompleted: 'Uppgift slutförd',
        histItemDataUpdated: 'Data uppdaterad',
        completedWithReason: 'Slutförd med orsak',
        createdDocuments: 'Skapade dokument',
        createdSatisfaction: 'Skapade betalning',
        goToConnection: 'Gå till anslutning',
        goToCreditorWeb: 'Gå till borgenärswebb',
        goToCreditor: 'Gå till mottagande borgenär',
        goToProduct: 'Gå till produkt',
        goToCase: 'Gå till ärende',
        creditorWebLinkError: 'Fel vid hämtning av länk för borgenärswebb',
        case: 'Ärende',
        state: 'Tillstånd',
        exportedDate: 'Exporterat datum',
        completedDate: 'Slutfört datum',
        connectStateCompleted: 'Slutförd',
        connectStateInProgress: 'Pågående',
    },
    connectConnectionUpdate: {
        [ConnectConnectionStatus.Active]: 'Aktiv',
        [ConnectConnectionStatus.Paused]: 'Pausad',
        [ConnectConnectionStatus.Disabled]: 'Inaktiverad',
    },
    connectCaseMappingUpdate: {
        [ConnectCaseMappingStatus.Exported]: 'Exporterad',
        [ConnectCaseMappingStatus.Retracted]: 'Återkallad',
        [ConnectCaseMappingStatus.Completed]: 'Slutförd',
        [ConnectCaseMappingStatus.DataUpdated]: 'Data uppdaterad',
    },
    connectRetractionReason: {
        [RetractionReason.Collected]: 'Skuld indriven',
        [RetractionReason.ConnectionDisabled]: 'Connect-anslutning inaktiverad',
        [RetractionReason.Rollback]: 'Återställd',
        [RetractionReason.Other]: 'Annat',
    },
    product: {
        productHandles: 'Produkten tillhandahåller',
    },
    productService: {
        [ProductService.Collection]: 'inkasso',
        [ProductService.CourtHandling]: 'domstolshantering',
    },
    documents: {
        documents: 'Dokument',
        noDocuments: 'Inga dokument',
        deleteDocument: 'Radera dokument',
        saveDocument: 'Spara dokument',
        autoRKIAddFoundation: 'Auto-RKI är aktiverat och kommer att försöka flytta RKI-registreringen till det öppna registret efter att detta fundament har lagts till',
        autoRKIUpdateFoundation: 'Auto-RKI är aktiverat och kommer att försöka flytta RKI-registreringen till det öppna registret efter att detta fundament har uppdaterats',
        file: 'Fil',
        signedFile: 'Signerad fil',
        createdBy: 'Skapad av',
        docId: 'Dok-ID',
        type: 'Typ',
        signingLink: 'Länk för signering',
        generateSigningLink: 'Generera länk för signering',
        createdAt: 'Skapad',
        date: 'Datum',
        signedAt: 'signerad',
        addDocument: 'Lägg till dokument',
        fromFile: 'Från fil',
        fromTemplate: 'Från mall',
        selectCourt: 'Domstol',
        documentSignedCheckbox: 'Är dokumentet signerat?',
        visibleForDebtor: 'Synligt för gäldenär',
        uploadDocument: 'Ladda upp dokument',
        createDocument: 'Skapa dokument',
        preview: 'Förhandsvisning',
        sendToCourt: 'Skicka till domstol',
        paidCourtFee: 'Betald domstolsavgift',
        createDate: 'Skapandedatum',
        interestDates: 'Räntedatum',
        interestAmount: 'Räntebelopp',
        totalAmount: 'Totalbelopp',
        amount: 'Belopp',
        note: 'Anteckning',
        procesinterest: 'Processränta',
        interestFromSubmitOfBPK: 'Ränta från inlämning av fordran till Kronofogden',
        caseinterest: 'Ärendets räntesats',
        preventForkyndt: 'Vill du att betalningsföreläggandet ska delges om gäldenären har avgett en insolvensförklaring hos Kronofogden, eller är under rekonstruktion, konkurs eller skuldsanering och därför är skyddad mot utmätning?',
        preventAutDistress: 'Vill du att Kronofogden automatiskt ska verkställa utmätning om gäldenären inte inkommer med invändningar (protester) mot ditt krav?',
        preventAutCivilCourt: 'Vill du att en rättegång automatiskt ska inledas i tvistemålsdomstol på grundval av betalningsföreläggandet om gäldenären inkommer med invändningar (protester) mot ditt krav?',
        selectBPKWarningDate: 'Välj datum för BPK-varning',
        directorNameAddress: 'Direktörens/ordförandens namn och adress',
        directorNameAddressDescription: 'Om gäldenären är ett företag/en förening – ange om möjligt direktörens/ordförandens namn och adress:',
        selectDebtors: 'Välj gäldenärer',
        selectDebtorsDescription: 'Välj vilka gäldenärer som ska inkluderas i fordran till Kronofogden.',
        selectAll: 'Välj alla',
        deselectAll: 'Avmarkera alla',
        debtorsSelected: 'gäldenärer valda',
        court: 'Domstol',
        selectType: 'Välj dokumenttyp',
        sureYouWantToDelete: 'Är du säker på att du vill radera',
        sureYouWantToSave: 'Är du säker på att du vill spara ändringarna?',
        documentSigned: 'Dokument signerat',
        generateLinkForSigning: 'Generera länk för signering',
        addCourtFeeToClientBilling: 'Lägg till avgift i borgenärsavräkning',
        addCourtDisbursementToClientBilling: 'Lägg till utlägg i borgenärsavräkning',
        addCourtFeeToCase: 'Lägg till kostnad på ärendet',
        sendInfoAboutRequisitionToRes: 'Skicka information om rekvisition till den ansvarige',
        responsible: 'Ansvarig',
        isFoundation: 'Är fundament',
        [DocumentTypes.COURT]: 'Rättsligt',
        [DocumentTypes.FOUNDATION]: 'Fundament',
        [DocumentTypes.OTHER]: 'Annat',
    },
    documentTypes: {
        [DocumentTypes.COURT]: 'Rättsligt',
        [DocumentTypes.FOUNDATION]: 'Fundament',
        [DocumentTypes.OTHER]: 'Annat',
        [DocumentTypes.SKYLDERKLAERING]: 'Skuldförklaring',
        [DocumentTypes.COURTOPGJORTOGFREMLAGT]: 'Opgjort og fremlagt i fogedretten',
        [DocumentTypes.FORLIG]: 'Förlikning',
        [DocumentTypes.DOM]: 'Dom',
        [DocumentTypes.PAATEGNING]: 'Påtegning',
        [DocumentTypes.GAELDSBREV]: 'Skuldebrev',
    },
    files: {
        fileName: 'Filnamn',
        downloadFailed: 'Nedladdning misslyckades',
    },
    updates: {
        continueCase: 'Fortsätt ärende',
        continueCaseRemove: 'Ta bort',
        setRemindedAt: 'Ange påminnelsedatum',
        remindDate: 'Påminn den',
        pauseNow: 'Pausa nu',
        remindNow: 'Påminn nu',
        pauseUntilReminding: 'Pausa den',
        pauseContinueAt: 'Fortsätt den',
        pausedUntil: 'Pausad till',
        dateSelectorTooltip: 'Välj datum för att visa pausstatusen',
        updateWillBeShownIn: 'Pausas om',
        paused: 'Pausad',
        reminded: 'påmind',
        pausedAndReminded: 'Pausad och påmind om',
        pausedAndRemindedPast: 'Pausad och påmind',
        ago: 'sedan',
        pausedPast: 'Pausad',
        andReminded: 'och påmind om',
        andRemindedPast: 'och påmind',
        expedientAKSActivated: 'Experian AKS aktiverad',
        chooseMoreThanTwoBulkActions: 'Välj två eller fler uppgifter för att göra en massbehandling.',
        bulkActions: 'Massåtgärd',
        selectAll: 'Välj alla',
    },
    integrateCalendar: {
        name: 'Abonnemangets namn',
        newSubscription: 'Nytt kalenderabonnemang',
        create: 'Skapa kalenderlänk',
        save: 'Spara inställningar',
        edit: 'Redigera',
        cancel: 'Avbryt',
        delete: 'Ta bort abonnemang',
        confirmDelete: 'Ta bort abonnemanget? Kalenderlänken slutar fungera.',
        courtMeetings: 'Domstolsmöten i domstolsmodulen',
        updateTypes: 'Uppgiftstyper',
        empty: 'Inga kalenderabonnemang ännu.',
        description: 'Skapa ett kalenderabonnemang för den här organisationen. Välj mötestyper och uppgiftstyper nedan. Endast valda typer synkroniseras, från en månad bakåt till ett år framåt.',
        privacy: 'Kalenderhändelser innehåller endast generiska titlar och tidpunkter. Namn, anteckningar, adresser och ärendeuppgifter ingår inte. Alla med länken kan läsa kalendern tills du tar bort abonnemanget.',
        noTypes: 'Inga typer valda: abonnemanget är pausat.',
        subscription: 'kalenderabonnemang',
        namePlaceholder: 'T.ex. Rättsmöten',
        nameHint: 'Används bara för att skilja abonnemang åt i Debbie.',
        courtMeetingsHelp: 'Välj de mötestyper som ska ingå i kalendern. Varje rättsmöte från domstolsmodulen visas i kalendern på sitt mötesdatum.',
        updateTypesHelp: 'Välj de uppgiftstyper som ska ingå i kalendern. Varje uppgift visas i kalendern på sitt påminnelsedatum.',
        selected: 'valda',
        selectAll: 'Välj alla',
        clearSelection: 'Rensa',
        paused: 'Pausat',
        meetingTypesCount: 'mötestyper',
        updateTypesCount: 'uppgiftstyper',
        link: 'Kalenderlänk',
        copyLink: 'Kopiera länk',
        created: 'Skapat',
        connectToOffice365: 'Synkronisera med Office 365',
        selectUpdateTypes: 'Välj uppgiftstyper',
    },
    auth: {
        account: 'Konto',
        logout: 'Logga ut',
        accountInactive: 'Ditt konto är inaktivt',
        chooseBetweenAccounts: 'Välj mellan konton',
    },
    rightNav: {
        creditors: 'Borgenärer',
    },
    login: {
        email: 'E-post',
        password: 'Lösenord',
        login: 'Logga in',
        twoFactorExplainer: 'Vi har skickat en sexsiffrig kod till din e-post. Ange den nedan för att logga in.',
        twoFactorPlaceholder: 'Kod',
        reset: 'Återställ',
        resetTokenExplainer: 'Du kommer att få en kod via e-post som du ska ange här för att återställa ditt lösenord.',
        resetTokenPlaceholder: 'Kod',
        newPasswordExplainer: 'Ange ditt nya lösenord',
        newPasswordPlaceholder: 'Ditt nya lösenord',
        updatePassword: 'Uppdatera',
        couldNotIdentifyYou: 'Vi kunde inte identifiera dig. Vänligen kontakta',
        mitIdDescription: 'Logga in med MitID för att få tillgång till dina uppgifter.',
        loginWithMitId: 'Logga in med MitID',
    },
    passwordResetEmail: {
        title: 'Återställ lösenord',
        body: 'Du har begärt att ändra ditt lösenord. För att ändra ditt lösenord, ange följande på sidan du begärde det från:',
    },
    onboarding: {
        welcome: 'Välkommen',
        passwordCreatorExplainer: 'För att konfigurera ditt konto, skapa ett lösenord.',
    },
    users: {
        userSettings: 'Användarinställningar',
        userCreated: 'Användare skapad',
        userUpdated: 'Användare uppdaterad',
        updateFailed: 'Uppdatering av användare misslyckades',
        createUser: 'Skapa användare',
        inviteUser: 'Bjud in användare',
        name: 'Namn',
        role: 'Roll',
        firstName: 'Förnamn',
        lastName: 'Efternamn',
        email: 'E-post',
        phone: 'Telefon',
        username: 'Användarnamn',
        password: 'Lösenord',
        users: 'Användare',
        noUsers: 'Inga användare att visa',
        search: 'Sök användare',
        newUser: 'Ny användare',
        passwordConfirmation: 'Bekräfta lösenord',
        creditors: 'Borgenärer',
        tenants: 'Organisationer',
        todoNotifications: 'Få ett e-postmeddelande när det finns osedda uppgifter eller aviseringar',
        selectCreditors: 'Välj borgenärer',
        selectTenants: 'Välj organisationer',
        selectRole: 'Välj roll',
        selectUser: 'Välj användare',
        passwordTooShort: 'Lösenordet är för kort',
        passwordsDontMatch: 'Lösenorden matchar inte',
        sendInvite: 'Skicka inbjudan via e-post',
        sureYouWantToDeleteUser: 'Är du säker på att du vill radera den här användaren permanent?',
        deleteUser: 'Radera användare',
        deleteUserPermanently: 'Radera användare permanent',
        archiveUser: 'Arkivera användare',
        sureYouWantToArchiveUser: 'Är du säker på att du vill arkivera den här användaren?',
        archiveUserDescription: 'Arkivering återkallar användarens åtkomst till plattformen men behåller namn och e-post så att historiska loggar och aktivitet förblir läsbara.',
        archiveUserWarning: 'Användaren loggas ut överallt och förlorar sitt lösenord. Om användaren återaktiveras senare måste en ny inbjudan accepteras.',
        reactivateUser: 'Återaktivera användare',
        sureYouWantToReactivateUser: 'Är du säker på att du vill återaktivera den här användaren?',
        reactivateUserDescription: 'Användaren får tillbaka sina tidigare roller och behörigheter och får en inbjudan via e-post för att välja ett nytt lösenord. Användaren kan inte logga in förrän inbjudan har accepterats.',
        userReactivated: 'Användaren har återaktiverats och bjudits in via e-post',
        userReactivatedInviteFailed: 'Användaren har återaktiverats, men inbjudan kunde inte skickas. Använd "Skicka inbjudan igen" för att försöka igen.',
        archivedUsers: 'Arkiverade användare',
        activeUsers: 'Aktiva användare',
        stateActive: 'Aktiv',
        stateInvited: 'Inbjuden',
        invitedUsers: 'Inbjudna användare',
        resendInvite: 'Skicka inbjudan igen',
        inviteResent: 'Inbjudan har skickats igen',
        inviteResendFailed: 'Det gick inte att skicka inbjudan igen',
        inviteLinkExpired: 'Denna inbjudningslänk har upphört att gälla',
        inviteLinkExpiredDescription: 'Inbjudningslänkar är giltiga i 30 dagar. Begär en ny så skickar vi en färsk länk till din e-post.',
        inviteLinkAlreadyUsed: 'Denna inbjudningslänk har redan använts',
        inviteLinkAlreadyUsedDescription: 'Du har redan skapat ditt lösenord. Logga in med din e-post och ditt lösenord.',
        inviteLinkInvalid: 'Denna inbjudningslänk är ogiltig',
        inviteLinkInvalidDescription: 'Länken kunde inte kännas igen. Se till att du öppnade det senaste inbjudningsmejlet.',
        requestNewInvite: 'Begär ny inbjudan',
        inviteRequestSent: 'En ny inbjudan har skickats. Kontrollera din e-post.',
        changeRole: 'Ändra användarens roll',
        changeRoleNotAdmin: 'Ändring av roller kan göras av en administratör',
        cantChangeClientRole: `Borgenärers roll kan inte ändras`,
    },
    rolesDescription: {
        [PermissionLevels.admin]: 'Denna roll är för företagets administratör/superanvändare som har åtkomst till alla funktioner och kan konfigurera alla tillgängliga inställningar.',
        [PermissionLevels.caseworker]: 'Denna roll är för den anställda som måste ha åtkomst till alla nödvändiga funktioner på ärendenivå. Det finns även åtkomst till allt på borgenärsnivå, och under inställningar har rollen åtkomst till mallar.',
    },
    teams: {
        team: 'Team',
        user: 'Användare',
        namePlaceholder: 'Teamnamn',
        saveName: 'Spara',
        searchNewTeamMember: 'Sök efter ny teammedlem',
        createTeam: 'Skapa nytt team',
        assignedTasks: 'Ansvarig för uppgifter',
        catchAll: 'Fångar allt',
        responsibleForUpdateTypes: 'Ansvarig för uppgifter',
        addUpdateType: 'Lägg till uppgift',
        selectTeam: 'Team',
        selectUser: 'Användare',
        responsibleForCase: 'Ansvarig för ärende',
    },
    invite: {
        subject: 'Inbjudan att gå med',
        body: `Hej \${firstName},

Du har blivit inbjuden att gå med i \${platform}. Använd länken nedan för att acceptera inbjudan.
\${url}?nu_token=\${token}`,
        html: `<p>Hej \${firstName},</p><p>Du har blivit inbjuden att gå med i \${platform}. Använd länken nedan för att acceptera inbjudan.</p>`,
        linkText: 'Logga in',
        creditorWeb: 'borgenärswebben från',
    },
    roles: {
        'super-admin': 'Superadministratör',
        admin: 'Administratör',
        caseworker: 'Handläggare',
        client: 'Borgenär',
        debtor: 'Gäldenär',
        'alternative-contact': 'Alternativ kontakt',
        unauthorized: 'Obehörig',
    },
    mentionsConditional: {
        if: 'Om',
        endIf: 'Slut om',
    },
    mentions: {
        [TemplateMention.PaymentPlanAmortisation]: 'Amorteringsplan',
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Generiskt ämne',
        [TemplateMention.FINANCIALS_PRICIPAL]: 'Kapitalbelopp',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: 'Inkassoavgifter',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: 'Administrationskostnader',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: 'Kompensationsavgifter',
        [TemplateMention.FINANCIALS_INTERESTS]: 'Räntor',
        [TemplateMention.FINANCIALS_INTEREST_RATE]: 'Räntesats',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: 'Inkassokostnader',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: 'Borgenärers referens-ID:n',
        [TemplateMention.CURRENCY]: 'Valuta',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: 'Betalningsplanens första belopp',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: 'Betalningsplanens första förfallodag',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: 'Betalningsplanens första datum',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: 'Betalningsplanens sista belopp',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: 'Betalningsplanens sista förfallodag',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: 'Betalningsplanens sista datum',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: 'Betalningsplanens postbelopp',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: 'Betalningsplanens postförfallodag',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: 'Betalningsplanens postdatum',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: 'Betalningsplanens skapandedatum',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: 'Betalningsplanens längd i dagar',
        [TemplateMention.PaymentPlanApr]: 'Effektiv ränta',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: 'Effektiv ränta per år',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'Om ärendet har årlig ränta',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: 'Betalningsplanens min. postbelopp',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: 'Betalningsplanens max. postbelopp',
        [TemplateMention.TOTAL_DEBT]: 'Total skuld',
        [TemplateMention.OVERPAYMENT]: 'Överbetalning',
        [TemplateMention.ACCORD_TEN_PERCENT]: 'Ackord: 10 % rabatt',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: 'Ackord: 20 % rabatt',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: 'Ackord: 30 % rabatt',
        [TemplateMention.ACCORD_FORTY_PERCENT]: 'Ackord: 40 % rabatt',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: 'Ackord: 50 % rabatt',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: 'Ackord: 60 % rabatt',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: 'Ackord: 70 % rabatt',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: 'Ackord: 80 % rabatt',
        [TemplateMention.ACCORD_NINETY_PERCENT]: 'Ackord: 90 % rabatt',
        [TemplateMention.IF_IS_COMPANY]: 'Om företag',
        [TemplateMention.IF_DEBTOR_IS_DEBT_REGISTERED]: 'Om gäldenären är registrerad i ett skuldregister',
        [TemplateMention.IF_CASE_HAS_MULTIPLE_PRINCIPALS]: 'Om ärendet har flera kapitalbelopp',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Om ärendet har påminnelseavgifter',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Om ärendet har inkassoavgifter',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Om ärendet har inkassokostnader',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Om ärendet har kompensationskostnader',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Om ärendet har processränta',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Om ärendet har fast ränta',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Om ärendet har årlig ränta i procent',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Om ärendet har deposition',
        [TemplateMention.DOCUMENTATION]: 'Dokumentation',
        [TemplateMention.DATE]: 'Datum',
        [TemplateMention.DATE_IN_THREE_DAYS]: 'Datum om 3 dagar',
        [TemplateMention.DATE_IN_SIX_DAYS]: 'Datum om 6 dagar',
        [TemplateMention.DATE_IN_TEN_DAYS]: 'Datum om 10 dagar',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: 'Datum om 11 dagar',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: 'Datum om 12 dagar',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: 'Datum om 14 dagar',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: 'Datum om 17 dagar',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: 'Datum om 30 dagar',
        [TemplateMention.PREVIOUS_THREE_YEARS]: 'De tre föregående årtalen',
        [TemplateMention.DEPOSIT]: 'Deposition',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: 'Deponerat till borgenär',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: 'Deponerat till inkassobolag',
        [TemplateMention.INTEREST_PAID_LAST_YEAR]: 'Ränta betald förra året',
        [TemplateMention.CONTACT_NAME]: 'Kontaktnamn',
        [TemplateMention.DEBTOR_NAME]: 'Gäldenärens namn',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Gäldenärens förnamn',
        [TemplateMention.CONTACT_ADDRESS]: 'Kontaktens gata',
        [TemplateMention.CONTACT_COADDRESS]: 'Kontaktens c/o-adress',
        [TemplateMention.CONTACT_ZIPCODE]: 'Kontaktens postnummer',
        [TemplateMention.CONTACT_CITY]: 'Kontaktens ort',
        [TemplateMention.CONTACT_COUNTRY]: 'Kontaktens land',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Om borgenären är ett företag',
        [TemplateMention.CREDITOR_IF_IS_VAT_REGISTERED]: 'Om borgenären är momsregistrerad',
        [TemplateMention.USER_NAME]: 'Användarnamn',
        [TemplateMention.USER_FIRST_NAME]: 'Användarens förnamn',
        [TemplateMention.IF_USER]: 'Om användare är tillgänglig',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Om borgenären tillåter banköverföringar',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Om borgenären tillåter FI-betalningar',
        [TemplateMention.DEBTOR_ADDRESS]: 'Gäldenärens gata',
        [TemplateMention.DEBTOR_COADDRESS]: 'Gäldenärens c/o-adress',
        [TemplateMention.DEBTOR_ZIPCODE]: 'Gäldenärens postnummer',
        [TemplateMention.DEBTOR_CITY]: 'Gäldenärens ort',
        [TemplateMention.DEBTOR_COUNTRY]: 'Gäldenärens land',
        [TemplateMention.DEBTOR_EMAIL]: 'Gäldenärens e-post',
        [TemplateMention.DEBTOR_PHONE]: 'Gäldenärens telefonnummer',
        [TemplateMention.LAST_PAYMENT_DATE]: 'Datum för senaste betalning',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: 'Belopp för senaste betalning',
        [TemplateMention.DEBTOR_SEQ_ID]: 'Gäldenärens löpnummer',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: 'Gäldenärens CVR och/eller CPR',
        [TemplateMention.CREDITOR_NAME]: 'Borgenärens namn',
        [TemplateMention.CASE_ID]: 'Ärende-ID',
        [TemplateMention.CASE_REFERENCE_ID]: 'Ärendets referens-ID',
        [TemplateMention.CREDITOR_ADDRESS]: 'Borgenärens adress',
        [TemplateMention.REMINDER_FEES]: 'Påminnelseavgifter',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Betalningsalternativ',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: 'Inkassobolagets kontonummer',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: 'Inkassobolagets registreringsnummer',
        [TemplateMention.COLLECTOR_PHONE]: 'Inkassobolagets telefon',
        [TemplateMention.COLLECTOR_COURT_PHONE]: 'Inkassobolagets domstolstelefon',
        [TemplateMention.COLLECTOR_EMAIL]: 'Inkassobolagets e-post',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Inkassobolagets smeknamn',
        [TemplateMention.COLLECTOR_NAME]: 'Inkassobolagets namn',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Inkassobolagets adress',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Inkassobolagets ort',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: 'Inkassobolagets postnummer',
        [TemplateMention.COLLECTOR_CVR]: 'Inkassobolagets CVR',
        [TemplateMention.CREDITOR_ZIPCODE]: 'Borgenärens postnummer',
        [TemplateMention.CREDITOR_CITY]: 'Borgenärens ort',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: 'Borgenärens CVR',
        [TemplateMention.PAYMENT_ID]: 'Betalnings-ID',
        [TemplateMention.JOURNAL_NUMBER]: 'Journalnummer',
        [TemplateMention.COURT_NAME]: 'Domstolens namn',
        [TemplateMention.COURT_ADDRESS]: 'Domstolens adress',
        [TemplateMention.COURT_CITY]: 'Domstolens ort',
        [TemplateMention.COURT_ZIP]: 'Domstolens postnummer',
        [TemplateMention.COURT_EMAIL]: 'Domstolens e-post',
        [TemplateMention.COURT_PHONE]: 'Domstolens telefon',
        [TemplateMention.COURT_EAN]: 'Domstolens EAN',
        [TemplateMention.REG_NO]: 'Domstolens registreringsnummer',
        [TemplateMention.ACCOUNT_NO]: 'Domstolens kontonummer',
        [TemplateMention.PAYMENT_PLAN_HTML]: 'Översikt över avbetalningar',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Kontaktadress på en rad',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Kontaktadress formaterad',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Alternativ kontakts referens-ID',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Om alternativ kontakt har ett referens-ID',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Gäldenärens adress på en rad',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Gäldenärens adress formaterad',
        [TemplateMention.DEBTOR_TABLE]: 'Gäldenärstabell',
        [TemplateMention.SIGN_FIELDS]: 'Signeringsfält',
        [TemplateMention.DK_BPK]: 'Betalingspåkrav',
        [TemplateMention.GL_BPK]: 'GL Betalingspåkrav',
        [TemplateMention.PAGE_BREAK]: 'Sidbrytning',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Betalningsplanens poster',
        [TemplateMention.PAYMENT_PLAN_STATUS_TAG]: 'Betalningsplanens status',
        [TemplateMention.SATISFACTION_BUTTONS]: 'Nöjdhetsknappar',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'Länk betalningsplan',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'Länk till betalningsplan',
        [TemplateMention.OVERPAYMENT_LINK]: 'Länk överbetalning',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'Länk överbetalning QR-kod',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'Länk till överbetalning',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'Länk till betalningsplan QR-kod',
        [TemplateMention.PAYMENT_LINK]: 'Länk till betalning',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'Länk till betalning',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'Länk till betalning QR-kod',
        [TemplateMention.DEBTOR_WEB_LINK]: 'Länk till gäldenärswebb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'Länk till gäldenärswebb lång',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'Länk till gäldenärswebb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'Länk till gäldenärswebb lång',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'Länk till gäldenärswebb QR-kod',
        [TemplateMention.CONDITIONAL_ELSE]: 'Annars',
        [TemplateMention.CONDITIONAL_END_IF]: 'Slut om',
        [TemplateMention.BANK_CREDITOR_NUMBER]: '',
        [TemplateMention.FOUNDATION_TYPE]: 'Grundtyp',
        [TemplateMention.FOUNDATION_DATE]: 'Grunddatum',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'Nyaste FS-nummer',
    },
    mentionsExplanation: {
        [TemplateMention.PaymentPlanAmortisation]: 'Ursprunglig betalningsplan med kapital, kostnader, ränta och återstående skuld. Utan betalningsstatus.',
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Text för ämnesfältet i e-post',
        [TemplateMention.FINANCIALS_PRICIPAL]: 'Ärendets totala kapitalbelopp',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: 'Ärendets totala inkassoavgift',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: 'Ärendets totala administrationskostnad',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: 'Ärendets totala kompensationsavgift',
        [TemplateMention.FINANCIALS_INTERESTS]: 'Ärendets totala ränta',
        [TemplateMention.FINANCIALS_INTEREST_RATE]: 'Ärendets lägsta aktuella räntesats',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: 'Ärendets totala inkassokostnad',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: 'Borgenärers referens-ID:n',
        [TemplateMention.CURRENCY]: 'Ärendeekonomins valuta',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: 'Beloppet för den första betalningen',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: 'Förfallodag för den första betalningen',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: 'Datum för den första betalningen',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: 'Beloppet för den sista betalningen',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: 'Förfallodag för den sista betalningen',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: 'Datum för den sista betalningen',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: 'Beloppet för den senaste betalningen',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: 'Förfallodag för den senaste betalningen',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: 'Datum för den senaste betalningen',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: 'Betalningsplanens skapandedatum',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: 'Antal dagar i betalningsplanen',
        [TemplateMention.PaymentPlanApr]: 'Betalningsplanens effektiva ränta som ett enda tal i procent, beräknad enligt bilaga 1 till den danska kreditavtalslagen',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: 'Kostnader i procent av kapitalbeloppet, uppställda år för år i betalningsplanen',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'Om ärendet har årlig ränta',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: 'Betalningsplanens min. postbelopp',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: 'Betalningsplanens max. postbelopp',
        [TemplateMention.TOTAL_DEBT]: 'Den totala skuldens belopp',
        [TemplateMention.OVERPAYMENT]: 'Överbetalningsbelopp',
        [TemplateMention.ACCORD_TEN_PERCENT]: 'Den totala skuldens belopp 10 % rabatt',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: 'Den totala skuldens belopp 20 % rabatt',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: 'Den totala skuldens belopp 30 % rabatt',
        [TemplateMention.ACCORD_FORTY_PERCENT]: 'Den totala skuldens belopp 40 % rabatt',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: 'Den totala skuldens belopp 50 % rabatt',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: 'Den totala skuldens belopp 60 % rabatt',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: 'Den totala skuldens belopp 70 % rabatt',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: 'Den totala skuldens belopp 80 % rabatt',
        [TemplateMention.ACCORD_NINETY_PERCENT]: 'Den totala skuldens belopp 90 % rabatt',
        [TemplateMention.IF_IS_COMPANY]: 'Om företag',
        [TemplateMention.IF_DEBTOR_IS_DEBT_REGISTERED]: 'Om gäldenären är registrerad i ett skuldregister',
        [TemplateMention.IF_CASE_HAS_MULTIPLE_PRINCIPALS]: 'Om ärendet har flera kapitalbelopp',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Om ärendet har påminnelseavgifter',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Om ärendet har inkassoavgifter',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Om ärendet har inkassokostnader',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Om ärendet har kompensationskostnader',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Om ärendet har processränta',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Om ärendet har fast ränta',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Om ärendet har årlig ränta i procent',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Om ärendet har deposition',
        [TemplateMention.DOCUMENTATION]: 'Dokumentation',
        [TemplateMention.DATE]: 'Dagens datum',
        [TemplateMention.DATE_IN_THREE_DAYS]: 'Datum om 3 dagar',
        [TemplateMention.DATE_IN_SIX_DAYS]: 'Datum om 6 dagar',
        [TemplateMention.DATE_IN_TEN_DAYS]: 'Datum om 10 dagar',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: 'Datum om 11 dagar',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: 'Datum om 12 dagar',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: 'Datum om 14 dagar',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: 'Datum om 17 dagar',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: 'Datum om 30 dagar',
        [TemplateMention.PREVIOUS_THREE_YEARS]: 'De tre årtalen som föregår innevarande år',
        [TemplateMention.DEPOSIT]: 'Totalt belopp för depositioner',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: 'Belopp deponerat till borgenär',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: 'Belopp deponerat till inkassobolag',
        [TemplateMention.INTEREST_PAID_LAST_YEAR]: 'Belopp betalt i ränta under föregående kalenderår',
        [TemplateMention.CONTACT_NAME]: 'Kontaktpersonens namn',
        [TemplateMention.DEBTOR_NAME]: 'Gäldenärens namn',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Gäldenärens förnamn',
        [TemplateMention.CONTACT_ADDRESS]: 'Kontaktpersonens gata',
        [TemplateMention.CONTACT_COADDRESS]: 'Kontaktpersonens c/o',
        [TemplateMention.CONTACT_ZIPCODE]: 'Kontaktpersonens postnummer',
        [TemplateMention.CONTACT_CITY]: 'Kontaktpersonens ort',
        [TemplateMention.CONTACT_COUNTRY]: 'Kontaktpersonens land',
        [TemplateMention.DEBTOR_ADDRESS]: 'Gäldenärens gata',
        [TemplateMention.DEBTOR_COADDRESS]: 'Gäldenärens c/o',
        [TemplateMention.DEBTOR_ZIPCODE]: 'Gäldenärens postnummer',
        [TemplateMention.DEBTOR_CITY]: 'Gäldenärens ort',
        [TemplateMention.DEBTOR_COUNTRY]: 'Gäldenärens land',
        [TemplateMention.DEBTOR_EMAIL]: 'Gäldenärens e-post',
        [TemplateMention.DEBTOR_PHONE]: 'Gäldenärens telefonnummer',
        [TemplateMention.LAST_PAYMENT_DATE]: 'Datum för senaste betalning',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: 'Belopp för senaste betalning',
        [TemplateMention.DEBTOR_SEQ_ID]: 'Gäldenärens ID',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: 'Gäldenärens CVR och/eller CPR',
        [TemplateMention.CREDITOR_NAME]: 'Borgenärens namn',
        [TemplateMention.CASE_ID]: 'Ärende-ID:t',
        [TemplateMention.CASE_REFERENCE_ID]: 'Ärendets referens-ID',
        [TemplateMention.CREDITOR_ADDRESS]: 'Borgenärens adress',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Om borgenären är ett företag',
        [TemplateMention.CREDITOR_IF_IS_VAT_REGISTERED]: 'Om borgenären är momsregistrerad',
        [TemplateMention.USER_NAME]: 'Användarnamn',
        [TemplateMention.USER_FIRST_NAME]: 'Användarens förnamn',
        [TemplateMention.IF_USER]: 'Om användare är tillgänglig',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Om borgenären tillåter banköverföringar',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Om borgenären tillåter FI-betalningar',
        [TemplateMention.REMINDER_FEES]: 'Ärendets totala påminnelseavgift',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Betalningsalternativ',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: 'Inkassobolagets bankkontonummer',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: 'Inkassobolagets bankregistreringsnummer',
        [TemplateMention.COLLECTOR_PHONE]: 'Inkassobolagets telefonnummer',
        [TemplateMention.COLLECTOR_COURT_PHONE]: 'Inkassobolagets domstolstelefonnummer',
        [TemplateMention.COLLECTOR_EMAIL]: 'Inkassobolagets e-post',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Inkassobolagets smeknamn',
        [TemplateMention.COLLECTOR_NAME]: 'Inkassobolagets namn',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Inkassobolagets adress',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Inkassobolagets ort',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: 'Inkassobolagets postnummer',
        [TemplateMention.COLLECTOR_CVR]: 'Inkassobolagets CVR',
        [TemplateMention.CREDITOR_ZIPCODE]: 'Borgenärens postnummer',
        [TemplateMention.CREDITOR_CITY]: 'Borgenärens ort',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: 'Borgenärens CVR',
        [TemplateMention.PAYMENT_ID]: 'Betalnings-ID / FIK-nummer',
        [TemplateMention.JOURNAL_NUMBER]: 'Journalnummer',
        [TemplateMention.COURT_NAME]: 'Domstolens namn',
        [TemplateMention.COURT_ADDRESS]: 'Civildomstolens adress',
        [TemplateMention.COURT_CITY]: 'Domstolens ort',
        [TemplateMention.COURT_ZIP]: 'Domstolens postnummer',
        [TemplateMention.COURT_EMAIL]: 'Domstolens e-post',
        [TemplateMention.COURT_PHONE]: 'Domstolens telefon',
        [TemplateMention.COURT_EAN]: 'Domstolens EAN',
        [TemplateMention.REG_NO]: 'Domstolens registreringsnummer',
        [TemplateMention.ACCOUNT_NO]: 'Domstolens kontonummer',
        [TemplateMention.PAYMENT_PLAN_HTML]: 'Översikt över antal betalningar och belopp',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Kontaktpersonens fullständiga adress på en rad',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Kontaktpersonens fullständiga adress på flera rader',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Alternativ kontakts referens-ID',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Om alternativ kontakt har ett referens-ID',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Gäldenärens fullständiga adress på en rad',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Gäldenärens fullständiga adress på flera rader',
        [TemplateMention.DEBTOR_TABLE]: 'Tabell som visar alla gäldenärer i ärendet',
        [TemplateMention.SIGN_FIELDS]: 'Signeringsfält',
        [TemplateMention.DK_BPK]: 'PDF av betalningsföreläggande',
        [TemplateMention.GL_BPK]: 'PDF av betalningsföreläggande (GL)',
        [TemplateMention.PAGE_BREAK]: 'Sidbrytning',
        [TemplateMention.PAYMENT_LINK]: 'Länk för att betala hela skulden',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'Länk för att signera skulderkännandet',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'Länk till betalningsplan (QR-kod)',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'Länk till betalning (QR-kod)',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'Länk till gäldenärswebb (QR-kod)',
        [TemplateMention.DEBTOR_WEB_LINK]: 'Länk till gäldenärswebb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'Länk till gäldenärswebb lång',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'Länk för att betala hela skulden',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Tabell som visar betalning, datum och status',
        [TemplateMention.PAYMENT_PLAN_STATUS_TAG]: 'Statuskort med förlopp, betalt belopp, återstående belopp och nästa betalning',
        [TemplateMention.SATISFACTION_BUTTONS]: 'Nöjdhetsknappar',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'Länk för att signera skulderkännandet',
        [TemplateMention.OVERPAYMENT_LINK]: 'Länk överbetalning',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'Länk överbetalning QR-kod',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'Länk till överbetalning',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'Länk till gäldenärswebb',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'Länk till gäldenärswebb lång',
        [TemplateMention.CONDITIONAL_ELSE]: 'Annars',
        [TemplateMention.CONDITIONAL_END_IF]: 'Slut om',
        [TemplateMention.BANK_CREDITOR_NUMBER]: '',
        [TemplateMention.FOUNDATION_TYPE]: 'Grundtyp',
        [TemplateMention.FOUNDATION_DATE]: 'Grunddatum',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'Nyaste FS-nummer',
    },
    mentionsExample: {
        [TemplateMention.PaymentPlanAmortisation]: 'Datum | Kapital | Kostnader | Ränta | Upplupen ränta | Totalt | Delbetalning | Återstående skuld',
        [TemplateMention.GENERIC_EMAIL_SUBJECT]: 'Angående din skuld till Testborgenär AB [ärendenr.: 171001-171533]',
        [TemplateMention.FINANCIALS_PRICIPAL]: '8 570,14 ',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_FEES]: '100,00',
        [TemplateMention.FINANCIALS_ADMINISTRATION_COSTS]: '175,00',
        [TemplateMention.FINANCIALS_COMPENSATION_FEES]: '310,00',
        [TemplateMention.FINANCIALS_INTERESTS]: '26,70 ',
        [TemplateMention.FINANCIALS_INTEREST_RATE]: '10%',
        [TemplateMention.FINANCIALS_DEBT_COLLECTION_COSTS]: '700,00',
        [TemplateMention.PRINCIPAL_REFERENECE_IDS]: '123, 124 och 125',
        [TemplateMention.CURRENCY]: 'SEK',
        [TemplateMention.PAYMENT_PLAN_FIRST_AMOUNT]: '200,00',
        [TemplateMention.PAYMENT_PLAN_FIRST_DEADLINE]: '20 oktober 2021',
        [TemplateMention.PAYMENT_PLAN_FIRST_DATE]: '15 oktober 2021',
        [TemplateMention.PAYMENT_PLAN_LAST_AMOUNT]: '170,14',
        [TemplateMention.PAYMENT_PLAN_LAST_DEADLINE]: '20 augusti 2024',
        [TemplateMention.PAYMENT_PLAN_LAST_DATE]: '15 augusti 2024',
        [TemplateMention.PAYMENT_PLAN_ENTRY_AMOUNT]: '200,00',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DEADLINE]: '20 november 2021',
        [TemplateMention.PAYMENT_PLAN_ENTRY_DATE]: '15 november 20211',
        [TemplateMention.PAYMENT_PLAN_CREATION_DATE]: '17 september 2021',
        [TemplateMention.PAYMENT_PLAN_LENGTH_IN_DAYS]: '1035',
        [TemplateMention.PaymentPlanApr]: '12,34',
        [TemplateMention.PAYMENT_PLAN_YEARLY_COSTS]: '* 1:a året effektiv ränta: 1,33',
        [TemplateMention.PAYMENT_PLAN_HAS_YEARLY_INTEREST]: 'Om ärendet har ränta',
        [TemplateMention.PAYMENT_PLAN_MIN_ENTRY_AMOUNT]: '55,00',
        [TemplateMention.PAYMENT_PLAN_MAX_ENTRY_AMOUNT]: '550,00',
        [TemplateMention.TOTAL_DEBT]: '6 770,14',
        [TemplateMention.OVERPAYMENT]: '123,23',
        [TemplateMention.ACCORD_TEN_PERCENT]: '6 093,13',
        [TemplateMention.ACCORD_TWENTY_PERCENT]: '5 416,11',
        [TemplateMention.ACCORD_THIRTY_PERCENT]: '4 739,10',
        [TemplateMention.ACCORD_FORTY_PERCENT]: '4 062,08',
        [TemplateMention.ACCORD_FIFTY_PERCENT]: '3 385,07',
        [TemplateMention.ACCORD_SIXTY_PERCENT]: '2 708,06',
        [TemplateMention.ACCORD_SEVENTY_PERCENT]: '2 031,04',
        [TemplateMention.ACCORD_EIGHTY_PERCENT]: '1 354,03',
        [TemplateMention.ACCORD_NINETY_PERCENT]: '677,01',
        [TemplateMention.IF_IS_COMPANY]: 'Villkor om företag',
        [TemplateMention.IF_DEBTOR_IS_DEBT_REGISTERED]: 'Villkor om gäldenären är registrerad i ett kreditregister',
        [TemplateMention.IF_CASE_HAS_MULTIPLE_PRINCIPALS]: 'Villkor om ärendet har flera kapitalbelopp',
        [TemplateMention.IF_CASE_HAS_REMINDER_FEES]: 'Villkor om ärendet har påminnelseavgifter',
        [TemplateMention.IF_CASE_HAS_COLLECTION_FEES]: 'Villkor om ärendet har inkassoavgifter',
        [TemplateMention.IF_CASE_HAS_COLLECTION_COSTS]: 'Villkor om ärendet har inkassokostnader',
        [TemplateMention.IF_CASE_HAS_COMPENSATION_COSTS]: 'Villkor om ärendet har kompensationskostnader',
        [TemplateMention.IF_CASE_HAS_PROCESSRENTE]: 'Villkor om ärendet har processränta',
        [TemplateMention.IF_CASE_HAS_FIXED_INTEREST]: 'Villkor om ärendet har fast ränta',
        [TemplateMention.IF_CASE_HAS_YEARLT_INTEREST]: 'Villkor om ärendet har årlig ränta',
        [TemplateMention.IF_CASE_HAS_DEPOSIT]: 'Villkor om ärendet har deposition',
        [TemplateMention.DOCUMENTATION]: 'Dokumentation',
        [TemplateMention.DATE]: '23 november 2021',
        [TemplateMention.DATE_IN_THREE_DAYS]: '26 november 2021',
        [TemplateMention.DATE_IN_SIX_DAYS]: '29 november 2021',
        [TemplateMention.DATE_IN_TEN_DAYS]: '3 december 2021',
        [TemplateMention.DATE_IN_ELEVEN_DAYS]: '4 december 2021',
        [TemplateMention.DATE_IN_TWELVE_DAYS]: '5 december 2021',
        [TemplateMention.DATE_IN_FOURTEEN_DAYS]: '7 december 2021',
        [TemplateMention.DATE_IN_SEVENTEEN_DAYS]: '10 december 2021',
        [TemplateMention.DATE_IN_THIRTY_DAYS]: '23 december 2021',
        [TemplateMention.PREVIOUS_THREE_YEARS]: '2018, 2019 och 2020',
        [TemplateMention.DEPOSIT]: '400,00',
        [TemplateMention.DEPOSITS_TO_CREDITOR]: '200,00',
        [TemplateMention.DEPOSITS_TO_COLLECTOR]: '200,00',
        [TemplateMention.INTEREST_PAID_LAST_YEAR]: '1 234,56',
        [TemplateMention.CONTACT_NAME]: 'Debbie Kontaktsson',
        [TemplateMention.DEBTOR_NAME]: 'Debbie Gäldenärsson',
        [TemplateMention.DEBTOR_FIRST_NAME]: 'Debbie',
        [TemplateMention.CONTACT_ADDRESS]: 'Kungsgatan 7',
        [TemplateMention.CONTACT_COADDRESS]: 'Emil Brandt',
        [TemplateMention.CONTACT_ZIPCODE]: '111 43',
        [TemplateMention.CONTACT_CITY]: 'Stockholm',
        [TemplateMention.CONTACT_COUNTRY]: 'Sverige',
        [TemplateMention.DEBTOR_ADDRESS]: 'Kungsgatan 7',
        [TemplateMention.DEBTOR_COADDRESS]: 'Emil Brandt',
        [TemplateMention.DEBTOR_ZIPCODE]: '111 43',
        [TemplateMention.DEBTOR_CITY]: 'Stockholm',
        [TemplateMention.DEBTOR_COUNTRY]: 'Sverige',
        [TemplateMention.DEBTOR_EMAIL]: 'gäldenär@example.com',
        [TemplateMention.DEBTOR_PHONE]: '88888888',
        [TemplateMention.LAST_PAYMENT_DATE]: '12 oktober 2021',
        [TemplateMention.LAST_PAYMENT_AMOUNT]: '200,00',
        [TemplateMention.DEBTOR_SEQ_ID]: '111111',
        [TemplateMention.DEBTOR_CVR_AND_OR_CPR]: '12345678',
        [TemplateMention.CREDITOR_NAME]: 'Testborgenär AB',
        [TemplateMention.CASE_ID]: '12345678',
        [TemplateMention.CASE_REFERENCE_ID]: '123456789',
        [TemplateMention.CREDITOR_ADDRESS]: 'Kungsgatan 7',
        [TemplateMention.CREDITOR_IF_IS_COMPANY]: 'Logik om borgenären är ett företag',
        [TemplateMention.CREDITOR_IF_IS_VAT_REGISTERED]: 'Logik om borgenären är momsregistrerad',
        [TemplateMention.USER_NAME]: 'Peter Petersson',
        [TemplateMention.USER_FIRST_NAME]: 'Peter',
        [TemplateMention.IF_USER]: 'Logik om användare är tillgänglig',
        [TemplateMention.IF_COLLECTOR_ALLOWS_BANK_TRANSFERS]: 'Logik om borgenären tillåter banköverföringar',
        [TemplateMention.IF_COLLECTOR_ALLOWS_FI_PAYMENTS]: 'Logik om borgenären tillåter FI-betalningar',
        [TemplateMention.REMINDER_FEES]: '300,00',
        [TemplateMention.COLLECTOR_PAYMENT_OPTIONS]: 'Betalningsalternativ',
        [TemplateMention.COLLECTOR_ACCOUNT_NUMBER]: '12345678',
        [TemplateMention.COLLECTOR_REGISTER_NUMBER]: '1234',
        [TemplateMention.COLLECTOR_PHONE]: '11223344',
        [TemplateMention.COLLECTOR_COURT_PHONE]: '11223345',
        [TemplateMention.COLLECTOR_EMAIL]: 'collector@debbie.dk',
        [TemplateMention.COLLECTOR_NICKNAME]: 'Testinkassobolag',
        [TemplateMention.COLLECTOR_NAME]: 'Testinkassobolag AB',
        [TemplateMention.COLLECTOR_ADDRESS_ADDRESS]: 'Kungsgatan 7',
        [TemplateMention.COLLECTOR_ADDRESS_CITY]: 'Stockholm',
        [TemplateMention.COLLECTOR_ADDRESS_ZIP]: '111 43',
        [TemplateMention.COLLECTOR_CVR]: '88776655',
        [TemplateMention.CREDITOR_ZIPCODE]: '111 43',
        [TemplateMention.CREDITOR_CITY]: 'Stockholm',
        [TemplateMention.CREDITOR_COMPANY_IDENTIFIER]: '66554433',
        [TemplateMention.PAYMENT_ID]: '+71<000000001111111 + 12345678<',
        [TemplateMention.JOURNAL_NUMBER]: '12345678-111111',
        [TemplateMention.COURT_NAME]: 'Stockholms tingsrätt',
        [TemplateMention.COURT_ADDRESS]: 'Scheelegatan 7',
        [TemplateMention.COURT_CITY]: 'Stockholm',
        [TemplateMention.COURT_ZIP]: '112 79',
        [TemplateMention.COURT_EMAIL]: 'stockholms.tingsratt@dom.se',
        [TemplateMention.COURT_PHONE]: '99687000',
        [TemplateMention.COURT_EAN]: '5798000161252',
        [TemplateMention.REG_NO]: '0216',
        [TemplateMention.ACCOUNT_NO]: '4069134793',
        [TemplateMention.PAYMENT_PLAN_HTML]: '* 1. Deposition på 200,00 SEK före 15 oktober 2021',
        [TemplateMention.CONTACT_ADDRESS_INLINE]: 'Kungsgatan 7, 111 43 Stockholm',
        [TemplateMention.CONTACT_ADDRESS_FORMATTED]: 'Kungsgatan 7,\n 111 43 Stockholm',
        [TemplateMention.ALTERNATIVE_CONTACT_REFERENCE_ID]: '123-123',
        [TemplateMention.HAS_ALTERNATIVE_CONTACT_REFERENCE_ID]: 'Logik om alternativt kontaktreferens-id finns',
        [TemplateMention.DEBTOR_ADDRESS_INLINE]: 'Kungsgatan 7, 111 43 Stockholm',
        [TemplateMention.DEBTOR_ADDRESS_FORMATTED]: 'Kungsgatan 7,\n 111 43 Stockholm',
        [TemplateMention.DEBTOR_TABLE]: 'Gäldenär 1|Gäldenär 2|...',
        [TemplateMention.SIGN_FIELDS]: 'Datum\n_______________________\nUnderskrift',
        [TemplateMention.DK_BPK]: 'PDF',
        [TemplateMention.GL_BPK]: 'PDF',
        [TemplateMention.PAGE_BREAK]: 'Sidbrytning',
        [TemplateMention.PAYMENT_LINK]: 'debtorweb.dk/r/fulldebt',
        [TemplateMention.DEBTOR_WEB_LINK]: 'debtorweb.dk',
        [TemplateMention.DEBTOR_WEB_LONG_LINK]: 'debtorweb.dk',
        [TemplateMention.PAYMENT_PLAN_LINK]: 'debtorweb.dk/r/paymentplant',
        [TemplateMention.OVERPAYMENT_LINK]: 'debtorweb.dk/r/overindbetaling',
        [TemplateMention.OVERPAYMENT_LINK_QR_CODE]: 'QR-kod',
        [TemplateMention.OVERPAYMENT_LINK_A_TAG]: 'debtorweb.dk/r/overindbetaling',
        [TemplateMention.PAYMENT_PLAN_LINK_QR_CODE]: 'QR-kod',
        [TemplateMention.PAYMENT_LINK_QR_CODE]: 'QR-kod',
        [TemplateMention.DEBTOR_WEB_LINK_QR_CODE]: 'QR-kod',
        [TemplateMention.PAYMENT_LINK_A_TAG]: 'debtorweb.dk/r/fulldebt',
        [TemplateMention.PAYMENT_PLAN_ENTRIES_TAG]: 'Belopp | Datum | Status',
        [TemplateMention.PAYMENT_PLAN_STATUS_TAG]: '3 av 8 poster · Nästa 31.05.26',
        [TemplateMention.SATISFACTION_BUTTONS]: '(:D) (:|) (:C)',
        [TemplateMention.PAYMENT_PLAN_LINK_A_TAG]: 'debtorweb.dk/r/paymentplant',
        [TemplateMention.DEBTOR_WEB_LINK_A_TAG]: 'debtorweb.dk',
        [TemplateMention.DEBTOR_WEB_LONG_LINK_A_TAG]: 'debtorweb.dk',
        [TemplateMention.CONDITIONAL_ELSE]: 'Annars',
        [TemplateMention.CONDITIONAL_END_IF]: 'Slut om',
        [TemplateMention.BANK_CREDITOR_NUMBER]: 'Ej tillämpligt',
        [TemplateMention.FOUNDATION_TYPE]: 'Dom',
        [TemplateMention.FOUNDATION_DATE]: '23 november 2021',
        [TemplateMention.LATEST_TRIBUNAL_REFERENCE]: 'FS 11-1111/1111',
    },
    import: {
        result: {
            description: 'Dina data har importerats. Här kan du granska resultatet och arbeta vidare med ärendena.',
            finishedWithErrors: 'Import slutförd med fel',
            errorsDescription: 'Importen är slutförd, men vissa rader kunde inte importeras.',
            processedSheets: 'Importerade blad',
            processedRows: 'rader bearbetade',
            sheet: 'Blad',
            viewCases: 'Visa skapade ärenden',
            failedTitle: 'Dessa rader behöver granskas',
            failedDescription: 'Ladda ner raderna som misslyckades, rätta felen och importera endast de korrigerade raderna i en ny import.',
            viewFailedRows: 'Visa misslyckade rader',
            nextStep: 'Redo för nästa steg',
            approveDescription: 'När du har granskat resultatet kan du godkänna de skapade ärenden som väntar på godkännande.',
            actionStarted: 'Åtgärden har lagts i kö. Du får ett e-postmeddelande när den är klar.',
            noCreatedCases: 'Importen har inga skapade ärenden.',
            endTitle: 'Avsluta de skapade ärendena',
            endDescription: 'Detta avslutar de skapade ärenden som väntar på godkännande eller är godkända med orsaken Fel från vår sida. Vill du fortsätta?',
        },
        progress: {
            linking: 'Kopplar kontaktpersoner',
            title: 'Importerar dina data',
            description: 'Du kan lämna sidan. Importen fortsätter i bakgrunden och förloppet sparas löpande.',
            preparing: 'Förbereder importen',
            rows: 'rader importerade',
            pending: 'Väntar',
            running: 'Importerar',
            completed: 'Klart',
            failed: 'Stoppad',
            pausedTitle: 'Importen behöver uppmärksamhet',
            pausedDescription: 'En uppgift misslyckades efter flera försök. Åtgärda orsaken och återuppta importen. Redan importerade data skapas inte igen.',
            retry: 'Återuppta import',
            finishing: 'Avslutar importen',
            legacy: 'Den här importen startades utan sparat förlopp. Status uppdateras när den är klar.',
        },
        workbook: {
            otherCaseGroup: 'Annan ärendegrupp · sparas men används inte i denna import',
            otherCaseGroupMappings: 'Mappningen innehåller attribut för andra ärendegrupper. De bevaras och används när du importerar till rätt ärendegrupp.',
            unavailableField: 'Otillgängligt fält',
            unavailableMappings: 'Vissa mappningar använder otillgängliga fält',
            unavailableMappingsDescription: 'Ett valt fält finns inte längre eller kan inte importeras i detta blad. Öppna kolumnens fältval och ta bort eller ersätt det otillgängliga fältet. Attribut för andra ärendegrupper bevaras och utlöser inte denna varning.',
            selectField: 'Välj fält',
            reuploadForHeaders: 'Ladda upp filen igen för att ändra rubrikraden.',
            fields: {
                accountNumber: 'Bankkontonummer',
                address: 'Adress',
                administrationCost: 'Administrationskostnad',
                alternativeContactAddress: 'Alternativ kontakt: adress',
                alternativeContactCity: 'Alternativ kontakt: ort',
                alternativeContactCoAddress: 'Alternativ kontakt: c/o-adress',
                alternativeContactCountry: 'Alternativ kontakt: land',
                alternativeContactEmail: 'Alternativ kontakt: e-post',
                alternativeContactName: 'Alternativ kontakt: namn',
                alternativeContactPhone: 'Alternativ kontakt: telefonnummer',
                alternativeContactType: 'Alternativ kontakt: typ',
                alternativeContactZipcode: 'Alternativ kontakt: postnummer',
                amount: 'Belopp',
                bailifsFee: 'Kronofogdens avgift',
                bailifsSalary: 'Kronofogdens arvode',
                birthdate: 'Födelsedatum',
                bpkWarnedAt: 'BPK-varnad den',
                caseCreatedAt: 'Ärende skapat den',
                caseGroup: 'Ärendegrupp',
                caseReferenceId: 'Ärendereferens',
                caseSeqId: 'Ärendenummer',
                caseStatus: 'Ärendestatus',
                caseTags: 'Ärendeetiketter',
                centralRegisterId: 'Organisationsnummer',
                city: 'Ort',
                clientContactUserEmail: 'Kontaktpersonens e-post',
                coAddress: 'C/o-adress',
                collectionCost: 'Inkassokostnader',
                collectionFee: 'Inkassoavgift',
                compensationCost: 'Kompensationskostnader',
                compoundInterestRate: 'Ränta på ränta',
                continuedAt: 'Återupptagningsdatum',
                controlFee: 'Kontrollavgift',
                country: 'Land',
                countryCode: 'Landskod',
                cpr: 'CPR',
                createdAt: 'Skapad',
                createdByUserWithEmail: 'Skapad av användare med e-post',
                creditNote: 'Kreditnota',
                creditorReferenceId: 'Borgenärens referens-id',
                currency: 'Valuta',
                customerReferenceId: 'Kundreferens',
                customerTerminated: 'Kund avslutad',
                cvr: 'CVR',
                date: 'Datum',
                debtDescription: 'Verifikatbeskrivning',
                debtReferenceId: 'Faktura-id',
                defaultBillingModelId: 'Standardavräkningsmodell',
                defaultWorkflowId: 'Standardarbetsflöde',
                deposit: 'Deposition',
                dueDate: 'Förfallodatum',
                economyBillingModelId: 'Faktureringsmodell',
                email: 'E-post',
                endReason: 'Orsak till avslut',
                experianClientId: 'Kundnummer hos Experian',
                expirationFromDate: 'Preskription från datum',
                fiPaymentIdRaw: 'FI-betalnings-id',
                fileId: 'Fil-ID',
                fileName: 'Filnamn',
                fileNote: 'Filanteckning',
                finalSettlement: 'Slutreglering',
                finalStatement: 'Slutredovisning',
                firstName: 'Förnamn',
                fixedInterest: 'Fast ränta',
                fogedRekvisitionsFee: 'Avgift för begäran om verkställighet',
                from: 'Avsändare',
                html: 'Innehåll (HTML)',
                imposedByCreditor: 'Påfört av borgenären',
                interestEndDate: 'Slutdatum för ränta',
                interestRate: 'Räntesats',
                interestStartDate: 'Räntans startdatum',
                interval: 'Intervall',
                isCompany: 'Är företag',
                issueDate: 'Datum',
                lang: 'Språk',
                lastName: 'Efternamn',
                loan: 'Lån',
                migratedId: 'Migrerat journalnummer',
                migratedStepId: 'Migrerat uppgifts-ID',
                name: 'Namn',
                newUserToken: 'Inbjudningstoken för ny användare',
                note: 'Anteckning',
                notes: 'Anteckningar',
                onAccount: 'A conto',
                pausedAt: 'Pausdatum',
                phone: 'Telefon',
                phoneLocale: 'Telefonlandskod',
                phoneNumber: 'Telefonnummer',
                policePresentationFee: 'Avgift för polisinställelse',
                principal: 'Kapitalbelopp',
                referenceId: 'Referensnummer',
                referenceVoucherReferenceId: 'Relaterad transaktionsreferens',
                referenceVoucherTypeId: 'Relaterad transaktionstyp',
                refund: 'Återbetalning',
                registrationNumber: 'Bankens clearingnummer',
                registryIdentifierScheme: 'Typ av registeridentifierare',
                registryIdentifierValue: 'Registeridentifierare',
                remindedAt: 'Påminnelsedatum',
                reminderFee: 'Påminnelseavgifter',
                reminderFeeCollector: 'Påminnelseavgifter från inkassobolag',
                rkiWarnedAt: 'RKI-varnad den',
                role: 'Roll',
                settlement: 'Förlikning',
                signedAt: 'Underskriftsdatum',
                startDate: 'Startdatum',
                state: 'Tillstånd',
                subject: 'Ämne',
                text: 'Text',
                to: 'Mottagare',
                type: 'Typ',
                udtraeksgebyr: 'Avgift för uttag',
                ultimateCreditorReferenceId: 'Slutlig borgenärs referensnummer',
                update: 'Uppdatering',
                updateTypeId: 'Uppdateringstyp',
                vatRegistered: 'Momsregistrerad',
                visibleForDebtor: 'Synlig för gäldenären',
                voucherReferenceId: 'Referensnummer för transaktion',
                writFee: 'Föreläggandeavgift',
                writSalary: 'Föreläggandearvode',
                zipcode: 'Postnummer',
            },
            mappedFromColumn: 'Kolumn i filen',
            mappedColumns: 'mappade kolumner',
            columnHint: 'Klicka på fältet under en kolumnrubrik för att välja var värdena ska användas.',
            missingFields: 'Obligatoriska fält utan kolumn',
            emptySheet: 'Arket har inga datarader. Välj ett annat ark eller ändra rubrikraden.',
            mappingHint: 'Välj ett eller flera fält för kolumnen. Ett fält kan bara hämta värden från en kolumn åt gången.',
            sheets: 'ark',
            skipped: 'Importeras inte',
            importAs: 'Importera som',
            skipSheet: 'Hoppa över arket',
            headerRow: 'Rubrikrad',
            skippedDescription: 'Detta ark ingår inte i importen. Du kan fortfarande se innehållet.',
            sourcePreview: 'Data från filen',
            searchFields: 'Sök efter fält…',
            searchTypes: 'Sök efter bladtyp…',
            addFixedValue: 'Lägg till fast värde',
            fixedValue: 'Fast värde',
            mappingSaving: 'Sparar inställningar…',
            mappingSaved: 'Inställningarna har sparats',
            mappingSaveFailed: 'Inställningarna kunde inte sparas. Dina ändringar finns kvar på sidan.',
            retryMappingSave: 'Försök igen',
            unsavedMapping: 'Dina ändringar har inte sparats ännu. Vill du lämna sidan?',
            attachmentNotUploaded: 'Bilagan har inte laddats upp',
            fixedFileHint: 'Ladda upp bilagan under Ladda upp bilagor och välj sedan filen här.',
            fixedValueHint: 'Gäller alla rader och ersätter fältets mappning till en Excel-kolumn.',
            removeFixedValue: 'Ta bort',
            imposedBy: 'Påfört av',
            creditor: 'Borgenär',
            collector: 'Inkassobolag',
            attribute: 'Attribut',
            createAttribute: 'Skapa nytt attribut',
            mappingSettings: 'Inställningar',
            invertSign: 'Vänd tecken',
            voucherSignHint: 'Beloppen i tabellen ska ha följande tecken:',
            voucherDebtSign: 'Skuld, ränta och kostnader: ett negativt belopp, t.ex. −1 000,00. Det ökar skulden.',
            voucherCreditSign: 'Kreditnotor och inbetalningar: ett positivt belopp, t.ex. +250,00. Det minskar skulden.',
            invertSignDescription: 'Positiva värden blir negativa och negativa blir positiva. Tabellen visar värdena med dina inställningar.',
            duplicateHeaders: 'Kolumnnamn måste vara unika. Välj rätt rubrikrad eller byt namn på dubbletter i filen.',
            missingColumns: 'Några sparade kolumner saknas. Välj en ny kolumn eller ta bort mappningen.',
            types: {
                cases: 'Ärenden',
                customers: 'Kunder',
                vouchers: 'Transaktioner',
                creditors: 'Borgenärer',
                ultimateCreditors: 'Slutliga borgenärer',
                users: 'Användare',
                billingVouchers: 'Avräkningstransaktioner',
                notes: 'Anteckningar',
                emails: 'E-post',
                letters: 'Brev',
                sms: 'SMS',
                steps: 'Uppgifter',
                updates: 'Uppdateringar',
                documents: 'Dokument',
                paymentPlans: 'Avbetalningsplaner',
            },
        },
        importedData: 'Importerade data',
        downloadInvoiceExampleHeader: 'Fakturaskulder',
        downloadInvoiceExampleText: 'Ladda ner importark med exempel på fakturaärenden.',
        downloadFinancialExampleHeader: 'Bankärenden',
        downloadFinancialExampleText: 'Ladda ner importark med exempel på bankärenden.',
        downloadAcontoExampleHeader: 'A conto-ärenden',
        downloadAcontoExampleText: 'Ladda ner importark med a conto-fakturerade ärenden.',
        downloadMigrationExampleHeader: 'Migrera ärenden',
        downloadMigrationExampleText: 'Ladda ner migreringsark med exempel på migreringsdata.',
        download: 'Ladda ner exempel',
        import: 'Import',
        backToImports: 'Tillbaka till importer',
        newImport: 'Ny import',
        noImports: 'Inga importer att visa',
        casesCreated: 'Skapade ärenden',
        casesUpdated: 'Uppdaterade ärenden',
        companyStatuses: 'Företagsstatusar',
        noStatus: 'Ingen status',
        caseUpdates: 'Ärendeuppdateringar',
        [ImportState.CANCELED]: 'Avbruten',
        [ImportState.CREATED]: 'Skapad',
        [ImportState.DELETED]: 'Raderad',
        [ImportState.IMPORTED]: 'Importerad',
        [ImportState.IMPORTING]: 'Importerar',
        [ImportState.SHEETADDED]: 'Ark tillagt',
        create: 'Skapa',
        uploadFile: 'Ladda upp fil',
        uploadedAppendicies: 'Uppladdade bilagor',
        mapColumns: 'Mappa kolumner',
        imported: 'Importerad',
        dropFileHereOr: 'Släpp filen här eller',
        dropAppendixHereOr: 'Släpp bilagan här eller',
        uploadImport: 'Ladda upp importark',
        uploadAppendix: 'Ladda upp bilaga',
        workbookGuide: {
            title: 'Ladda upp din Excel-fil',
            description: 'Samla dina data i en Excel-fil och koppla kolumnerna till fälten i Debbie.',
            dropFile: 'Dra och släpp din Excel-fil här',
            fileFormats: 'Välj en Excel-fil i formatet .xlsx eller .xls.',
            replaceFile: 'En ny fil ersätter den nuvarande importfilen.',
            chooseFile: 'Välj fil',
            uploadTitle: 'Ladda upp importfilen',
            uploadDescription: 'Välj Excel-filen med de data du vill importera. Filen kan innehålla flera blad.',
            sheetsTitle: 'Välj innehållet i varje blad',
            sheetsDescription: 'Ange om bladet innehåller till exempel ärenden, kunder eller transaktioner. Hoppa över blad som inte ska importeras.',
            mappingTitle: 'Mappa kolumnerna och kontrollera data',
            mappingDescription: 'Koppla kolumnerna till fälten i Debbie och rätta eventuella fel innan du importerar.',
        },
        appendixGuide: {
            title: 'Koppla bilagor till dina rader i Excel',
            description: 'Ladda upp dina filer här och använd filnamnen i Excel för att koppla varje bilaga till rätt rad.',
            dropFiles: 'Dra och släpp dina bilagor här',
            multipleFiles: 'Du kan ladda upp flera filer samtidigt.',
            chooseFiles: 'Välj filer',
            uploadTitle: 'Ladda upp bilagorna',
            uploadDescription: 'Välj de filer som ska ingå i importen, till exempel fakturor eller avtal.',
            referenceTitle: 'Skriv filnamnet i Excel',
            referenceDescription: 'Lägg till en kolumn med filnamnet på raden som bilagan hör till. Ange hela filnamnet, inklusive till exempel .pdf.',
            mappingTitle: 'Mappa kolumnen till ett filfält',
            mappingDescription: 'Ladda upp den uppdaterade Excel-filen under “Ladda upp importark”. Mappa kolumnen till “Filnamn” eller en filegenskap innan du importerar.',
        },
        migration: 'Migrering',
        createdAt: 'Skapad',
        state: 'Tillstånd',
        appendixUploaded: 'Bilaga uppladdad',
        dropAnotherFileHereOr: 'Släpp en annan fil här eller',
        uploadFileBtn: 'Ladda upp fil',
        deleteImport: 'Radera import',
        importFinished: 'Import slutförd',
        withRKIRegistrations: 'med RKI-registreringar',
        endAll: 'Avsluta alla',
        approveAll: 'Godkänn alla ärenden',
        createdCases: 'skapade ärenden.',
        startedEnding: 'Påbörjade avslutning av',
        cases: 'ärenden.',
        found: 'Hittade',
        rows: 'rader',
        and: 'och',
        debtors: 'gäldenärer',
        chain: 'Arbetsflöde',
        billingModel: 'Faktureringsmodell',
        tenantStandard: 'Kontostandard',
        creditorStandard: 'Borgenärsstandard',
        systemStandard: 'Systemstandard',
        more: 'fler.',
        showMore: 'Visa mer',
        importCases: 'Importera ärenden',
        youWillreceiveAnEmailWhenItIsDone: 'Du får ett e-postmeddelande när importen är klar.',
        importHasStarted: 'Import har startat',
        see: 'Se',
        seeMore: 'Se mer',
        here: 'här',
        file: 'filens',
        asWell: 'och',
        notMappedColumns: 'Följande kolumner har inte mappats',
        errors: 'fel',
        error: 'Fel',
        row: 'Rad',
        column: 'Kolumn',
        columnNotFound: 'Kolumn hittades inte',
        noErrorsFound: 'Inga fel hittades',
        rowsHeader: 'Rader',
        columnsHeader: 'Kolumner',
        failedRows: 'Misslyckade rader',
        failedImportRows: 'Misslyckade importrader',
        referenceId: 'Referens-id',
        creditorReferenceId: 'Borgenärens referens-id',
        isCompany: 'Är företag',
        caseCreatedAt: 'Ärende skapat den',
        caseStatus: 'Ärendestatus',
        endReason: 'Orsak till avslut',
        caseGroup: 'Ärendegrupp',
        migratedId: 'Migrerat journalnummer',
        name: 'Namn',
        birthdate: 'Födelsedatum',
        cpr: 'CPR',
        cvr: 'CVR',
        email: 'E-post',
        phone: 'Telefon',
        lang: 'Språk',
        address: 'Adress',
        coAddress: 'C/O-adress',
        zipcode: 'Postnummer',
        city: 'Ort',
        country: 'Land',
        fiPaymentIdRaw: 'FI-betalnings-id',
        caseTags: 'Ärendetaggar',
        economyBillingModelId: 'Faktureringsmodell',
        debtReferenceId: 'Faktura-id',
        fileName: 'Filnamn',
        issueDate: 'Datum',
        dueDate: 'Förfallodatum',
        expirationFromDate: 'Preskription från datum',
        currency: 'Valuta',
        debtDescription: 'Verifikatbeskrivning',
        principal: 'Kapitalbelopp',
        controlFee: 'Kontrollavgift',
        onAccount: 'A conto',
        finalSettlement: 'Slutreglering',
        deposit: 'Deposition',
        loan: 'Lån',
        settlement: 'Förlikning',
        fixedInterest: 'Fast ränta',
        udtraeksgebyr: 'Avgift för uttag',
        administrationCost: 'Administrationskostnad',
        reminderFee: 'Påminnelseavgifter',
        reminderFeeCollector: 'Påminnelseavgifter från inkassobolag',
        refund: 'Återbetalning',
        compensationCost: 'Kompensationskostnader',
        collectionCost: 'Inkassokostnader',
        collectionFee: 'Inkassoavgift',
        writFee: 'Föreläggandeavgift',
        writSalary: 'Föreläggandearvode',
        policePresentationFee: 'Avgift för polisinställelse',
        fogedRekvisitionsFee: 'Fogedrekvisitionsgebyr',
        bailifsSalary: 'Kronofogdens arvode',
        bailifsFee: 'Kronofogdens avgift',
        creditNote: 'Kreditnota',
        interestStartDate: 'Räntans startdatum',
        interestRate: 'Räntesats',
        finalStatement: 'Slutredovisning',
        customerTerminated: 'Kund avslutad',
        rkiWarnedAt: 'RKI-varnad den',
        bpkWarnedAt: 'BPK-varnad den',
        errorWarning: 'Din fil innehåller fel som förhindrar importen.',
        faqHeader: 'Behöver du hjälp med att importera ärenden?',
        faqText: 'Vi har skrivit en artikel om filimport i vår hjälpsektion. Där hittar du också en förklaring av typiska fel vid import av filer.',
        newCase: 'Nytt ärende',
        selectColumn: '-- Välj kolumn --',
        debtorMessages: 'Gäldenärsmeddelanden',
        importDebtorMessages: 'Importera gäldenärsmeddelanden',
    },
    updateTypesSettings: {
        addUpdateType: 'Skapa uppdateringstyp',
        title: 'Etikett för uppdateringstyp',
        editUpdateType: 'Redigera uppdateringstyp',
        createNewUpdateType: 'Skapa ny uppdateringstyp',
        customUpdateTypes: 'Skapade uppdateringstyper',
        standardUpdateTypes: 'Standarduppdateringstyper',
        allUpdateTypes: 'Alla uppdateringstyper',
        filterAutomatic: 'Automatiska',
        filterPause: 'Paus',
        filterInfo: 'Info',
    },
    updateTypes: {
        [UpdateType.CreditorEndedCase]: 'Borgenär avslutade ärende',
        [UpdateType.AKSStatus]: 'AKS-status',
        [UpdateType.AKSFailed]: 'AKS-registrering misslyckades',
        [UpdateType.EXITREQUEST]: 'Utträdesbegäran från borgenär',
        [UpdateType.CASESTATUSMOVE]: 'Ändrad ärendestatus',
        [UpdateType.SOP]: 'Slutredovisning',
        [UpdateType.UPDATE]: 'Uppdatering',
        [UpdateType.NOCONTACTINFORMATION]: 'Saknad kontaktinformation',
        [UpdateType.DEPOSIT]: 'Deposition',
        [UpdateType.NEWDEBT]: 'Ny skuld',
        [UpdateType.NEWINTERACTION]: 'Ny inkommande e-post',
        [UpdateType.eBoksFailed]: 'e-Boks-meddelande kunde inte levereras',
        [UpdateType.TECHNICALINVESTIGATION]: 'Utredd av tekniker',
        [UpdateType.TERMINATIONREQUEST]: 'Begäran om uppsägning skickad till borgenär',
        [UpdateType.PENDINGTERMINATION]: 'Väntande uppsägning av handläggare',
        [UpdateType.CANCELTERMINATION]: 'Avbruten uppsägning',
        [UpdateType.CASECONTINUED]: 'Ärende fortsatt',
        [UpdateType.POSTPONECASEWORKING]: 'Skjut upp handläggning',
        [UpdateType.RETURNLETTER]: 'Returbrev',
        [UpdateType.BOBEHANDLING]: 'Dödsbohandläggning',
        [UpdateType.BOBEHANDLET]: 'Dödsbo handlagt',
        [UpdateType.NotSureCourtSubmit]: 'Väntar på betalningsföreläggande-blankett',
        [UpdateType.YesCourtSubmit]: 'Redo att skickas automatiskt till domstol',
        [UpdateType.NoCourtSubmit]: 'Inte vald för automatisk inlämning till domstolen',
        [UpdateType.AWAITINGSTAEVNING]: 'Väntar på föreläggande',
        [UpdateType.AFDRAGSORDNINGER]: 'Betalningsplan',
        [UpdateType.ApprovedByCreditor]: 'Godkänd av borgenär',
        [UpdateType.ApprovedByDatahub]: 'Godkänd av Datahub',
        [UpdateType.CancelApprovedByDatahub]: 'Avbryt godkänd av Datahub',
        [UpdateType.REMOVEFROMRKI]: 'Ta bort från RKI',
        [UpdateType.AUTOREMOVEFROMRKI]: 'Automatisk radering av RKI-registrering',
        [UpdateType.CancelRejectedByDatahub]: 'Avbryt avvisad av Datahub',
        [UpdateType.CancelRequestedBecauseOfPaymentToCreditor]: 'Avbrytande begärt på grund av betalning till borgenär',
        [UpdateType.RejectedByCreditor]: 'Avvisad av borgenär',
        [UpdateType.RejectedByDatahub]: 'Avvisad av Datahub',
        [UpdateType.PAYMENTPLANINITIAL]: 'Ny betalningsplan skapad',
        [UpdateType.NEWCLIENTINTERACTION]: 'Ny borgenärsinteraktion',
        [UpdateType.NEWDEBTORINTERACTION]: 'Ny gäldenärsinteraktion',
        [UpdateType.DEBTORPERSONALDATAREQUEST]: 'Begäran om ändring av gäldenärsinformation',
        [UpdateType.AWAITINGCLIENTANSWER]: 'Väntar på svar från borgenär',
        [UpdateType.DEFAULTEDPAYMENTPLAN]: 'Missad betalningsplan',
        [UpdateType.OVERPAYPAYMENTPLAN]: 'Överbetald betalningsplan',
        [UpdateType.RKIApprovalRequest]: 'RKI-begäran för handläggare',
        [UpdateType.RKIREGISTRATION]: 'RKI-registrering krävs',
        [UpdateType.DOCSIGNED]: 'Dokument signerat',
        [UpdateType.COSMOSUBSCRIBED]: 'Prenumererar på Cosmo',
        [UpdateType.COSMOUNSUBSCRIBED]: 'Avslutade prenumeration på Cosmo',
        [UpdateType.AWAITINGFOGEDREKVISITION]: 'Väntar på ansökan om verkställighet',
        [UpdateType.ISINFOGEDRETTEN]: 'Hos Kronofogden',
        [UpdateType.ISINCIVILCOURT]: 'I tvistemålsdomstol',
        [UpdateType.PAYMENTONCASEINCOURT]: 'Betalning på ärende i domstol',
        [UpdateType.RECEIVEDCOURTFOUNDATION]: 'Mottagen dom/betalningsföreläggande-blankett/förlikning väntar på verkställighet',
        [UpdateType.POLITIFREMSTILLING]: 'Hämtning vid utebliven inställelse',
        [UpdateType.DECIDECOURT]: 'Besluta om domstolsbeslut',
        [UpdateType.RKISTATUS]: 'RKI-status',
        [UpdateType.AWAITINGPOWERTERMINATION]: 'Väntar på uppsägning av fullmakt',
        [UpdateType.RKIAPPROVEDBYCLIENT]: 'RKI godkänd av borgenär',
        [UpdateType.REQUESTCLIENTRKI]: 'RKI-begäran för borgenär',
        [UpdateType.TERMINATEDCUSTOMER]: 'Avslutad kund',
        [UpdateType.FOGEDREVISITIONCLIENTREQUEST]: 'Begäran om ansökan om verkställighet för borgenär',
        [UpdateType.TICKETRESOLVED]: 'Ärende löst',
        [UpdateType.MIGRATIONNOTE]: 'Migreringsanteckning',
        [UpdateType.TILJURIDISKBEHANDLING]: 'Till juridisk handläggning',
        [UpdateType.COURTEVENTS]: 'Domstolshändelser',
        [UpdateType.AFTEROFFICEHOURS]: 'Uppskjuten till efter kontorstid',
        [UpdateType.AWAITINGPAYMENTAFTERCONCILIATION]: 'Väntar på betalning efter förlikning',
        [UpdateType.PHONEMEETING]: 'Kallad till telefoniskt kronofogdemöte',
        [UpdateType.INSOLVENS]: 'Insolvens',
        [UpdateType.DEBTEXPIRESWITHINTHREEMONTHS]: 'Skulden preskriberas inom tre månader',
        [UpdateType.DEBTEXPIRED]: 'Skulden preskriberad',
        [UpdateType.EMAILFAILED]: 'E-post misslyckades',
        [UpdateType.EINVOICEFAILED]: 'E-faktura misslyckades',
        [UpdateType.AWAITINGCIVILCOURT]: 'Väntar på tvistemålsdomstol',
        [UpdateType.AWAITINGFINALSTATEMENT]: 'Väntar på slutredovisning',
        [UpdateType.MIGRATEDJOURNALNUMBER]: 'Migrerat journalnummer',
        [UpdateType.RKIREGISTRATIONOPEN]: 'RKI-registrering (öppen)',
        [UpdateType.RKIREGISTRATIONCLOSED]: 'RKI-registrering (avslutad)',
        [UpdateType.AUTORKIREGISTRATIONOPEN]: 'Auto-RKI-registrering (öppen)',
        [UpdateType.AUTORKIREGISTRATIONCLOSED]: 'Auto-RKI-registrering (avslutad)',
        [UpdateType.DEBTREGISTRATIONWARNED]: 'RKI-varnad',
        [UpdateType.STAEVNINGREQUSTCLIENT]: 'Ska gäldenären få ett föreläggande',
        [UpdateType.UDLAEG]: 'Utmätning',
        [UpdateType.UDLAEGCIVIL]: 'Utmätning',
        [UpdateType.NEWCOURTINTERACTION]: 'Ny domstolsinteraktion',
        [UpdateType.REMINDER]: 'Påminnelse',
        [UpdateType.OUTBOUNDCALL]: 'Utgående samtal',
        [UpdateType.UDLAEGAFLYSES]: 'Utmätning ska hävas',
        [UpdateType.OPPOSITION]: 'Bestridande',
        [UpdateType.NOTOPPOSITION]: 'Inget bestridande',
        [UpdateType.FSNUMMER]: 'FS-nummer',
        [UpdateType.OVERDRAGESTILINKASSOPARTNER]: 'Överlämna ärende till extern inkassopartner',
        [UpdateType.AKSUpdateName]: 'AKS uppdaterad: Namn',
        [UpdateType.AKSUpdateAddress]: 'AKS uppdaterad: Adress',
        [UpdateType.AKSUpdateStatus]: 'AKS uppdaterad: Status',
        [UpdateType.AKSUpdateProtection]: 'AKS uppdaterad: Namn-/adresskydd',
        [UpdateType.AKSUpdateNewRKI]: 'AKS uppdaterad: Ny RKI-registrering',
        [UpdateType.AKSUpdateDeletedRKI]: 'AKS uppdaterad: Raderad RKI-registrering',
        [UpdateType.AKSUpdateCreditWarning]: 'AKS uppdaterad: Kreditvarning',
        [UpdateType.AKSUpdateAdvertisementPreference]: 'AKS uppdaterad: Reklaminställning',
        [UpdateType.AKSUpdateGuardianStatus]: 'AKS uppdaterad: Förmyndarstatus',
        [UpdateType.AKSUpdateRKI]: 'AKS uppdaterad: RKI-anmärkning',
        [UpdateType.COURTREMINDER]: 'Domstolspåminnelse',
        [UpdateType.DEPARTED]: 'Avflyttad',
        [UpdateType.DECIDECONTINUE]: 'Besluta om fortsättning',
        [UpdateType.Dead]: 'Gäldenären har avlidit',
        [UpdateType.MovedAbroad]: 'Gäldenären har flyttat utomlands',
        [UpdateType.Disappeared]: 'Gäldenären har försvunnit',
        [UpdateType.Homeless]: 'Gäldenären har blivit hemlös',
        [UpdateType.Inactive]: 'Företaget är inaktivt',
        [UpdateType.OperationsCeased]: 'Företaget har upphört med verksamheten',
        [UpdateType.GuardianStatus]: 'Förmyndarstatus uppdaterad',
        [UpdateType.DeletedRKIRegistration]: 'RKI-registrering raderad',
        [UpdateType.DeletedRKIRegistrationWillingnessToPay]: 'RKI-registrering raderad - indikation på betalningsvilja',
        [UpdateType.NewRKIRegristration]: 'Ny RKI-registrering',
        [UpdateType.Address]: 'Adress uppdaterad',
        [UpdateType.AddressProtection]: 'Namn-/adresskydd uppdaterat',
        [UpdateType.RKIRemark]: 'RKI-anmärkning uppdaterad',
        [UpdateType.Active]: 'Gäldenären är nu aktiv',
        [UpdateType.CompanyActive]: 'Företaget är nu aktivt',
        [UpdateType.DissolutionStatus]: 'Upplösningsstatus',
        [UpdateType.PAYMENTPLANCANCLED]: 'Betalningsplan avbruten',
        [UpdateType.INTERNALREMARK]: 'Intern anmärkning',
        [UpdateType.MOVETOOPENRKI]: 'Flytta till öppen RKI',
        [UpdateType.DebtorIsUnderage]: 'Gäldenären är under 18 år',
        [UpdateType.SentToConnectPartner]: 'Skickad till connect-partner',
        [UpdateType.ReturnedToConnectPartner]: 'Returnerad till connect-partner',
        [UpdateType.DebtorCanBeRegisteredInDebtRegister]: 'Gäldenären kan registreras i ett kreditregister',
        [UpdateType.PAYMENTREVOKED]: 'Betalning återkallad',
    },
    updateTypesClient: {
        [UpdateType.AWAITINGCLIENTANSWER]: 'Nytt meddelande från inkassobolag',
    },
    caseFilter: {
        moreFilters: 'Filter',
        advancedFilters: 'Avancerade filter',
        casesSelected: 'valda ärenden',
        aggregationSum: 'Summa',
        orderCaseOverview: 'Beställ ärendeöversikt',
        creditorsGroup: 'Borgenärer',
        contactsGroup: 'Kontaktpersoner',
        maxRkiRegistrations: 'Max. RKI-registreringar',
        maxRkiRegistrationsSub: 'Välj maximalt antal RKI-registreringar en gäldenär kan ha.',
        maxRkiRegistrationsBadge: 'RKI max.',
        minRkiRegistrations: 'Min. RKI-registreringar',
        minRkiRegistrationsSub: 'Välj minsta antal RKI-registreringar en gäldenär kan ha.',
        minRkiRegistrationsBadge: 'RKI min.',
        rkiRegisteredByCollector: 'Är RKI-registrerad av inkassobolaget',
        isRegisteredByCollector: 'Är registrerad',
        isNotRegisteredByCollector: 'Är inte registrerad',
        contactHasEmail: 'Kontaktpersonen har en e-postadress',
        contactHasEmailBadge: 'Har e-post',
        contactHasPhone: 'Kontaktpersonen har ett telefonnummer',
        contactHasPhoneBadge: 'Har telefon',
        contactHasAddress: 'Kontaktpersonen har en adress',
        contactHasAddressBadge: 'Har adress',
        contactPersonIs: 'Kontaktpersonen är',
        debtor: 'Gäldenär',
        debtorBadge: 'Gäldenären är kontaktperson',
        alternativeContact: 'Alternativ kontaktperson',
        alternativeContactBadge: 'Har alternativ kontaktperson',
        company: 'Företag',
        companyBadge: 'Är företag',
        person: 'Är person',
        personBadge: 'Är person',
        paymentMethod: 'Betalningsmetod',
        hasCard: 'Har betalkort',
        doNotHaveCard: 'Har inte betalkort',
        companyStatus: 'Företagsstatus',
        selectCompanyStatus: 'Välj företagsstatus',
        companyTypes: 'Företagstyper',
        selectCompanyTypes: 'Välj företagstyper',
        court: 'Domstol',
        courtBadge: 'Domstol vald',
        selectCourt: 'Välj domstol',
        companyBranch: 'Bransch',
        selectCompanyBranch: 'Välj branscher',
        gender: 'Kön',
        [Gender.MALE]: 'Man',
        [Gender.FEMALE]: 'Kvinna',
        [Gender.BOTH]: 'Båda',
        zipcode: 'Postnummer',
        selectZipcode: 'Välj postnummer',
        satisfactions: 'Nöjdhet',
        casesGroup: 'Ärenden',
        caseStatus: 'Ärendestatus',
        selectCaseStatus: 'Välj ärendestatus',
        endReasons: 'Avslutsorsak',
        selectEndReasons: 'Välj avslutsorsaker',
        caseGroup: 'Ärendegrupp',
        selectCaseGroup: 'Välj ärendegrupp',
        caseImport: 'Ärendeimport',
        selectCaseImport: 'Välj ärendeimport',
        caseCreatedAfter: 'Ärende skapat efter',
        caseCreatedAfterPlaceholder: 'Efter',
        caseCreatedBefore: 'Ärende skapat före',
        caseCreatedBeforePlaceholder: 'Före',
        caseEndedAfter: 'Ärende avslutat efter',
        caseEndedAfterPlaceholder: 'Efter',
        caseEndedBefore: 'Ärende avslutat före',
        caseEndedBeforePlaceholder: 'Före',
        caseSeqIds: 'Ärendenummer',
        exceptCaseSeqIds: 'Utom ärendenummer',
        caseSeqIdsDescription: 'Ärendenummer separerade med radbrytning, semikolon, komma eller mellanslag.',
        caseSeqIdFilterBadge: 'Efter ärendenummer',
        updatesGroup: 'Ärendestatusar',
        caseIsCurrently: 'Ärenden som är',
        caseIsCurrentlyPaused: 'Pausade',
        caseIsCurrentlyNotPaused: 'Inte pausade',
        paused: 'Pausade',
        notPaused: 'Inte pausade',
        selectStatus: 'Välj status',
        hasFollowingStatus: 'Har status',
        hasFollowingStatusSub: 'Har eller har haft någon av följande statusar',
        hasFollowingStatusBadge: 'Har status',
        doNotHaveFollowingStatus: 'Har inte status',
        doNotHaveFollowingStatusSub: 'Har inte eller har inte haft någon av följande statusar',
        doNotHaveFollowingStatusBadge: 'Har inte status',
        isPausedFollowingStatus: 'Är pausat med status',
        isPausedFollowingStatusSub: 'Är pausat med någon av följande statusar just nu',
        isPausedFollowingStatusBadge: 'Är pausat med status',
        isNotPausedFollowingStatus: 'Inte pausat',
        isNotPausedFollowingStatusSub: 'Är inte pausat med någon av följande statusar',
        isNotPausedFollowingStatusBadge: 'Är inte pausat med status',
        economyGroup: 'Ekonomi',
        economyOnlyVoucherTypeIds: 'Endast valda verifikatstyper',
        economyMinAmount: 'Min.-saldo',
        economyMaxAmount: 'Max.-saldo',
        economyBillingModels: 'Ärenden med faktureringsmodell',
        economyBillingAppendixSetups: 'Ärenden med faktureringsbilageuppsättning',
        billingModels: 'Faktureringsmodeller',
        economyMin: 'Min.',
        economyMax: 'Max.',
        economySelectedBillingModels: 'Valda faktureringsmodeller',
        economySelectedBillingAppendixSetups: 'Valda bilageuppsättningar',
        workflowsGroup: 'Arbetsflöden',
        inSelectedWorkflows: 'Valda arbetsflöden',
        isInWorkflows: 'Är i arbetsflöde',
        selectWorkflows: 'Valda arbetsflöden',
        selectNextTaskIds: 'Välj uppgifter',
        nextTaskIds: 'Nästa uppgift i arbetsflödet',
        selectCurrentTaskIds: 'Välj uppgifter',
        currentTaskIds: 'Aktuell uppgift i arbetsflödet',
        noNextTask: 'Ingen nästa uppgift',
        documentsGroup: 'Dokument',
        hasDocumentOfType: 'Har dokument av typ',
        hasDocumentOfTypeBadge: 'Har dokument av typ',
        selectDocumentTypes: 'Välj dokumenttyper',
        documentsIsSigned: 'Välj endast signerade dokument',
        hasFoundation: 'Har underlag',
        hasNoFoundation: 'Har inget underlag',
        paymentPlansGroup: 'Betalningsplaner',
        paymentPlanStatuses: 'betalningsplaner med status',
        selectPaymentPlanStatus: 'Välj status',
        paymentPlanIsNotHavingStatuses: 'Välj betalningsplaner utan ovanstående statusar',
        paymentPlanIsNotHavingStatusesBadge: 'Betalningsplaner utan statusar',
        interactionsGroup: 'Interaktioner',
        interactionType: 'Interaktionstyp',
        selectInteractionType: 'Välj interaktionstyp',
        interactionState: 'Interaktionstillstånd',
        selectInteractionState: 'Välj interaktionstillstånd',
        interactionDirection: 'Interaktionsriktning',
        selectInteractionDirection: 'Välj interaktionsriktning',
        noneOfTheAboveBadge: 'Ingen av valda interaktioner',
        noneOfTheAbove: 'Ärenden med interaktioner utan någon av ovanstående',
        accountsGroups: 'Användare',
        selectedCreditors: 'borgenär(er) valda',
        caseVisitedBy: 'Ärende besökt av',
        selectAccount: 'Välj användare',
        caseVisitedBefore: 'Ärende besökt före',
        to: 'Till',
        caseVisitedAfter: 'Ärende besökt efter',
        from: 'Från',
        offset: 'Förskjutning',
        offsetExplanation: 'Välj antal ärenden att hoppa över',
        limit: 'Gräns',
        limitExplanation: 'Välj antal ärenden att välja',
        pagination: 'Paginering',
        properties: 'Fastigheter',
        property: 'Fastighet',
        propertyExplanation: 'Filtrera',
        bulkActions: 'Massåtgärder',
        bulkActionsConfirm: 'Är du säker på att du vill köra den valda massåtgärden på de valda ärendena?',
        approveVerifyAllCases: 'Är du säker på att du vill verifiera alla valda ärenden?',
        casesVerified: 'De valda ärendena verifieras nu',
        pauseCasesBulk: 'De valda ärendena pausas nu. Du får ett e-postmeddelande när systemet är klart.',
        continueCasesBulk: 'Den valda pausstatusen kommer att fortsätta på de valda ärendena. Du får ett e-postmeddelande när systemet är klart.',
        runProcedureBulk: 'Den valda genvägen körs nu på de valda ärendena. Du får ett e-postmeddelande när systemet är klart.',
        changeBillingModelBulk: 'Den valda genvägen körs nu på de valda ärendena. Du får ett e-postmeddelande när systemet är klart.',
        changeBillingModelDesc: 'Flytta ärenden till vald faktureringsmodell för ärenden som inte är fakturerade.',
        changeBillingModelPlaceholder: 'Faktureringsmodell',
        changeWorkflowBulk: 'Den valda genvägen körs nu på de valda ärendena. Du får ett e-postmeddelande när systemet är klart.',
        changeWorkflowDesc: 'Flytta ärenden till valt arbetsflöde.',
        changeWorkflowPlaceholder: 'Arbetsflöden',
    },
    aggregations: {
        aggregate: 'Aggregera ärenden',
    },
    aggregationTypes: {
        [AggregationType.CountAll]: 'Antal ärenden',
        [AggregationType.ByCaseGroup]: 'Ärendegrupp',
        [AggregationType.ByBillingModel]: 'Faktureringsmodell',
        [AggregationType.ByBillingAppendixSetup]: 'Faktureringsbilageuppsättning',
        [AggregationType.ByWorkflow]: 'Arbetsflöde',
        [AggregationType.ByCaseStatus]: 'Ärendestatus',
        [AggregationType.ByCreditor]: 'Borgenär',
        [AggregationType.ByMigratedWorkflowTaskId]: 'Migrerad arbetsflödesuppgift',
    },
    bulkActions: {
        runBulkAction: 'Kör massåtgärd',
        bulkActionStarted: 'Massåtgärd startad',
        bulkActions: 'Massåtgärd',
        bulkActionsConfirm: 'Är du säker på att du vill köra den här massåtgärden?',
        bulkActionBillingModelPlaceholder: 'Faktureringsmodell',
        bulkActionWorkflowPlaceholder: 'Arbetsflöde',
        bulkActionMoveToTaskInWorkflowPlaceholder: 'Välj uppgift i arbetsflödet',
        bulkActionChangeCaseGroup: 'Välj ärendegrupp',
        pleaseSelectAWorkflow: 'Välj ett arbetsflöde i ärendefiltret',
    },
    bulkActionTypes: {
        [BulkActionType.MoveCaseStatus]: 'Ändra ärendestatus',
        [BulkActionType.PauseCases]: 'Pausa valda ärenden',
        [BulkActionType.ContinueCases]: 'Fortsätt valda ärenden',
        [BulkActionType.RunProcedure]: 'Kör genväg på valda ärenden',
        [BulkActionType.ChangeBillingModel]: 'Ändra faktureringsmodell',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Ändra faktureringsbilageuppsättning',
        [BulkActionType.ChangeWorkflow]: 'Ändra arbetsflöde',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Flytta till arbetsflödesuppgift',
        [BulkActionType.RollbackOneTask]: 'Rulla tillbaka senaste arbetsflödesuppgift',
        [BulkActionType.RollbackAllTasks]: 'Rulla tillbaka alla arbetsflödesuppgifter',
        [BulkActionType.RunBillingModel]: 'Kör faktureringsmodell',
        [BulkActionType.ResubscribeCosmo]: 'Återanmäl Cosmo',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'Radera RKI-registreringar på avslutade ärenden',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'Flytta RKI-registreringar till sammanslagna ärenden',
        [BulkActionType.ChangeCaseGroup]: 'Ändra ärendegrupp',
        [BulkActionType.ResyncCosmo]: 'Synkronisera om Cosmo',
    },
    bulkActionDescriptions: {
        [BulkActionType.MoveCaseStatus]: 'Ändra ärendestatus till',
        [BulkActionType.PauseCases]: 'Pausa valda ärenden',
        [BulkActionType.ContinueCases]: 'Fortsätt valda ärenden',
        [BulkActionType.RunProcedure]: 'Kör genväg på valda ärenden',
        [BulkActionType.ChangeBillingModel]: 'Ändra faktureringsmodell',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Ändra faktureringsbilageuppsättning',
        [BulkActionType.ChangeWorkflow]: 'Ändra arbetsflöde',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Flytta till arbetsflödesuppgift',
        [BulkActionType.RollbackOneTask]: 'Rulla tillbaka senaste arbetsflödesuppgift',
        [BulkActionType.RollbackAllTasks]: 'Rulla tillbaka alla arbetsflödesuppgifter',
        [BulkActionType.RunBillingModel]: 'Kör faktureringsmodell',
        [BulkActionType.ResubscribeCosmo]: 'Återanmäl Cosmo',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'Radera RKI-registreringar på avslutade ärenden',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'Flytta RKI-registreringar till sammanslagna ärenden',
        [BulkActionType.ChangeCaseGroup]: 'Ändra ärendegrupp',
        [BulkActionType.ResyncCosmo]: 'Synkronisera om Cosmo',
    },
    bulkActionsEmailConfirmationSubject: {
        [BulkActionType.MoveCaseStatus]: 'Ändra ärendestatus',
        [BulkActionType.PauseCases]: 'Pausa valda ärenden',
        [BulkActionType.ContinueCases]: 'Fortsätt valda ärenden',
        [BulkActionType.RunProcedure]: 'Kör genväg på valda ärenden',
        [BulkActionType.ChangeBillingModel]: 'Ändra faktureringsmodell',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Ändra faktureringsbilageuppsättning',
        [BulkActionType.ChangeWorkflow]: 'Ändra arbetsflöde',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Flytta till arbetsflödesuppgift',
        [BulkActionType.RollbackOneTask]: 'Arbetsflödesuppgifter tillbakarullade',
        [BulkActionType.RollbackAllTasks]: 'Arbetsflödesuppgifter tillbakarullade',
        [BulkActionType.RunBillingModel]: 'Faktureringsmodellen har körts',
        [BulkActionType.ResubscribeCosmo]: 'Återanmälan till Cosmo har körts',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'RKI-registreringar på avslutade ärenden har raderats',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'RKI-registreringar har flyttats till sammanslagna ärenden',
        [BulkActionType.ChangeCaseGroup]: 'Ärendegrupper har ändrats',
        [BulkActionType.ResyncCosmo]: 'Cosmo omsynkroniserad',
    },
    bulkActionsEmailConfirmationBody: {
        [BulkActionType.MoveCaseStatus]: 'Ändrade ärendestatus på de valda ärendena.',
        [BulkActionType.PauseCases]: 'Pausning av valda ärenden klar.',
        [BulkActionType.ContinueCases]: 'Fortsatte valda ärenden.',
        [BulkActionType.RunProcedure]: 'Genväg körd på valda ärenden.',
        [BulkActionType.ChangeBillingModel]: 'Ändrade faktureringsmodell på de valda ärendena.',
        [BulkActionType.ChangeBillingAppendixSetup]: 'Ändrade faktureringsbilageuppsättning på de valda ärendena.',
        [BulkActionType.ChangeWorkflow]: 'Ändrade arbetsflöde på de valda ärendena.',
        [BulkActionType.MoveCaseToWorkflowTask]: 'Flyttade arbetsflödesuppgift på de valda ärendena.',
        [BulkActionType.RollbackOneTask]: 'Arbetsflödesuppgifter tillbakarullade.',
        [BulkActionType.RollbackAllTasks]: 'Arbetsflödesuppgifter tillbakarullade.',
        [BulkActionType.RunBillingModel]: 'Faktureringsmodellen har körts',
        [BulkActionType.ResubscribeCosmo]: 'Återanmälan till Cosmo har körts',
        [BulkActionType.DeleteRKIRegistrationsOnEndedCases]: 'RKI-registreringar på avslutade ärenden har raderats',
        [BulkActionType.MoveRKIRegistrationsToMergeCases]: 'RKI-registreringar har flyttats till sammanslagna ärenden',
        [BulkActionType.ChangeCaseGroup]: 'Ärendegrupper har ändrats',
        [BulkActionType.ResyncCosmo]: 'Cosmo har omsynkroniserats',
    },
    paymentPlansInsights: {
        paymentPlans: 'Betalningsplaner',
        quantityEntries: 'Antal poster',
        amountEntries: 'Belopp',
        funnelHeader: 'Livscykel',
        totalCreated: 'Skapade',
        activated: 'Aktiverade',
        inProgress: 'Pågående',
        completed: 'Slutförda',
        defaulted: 'Misskötta',
        deletedAfterActivation: 'Raderade',
        awaitingActivation: 'Väntar på aktivering',
        neverActivated: 'Aldrig aktiverade',
        ofCreated: (share) => `${share}% av skapade`,
        ofActivated: (share) => `${share}% av aktiverade`,
        churnHeader: 'Bortfall',
        churnRate: 'Bortfallsgrad',
        churnRateInfo: 'Andel aktiverade avbetalningsplaner som slutade i utebliven betalning.',
        defaultedPlans: 'Misskötta avbetalningsplaner',
        churnedBeforeFirstPayment: 'Före första betalningen',
        churnedAfterFirstPayment: 'Efter första betalningen',
        ofDefaulted: (share) => `${share}% av misskötta`,
        neverActivatedHeader: 'Skapade men aldrig aktiverade',
        neverActivatedInfo: 'Avbetalningsplaner som skapades men aldrig aktiverades, fördelade efter vem som skapade dem.',
        createdByDebtor: 'Skapade av gäldenären',
        createdByCaseworker: 'Skapade av handläggaren',
        paymentMethodsHeader: 'Betalningsmetoder',
        methodColumn: 'Metod',
        plansColumn: 'Avbetalningsplaner',
        activationRateColumn: 'Aktiveringsgrad',
        defaultRateColumn: 'Andel misskötta',
        methodBetalingsservice: 'Betalingsservice',
        methodLeverandorservice: 'Leverandørservice',
        methodVisa: 'Visa',
        methodMastercard: 'Mastercard',
        methodDankort: 'Dankort',
        methodCard: 'Kort',
        methodMobilePay: 'MobilePay',
        methodVipps: 'Vipps',
        methodSwish: 'Swish',
        methodOther: 'Annat',
        methodNone: 'Ingen betalningsmetod',
        creditorsHeader: 'Borgenärer med flest avbetalningsplaner',
        creditorColumn: 'Borgenär',
        finishedColumn: 'Slutförda',
        defaultedColumn: 'Misskötta',
        vintageHeader: 'Kohortanalys (vintage)',
        vintageInfo: 'Varje rad visar månaden då avbetalningsplanerna skapades, följda efter ålder. Läs nedåt i en kolumn (samma ålder) för att se om nyare kohorter missköts oftare eller mer sällan än äldre. Cellerna är tomma tills en kohort har uppnått den aktuella åldern.',
        vintageCohortColumn: 'Skapade',
        vintageAgeAxis: 'Månader sedan skapandet',
        vintageActivatedShort: (n) => `${n} aktiverade`,
        vintageLegendLabel: 'Kumulativ andel misskötta',
        vintageLow: 'lägre',
        vintageHigh: 'högre',
        vintageCellInfo: (rate, defaults, activated) => `${rate}% kumulativt bortfall (${defaults} av ${activated} aktiverade)`,
    },
    insights: {
        showingNewest: 'Visar de {count} senaste.',
        lastDays: 'Senaste {days} dagarna',
        fromDate: 'Från datum',
        toDate: 'Till datum',
        getReport: 'Hämta rapport',
        powerbi: {
            title: 'Dina data. Dina insikter.',
            intro: 'Välj datakällor för rapporten. Hämta ett Power BI-projekt (.pbip), paketerat med nödvändiga mappar, frågor och databeskrivningar i en ZIP-fil.',
            openInstructions: 'Packa upp ZIP-filen och öppna Debbie.pbip i Power BI Desktop för Windows. Aktivera Power BI Project och det utökade rapportformatet (PBIR) under förhandsversionsfunktioner om din version kräver det. Välj Anonym autentisering för webbkällan: API-nyckeln skickas redan i frågans header. Uppdatera för att läsa in data.',
            dataSources: 'Datakällor',
            selectSources: 'Välj minst en datakälla och godkänn varningen om API-nyckeln.',
            selectAll: 'Välj alla datakällor',
            includeSource: 'Ta med i projekt',
            downloadProject: 'Skapa nyckel och hämta Power BI-projekt (.pbip)',
            downloadAgain: 'Hämta samma projekt igen',
            securityWarning: 'Nedladdningen skapar en API-nyckel med läsbehörighet till de valda datakällorna. Nyckeln lagras i klartext i projektet och frågefilerna. Alla som har filerna kan använda åtkomsten. Förvara dem säkert och dela dem endast med betrodda mottagare. Om du delar dem med andra personer eller externa tjänster delar du även nyckeln och åtkomsten till data. Du kan återkalla nyckeln nedan.',
            acceptWarning: 'Jag förstår att en API-nyckel skapas och inkluderas i filerna.',
            keyCreated: 'API-nyckeln har utfärdats och visas nedan. Om du hämtar projektet igen används samma nyckel. Ändrar du valet eller nyckelns namn skapas en ny nyckel vid nästa nedladdning.',
            noAccess: 'Du behöver behörighet att utfärda API-nycklar för att skapa ett projekt. Välj först en borgenär i borgenärsportalen.',
            extendTitle: 'Lägg till datakällor i en befintlig rapport',
            manualInstructions: 'Välj ytterligare källor här och hämta ett projekt. I din befintliga Power BI-rapport väljer du Transformera data → Ny källa → Tom fråga → Avancerad redigerare. Klistra in innehållet från motsvarande fil i queries/, ge frågan källans namn och välj Stäng och använd. Källan läggs till med sin nya nyckel medan befintliga frågor, visualiseringar och mått bevaras. Lägg till relationer i modellvyn med hjälp av data-dictionary.json. Ersätt inte ditt befintliga projekt med det nedladdade projektet.',
            manualConnection: 'API / lägg till manuellt',
            manualKeyInstructions: 'För manuell konfiguration kopierar du frågan nedan och ersätter PASTE_API_KEY_HERE med en API-nyckel med angivet scope. Utfärda en nyckel genom att välja källan och hämta ett projekt, eller under API-inställningar. Befintliga nycklar får inte automatiskt åtkomst till nya källor.',
            copyQuery: 'Kopiera Power Query',
            keysDescription: 'Utfärdade nycklar med åtkomst till rapportdata, inklusive nycklar skapade under API-inställningar. Den hemliga nyckeln kan inte hämtas igen. Återkallande stoppar framtida åtkomst för alla rapporter och integrationer som använder nyckeln; redan inlästa data finns kvar i Power BI.',
            issuedAt: 'Utfärdad',
            revoke: 'Återkalla nyckel',
            revokeWarning: 'Vill du återkalla denna API-nyckel? Alla rapporter och integrationer som använder den förlorar åtkomst vid kommande anrop när den korta autentiseringscachen löper ut. Redan hämtade data finns kvar i filerna.',
            refreshInstructions: 'API:et begränsar anrop per källa till en gång per dygn. Undvik täta förhandsvisningar och uppdateringar. Vid schemalagd uppdatering i Power BI Service ska webbanslutningen autentiseras som Anonym; nyckeln finns kvar i frågan. Uppdatering och autentisering i Service konfigureras separat efter publicering.',
            modelNotes: 'Koppla tabeller med stabila id:n som caseId, customerId och creditorId; cases.id och referenceId är visnings-/externa referenser. Relationer filtrerar enkelriktat från en-sidan till många-sidan och omfattar bara valda tabeller. Andra möjliga kopplingar: cases.creditorId → creditors.creditorId, cases.workflowId → workflows.id, workflow-tasks.updateTypeId → update-types.updateTypeId, billing-vouchers.caseVoucherId → case-vouchers.caseVoucherId, payment-plans.documentId → documents.documentId. Undvik tvetydiga filtervägar. Updates.referenceId kan peka på olika entiteter: kontrollera update-types.referenceType; interactions och documents har referenceType, properties har ref. Filtrera referenstypen innan koppling till ärenden eller kunder. Belopp behåller API:ets minsta valutaenhet, t.ex. öre; dividera med 100 för DKK/SEK/NOK/EUR och summera varje valuta separat. Payment-plan-entries saknar valutakolumn; hämta valutan från ärendets sammanhang. Posteringar har tecken; summera inte alla typer urskillningslöst för att beräkna saldon. Undvik dubbelräkning vid koppling av detaljtabeller. Status- och typtexter följer valt språk. Tidsstämplar med tidszon konverteras till UTC; rena datum behålls vid midnatt. Objekt och listor sparas som JSON-text. Tomma källor behåller kolumnerna; saknade valfria fält blir null. Modellen innehåller standardfält, inte valfria detaljfält. Kunddata läses in först vid uppdatering.',
            shortIntro: 'Anslut Debbie till Power BI och bygg rapporter med de data du behöver.',
            help: 'Kom igång',
            chooseSources: 'Välj dina datakällor',
            chooseHint: 'Markera källor för Power BI eller använd </> för att ansluta manuellt.',
            clearSelection: 'Rensa val',
            groupCases: 'Ärenden och kunder',
            groupEconomy: 'Ekonomi och betalningar',
            groupActivity: 'Aktivitet och dokument',
            groupOrganisation: 'Organisation och arbetsflöden',
            yourProject: 'Ditt Power BI-projekt',
            projectContents: 'Dataanslutningar, relationer och databeskrivningar — redo för din rapport.',
            selectedSources: 'datakällor valda',
            emptySelection: 'Välj källor till vänster för att skapa ditt projekt.',
            downloadLabel: 'Hämta Power BI-projekt',
            downloadFormat: '.pbip-projekt · Levereras som ZIP · Power BI Desktop',
            shortSecurity: 'En ny API-nyckel följer med projektet. Du granskar åtkomsten före nedladdningen och kan alltid återkalla den.',
            confirmTitle: 'Skapa åtkomst till dina data',
            projectReady: 'Ditt projekt är klart',
            manageKeys: 'Visa och hantera API-nycklar',
            openProject: 'Öppna projektet i Power BI',
            refreshTitle: 'Håll rapporten uppdaterad',
            extendHint: 'Använd </>-knappen på en datakälla för en stegvis guide till att lägga till den i din befintliga Power BI-rapport. Befintliga visualiseringar och mått bevaras.',
            guideKeyTitle: 'Skapa en API-nyckel i Debbie',
            guideKey: 'Öppna Inställningar → Utvecklare → API och välj Skapa API-nyckel. Ge den ett namn du känner igen och välj behörigheten nedan. Skapa nyckeln och spara den säkert — den visas bara en gång. Du kan återanvända en befintlig nyckel med denna behörighet.',
            guideWebTitle: 'Lägg till en webbkälla i Power BI',
            guideWeb: 'Öppna din befintliga rapport i Power BI Desktop. Välj Start → Hämta data → Webb och sedan Avancerat. Kopiera adressen nedan till det första URL-fältet.',
            guideAuthTitle: 'Ange din API-nyckel',
            guideAuth: 'Under parametrar för HTTP-begärandehuvud väljer du Authorization. I fältet bredvid skriver du Bearer följt av ett blanksteg och din API-nyckel. Ersätt <your URL> i bilden med adressen ovan och <your token> med din nyckel. Välj OK. Om autentisering efterfrågas väljer du Anonym — nyckeln finns redan i headern.',
            guideImageAlt: 'Power BI-webbanslutning: URL överst och Authorization med Bearer följt av API-nyckeln nedanför.',
            guideLoadTitle: 'Läs in data i rapporten',
            guideLoad: 'Om Power Query visar en lista väljer du Till tabell och godtar standardinställningarna. Expandera sedan kolumnen med ikonen med två pilar och välj önskade fält. Ge frågan datakällans namn och välj Stäng och använd. Den nya tabellen visas tillsammans med befintliga data. Koppla den till andra tabeller i modellvyn via matchande id:n, till exempel caseId. Din befintliga rapport bevaras.',
            advancedQuery: 'Avancerat: använd Power Query-kod',
            dictionaryInstructions: 'data-dictionary.json beskriver valda källor, kolumner och relationer utan API-nyckeln. Använd den som referens när du bygger eller utökar rapporter. Projektet innehåller även tabellbeskrivningar och fördefinierade relationer.',
            sourceDescriptions: {
                cases: 'En rad per ej raderat ärende med kund, borgenär, status och arbetsflödesreferenser.',
                creditors: 'En rad per borgenär med identitet, status och kontaktreferenser.',
                satisfactions: 'En rad per nöjdhetssvar för ett ärende med betyg (1–5) och kommentar.',
                'case-vouchers': 'En rad per ej raderad ärendepostering med belopp med tecken, valuta, kategori och datum.',
                'billing-vouchers': 'En rad per ej raderad avräkningspostering. Borgenärer ser endast avräknade poster.',
                users: 'En rad per användare i organisationen med roll och kontaktuppgifter. Raderade användare utelämnas.',
                updates: 'En rad per uppgift. referenceId kan avse olika entiteter; kontrollera uppgiftstypen.',
                'update-types': 'En rad per uppgiftstyp med namn, referenstyp och beteendeflaggor.',
                workflows: 'En rad per arbetsflöde. Nyckeln heter id.',
                'workflow-tasks': 'En rad per uppgift i ett arbetsflöde med workflowId och updateTypeId.',
                'case-statuses': 'En rad per statusändring på ett ärende. Ett ärende kan ha flera rader.',
                interactions: 'En rad per interaktion med kanal, riktning, status och referenstyp.',
                documents: 'En rad per dokument med referenstyp, datum och filmetadata; utan filinnehåll.',
                'payment-plans': 'En rad per avbetalningsplan på ett ärende med status och påminnelseflaggor.',
                'payment-plan-entries': 'En rad per delbetalning med belopp, tidsfrister och status. Inget valutafält.',
                customers: 'En rad per ej raderad kund hos en borgenär. En kund kan ha flera ärenden.',
                'users-on-customers': 'En rad per kontakt/kundrelation. Kontaktuppgifter är JSON, inte organisationens userId.',
                properties: 'En rad per aktuellt attributvärde. ref anger entitetstyp för refId; data är JSON.',
            },
            sourceSummaries: {
                cases: 'Status, kunder och arbetsflöden',
                creditors: 'Borgenärsuppgifter och kontakter',
                satisfactions: 'Betyg och feedback på ärenden',
                'case-vouchers': 'Belopp, valutor och posteringstyper',
                'billing-vouchers': 'Avräkningar, fakturering och moms',
                users: 'Medarbetare och roller',
                updates: 'Uppgifter, datum och framsteg',
                'update-types': 'Uppgiftskategorier och beteenden',
                workflows: 'Definitioner av arbetsflöden',
                'workflow-tasks': 'Stegen i varje arbetsflöde',
                'case-statuses': 'Historik över ärendenas statusändringar',
                interactions: 'Kanaler, riktning och leveransstatus',
                documents: 'Dokumenttyper, datum och underskrifter',
                'payment-plans': 'Avtal och avbetalningsplanernas status',
                'payment-plan-entries': 'Delbetalningar, belopp och tidsfrister',
                customers: 'Kunduppgifter och referenser',
                'users-on-customers': 'Kontakter och deras kundrelationer',
                properties: 'Anpassade attribut och värden',
            },
        },
        connectToApi: 'Anslut till dina data via ett API',
        downloadLimit: 'Gränsen för att begära en specifik datakälla är en gång per dag',
        apiTypes: {
            ['cases']: 'Ärenden',
            ['users']: 'Användare',
            ['satisfactions']: 'Nöjdhet',
            ['case-vouchers']: 'Ärendeverifikat',
            ['billing-vouchers']: 'Faktureringsverifikat',
            ['creditors']: 'Borgenärer',
            ['updates']: 'Uppgifter',
            ['update-types']: 'Uppgiftstyper',
            ['workflows']: 'Arbetsflöden',
            ['workflow-tasks']: 'Arbetsflödesuppgifter',
            ['case-statuses']: 'Statuslogg för ärenden',
            ['interactions']: 'Interaktioner',
            ['documents']: 'Dokument',
            ['payment-plans']: 'Betalningsplaner',
            ['payment-plan-entries']: 'Poster i betalningsplan',
            ['users-on-customers']: 'Användare på kunder',
            ['customers']: 'Kunder',
            ['properties']: 'Fastigheter',
        },
        connectGuide: {
            description: 'Du kan komma åt dina data via ett API för extern användning',
            liIntroStep1: 'Gå till Inställningar och välj Utvecklare',
            liIntroStep2: 'Skapa en ny API-nyckel',
            liIntroStep3: 'Namnge nyckeln och välj motsvarande omfattning',
            liIntroStep4: 'Motsvarande omfattning är',
            liIntroStep5: 'Du kan nu använda din nya API-nyckel för att ansluta till',
            powerbiDescription: 'Genomgången nedan visar hur du ansluter till Power BI',
            liPowerbiStep1: "Anslut till en ny 'Webb'-datakälla i Power BI",
            liPowerbiStep2: 'Fyll i konfigurationerna som på bilden nedan där du ersätter',
            liPowerbiStep3: 'med webbadressen ovanför och',
            liPowerbiStep4: 'med din nyss skapade API-nyckel',
            liPowerbiStep5: 'Tryck på OK så är du klar',
            understood: 'Stäng',
        },
        connect: 'Anslut',
        download: 'Ladda ner',
        orderReport: 'Beställ rapport',
        billingFile: 'Faktureringsfil',
        billingFileDesc: 'Faktureringsfil för gäldenärstransaktioner per borgenär per dag.',
        caseOverview: 'Ärendeöversikt',
        caseOverviewDesc: 'Översikt över alla aktiva och avslutade ärenden inklusive status, ekonomi och gäldenärsinformation.',
        includeDocuments: 'Inkludera dokument',
        includeVouchers: 'Inkludera verifikat',
        includeRki: 'Inkludera RKI-rapporter',
        documents: 'Dokument',
        steps: 'Steg',
        vouchers: 'Verifikat',
        cases: 'Ärenden',
        collector: 'Inkassobolag',
        creditor: 'Borgenär',
        rki: 'RKI',
        downloadsYourExportIsReady: 'Din rapport är klar',
        downloadsYourExportIsReadyBody: '<p>Hej</p><p>Din rapport är klar att ladda ner.</p>',
        downloadsYourExportIsReadyButton: 'Ladda ner rapport',
        caseOverviewHeaderDocumentId: 'Dok-ID',
        caseOverviewHeaderFileLink: 'Länk till fil',
        caseOverviewHeaderType: 'Typ',
        caseOverviewHeaderSignedAt: 'Datum för underskrift',
        caseOverviewHeaderCreatedAt: 'Skapandedatum',
        caseOverviewHeaderDate: 'Datum',
        caseOverviewHeaderDueDate: 'Förfallodatum',
        caseOverviewHeaderCategory: 'Kategori',
        caseOverviewHeaderImposedBy: 'Ålagt av',
        caseOverviewHeaderText: 'Text',
        caseOverviewHeaderInterest: 'Räntesats',
        caseOverviewHeaderInterestStartDate: 'Räntans startdatum',
        caseOverviewHeaderInterestEndDate: 'Räntans slutdatum',
        caseOverviewHeaderAmount: 'Belopp',
        caseOverviewHeaderExpirationDate: 'Utgångsdatum',
        caseOverviewHeaderExpired: 'Utgången',
        caseOverviewCompany: 'Företag',
        caseOverviewPrivate: 'Person',
        caseOverviewHeaderCreditor: 'Borgenär',
        caseOverviewHeaderCreditorSeqId: 'Borgenärsnummer',
        caseOverviewHeaderCaseGroup: 'Ärendegrupp',
        caseOverviewHeaderImportedAt: 'Importdatum',
        caseOverviewHeaderCaseSeqId: 'Ärendenummer',
        caseOverviewHeaderMigratedJournalNumber: 'Migrerat j.nr.',
        caseOverviewHeaderReferenceId: 'Referens',
        caseOverviewHeaderDebtorSeqId: 'Gäldenärsnummer',
        caseOverviewHeaderDebtorName: 'Namn',
        caseOverviewHeaderDebtorEmail: 'E-post',
        caseOverviewHeaderDebtorPhone: 'Telefon',
        caseOverviewHeaderDebtorSatisfaction: 'Nöjdhet',
        caseOverviewHeaderDebtorSatisfactionComment: 'Nöjdhetskommentar',
        caseOverviewHeaderDebtorRKICount: 'Antal RKI-registreringar',
        caseOverviewHeaderDebtorCompanyStatus: 'Företagsstatus',
        caseOverviewHeaderDebtorCVR: 'CVR',
        caseOverviewHeaderDebtorBirthdate: 'Födelsedatum',
        caseOverviewHeaderDebtorAddressProtection: 'Skyddad adress',
        caseOverviewHeaderDebtorCountry: 'Land',
        caseOverviewHeaderDebtorZipCode: 'Postnummer',
        caseOverviewHeaderDebtorCity: 'Ort',
        caseOverviewHeaderDebtorAddress: 'Adress',
        caseOverviewHeaderDebtorCoAddress: 'C/o-adress',
        caseOverviewHeaderDebtorType: 'Gäldenärstyp',
        caseOverviewHeaderDebtorCount: 'Antal gäldenärer',
        caseOverviewHeaderCreditScore: 'Kreditvärdighet',
        caseOverviewHeaderCurrency: 'Valuta',
        caseOverviewHeaderPrincipal: 'Kapitalbelopp',
        caseOverviewHeaderPrincipalPaid: 'Betalt av kapitalbelopp',
        caseOverviewHeaderPrincipalLeft: 'Återstår av kapitalbelopp',
        caseOverviewHeaderReminderFeeCreditor: 'Påminnelseavgift från borgenär',
        caseOverviewHeaderReminderFeeCreditorPaid: 'Betalt av påminnelseavgift från borgenär',
        caseOverviewHeaderReminderFeeCreditorLeft: 'Återstår av påminnelseavgift från borgenär',
        caseOverviewHeaderReminderFeeCollector: 'Påminnelseavgift från inkassobolag',
        caseOverviewHeaderReminderFeeCollectorPaid: 'Betalt av påminnelseavgift från inkassobolag',
        caseOverviewHeaderReminderFeeCollectorLeft: 'Återstår av påminnelseavgift från inkassobolag',
        caseOverviewHeaderCompensationCostCreditor: 'Kompensationsavgift från borgenär',
        caseOverviewHeaderCompensationCostCreditorPaid: 'Betalt av kompensationsavgift från borgenär',
        caseOverviewHeaderCompensationCostCreditorLeft: 'Återstår av kompensationsavgift från borgenär',
        caseOverviewHeaderCompensationCostCollector: 'Kompensationsavgift från inkassobolag',
        caseOverviewHeaderCompensationCostCollectorPaid: 'Betalt av kompensationsavgift från inkassobolag',
        caseOverviewHeaderCompensationCostCollectorLeft: 'Återstår av kompensationsavgift från inkassobolag',
        caseOverviewHeaderCollectionCostCreditor: 'Inkassokostnad från borgenär',
        caseOverviewHeaderCollectionCostCreditorPaid: 'Betalt av inkassokostnad från borgenär',
        caseOverviewHeaderCollectionCostCreditorLeft: 'Återstår av inkassokostnad från borgenär',
        caseOverviewHeaderCollectionCostCollector: 'Inkassokostnad från inkassobolag',
        caseOverviewHeaderCollectionCostCollectorPaid: 'Betalt av inkassokostnad från inkassobolag',
        caseOverviewHeaderCollectionCostCollectorLeft: 'Återstår av inkassokostnad från inkassobolag',
        caseOverviewHeaderCollectionFeeCreditor: 'Inkassoavgift från borgenär',
        caseOverviewHeaderCollectionFeeCreditorPaid: 'Betalt av inkassoavgift från borgenär',
        caseOverviewHeaderCollectionFeeCreditorLeft: 'Återstår av inkassoavgift från borgenär',
        caseOverviewHeaderCollectionFeeCollector: 'Inkassoavgift från inkassobolag',
        caseOverviewHeaderCollectionFeeCollectorPaid: 'Betalt av inkassoavgift från inkassobolag',
        caseOverviewHeaderCollectionFeeCollectorLeft: 'Återstår av inkassoavgift från inkassobolag',
        caseOverviewHeaderCourtCostCreditor: 'Rättegångskostnader från borgenär',
        caseOverviewHeaderCourtCostCreditorPaid: 'Betalt av rättegångskostnader från borgenär',
        caseOverviewHeaderCourtCostCreditorLeft: 'Återstår av rättegångskostnader från borgenär',
        caseOverviewHeaderCourtCostCollector: 'Rättegångskostnader från inkassobolag',
        caseOverviewHeaderCourtCostCollectorPaid: 'Betalt av rättegångskostnader från inkassobolag',
        caseOverviewHeaderCourtCostCollectorLeft: 'Återstår av rättegångskostnader från inkassobolag',
        caseOverviewHeaderInterestCreditor: 'Ränta från borgenär',
        caseOverviewHeaderInterestCreditorPaid: 'Betalt av ränta från borgenär',
        caseOverviewHeaderInterestCreditorLeft: 'Återstår av ränta från borgenär',
        caseOverviewHeaderInterestCollector: 'Ränta från inkassobolag',
        caseOverviewHeaderInterestCollectorPaid: 'Betalt av ränta från inkassobolag',
        caseOverviewHeaderInterestCollectorLeft: 'Återstår av ränta från inkassobolag',
        caseOverviewHeaderCreditorTotal: 'Totalt från borgenär',
        caseOverviewHeaderCreditorTotalPaid: 'Betalt av totalt från borgenär',
        caseOverviewHeaderCreditorTotalLeft: 'Återstår av totalt från borgenär',
        caseOverviewHeaderCreditorTotalDepositsToCreditor: 'Insatt till borgenär totalt',
        caseOverviewHeaderCollectorTotal: 'Totalt från inkassobolag',
        caseOverviewHeaderCollectorTotalPaid: 'Betalt av totalt från inkassobolag',
        caseOverviewHeaderCollectorTotalLeft: 'Återstår av totalt från inkassobolag',
        caseOverviewHeaderTotal: 'Totalt',
        caseOverviewHeaderTotalPaid: 'Betalt av totalt',
        caseOverviewHeaderTotalLeft: 'Återstår av totalt',
        caseOverviewHeaderLastDepositDate: 'Senaste insättningsdatum',
        caseOverviewHeaderCurrentWorkflow: 'Arbetsflöde',
        caseOverviewHeaderCurrentWorkflowTask: 'Aktuell uppgift',
        caseOverviewHeaderCurrentWorkflowTaskTime: 'Datum för aktuell uppgift',
        caseOverviewHeaderNextWorkflowTask: 'Nästa uppgift',
        caseOverviewHeaderNextWorkflowTaskTime: 'Datum för nästa uppgift',
        caseOverviewHeaderFoundation: 'Grund',
        caseOverviewHeaderPaymentPlan: 'Betalningsplan',
        caseOverviewHeaderPaidPaymentPlanEntries: 'Betalda poster',
        caseOverviewHeaderTotalPaymentPlanEntries: 'Totalt antal poster i betalningsplan',
        caseOverviewHeaderCaseStatus: 'Ärendestatus',
        caseOverviewHeaderEndReason: 'Avslutsorsak',
        caseOverviewHeaderExitDate: 'Slutdatum',
        caseOverviewHeaderStepTitle: 'Stegtitel',
        caseOverviewHeaderStepCategory: 'Stegkategori',
        caseOverviewHeaderNextStepTitle: 'Titel för nästa steg',
        caseOverviewHeaderNextStepCategory: 'Kategori för nästa steg',
        caseOverviewHeaderSignedFoudations: 'Signerade grunder',
        caseOverviewHeaderPaymentPlans: 'Skapade betalningsplaner',
        caseOverviewHeaderFoundationDate: 'Grunddatum',
        caseOverviewHeaderFoundationCode: 'Grundkod',
        caseOverviewHeaderFoundationType: 'Grundtyp',
        caseOverviewHeaderRkiRegistry: 'Register',
        caseOverviewHeaderState: 'Tillstånd',
        caseOverviewHeaderReportedAt: 'Rapporterad',
        caseOverviewHeaderError: 'Felmeddelande',
        caseOverviewHeaderRKIReference: 'RKI-referensnummer',
        caseOverviewHeaderClientNumber: 'Borgenärsnummer',
        caseOverviewHeaderSurveillance: 'Bevakning',
        caseOverviewHeaderSurveillanceDate: 'Bevakningsdatum',
        paymentPlansOverview: 'Översikt över betalningsplaner',
        paymentPlansOverviewTabPaymentPlans: 'Betalningsplaner',
        paymentPlansOverviewTabPaymentPlanEntries: 'Avbetalningar',
        paymentPlansOverviewHeaderPaymentPlanId: 'Betalningsplan-ID',
        paymentPlansOverviewHeaderCaseSequentialId: 'Ärendenummer',
        paymentPlansOverviewHeaderCaseStatus: 'Ärendestatus',
        paymentPlansOverviewHeaderCreditorName: 'Borgenärsnamn',
        paymentPlansOverviewHeaderStatus: 'Status',
        paymentPlansOverviewHeaderCreatedAt: 'Skapandedatum',
        paymentPlansOverviewHeaderSettledEntries: 'Betalda avbetalningar',
        paymentPlansOverviewHeaderTotalEntries: 'Totalt antal avbetalningar',
        paymentPlansOverviewHeaderAmount: 'Avbetalningsbelopp',
        paymentPlansOverviewHeaderFromDate: 'Från datum',
        paymentPlansOverviewHeaderToDate: 'Till datum',
        paymentPlansOverviewEntriesHeaderPaymentPlanId: 'Avbetalnings-ID',
        paymentPlansOverviewEntriesHeaderCaseSequentialId: 'Ärendenummer',
        paymentPlansOverviewEntriesHeaderCaseStatus: 'Ärendestatus',
        paymentPlansOverviewEntriesHeaderCreditorName: 'Borgenärsnamn',
        paymentPlansOverviewEntriesHeaderAmount: 'Belopp',
        paymentPlansOverviewEntriesHeaderEntryStatus: 'Status',
        paymentPlansOverviewEntriesHeaderReminderDate: 'Påminnelsedatum',
        paymentPlansOverviewEntriesHeaderDate: 'Avbetalningsdatum',
        paymentPlansOverviewEntriesHeaderDeadlineDate: 'Slutlig tidsfrist',
        paymentPlansOverviewEntriesHeaderCancelDate: 'Datum för misskötsel',
        reportOrdered: 'Rapport beställd',
        reportOrderedText: 'Du får snart ett e-postmeddelande med din rapport.',
        reportOrderedCloseButton: 'Stäng',
        interactionsReports: 'Interaktionsrapport',
        interactionsReportsDesc: 'Rapport över alla inkommande och utgående interaktioner',
        interactionsReportsCreatedAt: 'Skapad',
        interactionsReportsState: 'Status',
        interactionsReportsType: 'Typ',
        interactionsReportsDirection: 'Riktning',
        interactionsReportsCreditorSeqId: 'Borgenärsnummer',
        interactionsReportsCreditor: 'Borgenär',
        interactionsReportsCaseSeqId: 'Ärende-ID',
        interactionsReportsAddress: 'Adress',
        interactionsReportsZipcode: 'Postnummer',
        interactionsReportsCity: 'Ort',
        interactionsReportsCountry: 'Land',
        creditorsReportSeqId: 'Borgenärsnummer',
        creditorsReportName: 'Borgenärsnamn',
        creditorsReportCentralRegisterId: 'Org.nr / personnr',
        creditorsReportStatus: 'Status',
        creditorsReportAddress: 'Adress',
        creditorsReportZipcode: 'Postnummer',
        creditorsReportCity: 'Ort',
        creditorsReportContactPerson: 'Kontaktperson hos borgenären',
        creditorsReportAcquisitionResponsible: 'Ackvisitionsansvarig',
        creditorsReportCaseworkerContact: 'Handläggarkontakt',
        creditorsReportDefaultWorkflow: 'Standardworkflow',
        creditorsReportCatchAllResponsible: 'Catch-all-ansvarig för uppgifter',
        creditorsReportExperianClientNumber: 'Experian klientnummer',
        creditorsReportCaseCount: 'Antal ärenden',
        creditorsReportLatestCaseCreatedAt: 'Datum för senast skapade ärende',
        creditorsReportCollectorName: 'Inkassobolagets namn',
        creditorsReportDefaultBillingModel: 'Standardavräkningsmodell',
        creditorsReportDefaultBillingAppendixSetup: 'Standarduppsättning för avräkningsbilagor',
        creditorsReportBillingEmailTo: 'Avräkningsemail till',
        creditorsReportBillingEmailCc: 'Avräkningsemail cc',
        creditorsReportBillingEmailBcc: 'Avräkningsemail bcc',
        creditorsReportPaymentDays: 'Betalningsdagar',
        creditorsReportMinimumBillingThreshold: 'Minimigräns för ärendeavräkning',
        creditorsReportCreatedAt: 'Skapad',
        dailyDeposits: 'Dagliga insättningar',
        dailyDepositsDesc: 'Dagliga insättningar per borgenär',
        paymentPlanReport: 'Betalningsplansrapport',
        paymentPlanReportDesc: 'Rapport med information om aktiva, avbrutna och tidigare betalningsplaner.',
        dailyDepositsEconomic: 'Dagliga insättningar per borgenär (e-conomic)',
        dailyDepositsEconomicDesc: 'Dagliga insättningar per borgenär till e-conomic utan Frisbii',
        invoiceAppendix: 'Fakturabilaga',
        invoiceAppendixDesc: 'Blad som visar ekonomiska transaktioner för borgenärer under en tidsperiod.',
        employeePerformance: 'Medarbetarprestation',
        employeePerformanceDesc: 'Rapport som visar varje medarbetares effektivitet.',
        phoneCalls: 'Översikt över telefonsamtal',
        phoneCallsDesc: 'Översikt som visar vem som ringde och beloppet av resulterande insättningar.',
        phoneCallsDays: 'Antal dagar efter samtalet som insättningen måste registreras.',
        depositAmount: 'Insatt belopp',
        depositCount: 'Antal insättningar',
        selectCreditor: 'Välj borgenär',
        quarter: 'Kvartal',
        optional: 'valfri',
        noDownloads: 'Det finns inga rapporter att ladda ner.',
    },
    tribunal: {
        tribunal: 'Domstol',
        couldNotCreateTribunalCase: 'Kunde inte skapa domstolsärende',
        createTribunalCase: 'Skapa',
        noTribunalCases: 'Inga domstolsärenden ännu',
        addTribunalCase: 'Lägg till domstolsärende',
        fsNo: 'FS-nr.',
        editFsNo: 'Redigera FS-nr.',
        FsNoUpdated: 'FS-nr. uppdaterat',
        document: 'Dokument',
        addDocument: 'Lägg till dokument',
        closedObjection: 'Avslutat på grund av bestridande',
        insolvency: 'Insolvens',
        insolvencyDate: 'Insolvensdatum',
        phoneCourtMeeting: 'Telefonmöte med domstol',
        register: 'Registrera',
        date: 'Datum',
        meetingLocation: 'Mötesplats',
        meetingDate: 'Mötesdatum',
        courtCaseCosts: 'Rättegångskostnader',
        notRegistered: 'Inte registrerad',
        createFogedrekvisition: 'Skapa utmätningsbegäran',
        assignee: 'Ansvarig',
        selectDistraintType: 'Välj typ av utmätning',
        registerDistraint: 'Registrera utmätning',
        distraintType: 'Typ av utmätning',
        amount: 'Belopp',
        comment: 'Kommentar',
        address: 'Adress',
        licenseplate: 'Registreringsnummer',
        vin: 'VIN',
        distraintDate: 'Datum för utmätning',
        distraintReferenceId: 'Inskrivningsnummer',
        distraintUpdated: 'Utmätning uppdaterad',
        distraintCancelled: 'Utmätning återkallad',
        distraintCancelledDate: 'Datum för återkallelse av utmätning',
        registerPolicePresentation: 'Registrera polishandräckning',
        register1Paategning: 'Registrera 1:a påteckning',
        foerstePaategningDate: 'Datum för 1:a påteckning',
        register2Paategning: 'Registrera 2:a påteckning',
        andenPaategningDate: 'Datum för 2:a påteckning',
        resendBPK: 'Skicka betalningsföreläggande på nytt',
        editBPK: 'Redigera betalningsföreläggande',
        debtorSentToPolicePresentation: 'Gäldenären skickad till polishandräckning',
        resendStaevning: 'Skicka stämning på nytt',
        editStaevning: 'Redigera stämning',
        resendFogedbegaering: 'Skicka utmätningsbegäran på nytt',
        editFogedbegaering: 'Redigera utmätningsbegäran',
        courtMeetingType: 'Mötestyp',
        bailiffInvoice: {
            bailiffInvoice: 'Kronofogdefaktura',
            client: 'Borgenär',
            debt: 'Skuld',
            paymentFee: 'Avgift för betalningskrav',
            distress: 'Utmätning',
            yesStartDistress: 'Ja till att inleda utmätning',
            yesAutoCase: 'Ja till automatiskt överlämnande till tingsrätt',
            createInvoice: 'Skapa faktura',
        },
        noFoundation: 'Inget underlag hittades. Lägg till ett i ärendet.',
        addFoundation: 'Lägg till underlag',
        foundation: 'Underlag',
        economy: 'Ekonomi',
        jurisdiction: 'Jurisdiktion',
        requisition: 'Begäran',
        court: 'Domstol',
        responsible: 'Ansvarig',
        sendRequisition: 'Skicka begäran',
        debt: 'Skuld',
        noCourt: 'Ingen domstol hittades',
        typeOfRequisituion: 'Typ av begäran',
        types: {
            [UdbetalingsRekvisitioner.Politifremstilling]: 'Polishandräckning',
            [UdbetalingsRekvisitioner.Betalingspåkrav]: 'Betalningskrav',
            [UdbetalingsRekvisitioner.Fogedrekvisition]: 'Utmätningsbegäran',
        },
        claim: 'Fordran',
        sendToCourt: 'Skicka till domstol',
        smallCase: 'Förenklat tvistemål',
        commonCivilCase: 'Ordinärt tvistemål',
        shortDescription: 'Kort beskrivning',
        statementClaim: 'Redogörelse och sakförhållanden',
        addAppendix: 'Lägg till bilaga',
        additionalInformation: 'Ytterligare information',
        caseCreation: 'Skapar ärende',
        caseCreationDescription: `Ärendet håller nu på att skapas i domstolssystemet. Det tar en stund, men ärendet kommer att uppdateras i Debbie när det är klart.`,
        keyCodeTitle: 'Ange nyckelkod för',
        keyCodeDescription: 'Använd NemID-nyckelkortet för att hitta den nyckel som motsvarar',
        sessionCreation: 'Skapar session',
        sessionCreationFailure: 'Det gick inte att skapa sessionen',
        keySubmittedExplainer: 'Nyckelkoden används för att logga in.',
        sessionCreationExplainer: 'För att ett ärende ska kunna skickas till domstolen måste en session skapas i tribunal. För att göra det behöver vi en nyckelkod från ditt NemID-nyckelkort.',
        keycode: 'NemID-nyckelkod',
        authKey: 'Nyckel',
        missingKeyTitle: 'Saknar tribunal-nyckel',
        missingKeyExplainer: 'För att skicka ärenden till domstolen behöver du en nyckel för tribunal.',
        meetings: 'Möten',
    },
    courtMeetingState: {
        [CourtMeetingState.Accepted]: 'Möte accepterat',
        [CourtMeetingState.Concluded]: 'Klart',
        [CourtMeetingState.NeedsApproval]: 'Väntar på godkännande',
        [CourtMeetingState.NeedsRevision]: 'Väntar på revidering',
        [CourtMeetingState.NotesSent]: 'Anteckningar mottagna',
        [CourtMeetingState.ReadyForMeeting]: 'Väntar på mötesanteckningar',
        [CourtMeetingState.Rejected]: 'Avvisat av ansvarig',
        [CourtMeetingState.Canceled]: 'Inställt',
    },
    debtorWeb: {
        overpaymentHeader: 'Du har pengar tillgodo',
        overpaymentSuccessHeader: 'Dina kontouppgifter har tagits emot',
        overpaymentSuccessTextHeader: 'Din återbetalning kommer att betalas ut så snart som möjligt. Om du angav något fel kan du uppdatera dina uppgifter nedan.',
        overpaymentPreAmount: 'Du ska få',
        overpaymentPostAmount: 'tillbaka. Skriv ditt bankkontonummer nedan så skickar vi dem till dig.',
        userInfoUpdateSuccess: 'Din begäran har skickats. Tack.',
        userInfoUpdateNoDataChanged: 'Inga ändringar registrerades',
        congratsNoDebt: 'Grattis. Du har ingen mer skuld i detta ärende.',
        congratsDeposit: 'Tack för din deposition i detta ärende.',
        congratsCaseEnd: 'Ärendet har avslutats.',
        satisfactionOne: 'Vi vill gärna höra om din upplevelse. Klicka',
        satisfactionTwo: 'här',
        satisfactionThree: 'för att berätta om den.',
        documentation: 'Dokumentation',
        goToPayment: 'Gå till betalning',
        signingPageSigned: 'Du har signerat dokumentet',
        signingPageDeclinedSigning: 'Du har avböjt att signera dokumentet',
        seeMore: 'Se mer',
        noCasesFound: 'Inga ärenden hittades',
    },
    associateCases: {
        associateCase: 'Solidariskt ansvar',
        associateWithCase: 'Hitta ärendet med den solidariskt ansvariga gäldenären.',
        associateWithCaseSearch: 'Sök efter ärende',
        associateCaseVoucher: 'Vill du synkronisera detta ärendeverifikat med de andra ärendena?',
        caseVoucherIsAssociated: 'Detta ärendeverifikat är synkroniserat med andra ärenden i det solidariska ansvaret.',
        joinExistingCase: 'Anslut till befintligt ärende',
        createNewAssociatedCase: 'Skapa nytt kopplat ärende',
        selectVouchers: 'Välj verifikat',
        selectVouchersDescription: 'Välj vilka verifikat som ska kopieras till det nya ärendet.',
        createAssociatedCaseButton: 'Skapa kopplat ärende',
        noVouchersAvailable: 'Inga verifikat tillgängliga att klona',
    },
    caseGroups: {
        caseGroups: 'Ärendegrupper',
        aiSettings: 'AI-inställningar',
        aiSettingsDescription: 'Instruktioner här används för alla ärenden i denna ärendegrupp.',
        createCaseGroup: 'Skapa ärendegrupp',
        addCaseGroup: 'Lägg till ärendegrupp',
        editCaseGroup: 'Redigera ärendegrupp',
        selectCaseGroup: 'Välj ärendegrupp',
        searchCaseGroups: 'Sök ärendegrupper',
        confirmDelete: 'Är du säker på att du vill radera ärendegruppen? Alla ärenden kommer att tas bort från gruppen.',
        caseGroup: 'Ärendegrupp',
        deleteCaseGroup: 'Radera',
        label: 'Namn',
        categorisedDebtOverview: 'Lägg till egenskaper i kategoriserad skuldöversikt',
        showPropertyLabel: 'Namn',
        addShowProperty: 'Lägg till egenskap',
    },
    costCeiling: {
        failedToLoad: 'Något gick fel. Försök igen senare.',
        costCeiling: 'Kostnadstak',
        customAmount: 'Anpassat kostnadstak (standard är kapitalbeloppet)',
        defaultForNewCases: 'Kostnadstak på nya ärenden',
        caseGroupDefaultDescription: 'Om kostnadstak är aktiverat på nya ärenden som skapas i denna ärendegrupp. Om ingen ärendegruppsinställning anges används inställningen från borgenären eller företaget.',
        noCreditorSetting: 'Ingen borgenärsinställning',
        noCaseGroupSetting: 'Ingen ärendegruppsinställning',
        enabled: 'Aktiverat',
        disabled: 'Inaktiverat',
    },
    createTenantContent: {
        defaultCaseGroupLabel: 'Ärenden för inkasso',
        defaultBankAccountName: 'Bankkonto',
    },
    tenants: {
        tenantDetails: 'Kontouppgifter',
        status: 'Status',
        goLive: 'Aktivera',
        disableTenant: 'Inaktivera konto',
        disableTenantWarning: 'Är du säker på att du vill inaktivera detta konto? Användarna förlorar åtkomst och åtgärden kan inte ångras i Lighthouse.',
        tenantTypeNotSet: 'Inte angiven',
        prices: 'Priser',
        identityCollector: 'Inkassobolag',
        invoicePipeFilter: 'Faktureringsfilter',
        defaultBillingModel: 'Standardfaktureringsmodell',
        defaultBillingAppendixSetup: 'Standarduppställning för faktureringsbilaga',
        configurationOptions: 'Konfigurationer',
        depositBankAccountForCreditors: 'Depositionskonto för borgenärer',
        depositBankAccountForCreditorsName: 'Banknamn',
        billingCustomText: {
            title: 'Anpassad text för fakturering',
            underCreditorName: 'Under borgenärens namn',
            endWhenReceivingPayment: 'Under betalningsinformation när borgenären ska betala något',
            endWhenSendingPayment: 'Under betalningsinformation när borgenären ska ta emot något',
        },
        collectionCommission: 'Inkassoprovision',
        depositOrder: 'Depositionsordning',
        date: 'Datum',
        voucherFrom: 'Verifikat påfört av',
        voucherType: 'Verifikattyp',
        voucherCategory: 'Verifikatkategori',
        newestFirst: 'Nyaste först',
        oldestFirst: 'Äldsta först',
        caseCloseFee: 'Avgift för avslutat ärende',
        clientCaseCreationFee: 'Avgift för borgenärs ärendeskapande',
        tenantCaseCreationFee: 'Avgift för organisationens ärendeskapande',
        debtRegisterRegistrationFee: 'Skuldregister-registreringsavgift',
        paymentDemandFee: 'Avgift för betalningskrav',
        fogedrekvisitionFee: 'Avgift för utmätningsbegäran',
        folkeregisteropslagsFee: 'Folkbokföringsuppslag',
        anmeldelseAfKravFee: 'Anmälan av fordran',
        legalAdviceHourlyRate: 'Timtaxa för juridisk rådgivning',
        afslysningAfUdlaeg: 'Avlysning av utmätning',
        autoDebtRegisterHeader: 'Auto skuldregistrering',
        automaticDebtRegister: 'Automatisk skuldregistrering',
        autoRegisterInOpenRegistry: 'Öppet register',
        autoIgnoreUnresolvedOppositions: 'Ignorera olösta interaktioner (invändningar)',
        autoDeleteDebtRegistrationOnCaseEnd: 'Radera skuldregistrering automatiskt när ärendet avslutas',
        autoDebtRegisterInfoTip: 'Klicka här för mer information',
        areYouSureAutoDebtRegister: 'Är du säker?',
        autoDebtRegisterRKI: {
            headline: 'Automatisk registrering i skuldregister.',
            info: 'Denna funktion tar hänsyn till följande: ',
            exclude: 'Den tar INTE hänsyn till följande: : ',
            endingInfo: 'Aktivera endast denna funktion om du vet att dina ärenden uppfyller ovanstående.',
            note: 'Observera att denna funktion även kan aktiveras/inaktiveras på borgenärsnivå.',
        },
        autoImposeCompensationCost: 'Påför automatiskt kompensationskostnader vid import av företagsärenden',
        autoSendInteractionsAfterXVerifications: 'Skicka automatiskt interaktioner efter x verifieringar',
        preventSendingLetters: 'Förhindra utskick av fysiska brev (webhooks kan användas för att skicka dem på andra sätt)',
        selfCollection: 'Påför inkassokostnader för egeninkasso',
        twoFactorRequired: 'Tvåfaktorsautentisering krävs för användare',
        outboundCall: 'Utgående samtal',
        autoExpireVouchers: 'Automatisk utgång av verifikat',
        hideDocumentsFromCreditors: 'Dölj dokument för borgenärer',
        allowDebtorSelfOverwrite: 'Tillåt gäldenärer att skriva över sina egna uppgifter utan godkännande',
        costCeilingEnabledByDefault: 'Aktivera kostnadstak på nya ärenden som standard',
        deleteCaseDataAfterYears: 'Radera ärendedata efter x år efter att ärendet har avslutats (GDPR)',
        enableGdprDataDeletion: 'Aktivera automatisk radering av GDPR-data',
        dangerZone: 'Farozon',
        AKSSettings: 'RKI-inställningar',
        rkiEnabled: 'Aktivera RKI',
        AKSKey: 'AKS-nyckel',
        AKSCode: 'AKS-kod',
        AKSUsername: 'AKS-användarnamn',
        AKSPassword: 'AKS-lösenord',
        manglerAdvokatindestaaelse: 'Saknar advokatgaranti',
        debitorRegistretEnabled: 'Aktivera Debitor Registret',
        debitorRegistretClientId: 'Client ID',
        debitorRegistretClientSecret: 'Client Secret',
        debitorRegistretCredentialsRequired: 'Ange både Client ID och Client Secret för att spara åtkomstuppgifterna',
        debitorRegistretSetupCreditors: 'Skapa borgenärer i Debitor Registret',
        debitorRegistretSetupCreditorsDescription: 'Skapar alla aktiva borgenärer i Debitor Registret och sparar deras borgenärsnummer.',
        debitorRegistretSetupCreditorsSuccess: 'Borgenärer skapade i Debitor Registret',
        debitorRegistretSetupCreditorsSkipped: 'Redan skapade',
        debitorRegistretSetupCreditorsFailed: 'Fel vid skapande av borgenärer i Debitor Registret',
        affiliatePartners: 'Affiliate-partners',
        createNewTenant: 'Skapa nytt konto',
        createNewTenantAsAffiliatePartner: 'Skapa nytt konto som affiliate-partner',
        disableAi: 'Inaktivera AI',
        disableCreditorCreationFromUi: 'Inaktivera skapande av borgenärer från användargränssnittet',
        autoVerifyCases: 'Verifiera ärenden automatiskt',
    },
    intents: {
        intent: 'Avsikt',
        days: 'Dagar',
        discount: 'Rabatt',
        percentDiscount: 'Procentuell rabatt',
        type: 'Typ',
        noDiscount: 'Ingen rabatt',
    },
    intentDiscountTypes: {
        [DiscountType.Amount]: 'Belopp',
        [DiscountType.Fraction]: 'Andel',
    },
    intentTypes: {
        [IntentType.Unknown]: 'Okänd',
        [IntentType.Deposit]: 'Deposition',
    },
    errors: {
        notFound: 'Sidan du letar efter kunde inte hittas.',
        caseNotFound: 'Ärendet kunde inte hittas',
        pleaseCreateTicket: 'Skapa gärna ett ärende om du tror att detta är ett fel.',
        unknownError: 'Ett fel uppstod.',
        authError: 'Du har inte behörighet.',
        meError: 'Ett fel uppstod när din användarinformation skulle hämtas. Om detta är oväntat, försök igen.',
        unauthorizedError: 'Du har inte behörighet att utföra denna åtgärd',
        invalid: 'ogiltig',
        missing: 'Saknas',
        loadingError: 'Fel vid inläsning av data',
    },
    letterTemplates: {
        journalNumber: 'Ärende:',
        caseReferenceId: 'Referens:',
        caseVoucherReferenceIds: 'Referenser:',
        returnAddress: 'Returadress:',
        w: 'W',
        e: 'E',
        t: 'T',
        centralRegisterId: 'CVR',
    },
    mentionContent: {
        amortisationRemainingAfterFinalPayment: 'Kvarvarande skuld efter sista delbetalningen',
        amortisationForgivenOnCompletion: 'Efterskänks när avtalet har fullföljts',
        amortisationDebtAfterSettlement: 'Skuld efter fullföljd ackordsuppgörelse',
        amortisationPaymentDate: 'Betalningsdatum',
        amortisationAddedFees: 'Tillkommande avgifter',
        amortisationRemainingAfterPayment: 'Återstående skuld efter betalning',
        amortisationRemainingDebt: 'Återstående skuld',
        amortisationPrincipal: 'Kapital',
        amortisationCosts: 'Kostnader',
        amortisationInterest: 'Ränta',
        amortisationAccruedInterest: 'Tillkommen ränta',
        amortisationPayment: 'Delbetalning',
        amortisationCurrentBalance: 'Aktuell skuld',
        reminderFeeRow: 'Påminnelseavgift enligt räntelagen avsnitt 9b, punkt 2',
        debtCollectionFeeRow: 'Inkassoavgift enligt räntelagen avsnitt 9b, punkt 1',
        debtCollectionCostRow: 'Inkassokostnad enligt räntelagen avsnitt 9a, punkt 1',
        compensationFeeRow: 'Kompensationsavgift enligt räntelagen avsnitt 9a, punkt 3',
        fixedInterestRow: 'Tidigare ackumulerad ränta',
        processInterestRow: 'Ackumulerad ränta från förfallodagen',
        yearlyInterestRow: 'Ackumulerad ränta',
        otherCosts: 'Andra kostnader',
        sum: 'Totalt utestående',
        paid: 'Redan betald',
        invoice: 'Faktura',
        caseVoucher: ' ',
        currency: 'Valuta',
        date: 'Datum',
        dueDate: 'Förfallodatum',
        amount: 'Belopp',
        deposited: 'Inbetalt',
        residue: 'Restbelopp',
        text: 'Text',
        appliedToPrincipal: 'Avräknat kapital',
        appliedToInterest: 'Avräknad ränta',
        appliedToCosts: 'Avräknade kostnader',
        principalBalance: 'Kvarvarande kapital',
        interestBalance: 'Kvarvarande ränta',
        costsBalance: 'Kvarvarande kostnader',
        expiredSince: 'Varav preskriberat',
        total: 'Totalt',
        email: 'E-post',
        phone: 'Telefon',
        signature: 'Signatur',
        journalNumber: 'Ärende:',
        genericEmailSubjectPre: 'Angående din skuld till',
        genericEmailSubjectForAlternativeContactPre: 'Ärende hos',
        satisfactionsOrClick: 'eller klicka',
        satisfactionsHere: 'här',
        principalReferenceIdsAnd: ' och ',
        previousYearsAnd: ' och ',
        nameAndAddressProtectedPerson: 'Person med namn- och adresskydd',
    },
    emailSignature: {
        privacyPolicyText: 'Databehandling. Vi kan behandla personuppgifter om dig. Du kan läsa vår integritetspolicy här:',
        regards: 'Med vänliga hälsningar',
    },
    notificationEmail: {
        newPendingMessages: 'Nya väntande meddelanden',
        from: 'från',
        regarding: 'ang.',
        goToApp: 'Gå till webbappen',
        newNotifications: 'Nya notiser',
        newTodos: 'Nya uppgifter',
    },
    newNoteEmail: {
        dear: 'Hej',
        newMessageFromCollector: 'Du har fått ett nytt meddelande från',
        subjectNewMessageFrom: 'Nytt meddelande från',
        clickHereToAnswer: 'Klicka på knappen nedan för att läsa mer eller svara på meddelandet.',
        answerAndReadMore: 'Svara eller läs mer',
        sentTo: 'Skickat till',
    },
    invoice: {
        deposit: 'Deposition',
        overpayment: 'Överbetalning',
        inclVat: 'inkl. moms',
        deposits: 'Depositioner',
        creditorSeqId: 'Id',
        period: 'Period',
        description: 'Beskrivning',
        amount: 'Belopp',
        ofVoucher: 'Av verifikat',
        subTotal: 'Delsumma',
        customerReferenceId: 'Kundreferens-id',
        imposedBy: 'Påförd av',
        vat: 'Moms',
        total: 'Totalt',
        date: 'Datum',
        number: 'Nummer',
        appendix: 'Bilaga',
        voucher: 'Verifikat',
        voucherReferenceId: 'Verifikatreferens',
        text: 'Text',
        disbursements: 'Utlägg',
        fees: 'Avgifter',
        collectionCommission: 'Inkassoprovision',
        creditorName: 'Borgenär',
        creditorReference: 'Borgenärsreferens-id',
        caseGroup: 'Ärendegrupp',
        caseSeqId: 'Ärende-id',
        caseReferenceId: 'Ärendereferens-id',
        depositId: 'Depositions-id',
        paidToClient: 'Utbetalt till borgenär',
        economicMovement: 'Borgenärstransaktion',
        debtorName: 'Gäldenärens namn',
        creditorDeposit: 'Borgenärsdeposition',
        previous: 'Föreg.',
        credited: 'Krediterad',
        currency: 'Valuta',
    },
    properties: {
        selectProperty: 'Välj en egenskap',
        searchProperties: 'Sök egenskaper',
        properties: 'Egenskaper',
        createNewPropertyType: 'Skapa ny egenskapstyp',
        infoGuideMentions: 'Använd denna tagg för att infoga data i en mall',
        infoGuideAPI: 'Använd fältet för att komma åt egenskapen via API',
        infoGuideImport: 'För att importera data till egenskapen kan du skapa en kolumn i ditt Excel-ark med en av följande kolumnrubriker',
        newProperty: 'Ny egenskapstyp',
        newPropertyFor: 'Skapa en ny egenskapstyp för',
        label: 'Etikett',
        description: 'Beskrivning',
        searchable: 'Sökbar',
        handle: 'Handtag',
        type: 'Typ',
        ref: 'Referens',
        scope: 'Tillhörighet',
        required: 'Obligatorisk',
        usage: 'Användning',
        historical: 'Historiska data',
        create: 'Skapa',
        defaultDropdownOptions: 'Alternativ 1\nAlternativ 2',
        dropdownOptions: 'Rullgardinsalternativ',
        cases: 'Ärenden',
        caseVouchers: 'Ärendeverifikat',
        creditors: 'Borgenärer',
        delete: 'Radera',
        or: 'eller',
        deleteAreYouSure: 'Om denna egenskap raderas tas den bort från alla ärenden och mallar. Är du säker?',
        option: 'Alternativ',
    },
    entities: {
        [Entity.Billing]: 'Fakturering',
        [Entity.Case]: 'Ärende',
        [Entity.Creditor]: 'Borgenär',
        [Entity.Customer]: 'Kund',
        [Entity.TribunalCase]: 'Domstolsärende',
        [Entity.Debtor]: 'Gäldenär',
        [Entity.Collector]: 'Inkassobolag',
        [Entity.BillingVoucher]: 'Faktureringsverifikat',
        [Entity.CaseVoucher]: 'Ärendeverifikat',
        [Entity.Template]: 'Mall',
        [Entity.Workflow]: 'Arbetsflöde',
    },
    filterType: {
        [FilterType.Exact]: 'Filtrera på exakt matchning',
        [FilterType.Containing]: 'Filtrera på innehållande matchning',
    },
    propertyTypeLabels: {
        ['Name']: 'Namn',
        ['Address']: 'Adress',
        ['Phone']: 'Telefon',
        ['Email']: 'E-post',
        ['Type']: 'Typ',
        ['Company']: 'Företag',
    },
    propertyTypeDescriptions: {
        ['Name of the alternative contact person.']: 'Namn på den alternativa kontaktpersonen.',
        ['Address for the alternative contact person.']: 'Adress till den alternativa kontaktpersonen.',
        ['Phone to the alternative contact person.']: 'Telefon till den alternativa kontaktpersonen.',
        ['Email to the alternative contact person.']: 'E-post till den alternativa kontaktpersonen.',
        ['Type of the alternative contact person.']: 'Typ av alternativ kontaktperson.',
        ['Company where the alternative contact person works.']: 'Företag där den alternativa kontaktpersonen arbetar.',
    },
    alternativeContactTypes: {
        [AlternativeContactType.Lawyer]: 'Advokat',
        [AlternativeContactType.Proprietorship]: 'Bostadsförvaltare',
        [AlternativeContactType.Owner]: 'Ägare',
        [AlternativeContactType.Guardian]: 'Förmyndare',
        [AlternativeContactType.Curator]: 'God man',
        [AlternativeContactType.Landlord]: 'Hyresvärd',
        [AlternativeContactType.FinancialAdvisor]: 'Ekonomisk rådgivare',
        [AlternativeContactType.TaxAuthority]: 'Skattemyndighet',
        [AlternativeContactType.PowerOfAttorney]: 'Fullmakt',
        [AlternativeContactType.Administrator]: 'Administratör',
        [AlternativeContactType.Police]: 'Polis',
        [AlternativeContactType.Guarantor]: 'Borgensman',
        [AlternativeContactType.Other]: 'Övrigt',
    },
    creditScore: {
        estimated: 'Uppskattad',
        estimate: 'sannolikhet för indrivning av restskulden',
        estimateZero: 'sannolikhet för indrivning',
        paid: 'Skulden har betalats',
    },
    voucherApplications: {
        header: 'Verifikatregler',
        createError: 'Kunde inte skapa verifikatregel, kontrollera att du inte skapar cirkulära referenser',
        creditorCustomApplicationList: 'Borgenärer med egna regler',
        noCustomApplications: 'Inga borgenärer har egna regler',
        textSelector1: 'När ett nytt ',
        textSelector2: ' skapas, där ärendets typ är ',
        textSelector3: ', skapas följande verifikat',
        forCreditor: 'När borgenär är',
        addCreditor: 'Välj borgenär',
    },
    voucherApplicationTypeLabels: {
        [VoucherApplicationType.Case]: 'ärende',
        [VoucherApplicationType.VoucherCategory]: 'verifikat med kategorin',
        [VoucherApplicationType.VoucherType]: 'verifikat av typen',
    },
    voucherApplicationTargetLabels: {
        [VoucherApplicationTarget.Both]: 'privat/företag',
        [VoucherApplicationTarget.Person]: 'privat',
        [VoucherApplicationTarget.Company]: 'företag',
    },
    interestFromLabels: {
        [InterestFrom.Date]: 'från skapandedatum',
        [InterestFrom.DueDate]: 'från förfallodatum',
    },
    todoQueue: {
        sorting: 'Sortering',
        oldest: 'Äldsta',
        creditScore: 'Kreditscore',
        creditorTodosNotSupported: 'Uppgifter hanteras ännu inte för borgenärer',
    },
    views: {
        associated: 'Kopplat',
        notAssociated: 'Inte kopplat',
        filter: 'Filter',
        view: 'vy',
        name: 'Vynamn',
        introHeader: 'Inga vyer här',
        introDescription: 'Du kan skapa en vy genom att klicka på knappen i det övre högra hörnet.',
        clear: 'Rensa',
        collapse: 'Fäll ihop',
        expand: 'Expandera',
        noData: 'Sidan är tom',
        is: 'är',
        oneOf: 'är en av',
        before: 'före',
        after: 'efter',
        values: 'värden',
        isNot: 'är inte',
        noneOf: 'är inte en av',
        invalidNumberError: ' är inte ett giltigt nummer',
        displayOptions: 'Värden',
        localChanges: 'Vy redigerad lokalt',
        resetLocalChanges: 'återställ ändringar',
        orderedBy: 'Sortera efter',
        orderedByDirection: 'Sorteringsriktning',
        primaryLabel: 'Primär etikett',
        secondaryLabel: 'Sekundär etikett',
        betaDisclaimer: 'Vyer är en betafunktion. Ändringar eller uppdateringar kan förekomma som potentiellt kan påverka tidigare skapade vyer. Vi arbetar kontinuerligt med att förbättra denna funktion och uppskattar ditt tålamod',
        commaSeparated: 'Kommaseparerad',
    },
    viewFilterTypeLabels: {
        isAssociatedCase: 'Ärendekoppling',
        agentProposalProposedAt: 'Datum för agentförslag',
        agentProposalDecidedAt: 'Beslutsdatum för agentförslag',
        caseStatus: 'Ärendestatus',
        creditorId: 'Borgenär',
        creditorState: 'Borgenärsstatus',
        interactionDirection: 'Interaktionsriktning',
        interactionType: 'Interaktionstyp',
        caseVoucherState: 'Verifikatstatus',
        caseVoucherSource: 'Verifikatkälla',
        caseVoucherCurrency: 'Verifikatvaluta',
        caseVoucherType: 'Verifikattyp',
        pausedWithUpdates: 'Pausad uppdatering',
        historicallyPausedUpdates: 'Historiskt pausad uppdatering',
        creditorCreatedAt: 'Borgenär skapad',
        updatePausedAt: 'Uppdatering pausad',
        updateContinuedAt: 'Uppdatering återupptagen',
        updateRemindedAt: 'Uppdatering påmind',
        caseCreatedAt: 'Ärende skapat',
        caseVoucherDate: 'Verifikatdatum',
        caseVoucherExpirationDate: 'Verifikatets utgångsdatum',
        caseVoucherIrrecoverableDate: 'Verifikatets datum för avskrivning',
        caseVoucherCreatedAt: 'Verifikat skapat',
        satisfactionCreatedAt: 'Betalning skapad',
        interactionCreatedAt: 'Interaktion skapad',
        endReasonId: 'Avslutsorsak',
        caseGroupId: 'Ärendegrupp',
        billingModelId: 'Faktureringsmodell',
        documentType: 'Dokumenttyp',
        caseWorkflow: 'Ärendearbetsflöde',
        currentCaseWorkflowTask: 'Aktuell uppgift i ärendearbetsflöde',
        nextCaseWorkflowTask: 'Nästa uppgift i ärendearbetsflöde',
        caseStatusTime: 'Tid i ärendestatus',
        caseNumbers: 'Ärende-id',
        properties: 'Egenskap',
        caseTags: 'Ärendetaggar',
        isCompany: 'Gäldenärstyp',
    },
    viewLabels: {
        'cases.id': 'Ärende-id',
        'cases.status': 'Ärendestatus',
        'cases.createdAt': 'Ärendets skapandedatum',
        'cases.createdBy': 'Ärende skapat av',
        'creditors.name': 'Borgenärens namn',
        'creditors.id': 'Borgenär-id',
        'billingModels.name': 'Faktureringsmodell',
        'caseGroups.label': 'Ärendegrupp',
        'workflows.title': 'Arbetsflöde',
        'caseVouchers.amount': 'Ärendeverifikatets belopp',
        caseVoucherProperties: 'Ärendeverifikatets egenskaper',
        caseProperties: 'Ärendeegenskaper',
        contactName: 'Kontaktnamn',
        'voucherTypes.label': 'Verifikattyp',
        caseResponsible: 'Ärendeansvarig',
        caseEndReason: 'Ärendets avslutsorsak',
        caseUpdates: 'Pausade ärendeuppdateringar',
    },
    interactionCategories: {
        title: 'Interaktionskategorier',
        createCategory: 'Skapa kategori',
        interactionCategory: 'interaktionskategori',
        interactionCategories: 'interaktionskategorier',
    },
    ai: {
        suggestion: 'AI-förslag',
        qualityScore: 'Kvalitetspoäng',
        safetyScore: 'Säkerhetspoäng',
        manipulationDetected: 'Manipulation upptäckt',
        sensitivityFlags: 'Känslighetsflaggor',
        reasoning: 'Motivering',
    },
    autoReply: {
        customInstructions: 'Anpassade AI-instruktioner',
        customInstructionsDescription: 'Dessa instruktioner inkluderas i alla AI-genererade svar. Använd detta för att definiera ton, specifika regler eller information som alltid ska inkluderas.',
        customInstructionsPlaceholder: 'T.ex.: Hänvisa alltid till vår webbplats för betalningsinformation. Använd alltid kundens förnamn.',
        creditorAISettings: 'AI-inställningar för borgenär',
        creditorAISettingsDescription: 'Anpassade instruktioner för AI-genererade svar för ärenden på denna borgenär.',
        title: 'AI-autosvar',
        description: 'Generera automatiskt svar på inkommande e-post med hjälp av AI',
        enabled: 'Aktivera autosvar',
        enabledDescription: 'När aktiverat genererar AI utkast till svar för inkommande e-post kopplad till ärenden',
        mode: 'Läge',
        modeOutbox: 'Utkorg (granskning)',
        modeOutboxDescription: 'Genererade svar sparas som utkast för manuell granskning innan de skickas',
        modeAutoSend: 'Autosänd',
        modeAutoSendDescription: 'Svar som uppfyller kvalitetströsklarna skickas automatiskt',
        qualityThreshold: 'Kvalitetströskel',
        qualityThresholdDescription: 'Lägsta kvalitetspoäng (0-1) som krävs för automatisk sändning',
        safetyThreshold: 'Säkerhetströskel',
        safetyThresholdDescription: 'Lägsta säkerhetspoäng (0-1) som krävs. Under detta blockeras svar',
        sensitivityFlags: 'Känslighetsblocklista',
        sensitivityFlagsDescription: 'Ämnen som kräver manuell granskning när de upptäcks',
        customFlags: 'Anpassade känslighetsflaggor',
        customFlagsDescription: 'Definiera anpassade ämnen som ska utlösa manuell granskning',
        addCustomFlag: 'Lägg till anpassad flagga',
        flagId: 'Flagg-ID',
        flagName: 'Namn',
        flagDescription: 'Beskrivning (vad ska AI:n leta efter)',
        noCustomFlags: 'Inga anpassade flaggor definierade',
        generationModel: 'Genereringsmodell',
        judgeModel: 'Bedömningsmodell',
        usageTitle: 'AI-användning',
        usageSuggestions: 'Förslag',
        usageCategorizations: 'Kategoriseringar',
        usageAutoReplies: 'Autosvar',
        usageLimitReached: 'Gränsen för AI-användning har nåtts denna månad',
        generateSuggestion: 'Generera AI-förslag',
        flags: {
            COURT_LEGAL: 'Domstol / Juridik',
            POLICE: 'Polis',
            FINANCIAL_HARDSHIP: 'Ekonomiska svårigheter',
            DISPUTE: 'Bestridande',
            THREAT_HOSTILE: 'Hot / Fientlighet',
            MEDICAL_HEALTH: 'Medicinskt / Hälsa',
        },
        blockedReasons: {
            auto_reply_disabled: 'Autosvar är inaktiverat',
            manipulation_detected: 'Manipulation upptäckt i inkommande meddelande',
            safety_threshold: 'Säkerhetspoäng under tröskeln',
            blocklist_match: 'Matchade känslighetsblocklista',
            custom_flag_match: 'Matchade anpassad känslighetsflagga',
            case_reassigned: 'Ärendet omfördelades',
        },
    },
    languages: {
        aa: 'Afar',
        ab: 'Abchaziska',
        ae: 'Avestiska',
        af: 'Afrikaans',
        ak: 'Akan',
        am: 'Amhariska',
        an: 'Aragonesiska',
        ar: 'Arabiska',
        as: 'Assamesiska',
        av: 'Avariska',
        ay: 'Aymara',
        az: 'Azerbajdzjanska',
        ba: 'Basjkiriska',
        be: 'Vitryska',
        bg: 'Bulgariska',
        bh: 'Bihariska språk',
        bi: 'Bislama',
        bm: 'Bambara',
        bn: 'Bengali',
        bo: 'Tibetanska',
        br: 'Bretonska',
        bs: 'Bosniska',
        ca: 'Katalanska',
        ce: 'Tjetjenska',
        ch: 'Chamorro',
        co: 'Korsikanska',
        cr: 'Cree',
        cs: 'Tjeckiska',
        cu: 'Kyrkoslaviska',
        cv: 'Tjuvasjiska',
        cy: 'Walesiska',
        da: 'Danska',
        de: 'Tyska',
        dv: 'Maldiviska',
        dz: 'Dzongkha',
        ee: 'Ewe',
        el: 'Grekiska (nygrekiska)',
        en: 'Engelska',
        eo: 'Esperanto',
        es: 'Spanska',
        et: 'Estniska',
        eu: 'Baskiska',
        fa: 'Persiska',
        ff: 'Fulani',
        fi: 'Finska',
        fj: 'Fijianska',
        fo: 'Färöiska',
        fr: 'Franska',
        fy: 'Västfrisiska',
        ga: 'Iriska',
        gd: 'Gaeliska',
        gl: 'Galiciska',
        gn: 'Guaraní',
        gu: 'Gujarati',
        gv: 'Manx',
        ha: 'Hausa',
        he: 'Hebreiska (moderna)',
        hi: 'Hindi',
        ho: 'Hiri Motu',
        hr: 'Kroatiska',
        ht: 'Haitisk kreol',
        hu: 'Ungerska',
        hy: 'Armeniska',
        hz: 'Herero',
        ia: 'Interlingua',
        id: 'Indonesiska',
        ie: 'Interlingue',
        ig: 'Igbo',
        ii: 'Nuosu',
        ik: 'Inupiaq',
        io: 'Ido',
        is: 'Isländska',
        it: 'Italienska',
        iu: 'Inuktitut',
        ja: 'Japanska',
        jv: 'Javanesiska',
        ka: 'Georgiska',
        kg: 'Kikongo',
        ki: 'Kikuyu',
        kj: 'Kwanyama',
        kk: 'Kazakiska',
        kl: 'Grönländska',
        km: 'Kambodjanska',
        kn: 'Kannada',
        ko: 'Koreanska',
        kr: 'Kanuri',
        ks: 'Kashmiri',
        ku: 'Kurdiska',
        kv: 'Komi',
        kw: 'Korniska',
        ky: 'Kirgiziska',
        la: 'Latin',
        lb: 'Luxemburgiska',
        lg: 'Luganda',
        li: 'Limburgiska',
        ln: 'Lingala',
        lo: 'Laotiska',
        lt: 'Litauiska',
        lu: 'Luba-Katanga',
        lv: 'Lettiska',
        mg: 'Malagassiska',
        mh: 'Marshallesiska',
        mi: 'Maori',
        mk: 'Makedonska',
        ml: 'Malayalam',
        mn: 'Mongoliska',
        mr: 'Marathi',
        ms: 'Malajiska',
        mt: 'Maltesiska',
        my: 'Burmesiska',
        na: 'Nauruanska',
        nb: 'Bokmål',
        nd: 'Nordndebele',
        ne: 'Nepali',
        ng: 'Ndonga',
        nl: 'Nederländska',
        nn: 'Nynorska',
        no: 'Norska',
        nr: 'Sydndebele',
        nv: 'Navajo',
        ny: 'Nyanja',
        oc: 'Occitanska',
        oj: 'Ojibwa',
        om: 'Oromo',
        or: 'Oriya',
        os: 'Ossetiska',
        pa: 'Punjabi',
        pi: 'Pali',
        pl: 'Polska',
        ps: 'Pashto',
        pt: 'Portugisiska',
        qu: 'Quechua',
        rm: 'Rätoromanska',
        rn: 'Rundi',
        ro: 'Rumänska',
        ru: 'Ryska',
        rw: 'Kinyarwanda',
        sa: 'Sanskrit',
        sc: 'Sardiska',
        sd: 'Sindhi',
        se: 'Nordsamiska',
        sg: 'Sango',
        si: 'Singalesiska',
        sk: 'Slovakiska',
        sl: 'Slovenska',
        sm: 'Samoanska',
        sn: 'Shona',
        so: 'Somaliska',
        sq: 'Albanska',
        sr: 'Serbiska',
        ss: 'Swati',
        st: 'Sydsotho',
        su: 'Sundanesiska',
        sv: 'Svenska',
        sw: 'Swahili',
        ta: 'Tamil',
        te: 'Telugu',
        tg: 'Tadzjikiska',
        th: 'Thailändska',
        ti: 'Tigrinja',
        tk: 'Turkmeniska',
        tl: 'Tagalog',
        tn: 'Tswana',
        to: 'Tonganska',
        tr: 'Turkiska',
        ts: 'Tsonga',
        tt: 'Tatariska',
        tw: 'Twi',
        ty: 'Tahitiska',
        ug: 'Uiguriska',
        uk: 'Ukrainska',
        ur: 'Urdu',
        uz: 'Uzbekiska',
        ve: 'Venda',
        vi: 'Vietnamesiska',
        vo: 'Volapük',
        wa: 'Vallonska',
        wo: 'Wolof',
        xh: 'Xhosa',
        yi: 'Jiddisch',
        yo: 'Yoruba',
        za: 'Zhuang',
        zh: 'Kinesiska',
        zu: 'Zulu',
    },
    weekdays: {
        0: 'Måndag',
        1: 'Tisdag',
        2: 'Onsdag',
        3: 'Torsdag',
        4: 'Fredag',
        5: 'Lördag',
        6: 'Söndag',
    },
    cosmo: {
        [ProviderName.DEBBIE]: {
            title: 'Debbie',
            description: 'Uppdaterar Cosmo med data från Debbie',
        },
        [ProviderName.LEGACY]: {
            title: 'Legacy [AKTIVERA INTE]',
            description: 'Migrering från äldre cosmo till cosmoV2',
        },
        [ProviderName.AKS]: {
            title: 'Experian Aktiv KreditSikring (AKS)',
            description: 'Aktiv KreditSikring (Aktiv kreditsäkring) ger dig aktuell och detaljerad kreditinformation om dina kunder. Tjänsten omfattar de senaste stamdata, finansiella nyckeltal, anmärkningar och annan väsentlig information som hjälper dig att bedöma ett företags finansiella hälsa.',
        },
        [ProviderName.CVR]: {
            title: 'CVR',
            description: 'Få tillgång till officiella företagsuppgifter direkt från CVR. Omfattar information om ett företags namn, adress, CVR-nummer, juridisk form, startdatum, ägare och andra viktiga uppgifter.',
        },
        [ProviderName.CPR]: {
            title: 'CPR',
            description: 'Få tillgång till den danska statens officiella register över personnummer. Här kan du hämta personuppgifter utifrån CPR-nummer eller sökning på namn/adress.',
        },
        [ProviderName.TINGBOGEN]: {
            title: 'Tingbogen',
            description: 'Få tillgång till registreringsinformation för fast egendom, fordon och andra tillgångar. Kontrollera ägaruppgifter, pantbrev, servitut och andra inteckningar direkt från det digitala fastighetsregistret.',
        },
        [ProviderName.MAILVALIDATOR]: {
            title: 'E-postvalidering',
            description: 'Debbie E-postvalidering kontrollerar om en e-postadress är korrekt och aktiv. Den verifierar att adressen är korrekt skriven, att domänen finns, och försöker även bekräfta om den specifika e-postadressen är aktiv, så att du kan undvika att skicka meddelanden till adresser som inte existerar.',
        },
        [ProviderName.COURT]: {
            title: 'Domstolsdistrikt',
            description: 'Hitta och tilldela automatiskt domstolsdistrikt till ärenden',
        },
        [ProviderName.VONAGE]: {
            title: 'Vonage',
            description: 'Hämta information om telefonnummer, såsom deras giltighet, typ (mobil eller fast telefoni) och operatörsuppgifter.',
        },
        [ProviderName.EJF]: {
            title: 'Ejerfortegnelsen',
            description: 'Få tillgång till uppgifter om fastighetsägande från det danska ägarregistret (Ejerfortegnelsen). Slå upp ägaruppgifter för fast egendom baserat på adress eller byggnadskod.',
        },
    },
    endReasonCategory: {
        [EndReasonCategory.Success]: 'Löst',
        [EndReasonCategory.Unresolved]: 'Förgäves',
        [EndReasonCategory.NotPossible]: 'Ej möjlig',
        [EndReasonCategory.Error]: 'Avbruten',
    },
    endReasonCategoryDescription: {
        [EndReasonCategory.Success]: 'Ärenden där vi har drivit in pengar till borgenären – helt eller delvis – via betalning eller ackord. Det är den kategori vi försöker maximera.',
        [EndReasonCategory.Unresolved]: 'Verkliga ärenden som inte löstes, men där ingen yttre omständighet gjorde det omöjligt: skulden preskriberades, bedömdes som oindrivbar, eller ärendet lades ner för att det inte lönade sig att driva vidare.',
        [EndReasonCategory.NotPossible]: 'Ärenden där indrivning blev omöjlig på grund av yttre omständigheter hos gäldenären – t.ex. konkurs, dödsfall, skuldsanering eller okänd adress. Räknas med i statistiken men kan inte betraktas som vårt fel.',
        [EndReasonCategory.Error]: 'Ärenden som tas bort ur statistiken (även ur nettolösningsgraden) eftersom de aldrig borde ha legat hos oss: felaktig registrering, dubbletter (sammanslagna), borgenären återkallade ärendet, eller gäldenären var minderårig.',
    },
    endReasonsSettings: {
        customEndReasons: 'Skapade avslutsorsaker',
        systemEndReasons: 'Standard avslutsorsaker',
        createEndReason: 'Skapa avslutsorsak',
        label: 'Namn',
        category: 'Kategori',
        labelPlaceholder: 'Namn på avslutsorsak',
        categoryPlaceholder: 'Välj kategori',
        uncategorized: 'Okategoriserad',
        editEndReason: 'Redigera avslutsorsak',
        deleteEndReason: 'Ta bort avslutsorsak',
        deleteEndReasonConfirm: 'Är du säker på att du vill ta bort den här avslutsorsaken? Det kan inte ångras.',
        deleteEndReasonInUse: 'Avslutsorsaken används av avslutade ärenden och kan inte tas bort',
        standardReadOnly: 'Standardorsaker delas av alla och kan inte redigeras eller tas bort.',
        endReasonNotFound: 'Avslutsorsaken kunde inte hittas',
        handle: 'Handle',
    },
    voucherTypeSelect: {
        selectBillingVoucherType: 'Välj avräkningsverifikattyp',
        selectCaseVoucherType: 'Välj ärendeverifikattyp',
        selectPaymentVoucherType: 'Välj verifikattyp för betalning',
        searchVoucherTypes: 'Sök verifikattyper',
        allVoucherTypes: 'Alla verifikattyper',
    },
    paymentTypeSelect: {
        selectPaymentType: 'Välj betalningstyp',
        searchPaymentTypes: 'Sök betalningstyper',
        allPaymentTypes: 'Alla betalningstyper',
    },
    contacts: {
        contact: 'kontakt',
        selectContact: 'Välj kontakt',
        selectPayoutContact: 'Betala ut till kontakt',
        searchContacts: 'Sök kontakter',
        allContacts: 'Alla kontakter',
        createContact: 'Skapa kontakt',
        editContact: 'Redigera kontakt',
        deleteContact: 'Ta bort kontakt',
        deleteContactConfirm: 'Är du säker på att du vill ta bort kontakten?',
        notSelectableHere: 'Kontakten saknar de uppgifter som krävs här och valdes därför inte',
        email: 'E-post',
        phone: 'Telefon',
        registryIdentifier: 'Organisations-/personnummer',
        bankAccount: 'Kontouppgifter',
    },
    errorEntities: {
        sftpServer: 'SFTP-server',
        sftpUser: 'SFTP-användare',
        endReason: 'avslutsorsak',
        update: 'uppdatering',
        workflow: 'arbetsflöde',
        creditorLink: 'borgenärslänk',
        interaction: 'interaktion',
        procedure: 'procedur',
        tribunalCase: 'domstolsärende',
        tribunalJob: 'domstolsjobb',
        document: 'dokument',
        paymentPlan: 'betalningsplan',
        file: 'fil',
        creditor: 'borgenär',
        billing: 'fakturering',
        billingCollection: 'faktureringsuppsättning',
        caseVoucher: 'ärendeverifikat',
        caseVoucherTable: 'ärendeverifikattabell',
        fixedDistribution: 'fast fördelning',
        billingModel: 'faktureringsmodell',
        billingAppendixSetup: 'inställningar för faktureringsbilaga',
        customer: 'kund',
        user: 'användare',
        settings: 'inställningar',
        case: 'ärende',
        party: 'part',
        import: 'import',
        transactionAccount: 'transaktionskonto',
        interactionCategory: 'interaktionskategori',
        view: 'vy',
        apiKey: 'API-nyckel',
        searchIndex: 'sökindex',
        merge: 'ärendesammanslagning',
        associateCase: 'ärendekoppling',
        deposit: 'deposition',
        task: 'uppgift',
        chain: 'arbetsflöde',
        contact: 'kontakt',
        remindDate: 'påminnelsedatum',
        changelog: 'ändringslogg',
        referenceId: 'referens-ID',
        aiSuggestion: 'AI-förslag',
        attachment: 'bilaga',
        preview: 'förhandsvisning',
        note: 'anteckning',
        rollbackTask: 'återställning av uppgift',
        runTask: 'körning av uppgift',
        bankAccountDetails: 'bankkontouppgifter',
        bulkActions: 'massåtgärd',
        pause: 'paus',
        meetingLocation: 'mötesplats',
        meetingDate: 'mötesdatum',
        satisfaction: 'nöjdhet',
        tags: 'taggar',
        template: 'mall',
        webhook: 'webhook',
        property: 'fastighet',
        updateType: 'uppdateringstyp',
        phone: 'telefonnummer',
        email: 'e-postadress',
        report: 'rapport',
        caseGroup: 'ärendegrupp',
        collector: 'inkassobolag',
        team: 'team',
        rkiRegistration: 'RKI-registrering',
        integration: 'integration',
        asset: 'tillgång',
    },
    tribunalSettings: {
        box4CaseStatementTemplate: 'Rubrik 4 - Mall för sakframställning',
        caseStatementTemplate: 'Mall för sakframställning',
        submission: 'Inlämning',
        ignorePaymentsWarning: 'Ignorera varning om att ärendet innehåller inbetalningar',
        box1Creditor: 'Rubrik 1 - Borgenär (och eventuell representant)',
        creditor: 'Borgenär',
        representative: 'Eventuell representant',
        contactInformation: 'Kontaktuppgifter',
        noPhoneMeetingBelow: 'Begär inte telefonmöte om kravets totala belopp är under (DKK):',
        representativePhone: 'Representantens telefonnummer',
        representativeEmail: 'Representantens e-post',
        representativeRegistrationNumber: 'Representantens reg.nr.',
        representativeAccountNumber: 'Representantens kontonr.',
        box2Debtor: 'Rubrik 2 - Gäldenär',
        includeCprInPaymentDemand: 'Inkludera CPR-nummer i betalningskravet',
        box4ClaimSize: 'Rubrik 4 - Kravets storlek',
        excludeVoucherTypesDescription: 'Exkludera valda ärendeposteringstyper vid inlämning av betalningskravet. Till exempel inkassokostnader.',
        selectVoucherTypesToSubtract: 'Välj ärendeposteringstyper som ska dras av vid inlämning',
        box5CaseStatement: 'Rubrik 5 - Sakframställning',
        box9SubmittedBy: 'Rubrik 9 - Inlämnad av (borgenär eller borgenärens representant)',
        courtCosts: 'Rättegångskostnader',
        selectCourtCostVoucherType: 'Välj ärendeposteringstyp för rättegångskostnader',
        vouchersToOverride: 'Posteringar som ska skrivas över (tas bort från ärendet)',
        selectVouchers: 'Välj posteringar',
        vouchersToSubtractFromCourtCosts: 'Posteringar som ska kvittas mot rättegångskostnaderna',
        keepHigherExtrajudicialCosts: 'Behåll utomrättsliga kostnader om de är högre än de rättsliga',
        interestActSection8a: 'Räntelagen § 8 a',
        interestActSection8aDescription: 'Rättegångskostnader som tilldömts genom dom eller annat domstolsavgörande i ett tvistemål löper med ränta från verkställighetsfristens utgång enligt § 5 st. 1 och 2.',
        selectInterestVoucherTypesAfterVerdict: 'Välj posteringstyper som ska löpa med ränta 14 dagar från dom',
        insolvencyDeclaration: 'Insolvensförklaring',
        useCustomInsolvencyUpdateType: 'Använd anpassad uppgiftstyp för insolvens',
        defaultEmailTemplate: 'Standardmall för e-post',
        defaultEmailAttachmentTemplate: 'Standardmall för e-postbilagan',
        editTemplate: 'Redigera mall',
    },
    cosmoSettings: {
        header: 'Cosmo-inställningar',
        warningPrefix: 'OBS:',
        warning: 'Gör inga ändringar på denna sida utan att rådfråga Debbie support.',
        identityProviderDescription: 'Välj vilka identitetsleverantörer som ska användas för personer respektive företag. En identitetsleverantör är den dataleverantör som används för att unikt identifiera en person eller ett företag',
        personIdentityProvider: 'Identitetsleverantör för personer',
        selectPersonIdentityProvider: 'Välj identitetsleverantör för personer',
        companyIdentityProvider: 'Identitetsleverantör för företag',
        selectCompanyIdentityProvider: 'Välj identitetsleverantör för företag',
        subscriptionStrategyDescription: 'Välj när användare ska anmälas till Cosmo',
        strategyOnOpenCases: 'Anmäl användare på alla aktiva ärenden och avanmäl när ärendena avslutas',
        strategyOnAllCustomers: '[not implemented] Anmäl användare när kunder skapas och avanmäl vid radering',
        strategyManual: 'Manuell anmälan och avanmälan av användare. Ingen automatisk anmälan/avanmälan.',
        providers: 'Leverantörer',
        disabledProviders: 'Avaktiverade leverantörer',
        notActivated: 'Inte aktiverad',
        settings: 'Inställningar',
        deactivate: 'Avaktivera',
        activate: 'Aktivera',
        identityProvider: 'Identitetsleverantör',
        persons: 'Personer',
        companies: 'Företag',
    },
    dnsSetup: {
        checkDns: 'Kontrollera DNS',
        title: 'DNS-inställning',
        allRecordsConfirmed: 'Alla poster har bekräftats',
        domainVerification: 'Domänverifiering',
        email: 'E-post',
        outboundEmails: 'Utgående e-post (DKIM & SPF)',
        spfExistingPrefix: 'Om det redan finns en SPF-post, se till att du lägger till',
        spfExistingSuffix: 'till den befintliga posten.',
        inboundEmails: 'Inkommande e-post',
        inboundForwarded: 'All inkommande e-post ska vidarebefordras automatiskt.',
        sites: 'Webbplatser',
        debtorWebApp: 'Gäldenärswebbapp',
        creditorWebApp: 'Borgenärswebbapp',
        verified: 'Verifierad',
        type: 'Typ',
        hostname: 'Värdnamn',
        value: 'Värde',
        currentValue: 'Nuvarande värde',
    },
    createTenant: {
        tenantType: 'Kontotyp',
        agency: 'Inkassobyrå',
        agencyDescription: 'Inkassobyrå som driver in på uppdrag av externa kunder. Indrivna medel fördelas till borgenärerna och funktioner som domstolsprocesser är aktiverade.',
        accountsReceivable: 'Kundreskontra',
        accountsReceivableDescription: 'Företag som själv driver in sina fordringar. Kontot är själv den enda borgenären och använder en förenklad kundreskontramodell.',
        companyName: 'Företagets namn',
        vatNumber: 'Momsregistreringsnummer (DK12345678)',
        billingAddress: 'Faktureringsadress',
        country: 'Land',
        language: 'Språk',
        currency: 'Valuta',
        timezone: 'Tidszon',
        demoDescription: 'Demokonto som används för säljpresentationer. Dessa konton kan ha testdata och viss statistik är fiktiv. Utskick av e-post, sms osv. simuleras och ingen riktig data skickas. Data skickas till användaren som använder systemet.',
        sandboxDescription: 'Används för kunder som behöver en sandlådemiljö. Utskick av e-post, sms osv. simuleras och ingen riktig data skickas. Data skickas till användaren som använder systemet.',
        gettingStartedDescription: 'Konton efter go-live där konfiguration, API-integration, onboarding osv. pågår. Kontot kan senare sättas som aktivt. Utskick av e-post, sms osv. simuleras och ingen riktig data skickas. Data skickas till användaren som använder systemet.',
        demoMockData: 'Demo-testdata',
        noMockData: '-- Ingen testdata --',
        addFrisbiiPaymentGateway: 'Lägg till Frisbii betalningsgateway',
        principalType: 'Kapitalbeloppstyp',
        interestType: 'Räntetyp',
        noInterest: '-- Ingen ränta --',
        quantityCreditors: 'Antal borgenärer',
        quantityCasesPerCreditor: 'Antal ärenden per borgenär',
        privateDebtors: 'Privata gäldenärer',
        companyDebtors: 'Företagsgäldenärer',
        mixed: 'Blandat',
        createTenant: 'Skapa konto',
    },
    experianClientNumber: {
        header: 'Skicka in Experian-klientnummer',
        withAksCustomerNumber: 'med AKS-kundnummer:',
        partnershipText: 'har inlett ett samarbete med nedanstående företag. Därför begärs ett RKI-klientnummer för',
        forFutureRegistrations: 'för framtida registreringar.',
        companyName: 'Företagsnamn:',
        address: 'Adress:',
        clientNumberRegistered: 'Klientnumret har registrerats',
        clientNumberPlaceholder: 'Klientnummer',
        submit: 'Skicka in',
    },
    satisfaction: {
        backToMyCase: 'Tillbaka till mitt ärende',
        header: 'Din åsikt betyder mycket för oss',
        intro: 'För att kunna ge bästa möjliga service vill vi gärna höra om din upplevelse.',
        whichSmiley: 'Vilken smiley beskriver bäst din upplevelse av hanteringen av ärende #',
        optionalComment: 'Eventuell kommentar',
        submit: 'Skicka in',
        thanks: 'Tack för att du skickade in din feedback',
    },
    webappSettings: {
        title: 'Webbappar',
        debtorWeb: 'Gäldenärsportal',
        creditorWeb: 'Borgenärsportal',
        creditorIntroduction: 'Välj vilken information borgenärer kan se i sin portal.',
        documentsTitle: 'Dokument',
        hideDocumentsDescription: 'Dölj ärendenas dokument i borgenärsportalen. Dokumenten är fortfarande tillgängliga för era handläggare.',
    },
    lighthouse: {
        cosmo: 'Cosmo',
        modules: 'Moduler',
        recalculateTenant: 'Räkna om tenant',
        recalculateTenantDescription: 'Räkna om ränta, preskription och fakturering för alla väntande och verifierade ärenden på tenanten.',
        recalculateTenantConfirm: 'Räkna om alla väntande och verifierade ärenden på denna tenant? Det kan skapa faktureringsjusteringar.',
        recalculate: 'Räkna om',
        recalculation: 'Omräkning',
        recalculationRunsInBackground: 'Den körs i bakgrunden.',
    },
    debtorWebSettings: {
        introduction: 'Anpassa texter och självbetjäning i portalen som dina gäldenärer använder.',
        textsTitle: 'Texter och kontakt',
        textsDescription: 'Använd standardtexterna eller skriv egna. Texterna visas på gäldenärens ärende.',
        customWelcome: 'Använd egen välkomsttext',
        welcomeDescription: 'Ersätter introduktionen högst upp i ärendet.',
        defaultText: 'Standardtext',
        defaultWelcomeDescription: 'Standardtexten visar gäldenärens saldo, borgenärens namn och portalens funktioner.',
        showContactInformation: 'Visa kontaktuppgifter',
        contactInformationDescription: 'Visa kontaktavsnittet med er e-post och ert telefonnummer i ärendet.',
        customContact: 'Använd egen kontakttext',
        contactDescription: 'Texten visas tillsammans med era kontaktuppgifter.',
        paymentsTitle: 'Betalning och avbetalning',
        allowPartialPayments: 'Tillåt delbetalningar',
        partialPaymentsDescription: 'Låt gäldenären betala en del av saldot via betalningsportalen.',
        encouragePaymentPlan: 'Visa förslag om avbetalningsplan',
        paymentPlanDescription: 'Föreslå att begära en avbetalningsplan när det är möjligt i ärendet.',
        detailsTitle: 'Uppgifter och ärendenummer',
        allowSelfOverwrite: 'Tillåt ändringar utan godkännande',
        selfOverwriteDescription: 'Låt gäldenärer skriva över sina egna uppgifter utan en handläggares godkännande.',
        preferOriginalJournalNumber: 'Använd ursprungligt ärendenummer',
        journalNumberDescription: 'Visa ärendenumret från ert tidigare system. Om det saknas används ärendenumret i Debbie.',
        unsavedChanges: 'Osparade ändringar',
        saveDescription: 'Ändringarna träder i kraft när du sparar.',
        saveChanges: 'Spara ändringar',
        emptyText: 'Fyll i din egen text eller stäng av anpassningen för att använda standardtexten.',
        leaveWithoutSaving: 'Du har osparade ändringar. Vill du lämna sidan?',
        welcomeText: 'Välkomsttext',
        contactUsText: 'Kontakta oss-text',
        hideContactInformation: 'Dölj kontaktuppgifter',
        noPartialPayments: 'Inga delbetalningar',
        doNotEncouragePaymentPlan: 'Uppmuntra inte till avbetalningsplan',
        useMigratedJournalNumber: 'Använd migrerat journalnummer (fallback till Debbie-journalnummer)',
    },
    resolutionRate: {
        title: 'Lösningsgrad',
        description: 'Andel ärenden som löstes och hur snabbt de blev lösta.',
        headerEnded: 'Avslutade ärenden',
        headerSuccess: 'Lösta',
        headerNotPossible: 'Inte möjligt',
        headerUnresolved: 'Olösta',
        headerError: 'Fel (exkluderas från statistiken)',
        headerPending: 'Väntande',
        headerVerified: 'Verifierade',
        grossRate: 'Bruttolösningsgrad',
        grossRateInfo: 'Andel av alla avslutade ärenden som löstes genom betalning, delbetalning eller ackord.',
        netRate: 'Nettolösningsgrad',
        netRateInfo: 'Andel lösta ärenden av alla avslutade ärenden, exklusive ärenden som tagits bort ur statistiken som fel (felaktigt skapade, återkallade, sammanslagna osv.).',
        grossMoneyRate: 'Bruttolösningsgrad (DKK)',
        grossMoneyRateInfo: 'Indrivet belopp i förhållande till totalt kapitalbelopp för alla ärenden som avslutats under perioden.',
        collectedAmount: 'Indrivet',
        totalPrincipalEnded: 'Kapitalbelopp i avslutade ärenden',
        avgDaysToResolution: 'Genomsnittlig tid till lösning',
        avgDaysToResolutionInfo: 'Genomsnittligt antal dagar från att ärendet skapades tills det avslutades som löst.',
        medianDaysToResolution: 'Mediantid till lösning',
        speedHeader: 'Lösningshastighet',
        speedInfo: 'Andel av de lösta ärendena som löstes inom respektive tidsintervall. Kumulativ andel.',
        speedWithinDays: 'Inom {days} dagar',
        byMonthHeader: 'Avslutade ärenden per månad',
        byEndReasonHeader: 'Fördelning efter avslutsorsak',
        legendHeader: 'Vad kategorierna betyder',
        legendIntro: 'Varje avslutsorsak tillhör en av fyra kategorier. Kategorin avgör om ärendet räknas som löst, olöst eller exkluderas från statistiken.',
        columnEndReason: 'Avslutsorsak',
        columnCategory: 'Kategori',
        columnCount: 'Antal',
        columnPrincipal: 'Kapitalbelopp',
        columnCollected: 'Indrivet',
        daysSuffix: 'dagar',
        explainCategories: 'Förklara lösningskategorier',
        excludingErrors: (count) => `${count} exkl. fel`,
        percentOfAll: (percent) => `${percent} av alla`,
        medianPrefix: 'Median',
    },
    generalManagementInsights: {
        tabs: {
            portfolio: 'Ärendeportfölj',
            resolutionRate: 'Lösningsgrad',
            caseHandling: 'Ärendehantering',
            calls: 'Samtal',
            communicationsAndWorkflows: 'Kommunikation och arbetsflöden',
            expiration: 'Preskription',
            revenue: 'Intäkter',
            tribunal: 'Domstol',
            incomingPayments: 'Inbetalningar',
            paymentPlans: 'Avbetalningsplaner',
        },
        filters: {
            caseGroupsPlaceholder: 'Alla ärendegrupper',
            creditorsPlaceholder: 'Alla borgenärer',
            searchPlaceholder: 'Skriv för att söka',
        },
        incomingPayments: {
            byMonthHeader: 'Betalningar per månad',
            bySourceHeader: 'Fördelning efter mottagare',
            byStateHeader: 'Fördelning efter typ',
            byPaymentTypeHeader: 'Fördelning efter betalningsmetod',
            countLabel: 'Antal',
            amountLabel: 'Belopp',
            sourceCollector: 'Mottaget av inkassobolaget',
            sourceCreditor: 'Mottaget av borgenären',
            shareOfAmount: (share) => `${share}% av beloppet`,
            countWithShare: (count, share) => `${count} betalningar (${share}%)`,
            stateLabels: {
                [CaseVoucherState.FullPayment]: 'Full betalning',
                [CaseVoucherState.PartialPayment]: 'Delbetalning',
                [CaseVoucherState.Overpayment]: 'Överbetalning',
                [CaseVoucherState.PaymentPlanEntryPayment]: 'Avbetalning enligt plan',
                [CaseVoucherState.UnkownPaymentPlanPayment]: 'Okänd avbetalning',
                [CaseVoucherState.AccordPayment]: 'Ackord',
                [CaseVoucherState.PrincipalPayment]: 'Betalning av kapitalbelopp',
            },
            paymentTypeUnknown: 'Okänd',
            columnPaymentType: 'Betalningsmetod',
            columnCount: 'Antal',
            columnCountShare: 'Andel av antal',
            columnAmount: 'Belopp',
            columnAmountShare: 'Andel av belopp',
            currencyLabel: 'Valuta',
            noData: 'Inga data',
        },
        common: {
            incoming: 'Inkommande',
            outgoing: 'Utgående',
            others: 'Övriga',
            noCaseGroup: 'Ingen ärendegrupp',
            noData: 'Inga data',
            creditor: 'Borgenär',
            caseGroup: 'Ärendegrupp',
            updateType: 'Uppgiftstyp',
            user: 'Användare',
            tag: 'Tagg',
            count: 'Antal',
            total: 'Totalt',
            payment: 'Betalning',
            paymentPlan: 'Avbetalningsplan',
            revenue: 'Intäkter',
            open: 'Öppna',
            oldest: 'Äldst',
            over7Days: 'Över 7 d',
            over30Days: 'Över 30 d',
            medianAge: 'Medianålder',
            daysValue: (days) => `${days} dagar`,
            xOfY: (a, b) => `${a} av ${b}`,
        },
        portfolio: {
            createdAndEndedCasesPerMonth: 'Skapade och avslutade ärenden per månad',
            createdCasesPerCreditor: 'Skapade ärenden per borgenär',
            activeCasesPerMonth: 'Aktiva ärenden per månad',
            submittedAndImposedPerMonth: 'Inlämnade och påförda belopp per månad',
            ageDistributionOfActiveCases: 'Åldersfördelning för aktiva ärenden',
            top10CreditorsByOutstanding: 'De 10 borgenärerna med högst totalt utestående belopp',
            createdCases: 'Skapade ärenden',
            activeCases: 'Aktiva ärenden',
            imposedByCreditor: 'Påfört av borgenären',
            imposedByCollector: 'Påfört av inkassobolaget',
            compositionFootnote: 'Verifikationerna delas upp efter vem som registrerade dem: borgenären (kapitalbelopp, fakturor, påminnelseavgifter) eller inkassobolaget (ränta, kostnader, rättegångskostnader och avgifter som tillkom under indrivningen).',
            cases: 'Ärenden',
            balance: 'Saldo',
            columnCaseCount: 'Ärenden',
            columnTotalOutstanding: 'Totalt utestående',
        },
        caseHandling: {
            allCaseGroups: 'Alla ärendegrupper',
            allCreditors: 'Alla borgenärer',
            allUpdateTypes: 'Alla uppgiftstyper',
            allResponsibles: 'Alla ansvariga',
            unassignedOption: 'Ej tilldelad',
            teamsGroup: 'Team',
            usersGroup: 'Användare',
            behindPerUser: 'Eftersläpning per användare',
            behindPerUserDescription: 'Öppna uppgifter per användare, inklusive ej tilldelade uppgifter så att brister i ansvarsfördelningen syns.',
            behindPerTeam: 'Eftersläpning per team',
            behindPerTeamDescription: 'Öppna uppgifter per team för att se vilka team som ligger efter.',
            noOpenTasksByUser: 'Inga öppna uppgifter per användare',
            noOpenTasksByTeam: 'Inga öppna uppgifter per team',
            unknownUser: 'Okänd användare',
            unknownTeam: 'Okänt team',
            user: 'Användare',
            currentTaskBacklog: 'Aktuell uppgiftskö',
            timeSpentPerUpdateType: 'Tidsåtgång per uppgiftstyp',
            avgTimeOnTaskList: (label) => (label ?? '')
                ? `Genomsnittlig tid i uppgiftslistan – ${label}`
                : 'Genomsnittlig tid i uppgiftslistan',
            lessThanOneDay: '< 1 d',
            taskBacklogDescription: 'Visar uppgifterna som just nu finns i uppgiftslistan. Använd vyn för att se vad teamet ligger efter med och vilka uppgiftstyper som behöver prioriteras.',
            totalOpenTasks: 'Totalt antal öppna uppgifter',
            oldestLabel: (days) => `Äldst: ${days}`,
            overDeadline: 'Överskriden tidsfrist',
            percentOfTasksWithDeadline: (percent) => `${percent}% av uppgifter med tidsfrist`,
            noDeadlinesConfigured: 'Inga tidsfrister angivna',
            olderThan7Days: 'Äldre än 7 dagar',
            percentOfBacklog: (percent) => `${percent}% av uppgiftskön`,
            olderThan30Days: 'Äldre än 30 dagar',
            unassigned: 'Ej tilldelad',
            ageDistribution: 'Åldersfördelning',
            ageDistributionDescription: 'Hur länge har de öppna uppgifterna funnits i uppgiftslistan? Staplarna till höger bör vara låga, annars börjar uppgifter samlas på hög.',
            quantity: 'Antal',
            prioritizationPerUpdateType: 'Prioritering per uppgiftstyp',
            prioritizationDescription: 'Sorterat efter antal uppgifter med överskriden tidsfrist. Uppgiftstyper utan tidsfrist hamnar längst ned. Ange en tidsfrist för uppgiftstypen för att ta med den i prioriteringen.',
            noTasksOnList: 'Det finns inga uppgifter i uppgiftslistan.',
            behindPerCreditor: 'Eftersläpning per borgenär',
            behindPerCreditorDescription: 'Sorterat efter antal uppgifter som är äldre än 7 dagar. Använd vyn för att se vilka borgenärer som just nu behöver extra uppmärksamhet.',
            noOpenTasksByCreditor: 'Inga öppna uppgifter per borgenär.',
            behindPerCaseGroup: 'Eftersläpning per ärendegrupp',
            behindPerCaseGroupDescription: 'Vilka ärendegrupper har störst uppgiftskö och var väntar uppgifterna längst?',
            noOpenTasksByCaseGroup: 'Inga öppna uppgifter per ärendegrupp.',
            hoursPerUpdateType: 'Timmar per uppgiftstyp',
            timeTrackingDescription: 'Tid registreras automatiskt på en uppgift när en uppgiftstyp väljs i uppgiftslistan. Klockan startar när ett ärende öppnas och stannar när ärendet lämnas eller uppgiften markeras som löst.',
            average: 'Genomsnitt',
            median: 'Median',
            taskCount: 'Antal uppgifter',
            taskQueueDurationDescription: 'Visar hur länge uppgifter i genomsnitt har funnits i uppgiftslistan, räknat från att de skapades tills de återupptogs.',
            columnAvgPerTask: 'Genomsnitt per uppgift',
            columnResolvedTasksCount: 'Lösta uppgifter',
            totalTimeSpent: 'Total tidsåtgång',
            weekdays: {
                sun: 'Sön',
                mon: 'Mån',
                tue: 'Tis',
                wed: 'Ons',
                thu: 'Tor',
                fri: 'Fre',
                sat: 'Lör',
            },
            onParWithTeam: 'I nivå med teamet',
            comparedToTeam: (signedPct) => `${signedPct} jämfört med teamet`,
            resolvedCount: 'Antal lösta',
            percentile25: '25:e percentilen',
            percentile75: '75:e percentilen',
            fastest: 'Snabbast',
            slowest: 'Långsammast',
            timeSpentDistribution: 'Fördelning av tidsåtgång',
            timeSpentDistributionDescription: 'Hur användarens uppgifter fördelar sig över tid, jämfört med teamets fördelning. Om användaren ligger till höger om teamet tar uppgifterna i allmänhet längre tid.',
            team: 'Team',
            efficiencyPerWeekday: 'Effektivitet per veckodag',
            efficiencyPerWeekdayDescription: 'Genomsnittlig tid per uppgift och veckodag: användarens egen tid (mörk) jämfört med teamets genomsnitt (ljus). Staplarna visar också hur många uppgifter användaren har löst respektive dag.',
            userAvg: 'Användarens genomsnitt',
            teamAvg: 'Teamets genomsnitt',
            tasks: 'Uppgifter',
            minutesSuffix: ' min',
        },
        calls: {
            overviewSectionHeader: 'Samtal och intäkter under perioden',
            callsPerMonthHeader: 'Samtal per månad',
            creditorReachHeader: 'Borgenärer – hur lätt når vi gäldenärerna?',
            outgoingTagsHeader: 'Utgående samtal – taggar och resultat',
            incomingTagsHeader: 'Inkommande samtal – taggar och resultat',
            caseworkerPerformanceHeader: 'Handläggare – resultat',
            shareOfCalls: (share) => `${share}% av samtalen`,
            stat: {
                totalCalls: 'Totalt antal samtal',
                totalCallsInfo: 'Totalt antal samtalsinteraktioner registrerade på ärenden under den valda perioden.',
                incomingInfo: 'Antal samtal där en gäldenär eller någon annan ringde in.',
                outgoingInfo: 'Antal samtal som ringts av handläggare.',
                outgoingAnswered: 'Besvarade utgående samtal',
                outgoingAnsweredInfo: 'Utgående samtal utan taggen ”Inget svar”. Andelen visas i förhållande till alla utgående samtal.',
                outgoingNoAnswer: 'Obesvarade utgående samtal',
                outgoingNoAnswerInfo: 'Utgående samtal där handläggaren har angett taggen ”Inget svar”. Andelen visas i förhållande till alla utgående samtal.',
                withPayment: 'Med betalning',
                withPaymentInfo: 'Antal samtal som följts av en betalning på samma ärende inom 7 dagar.',
                withNewPaymentPlan: 'Med ny avbetalningsplan',
                withNewPaymentPlanInfo: 'Antal samtal som följts av en ny avbetalningsplan på samma ärende inom 7 dagar.',
                collectionCommission: 'Inkassoprovision',
                collectionCommissionInfo: 'Summan av inkassoprovision (avräkningsverifikationer) bokförd inom 7 dagar efter ett samtal under perioden.',
                otherFees: 'Övriga avgifter',
                otherFeesInfo: 'Summan av övriga avgifter (avräkningsverifikationer) bokförda inom 7 dagar efter ett samtal under perioden.',
                totalRevenue: 'Totala intäkter',
                totalRevenueInfo: 'Totala intäkter (inkassoprovision och övriga avgifter) bokförda inom 7 dagar efter ett samtal under perioden. ”Per samtal” är genomsnittet fördelat över alla samtal.',
                perCall: (amount) => `${amount} per samtal`,
            },
            emptyTags: 'Inga taggar registrerade under perioden.',
            unknownUser: 'Okänd användare',
            emptyCaseworkers: (minCalls) => `Inga handläggare med minst ${minCalls} samtal under perioden.`,
            caseworkerHelp: (minCalls) => `Endast handläggare med minst ${minCalls} registrerade samtal under perioden visas. Resultatet mäter andelen av handläggarens samtal som följts av en betalning eller en ny avbetalningsplan på samma ärende inom 7 dagar.`,
            emptyCreditors: (minCalls) => `Inga borgenärer med minst ${minCalls} samtal under perioden.`,
            creditorReachHelpPrefix: 'Sortera efter ',
            creditorReachHelpAnswered: 'Besvarade',
            creditorReachHelpMiddle: ' för att se vems gäldenärer som är lättast att nå. Endast utgående samtal räknas i svarsfrekvensen. Samtal utan taggen ',
            creditorReachHelpNoAnswer: '”Inget svar”',
            creditorReachHelpMin: (minCalls) => ` räknas som besvarade. Endast borgenärer med minst ${minCalls} samtal under perioden visas.`,
            answered: 'Besvarade',
            caseworker: 'Handläggare',
        },
        communications: {
            sectionHeader: 'Kommunikation under perioden',
            templatesHeader: 'Mallar – resultat och relaterade intäkter',
            byTypeHeader: 'Interaktioner per typ och riktning',
            letterReturnsHeader: 'Returbrev – antal, svarstid och orsak',
            dataQualityHeader: 'Kontaktuppgifternas kvalitet per borgenär och ärendegrupp',
            futureWorkflowsHeader: 'Arbetsflöden – kommande uppgifter per uppgiftstyp',
            shareOfAll: (percent) => `${percent} av alla`,
            shareOfSent: (percent) => `${percent} av skickade`,
            stat: {
                totalInteractions: 'Totalt antal interaktioner',
                totalInteractionsInfo: 'Totalt antal kommunikationsinteraktioner under perioden, oavsett typ och riktning.',
                outgoingInfo: 'Antal utgående interaktioner under perioden.',
                incomingInfo: 'Antal inkommande interaktioner under perioden.',
                withPaymentPlan: 'Med ny avbetalningsplan',
                withPaymentPlanInfo: 'Interaktioner som följts av en ny avbetalningsplan på samma ärende inom 7 dagar.',
                withPayment: 'Med betalning',
                withPaymentInfo: 'Interaktioner som följts av en betalning på samma ärende inom 7 dagar.',
                linkClicks: 'Länkklick',
                linkClicksInfo: 'Totalt antal länkklick registrerade på interaktioner under perioden.',
                collectionCommission: 'Inkassoprovision',
                collectionCommissionInfo: 'Summan av inkassoprovision bokförd inom 7 dagar på ärenden som fått en interaktion under perioden.',
                otherFees: 'Övriga avgifter',
                otherFeesInfo: 'Summan av övriga avgifter (kategorin FEE) bokförda inom 7 dagar på ärenden som fått en interaktion under perioden.',
                totalRevenue: 'Totala intäkter',
                totalRevenueInfo: 'Intäkter hänförs till det senaste utgående mallmeddelandet före varje avgift, inom 7 dagar. Varje avgift räknas en gång.',
                lettersSent: 'Skickade brev',
                lettersSentInfo: 'Antal brev som skickats under perioden.',
                lettersReturned: 'Returnerade brev',
                lettersReturnedInfo: 'Antal brev där PostNord registrerat en misslyckad leverans under perioden.',
                averageReturnTime: 'Genomsnittlig svarstid',
                averageReturnTimeInfo: 'Genomsnittligt antal dagar från att brevet skickas tills returen registreras.',
            },
            emptyTemplates: 'Inga mallbaserade interaktioner under perioden.',
            emptyInteractions: 'Inga interaktioner under perioden.',
            emptyReturns: 'Inga returbrev registrerade under perioden.',
            emptyCases: 'Inga ärenden hittades.',
            emptyWorkflowTasks: 'Inga kommande arbetsflödesuppgifter hittades.',
            templatesHelp: 'Varje rad visar en mall som använts för utgående interaktioner under perioden. Avbetalningsplan % och Betalning % visar hur många skickade interaktioner som inom 7 dagar följts av en ny avbetalningsplan respektive en inbetalning på samma ärende. Länkklick är klickhändelser registrerade på interaktionerna. Intäkter är summan av inkassoprovision och övriga avgifter bokförda på samma ärende inom 7 dagar efter utskicket.',
            dataQualityHelp: 'Tabellen visar kontaktuppgifternas kvalitet per borgenär och ärendegrupp. Låga retur- och felfrekvenser innebär att vi når gäldenärerna via de valda kanalerna. Siffrorna inom parentes visar det faktiska antalet misslyckade leveranser.',
            workflowHelp: 'Antal kommande arbetsflödesuppgifter per uppgiftstyp, baserat på ärendets nästa planerade uppgift (cases.workflow_next_task_id). Filtren ovan tillämpas inte; tabellen visar den aktuella uppgiftskön.',
            daysValue: (days) => `${days} dagar`,
            col: {
                template: 'Mall',
                type: 'Typ',
                sent: 'Skickade',
                linkClicks: 'Länkklick',
                returnReason: 'Returorsak',
                shareOfSent: 'Andel av skickade',
                averageResponseTime: 'Svarstid (genomsnitt)',
                lettersReturned: 'Returnerade brev',
                emailsFailed: 'Misslyckade e-postleveranser',
                eboksFailed: 'Misslyckade e-Boks-leveranser',
                cases: 'Ärenden',
                overdue: 'Försenade',
                next7Days: 'Nästa 7 dagar',
                days8To30: '8–30 dagar',
                later: 'Senare',
            },
        },
        expiration: {
            headerExpiration: 'Preskription',
            headerSuspension: 'Möjlighet att avbryta preskription',
            clear: 'Rensa',
            loadingForMonth: (month) => `Laddar fördelning för ${month}…`,
            distributionPerCreditor: (month) => `Fördelning per borgenär – ${month}`,
            distributionPerCaseGroup: (month) => `Fördelning per ärendegrupp – ${month}`,
        },
        revenue: {
            settledRevenuePerMonth: 'Avräknade intäkter per månad',
            collectionCommissionByCasePostingType: 'Inkassoprovision efter typ av ärendepost',
            otherFeesByFeeType: 'Övriga avgifter efter avgiftstyp',
            billingSpeedPerCreditor: 'Faktureringshastighet per borgenär',
            workInProgressNotYetBilled: 'Pågående arbete (ännu inte fakturerat)',
            revenuePerCreditor: 'Intäkter per borgenär',
            revenuePerCaseGroup: 'Intäkter per ärendegrupp',
            collectionCommission: 'Inkassoprovision',
            fees: 'Avgifter',
            otherFees: 'Övriga avgifter',
            avgDaysToBilling: 'Genomsnittligt antal dagar till fakturering',
            billed: 'Fakturerat',
            unbilled: 'Ej fakturerat',
            totalOtherFees: 'Totala övriga avgifter',
            totalCollectionCommission: 'Total inkassoprovision',
            name: 'Namn',
        },
        tribunal: {
            paymentOrderOutcomes: 'Utfall av betalningsförelägganden',
            casesFiledAndBailiffMeetingsPerMonth: 'Inlämnade domstolsärenden och utmätningsmöten per månad',
            courtProcessingTime: 'Domstolens handläggningstid (betalningsförelägganden)',
            percentOfCases: (share) => `${share}% av ärendena`,
            stat: {
                totalFiled: 'Totalt inlämnade',
                totalFiledInfo: 'Antal unika ärenden där ett betalningsföreläggande skapats eller lämnats in på nytt under den valda perioden. Datumet avser när betalningsföreläggandet lämnades in.',
                paidAfterFiling: 'Betalda efter inlämning',
                paidAfterFilingInfo: 'Antal ärenden som avslutats som betalda inom 3 månader efter den senaste åtgärden i domstolsmodulen. Ärendena räknas efter datumet för det ursprungliga betalningsföreläggandet, inte betalningsdatumet. Ärendet måste vara avslutat med orsaken ”Betalt” i Debbie.',
                paidBetweenFirstAndSecondEndorsement: 'Betalda mellan första och andra påteckningen',
                paidBetweenFirstAndSecondEndorsementInfo: 'Antal unika ärenden där en betalning registrerats mellan den första påteckningen och upp till 5 dagar efter den andra, för att fånga upp senare registrerade betalningar. Ärendet behöver inte vara avslutat som betalt. Ärendena räknas efter datumet för det ursprungliga betalningsföreläggandet.',
                paidBetweenSecondEndorsementAndBailiffMeeting: 'Betalda mellan andra påteckningen och utmätningsmötet',
                paidBetweenSecondEndorsementAndBailiffMeetingInfo: 'Antal unika ärenden där en betalning registrerats mellan den andra påteckningen och upp till 5 dagar efter utmätningsmötet, för att fånga upp senare registrerade betalningar. Ärendet behöver inte vara avslutat som betalt. Ärendena räknas efter datumet för det ursprungliga betalningsföreläggandet. Utmätningsmötet måste vara registrerat i Debbie.',
                distraintsPerformed: 'Utförda utmätningar',
                distraintsPerformedInfo: 'Antal unika ärenden där en utmätning registrerats. Ärendena räknas efter datumet för det ursprungliga betalningsföreläggandet, inte utmätningsdatumet. Observera att utmätningar som inte registrerats i Debbie inte ingår.',
                paymentPlansCreatedAfterBailiffMeeting: 'Avbetalningsplaner skapade efter utmätningsmöte',
                paymentPlansCreatedAfterBailiffMeetingInfo: 'Antal avbetalningsplaner skapade inom 1 månad efter ett utmätningsmöte. Ärendena räknas efter datumet för det ursprungliga betalningsföreläggandet, inte datumet för avbetalningsplanen. Alla skapade planer räknas, även senare avbrutna eller misskötta planer. Utmätningsmötet måste vara registrerat i Debbie.',
                activePaymentPlansNow: 'Aktiva avbetalningsplaner nu',
                activePaymentPlansNowInfo: 'Hur många av avbetalningsplanerna som skapats efter ett utmätningsmöte som är aktiva nu.',
                finishedPaymentPlans: 'Slutförda avbetalningsplaner',
                finishedPaymentPlansInfo: 'Hur många av avbetalningsplanerna som skapats efter ett utmätningsmöte som är slutförda och helt betalda.',
                objections: 'Invändningar',
                objectionsInfo: 'Antal utmätningsärenden som avslutats med en invändning efter den första påteckningen. Ärendena räknas efter datumet för det ursprungliga betalningsföreläggandet, inte datumet för invändningen. Invändningar som inte registrerats i Debbie ingår inte.',
                insolvencies: 'Insolvenser',
                insolvenciesInfo: 'Antal unika ärenden där insolvens registrerats. Ärendena räknas efter datumet för det ursprungliga betalningsföreläggandet, inte datumet för insolvensregistreringen. Insolvenser som inte registrerats i Debbie ingår inte.',
            },
            bailiffMeetings: 'Utmätningsmöten',
            courtSpeedBenchmarkDescription: 'Total tid från ärendets start till varje steg i det förenklade förfarandet. Siffran under visar tiden sedan föregående steg.',
            court: 'Domstol',
            firstEndorsement: 'Första påteckningen',
            secondEndorsement: 'Andra påteckningen',
            invitation: 'Kallelse',
            bailiffMeeting: 'Utmätningsmöte',
            casesByCourt: 'Inlämnade ärenden per domstol',
            casesByCourtDescription: 'Antal ursprungliga betalningsförelägganden som denna klient lämnat in till varje domstol under den valda perioden, samt hur många som returnerats av domstolen för rättelse och ny inlämning.',
            casesByCourtCount: 'Inlämnade ärenden',
            casesByCourtShare: 'Andel av totalt',
            casesByCourtRevised: 'Returnerade för rättelse',
            casesByCourtRevisedShare: 'Andel rättelser',
        },
    },
};
export default map;
//# sourceMappingURL=sv.js.map